webpackJsonp([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(321);
	module.exports = __webpack_require__(612);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(8)
	  , core      = __webpack_require__(58)
	  , hide      = __webpack_require__(32)
	  , redefine  = __webpack_require__(33)
	  , ctx       = __webpack_require__(59)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
[1285, 14],
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setConsumerType = exports.setFlowType = exports.setFlow = exports.toggleExperiment = exports.updateGlobalSpinner = exports.hideGlobalSpinner = exports.showGlobalSpinner = exports.toggleLoading = exports.setDev = exports.setPageErrors = exports.setContactUsError = exports.setError = exports.setOfferId = exports.setSalesSessionId = exports.common = exports.initialState = exports.SET_CONSUMER_TYPE = exports.SET_FLOW_TYPE = exports.SET_FLOW = exports.TOGGLE_EXPERIMENT = exports.UPDATE_SPINNER = exports.TOGGLE_SPINNER = exports.TOGGLE_LOADING = exports.SET_DEV = exports.SET_PAGE_ERRORS = exports.SET_CONTACT_US_ERROR = exports.SET_ERROR = exports.SET_OFFER_ID = exports.SET_SALES_SESSION_ID = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _commonSelectors = __webpack_require__(614);
	
	Object.keys(_commonSelectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _commonSelectors[key];
	    }
	  });
	});
	
	var _cookie = __webpack_require__(688);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _platform = __webpack_require__(1097);
	
	var _platform2 = _interopRequireDefault(_platform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SET_SALES_SESSION_ID = exports.SET_SALES_SESSION_ID = 'hg/common/SET_SALES_SESSION_ID';
	var SET_OFFER_ID = exports.SET_OFFER_ID = 'hg/common/SET_OFFER_ID';
	var SET_ERROR = exports.SET_ERROR = 'hg/common/SET_ERROR';
	var SET_CONTACT_US_ERROR = exports.SET_CONTACT_US_ERROR = 'hg/common/SET_CONTACT_US_ERROR';
	var SET_PAGE_ERRORS = exports.SET_PAGE_ERRORS = 'hg/common/SET_PAGE_ERRORS';
	var SET_DEV = exports.SET_DEV = 'hg/common/SET_DEV';
	var TOGGLE_LOADING = exports.TOGGLE_LOADING = 'hg/common/TOGGLE_LOADING';
	var TOGGLE_SPINNER = exports.TOGGLE_SPINNER = 'hg/common/TOGGLE_SPINNER';
	var UPDATE_SPINNER = exports.UPDATE_SPINNER = 'hg/common/UPDATE_SPINNER';
	var TOGGLE_EXPERIMENT = exports.TOGGLE_EXPERIMENT = 'hg/common/TOGGLE_EXPERIMENT';
	var SET_FLOW = exports.SET_FLOW = 'hg/common/SET_FLOW';
	var SET_FLOW_TYPE = exports.SET_FLOW_TYPE = 'hg/common/SET_FLOW_TYPE';
	var SET_CONSUMER_TYPE = exports.SET_CONSUMER_TYPE = 'hg/common/SET_CONSUMER_TYPE';
	
	// TODO: clear initial values
	var DEFAULT_USER_ID = '';
	var DEFAULT_OFFER_ID = '210105';
	
	var spinnerTimeout = void 0;
	
	var initialState = exports.initialState = {
	  salesSessionId: '',
	  userId: _cookie2.default.getUserId() || DEFAULT_USER_ID,
	  offerId: DEFAULT_OFFER_ID,
	  consumerType: '',
	  flow: '',
	  flowType: '',
	  loading: false,
	  experiment: false,
	  spinner: {
	    show: false,
	    hideContent: true,
	    priority: 0
	  },
	  error: null,
	  pageErrors: [],
	  dev: false,
	  platform: {
	    os: {
	      family: _platform2.default.os.family
	    }
	  }
	};
	
	var common = exports.common = function common() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	
	    case SET_SALES_SESSION_ID:
	      return _extends({}, state, {
	        salesSessionId: action.salesSessionId
	      });
	
	    case SET_OFFER_ID:
	      return _extends({}, state, {
	        offerId: action.offerId
	      });
	
	    case SET_ERROR:
	      return _extends({}, state, {
	        error: action.error
	      });
	
	    case SET_CONTACT_US_ERROR:
	      return _extends({}, state, {
	        contactUsErrorCode: action.error
	      });
	
	    case SET_PAGE_ERRORS:
	      return _extends({}, state, {
	        pageErrors: action.pageErrors
	      });
	
	    case SET_DEV:
	      return _extends({}, state, {
	        dev: action.dev
	      });
	
	    case TOGGLE_LOADING:
	      return _extends({}, state, {
	        loading: action.loading
	      });
	
	    case TOGGLE_SPINNER:
	      return _extends({}, state, {
	        spinner: action.spinner
	      });
	
	    case UPDATE_SPINNER:
	      return _extends({}, state, {
	        spinner: _extends({}, state.spinner, action.payload)
	      });
	
	    case TOGGLE_EXPERIMENT:
	      return _extends({}, state, {
	        experiment: action.experiment
	      });
	
	    case SET_FLOW:
	      return _extends({}, state, {
	        flow: action.flow
	      });
	
	    case SET_FLOW_TYPE:
	      return _extends({}, state, {
	        flowType: action.flowType
	      });
	
	    case SET_CONSUMER_TYPE:
	      return _extends({}, state, {
	        consumerType: action.consumerType
	      });
	
	    default:
	      return state;
	  }
	};
	
	var setSalesSessionId = exports.setSalesSessionId = function setSalesSessionId(salesSessionId) {
	  return {
	    type: SET_SALES_SESSION_ID,
	    salesSessionId: salesSessionId
	  };
	};
	
	var setOfferId = exports.setOfferId = function setOfferId(offerId) {
	  // cookie.save('offerId', offerId, { path: '/' });
	  return {
	    type: SET_OFFER_ID,
	    offerId: offerId
	  };
	};
	
	var setError = exports.setError = function setError(error) {
	  return {
	    type: SET_ERROR,
	    error: error
	  };
	};
	
	var setContactUsError = exports.setContactUsError = function setContactUsError(error) {
	  return {
	    type: SET_CONTACT_US_ERROR,
	    error: error
	  };
	};
	
	var setPageErrors = exports.setPageErrors = function setPageErrors(pageErrors) {
	  return {
	    type: SET_PAGE_ERRORS,
	    pageErrors: pageErrors
	  };
	};
	
	var setDev = exports.setDev = function setDev(isDev) {
	  return {
	    type: SET_DEV,
	    dev: isDev
	  };
	};
	
	var toggleLoading = exports.toggleLoading = function toggleLoading(loading) {
	  return {
	    type: TOGGLE_LOADING,
	    loading: loading
	  };
	};
	
	var showGlobalSpinner = exports.showGlobalSpinner = function showGlobalSpinner() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$delayed = _ref.delayed,
	      delayed = _ref$delayed === undefined ? false : _ref$delayed,
	      _ref$hideContent = _ref.hideContent,
	      hideContent = _ref$hideContent === undefined ? true : _ref$hideContent,
	      _ref$delayAmount = _ref.delayAmount,
	      delayAmount = _ref$delayAmount === undefined ? 500 : _ref$delayAmount,
	      _ref$priority = _ref.priority,
	      priority = _ref$priority === undefined ? 0 : _ref$priority,
	      _ref$message = _ref.message,
	      message = _ref$message === undefined ? '' : _ref$message,
	      _ref$initiator = _ref.initiator,
	      initiator = _ref$initiator === undefined ? '' : _ref$initiator;
	
	  // clearTimeout(spinnerTimeout);dispatch(hideGlobalSpinner());
	  // const delay = delayed ? delayAmount : 0;
	
	  return function (dispatch) {
	    dispatch(hideGlobalSpinner());
	    var action = {
	      type: TOGGLE_SPINNER,
	      spinner: {
	        show: true,
	        hideContent: hideContent,
	        priority: priority,
	        message: message,
	        // for debugging
	        initiator: initiator
	      }
	    };
	
	    if (delayed) {
	      spinnerTimeout = setTimeout(function () {
	        dispatch(action);
	      }, delayAmount);
	    } else {
	      dispatch(action);
	    }
	  };
	};
	
	var hideGlobalSpinner = exports.hideGlobalSpinner = function hideGlobalSpinner(initiator) {
	  clearTimeout(spinnerTimeout);
	  return {
	    type: TOGGLE_SPINNER,
	    spinner: {
	      show: false,
	      // for debugging
	      initiator: initiator
	    }
	  };
	};
	
	var updateGlobalSpinner = exports.updateGlobalSpinner = function updateGlobalSpinner(payload) {
	  return {
	    type: UPDATE_SPINNER,
	    payload: payload
	  };
	};
	
	var toggleExperiment = exports.toggleExperiment = function toggleExperiment(experiment) {
	  return {
	    type: TOGGLE_EXPERIMENT,
	    experiment: experiment
	  };
	};
	
	var setFlow = exports.setFlow = function setFlow(flow) {
	  return {
	    type: SET_FLOW,
	    flow: flow
	  };
	};
	
	var setFlowType = exports.setFlowType = function setFlowType(flowType) {
	  return {
	    type: SET_FLOW_TYPE,
	    flowType: flowType
	  };
	};
	
	var setConsumerType = exports.setConsumerType = function setConsumerType(consumerType) {
	  return {
	    type: SET_CONSUMER_TYPE,
	    consumerType: consumerType
	  };
	};
	
	exports.default = common;

/***/ },
/* 8 */
71,
/* 9 */,
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(572)

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buyFlowUrls = exports.navigationRoutes = exports.navigationSteps = undefined;
	
	var _navigationRoutes;
	
	var _endpoints = __webpack_require__(687);
	
	var _directory = __webpack_require__(320);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var navigationSteps = exports.navigationSteps = {
	  myPlan: {
	    MYPLAN: 'myplan',
	    SPEED: 'myPlanSpeed',
	    OFFERS: 'myPlanOffers',
	    OFFERS_FILTER: 'myPlanOffersFilter',
	    CHANNELS: 'myPlanChannels',
	    ADDON_CHANNEL: 'myPlanAddOnChannel',
	    ADDON_EQUIPMENT: 'myPlanAddOnEquipment',
	    ADDON_MANAGE_STREAMING_VIDEO: 'myPlanAddOnStreamingVideo',
	    UPSELL_STREAMING_VIDEO: 'myPlanUpsellStreamingVideo',
	    CANCEL: 'myPlanCancel',
	    REVIEW: 'myPlanReview',
	    CONFIRMATION: 'myPlanConfirmation',
	    OMNI_LANDING: 'myPlanOmniLanding',
	    CONTACTUS: 'myPlanContactUs',
	    MESSAGE: 'myPlanMessage',
	    ERROR: 'myPlanError'
	  },
	  movers: {
	    LOCALIZATION: 'moversLocalization',
	    UNSERVICEABLE: 'moversUnserviceable',
	    CANCEL: 'moversCancel',
	    SPECIALIST: 'moversSpecialist',
	    INSTALL: 'moversInstall',
	    REVIEW: 'moversReview',
	    CONFIRMATION: 'moversConfirmation',
	    CONTACTUS: 'moversContactUs',
	    CANCELLATION_CONTACTUS: 'moversCancellationContactUs',
	    ERROR: 'moversError',
	    CANCELLATION_ERROR: 'moversCancellationError'
	  },
	  quickCheckout: {
	    CHECKOUT: 'checkout',
	    REVIEW: 'review',
	    CONFIRMATION: 'confirmation',
	    REDIRECT: 'quickCheckoutRedirect',
	    CONTACTUS: 'quickCheckoutContactUs',
	    ERROR: 'checkoutError'
	  },
	  account: {
	    MULTIPLE_ADDRESS: 'accountMultipleAddress'
	  },
	  omni: {
	    OMNI_SALES: 'omniSales'
	  }
	};
	
	var navigationRoutes = exports.navigationRoutes = (_navigationRoutes = {}, _defineProperty(_navigationRoutes, navigationSteps.omni.OMNI_SALES, {
	  key: navigationSteps.omni.OMNI_SALES,
	  path: '/omniSales',
	  name: 'OmniSales',
	  endpoints: {
	    omniLocalize: function omniLocalize() {
	      return {
	        url: 'http://services.stg.xfinity.com/OfferInquiries/api/localization/localize',
	        method: 'POST'
	      };
	    },
	    getSuggestions: function getSuggestions(search) {
	      return {
	        url: 'https://www.stg.xfinity.com/learn/api/neptune/address-search/suggestions?search=' + search,
	        method: 'GET'
	      };
	    },
	    tentantDecodeToken: function tentantDecodeToken() {
	      return {
	        url: 'https://services.stg.xfinity.com/Tenant/api/tenant/decodetoken',
	        method: 'POST'
	      };
	    },
	    tentantEncodeToken: function tentantEncodeToken() {
	      return {
	        url: 'https://services.stg.xfinity.com/Tenant/api/tenant/create-token',
	        method: 'POST'
	      };
	    },
	    getReleaseNotes: function getReleaseNotes() {
	      return {
	        url: '//omni-feedback.aws-origin.xfinity.com/api/category/1/release-notes',
	        method: 'GET'
	      };
	    },
	    getFeatures: function getFeatures() {
	      return {
	        url: '//omni-feedback.aws-origin.xfinity.com/api/category/2/feature-requests',
	        method: 'GET'
	      };
	    },
	    getIssues: function getIssues() {
	      return {
	        url: '//omni-feedback.aws-origin.xfinity.com/api/category/4/report-an-issue',
	        method: 'GET'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.myPlan.MYPLAN, {
	  key: navigationSteps.myPlan.MYPLAN,
	  path: _directory.subfolder + '/myplan',
	  name: 'MyPlan',
	  endpoints: {
	    validateAuth: function validateAuth() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/authentication',
	        method: 'GET'
	      };
	    },
	    loadCustomer: function loadCustomer() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/customer',
	        method: 'GET'
	      };
	    },
	    loadPlan: function loadPlan() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/customer/plan',
	        method: 'GET'
	      };
	    },
	    loadEquipment: function loadEquipment() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/customer/equipments',
	        method: 'GET'
	      };
	    },
	    getContext: function getContext() {
	      var validatePlanAvailable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'false';
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/customer/consumerContext?validatePlanAvailable=' + validatePlanAvailable,
	        method: 'GET'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.myPlan.REVIEW, {
	  key: navigationSteps.myPlan.REVIEW,
	  path: _directory.subfolder + '/review',
	  name: 'Review',
	  endpoints: {
	    reviewCart: function reviewCart() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/carts/reviewcart',
	        method: 'POST'
	      };
	    },
	    submitOrder: function submitOrder() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/order/submitorder',
	        method: 'POST'
	      };
	    }
	  },
	  apiNames: []
	}), _defineProperty(_navigationRoutes, navigationSteps.myPlan.CONFIRMATION, {
	  key: navigationSteps.myPlan.CONFIRMATION,
	  path: _directory.subfolder + '/confirmation',
	  name: 'Confirmation',
	  endpoints: {
	    getConfirmation: function getConfirmation() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/confirm/details',
	        method: 'GET'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.myPlan.CHANNELS, {
	  key: navigationSteps.myPlan.CHANNELS,
	  path: _directory.subfolder + '/channels',
	  name: 'Customize Channels',
	  endpoints: {
	    loadOfferByChannels: function loadOfferByChannels() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/offer/channelgroups',
	        method: 'GET'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.myPlan.ADDON_CHANNEL, {
	  key: navigationSteps.myPlan.ADDON_CHANNEL,
	  path: _directory.subfolder + '/addon/channel',
	  name: 'Customize channels',
	  endpoints: {
	    checkEligibility: function checkEligibility(buyflowConsumerType) {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/customers/eligibilities/' + buyflowConsumerType,
	        method: 'GET'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.myPlan.ADDON_EQUIPMENT, {
	  key: navigationSteps.myPlan.ADDON_EQUIPMENT,
	  path: _directory.subfolder + '/addon/equipment',
	  name: 'Customize equipment'
	}), _defineProperty(_navigationRoutes, navigationSteps.myPlan.ADDON_MANAGE_STREAMING_VIDEO, {
	  key: navigationSteps.myPlan.ADDON_MANAGE_STREAMING_VIDEO,
	  path: _directory.subfolder + '/addon/manage-streaming-video',
	  name: 'Manage Streaming Video'
	}), _defineProperty(_navigationRoutes, navigationSteps.myPlan.UPSELL_STREAMING_VIDEO, {
	  key: navigationSteps.myPlan.UPSELL_STREAMING_VIDEO,
	  path: _directory.subfolder + '/addon/streaming-video',
	  name: 'Streaming Video',
	  endpoints: {
	    addToCart: function addToCart() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/carts/offers/streamingVideo',
	        method: 'POST'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.myPlan.CANCEL, {
	  key: navigationSteps.myPlan.CANCEL,
	  path: _directory.subfolder + '/cancel',
	  name: 'Cancel',
	  endpoints: {
	    confirmCart: function confirmCart() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/carts/confirmcart',
	        method: 'POST'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.myPlan.OMNI_LANDING, {
	  key: navigationSteps.myPlan.OMNI_LANDING,
	  path: _directory.subfolder + '/omni-landing',
	  name: 'Omni Landing Page',
	  endpoints: {
	    getPrerequisites: function getPrerequisites() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/omni/prerequisites',
	        method: 'GET'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.myPlan.SPEED, {
	  key: navigationSteps.myPlan.SPEED,
	  path: _directory.subfolder + '/internet-speed',
	  name: 'Customize Internet Speed',
	  endpoints: {
	    loadOfferBySpeed: function loadOfferBySpeed() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/offer/speedgroups',
	        method: 'GET'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.myPlan.OFFERS, {
	  key: navigationSteps.myPlan.OFFERS,
	  path: _directory.subfolder + '/offers',
	  name: 'Customize Offers',
	  endpoints: {
	    loadContent: function loadContent(dataString) {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/offer/byfilter?' + dataString,
	        method: 'GET'
	      };
	    },
	    addOfferToCart: function addOfferToCart() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/cart/offeradd',
	        method: 'POST'
	      };
	    },
	    addDefaultOfferToCart: function addDefaultOfferToCart() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/carts/offers/default',
	        method: 'POST'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.myPlan.OFFERS_FILTER, {
	  key: navigationSteps.myPlan.OFFERS_FILTER,
	  path: _directory.subfolder + '/offersFilter',
	  name: 'Customize Offers'
	}), _defineProperty(_navigationRoutes, navigationSteps.myPlan.CONTACTUS, {
	  key: navigationSteps.myPlan.CONTACTUS,
	  path: _directory.subfolder + '/contact-us',
	  name: 'Contact Us',
	  endpoints: {
	    userInteraction: function userInteraction() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/log/userinteraction',
	        method: 'POST'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.myPlan.MESSAGE, {
	  key: navigationSteps.myPlan.MESSAGE,
	  path: _directory.subfolder + '/message',
	  name: 'Message'
	}), _defineProperty(_navigationRoutes, navigationSteps.myPlan.ERROR, {
	  key: navigationSteps.myPlan.ERROR,
	  path: _directory.subfolder + '/error',
	  name: 'Error',
	  endpoints: {
	    logErrors: function logErrors() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/log/apperror',
	        method: 'POST'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.movers.LOCALIZATION, {
	  key: navigationSteps.movers.LOCALIZATION,
	  path: _directory.subfolder + '/' + _directory.moversFolder + '/localization',
	  name: 'Localization',
	  endpoints: {
	    moveCustomer: function moveCustomer() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/customer/move/moveto',
	        method: 'POST'
	      };
	    },
	    getSuggestions: function getSuggestions(search) {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/move/address-search?search=' + search,
	        method: 'GET'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.movers.UNSERVICEABLE, {
	  key: navigationSteps.movers.UNSERVICEABLE,
	  path: _directory.subfolder + '/' + _directory.moversFolder + '/unserviceable',
	  name: 'Unserviceable',
	  apiNames: [],
	  endpoints: {
	    getBingData: function getBingData(encodedAddressSearch) {
	      return {
	        url: '//dev.virtualearth.net/REST/v1/Locations?query=' + encodedAddressSearch + '&maxResults=1&key=AkMwtnd4qXsRuh77BytvNEuuVfOUuPdyUuaowJeExSCBKk-OBj8YlYTIqCJW2Gom',
	        method: 'GET'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.movers.CANCEL, {
	  key: navigationSteps.movers.CANCEL,
	  path: _directory.subfolder + '/' + _directory.moversFolder + '/cancel',
	  name: 'Cancel',
	  endpoints: {
	    disconnectCustomer: function disconnectCustomer() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/customer/move/disconnect',
	        method: 'POST'
	      };
	    }
	  },
	  apiNames: []
	}), _defineProperty(_navigationRoutes, navigationSteps.movers.SPECIALIST, {
	  key: navigationSteps.movers.SPECIALIST,
	  path: _directory.subfolder + '/' + _directory.moversFolder + '/specialist',
	  name: 'Specialist',
	  endpoints: {
	    submitOrder: function submitOrder() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/checkout/submitorder',
	        method: 'POST'
	      };
	    }
	  },
	  apiNames: []
	}), _defineProperty(_navigationRoutes, navigationSteps.movers.INSTALL, {
	  key: navigationSteps.movers.INSTALL,
	  path: _directory.subfolder + '/' + _directory.moversFolder + '/install',
	  name: 'Install',
	  endpoints: {
	    loadInstall: function loadInstall() {
	      var retrieveTimeSlots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/cart/installation/' + retrieveTimeSlots,
	        method: 'GET'
	      };
	    },
	    confirmSik: function confirmSik() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/cart/installation-sik',
	        method: 'POST'
	      };
	    },
	    confirmPro: function confirmPro() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/cart/installation-pro',
	        method: 'POST'
	      };
	    }
	  },
	  apiNames: []
	}), _defineProperty(_navigationRoutes, navigationSteps.movers.REVIEW, {
	  key: navigationSteps.movers.REVIEW,
	  path: _directory.subfolder + '/' + _directory.moversFolder + '/review',
	  name: 'Review',
	  endpoints: {
	    loadReview: function loadReview() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/move/review',
	        method: 'GET'
	      };
	    },
	    submitOrder: function submitOrder() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/checkout/submitorder',
	        method: 'POST'
	      };
	    }
	  },
	  apiNames: []
	}), _defineProperty(_navigationRoutes, navigationSteps.movers.CONFIRMATION, {
	  key: navigationSteps.movers.CONFIRMATION,
	  path: _directory.subfolder + '/' + _directory.moversFolder + '/confirmation',
	  name: 'Confirmation',
	  endpoints: {
	    loadConfirmation: function loadConfirmation() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/move/confirm',
	        method: 'GET'
	      };
	    }
	  },
	  apiNames: []
	}), _defineProperty(_navigationRoutes, navigationSteps.movers.CONTACTUS, {
	  key: navigationSteps.movers.CONTACTUS,
	  path: _directory.subfolder + '/' + _directory.moversFolder + '/contact-us',
	  name: 'Contact Us',
	  endpoints: {
	    userInteraction: function userInteraction() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/log/userinteraction',
	        method: 'POST'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.movers.CANCELLATION_CONTACTUS, {
	  key: navigationSteps.movers.CANCELLATION_CONTACTUS,
	  path: _directory.subfolder + '/' + _directory.moversFolder + '/cancel/contact-us',
	  name: 'Contact Us',
	  endpoints: {
	    userInteraction: function userInteraction() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/log/userinteraction',
	        method: 'POST'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.movers.ERROR, {
	  key: navigationSteps.movers.ERROR,
	  path: _directory.subfolder + '/' + _directory.moversFolder + '/error',
	  name: 'Error',
	  apiNames: []
	}), _defineProperty(_navigationRoutes, navigationSteps.movers.CANCELLATION_ERROR, {
	  key: navigationSteps.movers.CANCELLATION_ERROR,
	  path: _directory.subfolder + '/' + _directory.moversFolder + '/cancel/error',
	  name: 'Error',
	  apiNames: []
	}), _defineProperty(_navigationRoutes, navigationSteps.quickCheckout.CHECKOUT, {
	  key: navigationSteps.quickCheckout.CHECKOUT,
	  path: _directory.subfolder + '/' + _directory.checkoutFolder,
	  name: 'Checkout',
	  endpoints: {
	    validateProductMapping: function validateProductMapping(tveGoChannelUID) {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/checkout/validateproductmapping?tveGoChannelUID=' + tveGoChannelUID,
	        method: 'GET'
	      };
	    },
	    addDefaultOffer: function addDefaultOffer() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/cart/defaultofferadd',
	        method: 'POST'
	      };
	    },
	    validateCustomerLobAndProduct: function validateCustomerLobAndProduct(shoppingElementId) {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/checkout/validatecustomerlobandproduct?shoppingElementId=' + shoppingElementId,
	        method: 'GET'
	      };
	    },
	    validateProductForQuickcheckout: function validateProductForQuickcheckout(payload) {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/checkout/validateproductforquickcheckout?productName=' + payload.productName + '&checkoutType=' + payload.checkoutType,
	        method: 'GET'
	      };
	    },
	    configureProductToCart: function configureProductToCart(productId) {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/checkout/configureproducttocart?productId=' + productId,
	        method: 'POST'
	      };
	    },
	    analytics: function analytics() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/analytics/quickcheckout?message=',
	        method: 'GET'
	      };
	    }
	  },
	  apiNames: []
	}), _defineProperty(_navigationRoutes, navigationSteps.quickCheckout.REVIEW, {
	  key: navigationSteps.quickCheckout.REVIEW,
	  path: _directory.subfolder + '/' + _directory.checkoutFolder + '/review',
	  name: 'Review',
	  endpoints: {
	    reviewCart: function reviewCart() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/checkout/review',
	        method: 'GET'
	      };
	    },
	    submitOrder: function submitOrder() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/checkout/submitorder',
	        method: 'POST'
	      };
	    }
	  },
	  apiNames: []
	}), _defineProperty(_navigationRoutes, navigationSteps.quickCheckout.CONFIRMATION, {
	  key: navigationSteps.quickCheckout.CONFIRMATION,
	  path: _directory.subfolder + '/' + _directory.checkoutFolder + '/confirmation',
	  name: 'Confirmation',
	  endpoints: {
	    getConfirmation: function getConfirmation() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/confirm/getinfo?confirmationRequest.populateAnalyticsData=true&confirmationRequest.isQuickCheckOut=true',
	        method: 'GET'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.quickCheckout.REDIRECT, {
	  key: navigationSteps.quickCheckout.REDIRECT,
	  path: _directory.subfolder + '/' + _directory.checkoutFolder + '/redirect',
	  name: 'Redirect'
	}), _defineProperty(_navigationRoutes, navigationSteps.quickCheckout.CONTACTUS, {
	  key: navigationSteps.quickCheckout.CONTACTUS,
	  path: _directory.subfolder + '/' + _directory.checkoutFolder + '/contact-us',
	  name: 'Contact Us',
	  endpoints: {
	    userInteraction: function userInteraction() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/log/userinteraction',
	        method: 'POST'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.quickCheckout.ERROR, {
	  key: navigationSteps.quickCheckout.ERROR,
	  path: _directory.subfolder + '/' + _directory.checkoutFolder + '/error',
	  name: 'Sorry',
	  apiNames: []
	}), _defineProperty(_navigationRoutes, navigationSteps.account.ACCOUNT, {
	  key: navigationSteps.account.ACCOUNT,
	  path: _directory.subfolder + '/' + _directory.accountFolder,
	  name: 'Account',
	  endpoints: {
	    getRedirect: function getRedirect() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/customer/accounts',
	        method: 'GET'
	      };
	    }
	  }
	}), _defineProperty(_navigationRoutes, navigationSteps.account.MULTIPLE_ADDRESS, {
	  key: navigationSteps.account.MULTIPLE_ADDRESS,
	  path: _directory.subfolder + '/' + _directory.accountFolder + '/multiple-address',
	  name: 'Multiple Address',
	  endpoints: {
	    getAddresses: function getAddresses() {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/customer/accounts/details',
	        method: 'GET'
	      };
	    },
	    setAddress: function setAddress(accountNumber) {
	      return {
	        url: '' + _endpoints.BASE_URL + _directory.subfolder + '/api/customer/' + accountNumber,
	        method: 'POST'
	      };
	    }
	  }
	}), _navigationRoutes);
	
	var buyFlowUrls = exports.buyFlowUrls = {
	  CUSTOMIZE: '/buy/customize'
	};

/***/ },
/* 12 */
107,
/* 13 */,
/* 14 */
109,
/* 15 */
[1329, 154, 86, 8],
/* 16 */,
/* 17 */
[1290, 12],
/* 18 */
[1308, 6, 330, 53, 17],
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _effects = __webpack_require__(10);
	
	var _loader = __webpack_require__(27);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _helpers = __webpack_require__(77);
	
	var _dataProvider = __webpack_require__(26);
	
	var _dataConfig = __webpack_require__(617);
	
	var _dataConfig2 = _interopRequireDefault(_dataConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var dataProvider = function () {
	  function dataProvider() {
	    _classCallCheck(this, dataProvider);
	  }
	
	  _createClass(dataProvider, [{
	    key: 'load',
	    value: regeneratorRuntime.mark(function load(callConfig, loaderConfig) {
	      var _marked, buildParallelCalls, updateState, state, i, calls, endpoints, endpointData;
	
	      return regeneratorRuntime.wrap(function load$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              updateState = function updateState(endpointData, localCallConfig) {
	                var i;
	                return regeneratorRuntime.wrap(function updateState$(_context3) {
	                  while (1) {
	                    switch (_context3.prev = _context3.next) {
	                      case 0:
	                        i = 0;
	
	                      case 1:
	                        if (!(i < endpointData.length)) {
	                          _context3.next = 11;
	                          break;
	                        }
	
	                        if (!endpointData[i]) {
	                          _context3.next = 7;
	                          break;
	                        }
	
	                        _context3.next = 5;
	                        return (0, _effects.put)((0, _dataProvider.normalizeData)(_lodash2.default.get(localCallConfig[i], 'state'), endpointData[i], {
	                          loaded: true,
	                          persistExpiresAt: (0, _moment2.default)().add(20, 'minute').toDate()
	                        }));
	
	                      case 5:
	                        _context3.next = 8;
	                        break;
	
	                      case 7:
	                        null;
	
	                      case 8:
	                        i++;
	                        _context3.next = 1;
	                        break;
	
	                      case 11:
	                      case 'end':
	                        return _context3.stop();
	                    }
	                  }
	                }, _marked[1], this);
	              };
	
	              buildParallelCalls = function buildParallelCalls(calls, state) {
	                return regeneratorRuntime.wrap(function buildParallelCalls$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        _context2.next = 2;
	                        return (0, _helpers.mapGen)(calls, regeneratorRuntime.mark(function _callee(config) {
	                          var stateKey, stateData, message, spinnerMessage, param, computedParam, alwaysCall;
	                          return regeneratorRuntime.wrap(function _callee$(_context) {
	                            while (1) {
	                              switch (_context.prev = _context.next) {
	                                case 0:
	                                  stateKey = _lodash2.default.get(config, 'state');
	                                  stateData = _lodash2.default.get(state, _lodash2.default.get(config, 'stateCheck', _dataConfig2.default[stateKey].state));
	                                  message = _lodash2.default.get(config, 'spinnerMessage', _dataConfig2.default[stateKey].message);
	
	                                  if (!_lodash2.default.isFunction(message)) {
	                                    _context.next = 9;
	                                    break;
	                                  }
	
	                                  _context.next = 6;
	                                  return message();
	
	                                case 6:
	                                  _context.t0 = _context.sent;
	                                  _context.next = 10;
	                                  break;
	
	                                case 9:
	                                  _context.t0 = message;
	
	                                case 10:
	                                  spinnerMessage = _context.t0;
	                                  param = _lodash2.default.get(config, 'param');
	
	                                  if (!_lodash2.default.isFunction(param)) {
	                                    _context.next = 18;
	                                    break;
	                                  }
	
	                                  _context.next = 15;
	                                  return param();
	
	                                case 15:
	                                  _context.t1 = _context.sent;
	                                  _context.next = 19;
	                                  break;
	
	                                case 18:
	                                  _context.t1 = param;
	
	                                case 19:
	                                  computedParam = _context.t1;
	                                  alwaysCall = _lodash2.default.get(config, 'alwaysCall', false);
	
	                                  if (!(!_lodash2.default.get(stateData, _lodash2.default.get(config, 'loadCheck', 'loaded'), false) || alwaysCall)) {
	                                    _context.next = 25;
	                                    break;
	                                  }
	
	                                  return _context.abrupt('return', (0, _effects.call)(_loader2.default.request, _dataConfig2.default[stateKey].endpoint(computedParam), _extends({ spinnerMessage: spinnerMessage, useGlobalSpinner: false }, loaderConfig)));
	
	                                case 25:
	                                  return _context.abrupt('return', (0, _effects.call)(function () {
	                                    return false;
	                                  }));
	
	                                case 26:
	                                case 'end':
	                                  return _context.stop();
	                              }
	                            }
	                          }, _callee, this);
	                        }));
	
	                      case 2:
	                        return _context2.abrupt('return', _context2.sent);
	
	                      case 3:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _marked[0], this);
	              };
	
	              _marked = [buildParallelCalls, updateState].map(regeneratorRuntime.mark);
	              _context4.next = 5;
	              return (0, _effects.select)();
	
	            case 5:
	              state = _context4.sent;
	              _context4.prev = 6;
	              i = 0;
	
	            case 8:
	              if (!(i < callConfig.length)) {
	                _context4.next = 21;
	                break;
	              }
	
	              calls = _lodash2.default.isArray(callConfig[i]) ? callConfig[i] : [callConfig[i]];
	              _context4.next = 12;
	              return buildParallelCalls(calls, state);
	
	            case 12:
	              endpoints = _context4.sent;
	              _context4.next = 15;
	              return endpoints;
	
	            case 15:
	              endpointData = _context4.sent;
	              _context4.next = 18;
	              return updateState(endpointData, calls);
	
	            case 18:
	              i++;
	              _context4.next = 8;
	              break;
	
	            case 21:
	              return _context4.abrupt('return', true);
	
	            case 24:
	              _context4.prev = 24;
	              _context4.t0 = _context4['catch'](6);
	              return _context4.abrupt('return', false);
	
	            case 27:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, load, this, [[6, 24]]);
	    })
	  }]);
	
	  return dataProvider;
	}();
	
	//Ensure only a singleton is exported
	
	
	var instance = new dataProvider();
	
	exports.default = instance;

/***/ },
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
[1324, 69],
/* 24 */,
/* 25 */
[1325, 46],
/* 26 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var SET_DATA = exports.SET_DATA = 'mp/dataProvider/SET_DATA';
	var NORMALIZE_DATA = exports.NORMALIZE_DATA = 'mp/dataProvider/NORMALIZE_DATA';
	
	var normalizeData = exports.normalizeData = function normalizeData(key, data, meta) {
	  return {
	    type: NORMALIZE_DATA,
	    key: key,
	    data: data,
	    meta: meta
	  };
	};
	
	var setData = exports.setData = function setData(key, payload) {
	  return {
	    type: SET_DATA,
	    key: key,
	    payload: payload
	  };
	};
	
	var getKeyedData = exports.getKeyedData = function getKeyedData(stateKey, actionKey, actionData) {
	  return stateKey !== actionKey ? null : _extends({
	    loaded: true
	  }, actionData);
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.requestConfigKeys = exports.defaults = exports.responseStatus = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(297);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _effects = __webpack_require__(10);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRouter = __webpack_require__(16);
	
	var _overlay = __webpack_require__(191);
	
	var _common = __webpack_require__(7);
	
	var _error = __webpack_require__(198);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _contentProvider = __webpack_require__(74);
	
	var _contentProvider2 = _interopRequireDefault(_contentProvider);
	
	var _dataLayer = __webpack_require__(75);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var responseStatus = exports.responseStatus = {
	  SUCCESS: 'Success',
	  ERROR: 'Error',
	  REDIRECT: 'Redirect',
	  OVERLAY: 'Overlay'
	};
	
	var defaults = exports.defaults = {
	  url: '',
	  method: 'GET',
	  data: undefined,
	  timeout: 150000,
	  useGlobalSpinner: true,
	  hideContentWhileLoading: true,
	  fetchCustomizationTypesIfNotFetched: false,
	  clearPageErrors: true,
	  showPageLevelError: true,
	  spinnerInitiater: 'loader',
	  redirectOnError: true,
	  withCredentials: false,
	  errorPage: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.ERROR].path,
	  spinnerMessage: '',
	  preLoad: function preLoad() {},
	  postLoad: function postLoad() {},
	  postLoadOnError: true,
	  headers: {
	    'access-control-allow-origin': window.location.hostname
	  }
	};
	
	var requestConfigKeys = exports.requestConfigKeys = ['url', 'method', 'data', 'timeout', 'headers', 'withCredentials'];
	
	var Loader = function () {
	  function Loader() {
	    _classCallCheck(this, Loader);
	  }
	
	  _createClass(Loader, [{
	    key: 'request',
	    value: regeneratorRuntime.mark(function request(endpoint, opts) {
	      var _marked, config, requestConfig, redirect, preLoad, postLoad, response, _response, data, status, redirectUrl, externalRedirect, redirecting, errorMessages, _errorMessages;
	
	      return regeneratorRuntime.wrap(function request$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              postLoad = function postLoad(data) {
	                return regeneratorRuntime.wrap(function postLoad$(_context3) {
	                  while (1) {
	                    switch (_context3.prev = _context3.next) {
	                      case 0:
	                        if (!config.useGlobalSpinner) {
	                          _context3.next = 3;
	                          break;
	                        }
	
	                        _context3.next = 3;
	                        return (0, _effects.put)((0, _common.hideGlobalSpinner)(config.spinnerInitiater));
	
	                      case 3:
	                        _context3.next = 5;
	                        return (0, _effects.call)(config.postLoad, data);
	
	                      case 5:
	                      case 'end':
	                        return _context3.stop();
	                    }
	                  }
	                }, _marked[2], this);
	              };
	
	              preLoad = function preLoad() {
	                return regeneratorRuntime.wrap(function preLoad$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        if (!config.useGlobalSpinner) {
	                          _context2.next = 3;
	                          break;
	                        }
	
	                        _context2.next = 3;
	                        return (0, _effects.put)((0, _common.showGlobalSpinner)({ message: config.spinnerMessage, hideContent: config.hideContentWhileLoading, spinnerInitiater: config.spinnerInitiater }));
	
	                      case 3:
	                        if (config.useGlobalSpinner) {
	                          _context2.next = 6;
	                          break;
	                        }
	
	                        _context2.next = 6;
	                        return (0, _effects.put)((0, _common.updateGlobalSpinner)({ message: config.spinnerMessage }));
	
	                      case 6:
	                        if (!config.clearPageErrors) {
	                          _context2.next = 9;
	                          break;
	                        }
	
	                        _context2.next = 9;
	                        return (0, _effects.put)((0, _common.setPageErrors)([]));
	
	                      case 9:
	                        _context2.next = 11;
	                        return (0, _effects.call)(config.preLoad);
	
	                      case 11:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _marked[1], this);
	              };
	
	              redirect = function redirect(redirectUrl, externalRedirect) {
	                return regeneratorRuntime.wrap(function redirect$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (redirectUrl) {
	                          _context.next = 2;
	                          break;
	                        }
	
	                        return _context.abrupt('return', false);
	
	                      case 2:
	                        if (!(redirectUrl.indexOf('/') === 0 && !externalRedirect)) {
	                          _context.next = 6;
	                          break;
	                        }
	
	                        _context.next = 5;
	                        return (0, _effects.call)(_reactRouter.browserHistory.push, redirectUrl);
	
	                      case 5:
	                        return _context.abrupt('return', true);
	
	                      case 6:
	                        if (!(redirectUrl.indexOf('/') === 0 && externalRedirect)) {
	                          _context.next = 9;
	                          break;
	                        }
	
	                        window.location = redirectUrl;
	                        return _context.abrupt('return', true);
	
	                      case 9:
	
	                        window.location = '//' + redirectUrl;
	                        return _context.abrupt('return', true);
	
	                      case 11:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _marked[0], this);
	              };
	
	              _marked = [redirect, preLoad, postLoad].map(regeneratorRuntime.mark);
	              config = Object.assign({}, defaults, opts, endpoint);
	              requestConfig = Object.assign({}, _lodash2.default.pick(config, requestConfigKeys));
	              response = void 0;
	              _context4.next = 9;
	              return (0, _effects.call)(preLoad);
	
	            case 9:
	              _context4.prev = 9;
	              _context4.next = 12;
	              return (0, _effects.call)(_axios2.default, requestConfig);
	
	            case 12:
	              response = _context4.sent;
	              _context4.next = 30;
	              break;
	
	            case 15:
	              _context4.prev = 15;
	              _context4.t0 = _context4['catch'](9);
	              _context4.next = 19;
	              return (0, _effects.put)((0, _common.setError)(_context4.t0));
	
	            case 19:
	              if (!config.postLoadOnError) {
	                _context4.next = 22;
	                break;
	              }
	
	              _context4.next = 22;
	              return (0, _effects.call)(postLoad);
	
	            case 22:
	              if (!config.redirectOnError) {
	                _context4.next = 29;
	                break;
	              }
	
	              _context4.next = 25;
	              return (0, _effects.put)({
	                type: _error.HANDLE_ERROR,
	                errorType: _error.errorTypes.EXCEPTION,
	                endpointUrl: requestConfig.url,
	                content: _context4.t0
	              });
	
	            case 25:
	              _context4.next = 27;
	              return (0, _effects.call)(_reactRouter.browserHistory.push, config.errorPage);
	
	            case 27:
	              _context4.next = 29;
	              return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	            case 29:
	              throw new Error(JSON.stringify(_context4.t0));
	
	            case 30:
	              _response = response, data = _response.data;
	
	              if (!data.analyticsData) {
	                _context4.next = 34;
	                break;
	              }
	
	              _context4.next = 34;
	              return (0, _effects.put)({
	                type: _dataLayer.ANALYTICS_DATA_RECEIVED,
	                payload: { analyticsData: data.analyticsData }
	              });
	
	            case 34:
	              _context4.next = 36;
	              return (0, _effects.call)(postLoad, data);
	
	            case 36:
	              status = data.responseStatus;
	              redirectUrl = data.redirectUrl;
	              externalRedirect = data.externalRedirect;
	              _context4.t1 = status;
	              _context4.next = _context4.t1 === responseStatus.REDIRECT ? 42 : _context4.t1 === responseStatus.ERROR ? 62 : _context4.t1 === responseStatus.OVERLAY ? 70 : _context4.t1 === responseStatus.SUCCESS ? 75 : 75;
	              break;
	
	            case 42:
	              _context4.next = 44;
	              return (0, _effects.call)(redirect, redirectUrl, externalRedirect);
	
	            case 44:
	              redirecting = _context4.sent;
	              _context4.next = 47;
	              return (0, _effects.put)((0, _common.setError)(data));
	
	            case 47:
	              _context4.next = 49;
	              return (0, _effects.put)((0, _common.setPageErrors)([]));
	
	            case 49:
	              if (!data.consumerType) {
	                _context4.next = 52;
	                break;
	              }
	
	              _context4.next = 52;
	              return (0, _effects.put)((0, _common.setConsumerType)(data.consumerType));
	
	            case 52:
	              if (_lodash2.default.isEmpty(data.errors)) {
	                _context4.next = 56;
	                break;
	              }
	
	              errorMessages = data.errors.map(function (error) {
	                return error.errorCode === '' ? error.userMessage : _contentProvider2.default.getValue('errors.' + error.errorCode, [], 'Unmapped error: ' + error.errorCode + ' - field: ' + error.errorField);
	              });
	              _context4.next = 56;
	              return (0, _effects.put)({
	                type: _dataLayer.ANALYTICS_ERRORS_RECEIVED,
	                payload: { errorMessages: errorMessages }
	              });
	
	            case 56:
	              if (!redirecting) {
	                _context4.next = 59;
	                break;
	              }
	
	              _context4.next = 59;
	              return (0, _effects.cancel)();
	
	            case 59:
	              _context4.next = 61;
	              return (0, _effects.call)(_reactRouter.browserHistory.push, config.errorPage);
	
	            case 61:
	              throw new Error('generator error');
	
	            case 62:
	              _errorMessages = data.errors.map(function (error) {
	                return error.errorCode === '' ? error.userMessage : _contentProvider2.default.getValue('errors.' + error.errorCode, [], 'Unmapped error: ' + error.errorCode + ' - field: ' + error.errorField);
	              });
	              _context4.next = 65;
	              return (0, _effects.put)({
	                type: _dataLayer.ANALYTICS_ERRORS_RECEIVED,
	                payload: { errorMessages: _errorMessages }
	              });
	
	            case 65:
	              if (!config.showPageLevelError) {
	                _context4.next = 69;
	                break;
	              }
	
	              // HACK: window.scrollTo isn't scrolling to top
	              document.getElementById('polaris-nav-header-wrapper').scrollIntoView();
	              //yield call(window.scrollTo, 0, 0);
	
	              _context4.next = 69;
	              return (0, _effects.put)((0, _common.setPageErrors)(_errorMessages));
	
	            case 69:
	              throw { error: 'generator error', data: data };
	
	            case 70:
	              _context4.next = 72;
	              return (0, _effects.put)((0, _overlay.setOverlayData)(data.overlay, data.overlayData));
	
	            case 72:
	              _context4.next = 74;
	              return (0, _effects.put)((0, _overlay.setOverlay)(data.overlay, true));
	
	            case 74:
	              throw { error: 'overlay launched', data: data };
	
	            case 75:
	              return _context4.abrupt('return', data);
	
	            case 76:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, request, this, [[9, 15]]);
	    })
	  }]);
	
	  return Loader;
	}();
	
	//Ensure only a singleton is exported
	
	
	var instance = new Loader();
	
	exports.default = instance;

/***/ },
/* 28 */,
/* 29 */
88,
/* 30 */,
/* 31 */
886,
/* 32 */
[1293, 18, 68, 17],
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(8)
	  , hide      = __webpack_require__(32)
	  , has       = __webpack_require__(29)
	  , SRC       = __webpack_require__(86)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(58).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	  , fails   = __webpack_require__(12)
	  , defined = __webpack_require__(46)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ },
/* 35 */
[1323, 126, 46],
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
[1310, 127, 68, 35, 53, 29, 330, 17],
/* 40 */
[1313, 29, 25, 216],
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
232,
/* 46 */
234,
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(12);
	
	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ },
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(59)
	  , IObject  = __webpack_require__(126)
	  , toObject = __webpack_require__(25)
	  , toLength = __webpack_require__(23)
	  , asc      = __webpack_require__(691);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 52 */
[1316, 1, 58, 12],
/* 53 */
[1326, 14],
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
36,
/* 59 */
[1289, 31],
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(346)
	  , $export = __webpack_require__(1)
	  , shared  = __webpack_require__(154)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(349)));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(17)){
	  var LIBRARY             = __webpack_require__(79)
	    , global              = __webpack_require__(8)
	    , fails               = __webpack_require__(12)
	    , $export             = __webpack_require__(1)
	    , $typed              = __webpack_require__(155)
	    , $buffer             = __webpack_require__(223)
	    , ctx                 = __webpack_require__(59)
	    , anInstance          = __webpack_require__(78)
	    , propertyDesc        = __webpack_require__(68)
	    , hide                = __webpack_require__(32)
	    , redefineAll         = __webpack_require__(83)
	    , toInteger           = __webpack_require__(69)
	    , toLength            = __webpack_require__(23)
	    , toIndex             = __webpack_require__(85)
	    , toPrimitive         = __webpack_require__(53)
	    , has                 = __webpack_require__(29)
	    , same                = __webpack_require__(343)
	    , classof             = __webpack_require__(125)
	    , isObject            = __webpack_require__(14)
	    , toObject            = __webpack_require__(25)
	    , isArrayIter         = __webpack_require__(208)
	    , create              = __webpack_require__(80)
	    , getPrototypeOf      = __webpack_require__(40)
	    , gOPN                = __webpack_require__(81).f
	    , getIterFn           = __webpack_require__(225)
	    , uid                 = __webpack_require__(86)
	    , wks                 = __webpack_require__(15)
	    , createArrayMethod   = __webpack_require__(51)
	    , createArrayIncludes = __webpack_require__(145)
	    , speciesConstructor  = __webpack_require__(217)
	    , ArrayIterators      = __webpack_require__(226)
	    , Iterators           = __webpack_require__(103)
	    , $iterDetect         = __webpack_require__(151)
	    , setSpecies          = __webpack_require__(84)
	    , arrayFill           = __webpack_require__(201)
	    , arrayCopyWithin     = __webpack_require__(323)
	    , $DP                 = __webpack_require__(18)
	    , $GOPD               = __webpack_require__(39)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ },
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.check = check;
	exports.hasOwn = hasOwn;
	exports.remove = remove;
	exports.deferred = deferred;
	exports.arrayOfDeffered = arrayOfDeffered;
	exports.delay = delay;
	exports.createMockTask = createMockTask;
	exports.autoInc = autoInc;
	exports.makeIterator = makeIterator;
	exports.log = log;
	exports.deprecate = deprecate;
	exports.wrapSagaDispatch = wrapSagaDispatch;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var sym = exports.sym = function sym(id) {
	  return '@@redux-saga/' + id;
	};
	var TASK = exports.TASK = sym('TASK');
	var HELPER = exports.HELPER = sym('HELPER');
	var MATCH = exports.MATCH = sym('MATCH');
	var CANCEL = exports.CANCEL = sym('cancelPromise');
	var SAGA_ACTION = exports.SAGA_ACTION = sym('SAGA_ACTION');
	var konst = exports.konst = function konst(v) {
	  return function () {
	    return v;
	  };
	};
	var kTrue = exports.kTrue = konst(true);
	var kFalse = exports.kFalse = konst(false);
	var noop = exports.noop = function noop() {};
	var ident = exports.ident = function ident(v) {
	  return v;
	};
	
	var isDev = exports.isDev = ("production") === 'development';
	
	function check(value, predicate, error) {
	  if (!predicate(value)) {
	    log('error', 'uncaught at check', error);
	    throw new Error(error);
	  }
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn(object, property) {
	  return is.notUndef(object) && hasOwnProperty.call(object, property);
	}
	
	var is = exports.is = {
	  undef: function undef(v) {
	    return v === null || v === undefined;
	  },
	  notUndef: function notUndef(v) {
	    return v !== null && v !== undefined;
	  },
	  func: function func(f) {
	    return typeof f === 'function';
	  },
	  number: function number(n) {
	    return typeof n === 'number';
	  },
	  array: Array.isArray,
	  promise: function promise(p) {
	    return p && is.func(p.then);
	  },
	  iterator: function iterator(it) {
	    return it && is.func(it.next) && is.func(it.throw);
	  },
	  task: function task(t) {
	    return t && t[TASK];
	  },
	  observable: function observable(ob) {
	    return ob && is.func(ob.subscribe);
	  },
	  buffer: function buffer(buf) {
	    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
	  },
	  pattern: function pattern(pat) {
	    return pat && (typeof pat === 'string' || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
	  },
	  channel: function channel(ch) {
	    return ch && is.func(ch.take) && is.func(ch.close);
	  },
	  helper: function helper(it) {
	    return it && it[HELPER];
	  },
	  stringableFunc: function stringableFunc(f) {
	    return is.func(f) && hasOwn(f, 'toString');
	  }
	};
	
	function remove(array, item) {
	  var index = array.indexOf(item);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	}
	
	function deferred() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var def = _extends({}, props);
	  var promise = new Promise(function (resolve, reject) {
	    def.resolve = resolve;
	    def.reject = reject;
	  });
	  def.promise = promise;
	  return def;
	}
	
	function arrayOfDeffered(length) {
	  var arr = [];
	  for (var i = 0; i < length; i++) {
	    arr.push(deferred());
	  }
	  return arr;
	}
	
	function delay(ms) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var timeoutId = void 0;
	  var promise = new Promise(function (resolve) {
	    timeoutId = setTimeout(function () {
	      return resolve(val);
	    }, ms);
	  });
	
	  promise[CANCEL] = function () {
	    return clearTimeout(timeoutId);
	  };
	
	  return promise;
	}
	
	function createMockTask() {
	  var _ref;
	
	  var running = true;
	  var _result = void 0,
	      _error = void 0;
	
	  return _ref = {}, _defineProperty(_ref, TASK, true), _defineProperty(_ref, 'isRunning', function isRunning() {
	    return running;
	  }), _defineProperty(_ref, 'result', function result() {
	    return _result;
	  }), _defineProperty(_ref, 'error', function error() {
	    return _error;
	  }), _defineProperty(_ref, 'setRunning', function setRunning(b) {
	    return running = b;
	  }), _defineProperty(_ref, 'setResult', function setResult(r) {
	    return _result = r;
	  }), _defineProperty(_ref, 'setError', function setError(e) {
	    return _error = e;
	  }), _ref;
	}
	
	function autoInc() {
	  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = exports.uid = autoInc();
	
	var kThrow = function kThrow(err) {
	  throw err;
	};
	var kReturn = function kReturn(value) {
	  return { value: value, done: true };
	};
	function makeIterator(next) {
	  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var isHelper = arguments[3];
	
	  var iterator = { name: name, next: next, throw: thro, return: kReturn };
	
	  if (isHelper) {
	    iterator[HELPER] = true;
	  }
	  if (typeof Symbol !== 'undefined') {
	    iterator[Symbol.iterator] = function () {
	      return iterator;
	    };
	  }
	  return iterator;
	}
	
	/**
	  Print error in a useful way whether in a browser environment
	  (with expandable error stack traces), or in a node.js environment
	  (text-only log output)
	 **/
	function log(level, message) {
	  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  /*eslint-disable no-console*/
	  if (typeof window === 'undefined') {
	    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
	  } else {
	    console[level](message, error);
	  }
	}
	
	function deprecate(fn, deprecationWarning) {
	  return function () {
	    if (isDev) log('warn', deprecationWarning);
	    return fn.apply(undefined, arguments);
	  };
	}
	
	var internalErr = exports.internalErr = function internalErr(err) {
	  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
	};
	
	function wrapSagaDispatch(dispatch) {
	  return function sagaDispatch(action) {
	    var wrappedAction = Object.defineProperty(action, SAGA_ACTION, { value: true });
	    return dispatch(wrappedAction);
	  };
	}

/***/ },
/* 67 */
[1305, 86, 14, 29, 18, 12],
/* 68 */
130,
/* 69 */
242,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.contentProvider = exports.inject = exports.Content = exports.PureContent = exports.DEFAULT_VAL = exports.reducer = exports.initialState = exports.UPDATE_CONTENT = exports.SET_CONTENT = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(43);
	
	var _server = __webpack_require__(536);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SET_CONTENT = exports.SET_CONTENT = 'hg/content/SET_CONTENT';
	var UPDATE_CONTENT = exports.UPDATE_CONTENT = 'hg/content/UPDATE_CONTENT';
	
	var initialState = exports.initialState = {
	  content: {},
	  initialized: false,
	  newContent: {}
	};
	
	var reducer = exports.reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	
	    case SET_CONTENT:
	      return _extends({}, state, {
	        content: action.content,
	        initialized: true
	      });
	
	    case UPDATE_CONTENT:
	      return _extends({}, state, {
	        content: action.content,
	        newContent: action.newContent
	      });
	
	    default:
	      return state;
	  }
	};
	
	// default to empty string in prod
	var DEFAULT_VAL = exports.DEFAULT_VAL =  true ? '' : 'DEFAULT_VAL';
	
	var ContentProvider = function () {
	  function ContentProvider() {
	    _classCallCheck(this, ContentProvider);
	  }
	
	  _createClass(ContentProvider, [{
	    key: 'setStore',
	    value: function setStore(store) {
	      // allow passing a custome store for testing with a mocked store
	      this.store = store;
	    }
	  }, {
	    key: 'getStore',
	    value: function getStore() {
	      return this.store;
	    }
	  }, {
	    key: 'setContent',
	    value: function setContent(content) {
	      this.getStore().dispatch({ type: SET_CONTENT, content: content });
	    }
	  }, {
	    key: 'updateContent',
	    value: function updateContent(contentToInject) {
	      var state = this.getStore().getState();
	
	      // prevent content update before content is initialized
	      if (!state.contentProvider.initialized) {
	        return;
	      }
	      var existingNewContent = state.contentProvider.newContent;
	      var newContent = Object.assign({}, existingNewContent, contentToInject);
	      var content = Object.assign({}, this.getContent(), contentToInject);
	
	      this.getStore().dispatch({
	        type: UPDATE_CONTENT,
	        content: content,
	        newContent: newContent
	      });
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      var state = this.getStore().getState();
	
	      if (!state.contentProvider.initialized) {
	        return {};
	      }
	
	      return state.contentProvider.content;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue(key) {
	      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_VAL;
	
	      var content = _lodash2.default.get(this.getContent(), key, defaultValue);
	
	      return inject(content, params);
	    }
	  }]);
	
	  return ContentProvider;
	}();
	
	//IMORTANT: 'key' and 'for' are reserved prop names. Using 'contentKey' instead
	// wrapped the comp in connect to pass the latest content from the store to force re-render on updates. This is a workaround. Not needed in Buyflow
	
	
	var PureContent = exports.PureContent = function PureContent(_ref) {
	  var contentKey = _ref.contentKey,
	      params = _ref.params,
	      defaultValue = _ref.defaultValue;
	
	
	  return (/*eslint-disable react/no-danger*/ //disable dangerouslySetInnerHTML warning
	    _react2.default.createElement(
	      'span',
	      { className: 'content', 'data-content-key': contentKey },
	      _react2.default.createElement('span', { className: 'content-value', dangerouslySetInnerHTML: { __html: contentInstance.getValue(contentKey, params, defaultValue) } }),
	      _react2.default.createElement(
	        'span',
	        { className: 'content-key' },
	        contentKey
	      )
	    )
	  );
	};
	var Content = exports.Content = (0, _reactRedux.connect)(function (state) {
	  return { content: state.contentProvider.content };
	})(function (props) {
	  return _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: contentInstance.getStore() },
	    _react2.default.createElement(PureContent, props)
	  );
	});
	
	PureContent.propTypes = {
	  contentKey: _react.PropTypes.string.isRequired,
	  params: _react.PropTypes.array,
	  defaultValue: _react.PropTypes.string
	};
	
	var inject = exports.inject = function inject(string) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var result = string.replace(/\$\{p(\d)\}/g, function (match, id) {
	    var paramsVal = params[id - 1];
	
	    return _react2.default.isValidElement(paramsVal) ? (0, _server.renderToString)(paramsVal) : paramsVal;
	  });
	
	  return result;
	};
	
	//Ensure only a singleton is exported
	var contentInstance = new ContentProvider();
	
	exports.default = contentInstance;
	var contentProvider = exports.contentProvider = contentInstance;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logUserClick = exports.logCustomEvent = exports.logFormErrors = exports.CUSTOM_EVENT_RECEIVED = exports.ANALYTICS_ERRORS_RECEIVED = exports.ANALYTICS_DATA_RECEIVED = exports.PAGE_LOADED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _helpers = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PAGE_LOADED = exports.PAGE_LOADED = 'hg/dataLayer/PAGE_LOADED';
	var ANALYTICS_DATA_RECEIVED = exports.ANALYTICS_DATA_RECEIVED = 'hg/dataLayer/ANALYTICS_DATA_RECEIVED';
	var ANALYTICS_ERRORS_RECEIVED = exports.ANALYTICS_ERRORS_RECEIVED = 'hg/dataLayer/ANALYTICS_ERRORS_RECEIVED';
	var CUSTOM_EVENT_RECEIVED = exports.CUSTOM_EVENT_RECEIVED = 'hg/dataLayer/CUSTOM_EVENT_RECEIVED';
	
	var initialState = {};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case PAGE_LOADED:
	      return _extends({}, state, action.payload);
	
	    case ANALYTICS_DATA_RECEIVED:
	      return _extends({}, state, action.payload);
	
	    case ANALYTICS_ERRORS_RECEIVED:
	      return _extends({}, state, action.payload);
	
	    case CUSTOM_EVENT_RECEIVED:
	      return _extends({}, state, action.payload);
	
	    default:
	      return state;
	  }
	};
	
	var logFormErrors = exports.logFormErrors = function logFormErrors(errors) {
	  var flatErrors = (0, _helpers.flattenObject)(errors);
	  var errorMessages = _lodash2.default.values(flatErrors);
	
	  return {
	    type: ANALYTICS_ERRORS_RECEIVED,
	    payload: { errorMessages: errorMessages }
	  };
	};
	
	var logCustomEvent = exports.logCustomEvent = function logCustomEvent(eventContent) {
	  return {
	    type: CUSTOM_EVENT_RECEIVED,
	    payload: { eventContent: eventContent }
	  };
	};
	
	var logUserClick = exports.logUserClick = function logUserClick(eventContent) {
	  return logCustomEvent(_extends({
	    type: "click",
	    eventName: "button click"
	  }, eventContent));
	};

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _selectors = __webpack_require__(624);
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});
	var SET_DATA = exports.SET_DATA = 'mp/customer/SET_DATA';
	var initialState = exports.initialState = {
	  loaded: false,
	  customer: {
	    customer: {}
	  }
	};
	
	var customer = exports.customer = function customer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	
	    case SET_DATA:
	      return _extends({}, state, action.payload);
	
	    default:
	      return state;
	  }
	};
	
	exports.default = customer;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.objectContainsNonEmptyArrays = exports.areAllObjPropsFalsy = exports.findInString = exports.noEndingSlash = exports.mapGen = exports.lowerObj = exports.flattenObject = exports.priceToString = exports.detectCreditCard = exports.camelToConstant = exports.cleanJsonInResponse = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _normalization = __webpack_require__(199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// temp solution to change json respons prop case to camelCase (e,g, Name => name)
	//export const cleanJSONProps = obj => _.mapKeys(obj, (v, k) => _.camelCase(k));
	
	var cleanJsonInResponse = exports.cleanJsonInResponse = function cleanJsonInResponse(response) {
	  return JSON.parse(JSON.stringify(response), function (key, value) {
	    if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') for (var k in value) {
	      if (/^[A-Z]/.test(k) && Object.hasOwnProperty.call(value, k)) {
	        value[k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
	        delete value[k];
	      }
	    }
	    return value;
	  });
	};
	
	// converts camelCase to CONSTANT_CASE
	var camelToConstant = exports.camelToConstant = function camelToConstant(str) {
	  return str.replace(/\W+/g, '_').replace(/([a-z\d])([A-Z])/g, '$1_$2').toUpperCase();
	};
	
	var creditCardRegex = {
	  visa: new RegExp('^4[0-9]{0,15}$'),
	  mastercard: new RegExp('^5$|^5[1-5][0-9]{0,14}$'),
	  amex: new RegExp('^3$|^3[47][0-9]{0,13}$'),
	  discover: new RegExp('^6$|^6[05]$|^601[1]?$|^65[0-9][0-9]?$|^6(?:011|5[0-9]{2})[0-9]{0,12}$')
	};
	
	// return an array of card types that matches the passed card number
	var detectCreditCard = exports.detectCreditCard = function detectCreditCard(number) {
	  return Object.keys(creditCardRegex).filter(function (type) {
	    return number && (0, _normalization.removeNonDigits)(number).match(creditCardRegex[type]);
	  });
	};
	
	var priceToString = exports.priceToString = function priceToString() {
	  var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { dollars: '0', cents: '00' };
	  return '$' + amount.dollars + '.' + amount.cents;
	};
	
	//https://gist.github.com/penguinboy/762197
	var flattenObject = exports.flattenObject = function flattenObject(ob) {
	  var toReturn = {};
	
	  for (var i in ob) {
	    if (!ob.hasOwnProperty(i)) continue;
	
	    if (_typeof(ob[i]) == 'object') {
	      var flatObject = flattenObject(ob[i]);
	
	      for (var x in flatObject) {
	        if (!flatObject.hasOwnProperty(x)) continue;
	
	        toReturn[i + '.' + x] = flatObject[x];
	      }
	    } else {
	      toReturn[i] = ob[i];
	    }
	  }
	  return toReturn;
	};
	
	// http://stackoverflow.com/questions/12539574/whats-the-best-way-most-efficient-to-turn-all-the-keys-of-an-object-to-lower
	var lowerObj = exports.lowerObj = function lowerObj(obj) {
	  return _lodash2.default.transform(obj, function (result, val, key) {
	    result[key.toLowerCase()] = val;
	  });
	};
	
	// Array map function that works with yield keyword
	var mapGen = exports.mapGen = regeneratorRuntime.mark(function mapGen(arr, callback, thisArg) {
	  var T,
	      A,
	      k,
	      O,
	      len,
	      kValue,
	      mappedValue,
	      _args = arguments;
	  return regeneratorRuntime.wrap(function mapGen$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          T = void 0, A = void 0, k = void 0;
	
	          if (!(arr == null)) {
	            _context.next = 3;
	            break;
	          }
	
	          throw new TypeError('this is null or not defined');
	
	        case 3:
	          O = Object(arr);
	          len = O.length >>> 0;
	
	          if (!(typeof callback !== 'function')) {
	            _context.next = 7;
	            break;
	          }
	
	          throw new TypeError(callback + ' is not a function');
	
	        case 7:
	
	          if (_args.length > 1) {
	            T = thisArg;
	          }
	
	          A = new Array(len);
	
	          k = 0;
	
	        case 10:
	          if (!(k < len)) {
	            _context.next = 21;
	            break;
	          }
	
	          kValue = void 0, mappedValue = void 0;
	
	          if (!(k in O)) {
	            _context.next = 18;
	            break;
	          }
	
	          kValue = O[k];
	          _context.next = 16;
	          return callback.call(T, kValue, k, O);
	
	        case 16:
	          mappedValue = _context.sent;
	
	          A[k] = mappedValue;
	
	        case 18:
	          k++;
	          _context.next = 10;
	          break;
	
	        case 21:
	          return _context.abrupt('return', A);
	
	        case 22:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, mapGen, this);
	});
	
	// useful for keeping urls uniform
	var noEndingSlash = exports.noEndingSlash = function noEndingSlash(text) {
	  return text[text.length - 1] === '/' ? text.slice(0, -1) : text;
	};
	
	var findInString = exports.findInString = function findInString(string, substring) {
	  if (typeof string !== 'string' && typeof substring !== 'string') {
	    return false;
	  } else {
	    return string.toLowerCase().indexOf(substring) > -1;
	  }
	};
	
	var areAllObjPropsFalsy = exports.areAllObjPropsFalsy = function areAllObjPropsFalsy(items) {
	  return _lodash2.default.reduce(items, function (result, value) {
	    return value ? !!value : result;
	  }, false);
	};
	
	// objectContainsNonEmptyArrays({ a: [], b: ["item"], c: [] })  returns true
	// objectContainsNonEmptyArrays({ a: [], b: [], c: [] })        returns false
	var objectContainsNonEmptyArrays = exports.objectContainsNonEmptyArrays = function objectContainsNonEmptyArrays(object) {
	  return _lodash2.default.some(Object.keys(object), function (key) {
	    return object[key].length > 0;
	  });
	};

/***/ },
/* 78 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ },
/* 79 */
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 80 */
[1307, 6, 336, 204, 216, 203, 206],
/* 81 */
[1312, 338, 204],
/* 82 */
[1315, 338, 204],
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(33);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(8)
	  , dP          = __webpack_require__(18)
	  , DESCRIPTORS = __webpack_require__(17)
	  , SPECIES     = __webpack_require__(15)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 85 */
[1322, 69],
/* 86 */
159,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utils = exports.effects = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;
	
	var _runSaga = __webpack_require__(1274);
	
	Object.defineProperty(exports, 'runSaga', {
	  enumerable: true,
	  get: function get() {
	    return _runSaga.runSaga;
	  }
	});
	
	var _channel = __webpack_require__(185);
	
	Object.defineProperty(exports, 'END', {
	  enumerable: true,
	  get: function get() {
	    return _channel.END;
	  }
	});
	Object.defineProperty(exports, 'eventChannel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.eventChannel;
	  }
	});
	Object.defineProperty(exports, 'channel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.channel;
	  }
	});
	
	var _buffers = __webpack_require__(184);
	
	Object.defineProperty(exports, 'buffers', {
	  enumerable: true,
	  get: function get() {
	    return _buffers.buffers;
	  }
	});
	
	var _sagaHelpers = __webpack_require__(573);
	
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.throttle;
	  }
	});
	
	var _utils = __webpack_require__(66);
	
	Object.defineProperty(exports, 'delay', {
	  enumerable: true,
	  get: function get() {
	    return _utils.delay;
	  }
	});
	Object.defineProperty(exports, 'CANCEL', {
	  enumerable: true,
	  get: function get() {
	    return _utils.CANCEL;
	  }
	});
	
	var _middleware = __webpack_require__(1273);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	var _effects = __webpack_require__(572);
	
	var effects = _interopRequireWildcard(_effects);
	
	var _utils2 = __webpack_require__(1275);
	
	var utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _middleware2.default;
	exports.effects = effects;
	exports.utils = utils;

/***/ },
/* 100 */,
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(15)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(32)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(59)
	  , call        = __webpack_require__(332)
	  , isArrayIter = __webpack_require__(208)
	  , anObject    = __webpack_require__(6)
	  , toLength    = __webpack_require__(23)
	  , getIterFn   = __webpack_require__(225)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ },
/* 103 */
129,
/* 104 */
[1318, 18, 29, 15],
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	  , defined = __webpack_require__(46)
	  , fails   = __webpack_require__(12)
	  , spaces  = __webpack_require__(221)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ },
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toggleChannelDetails = exports.toggleDetails = exports.plan = exports.initialState = exports.TOGGLE_CHANNEL = exports.TOGGLE_DETAILS = exports.SET_DATA = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _planSelectors = __webpack_require__(630);
	
	Object.keys(_planSelectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _planSelectors[key];
	    }
	  });
	});
	
	var _planHelpers = __webpack_require__(628);
	
	var SET_DATA = exports.SET_DATA = 'mp/plan/SET_DATA';
	var TOGGLE_DETAILS = exports.TOGGLE_DETAILS = 'mp/plan/TOGGLE_DETAILS';
	var TOGGLE_CHANNEL = exports.TOGGLE_CHANNEL = 'mp/plan/TOGGLE_CHANNEL';
	
	var initialState = exports.initialState = {
	  loaded: false,
	  isPlanAvailable: true,
	  servicePackages: {},
	  currentPlan: {},
	  totalAmount: {},
	  channels: [],
	  additionalServices: [],
	  charges: {},
	  equipment: [],
	  eligibility: {},
	  addAdjustCapability: {},
	  lobs: {
	    TV: {
	      serviceName: "XFINITY TV"
	    },
	    Internet: {
	      serviceName: "XFINITY Internet"
	    },
	    Voice: {
	      serviceName: "XFINITY Voice"
	    },
	    Home: {
	      serviceName: "XFINITY Home Security"
	    }
	  }
	};
	
	var plan = exports.plan = function plan() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	
	    case SET_DATA:
	      return _extends({}, state, action.payload);
	
	    case TOGGLE_DETAILS:
	      {
	        return _extends({}, state, {
	          servicePackages: {
	            packages: (0, _planHelpers.handleToggle)(state.servicePackages.packages, action.planName)
	          }
	        });
	      }
	
	    case TOGGLE_CHANNEL:
	      {
	        return _extends({}, state, {
	          channels: (0, _planHelpers.handleToggle)(state.channels, action.channelName)
	        });
	      }
	
	    default:
	      return state;
	  }
	};
	
	var toggleDetails = exports.toggleDetails = function toggleDetails(planName) {
	  return {
	    type: TOGGLE_DETAILS,
	    planName: planName
	  };
	};
	
	var toggleChannelDetails = exports.toggleChannelDetails = function toggleChannelDetails(channelName) {
	  return {
	    type: TOGGLE_CHANNEL,
	    channelName: channelName
	  };
	};
	
	exports.default = plan;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _quickCheckoutSelectors = __webpack_require__(631);
	
	Object.keys(_quickCheckoutSelectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _quickCheckoutSelectors[key];
	    }
	  });
	});
	var SET_DATA = exports.SET_DATA = 'mp/quickCheckout/SET_DATA';
	
	var initialState = exports.initialState = {
	  quickCheckout: {}
	};
	
	var quickCheckout = exports.quickCheckout = function quickCheckout() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	
	    case SET_DATA:
	      return _extends({}, state, action.payload);
	
	    default:
	      return state;
	  }
	};
	
	var setQuickCheckoutData = exports.setQuickCheckoutData = function setQuickCheckoutData(productData) {
	  return {
	    type: SET_DATA,
	    payload: {
	      quickCheckout: productData
	    }
	  };
	};
	
	exports.default = quickCheckout;

/***/ },
/* 125 */
[1287, 45, 15],
/* 126 */
[1296, 45],
/* 127 */
157,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var KEY_PREFIX = exports.KEY_PREFIX = 'reduxPersist:';
	var REHYDRATE = exports.REHYDRATE = 'persist/REHYDRATE';

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reviewSelectors = __webpack_require__(306);
	
	Object.keys(_reviewSelectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reviewSelectors[key];
	    }
	  });
	});
	
	var _reviewHelpers = __webpack_require__(305);
	
	Object.keys(_reviewHelpers).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reviewHelpers[key];
	    }
	  });
	});
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'hg/review/LOAD_CONTENT';
	var CONFIRM = exports.CONFIRM = 'hg/review/CONFIRM';
	var SET_CONTENT = exports.SET_CONTENT = 'hg/review/SET_CONTENT';
	var SELECT_OPTION = exports.SELECT_OPTION = 'hg/review/SELECT_OPTION';
	var SET_REF_NUM = exports.SET_REF_NUM = 'hg/review/SET_REF_NUM';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'hg/review/DL_PAGE_LOADED';
	var DL_PAGE_FAILED = exports.DL_PAGE_FAILED = 'hg/review/DL_PAGE_FAILED';
	var SET_DATA = exports.SET_DATA = 'mp/review/SET_DATA';
	var SUBMIT_ORDER = exports.SUBMIT_ORDER = 'hg/review/SUBMIT_ORDER';
	
	var CHECKOUT_TYPE_PPV = exports.CHECKOUT_TYPE_PPV = 'QuickCheckoutPPV';
	var CHECKOUT_TYPE_DEFAULT = exports.CHECKOUT_TYPE_DEFAULT = 'QuickCheckout';
	
	// TODO: when the endpoint is ready, replace this dummy content with an empty object
	var initialState = exports.initialState = {
	  loaded: false,
	  content: {
	    "review": {
	      "flowEntryLink": {
	        "entryPointUrl": "/buy/plan",
	        "entryPointName": "Back to My Plan"
	      },
	      currentMonthlyTotalCharges: {},
	      reviewChargesSection: {
	        "monthlyChargesSection": {
	          "allPrices": {},
	          "reviewItems": {},
	          "reviewSubItems": {
	            "premiumChannels": [],
	            "equipment": []
	          }
	        },
	        "oneTimeChargesSection": {
	          "allPrices": {
	            "prices": [{
	              "amount": {
	                "dollars": "25",
	                "cents": "00"
	              },
	              "isOneTime": false,
	              "isIncluded": false,
	              "priceType": "OneTime"
	            }],
	            "isIncluded": false
	          },
	          "reviewItems": {}
	        }
	      },
	      reviewSummary: {
	        "newMonthlyTotalCharges": {
	          "allPrices": {
	            "prices": [],
	            "isIncluded": false
	          }
	        },
	        "oneTimeTotalCharges": {}
	      },
	      "contracts": [],
	      "verifications": []
	    }
	  }
	};
	
	var review = exports.review = function review() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	
	    case SET_CONTENT:
	      return _extends({}, state, {
	        content: action.payload.content.review
	      });
	
	    case SET_REF_NUM:
	      return _extends({}, state, {
	        refNum: action.refNum
	      });
	
	    case SELECT_OPTION:
	      return _extends({}, state, {
	        selectedOption: action.option
	      });
	
	    case SET_DATA:
	      return _extends({}, state, action.payload);
	
	    default:
	      return state;
	  }
	};
	
	// Action Creators
	var setRefNum = exports.setRefNum = function setRefNum(refNum) {
	  return {
	    type: SET_REF_NUM,
	    refNum: refNum
	  };
	};
	
	var selectOption = exports.selectOption = function selectOption(paymentOption) {
	  return {
	    type: SELECT_OPTION,
	    option: paymentOption
	  };
	};
	
	var loadContent = exports.loadContent = function loadContent() {
	  return {
	    type: LOAD_CONTENT
	  };
	};
	
	var confirm = exports.confirm = function confirm() {
	  return {
	    type: CONFIRM
	  };
	};
	
	var submitOrder = exports.submitOrder = function submitOrder(salesSessionId) {
	  return {
	    type: SUBMIT_ORDER,
	    salesSessionId: salesSessionId
	  };
	};
	
	exports.default = review;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setSelectedTimeSlot = exports.showFetchingSpinner = exports.hideFetchingSpinner = exports.confirmInstall = exports.selectPro = exports.selectSik = exports.setTimeslots = exports.updateInstallationOption = exports.setData = exports.loadContent = exports.moversInstall = exports.PRO_INSTALL_OPTION = exports.SIK_INSTALL_OPTION = exports.DL_PAGE_LOADED = exports.HIDE_FETCHING_SPINNER = exports.SHOW_FETCHING_SPINNER = exports.SET_TIMESLOTS = exports.SET_DATA = exports.UPDATE_OPTION = exports.CONFIRM_INSTALL = exports.SELECT_PRO = exports.SELECT_SIK = exports.LOAD_CONTENT = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _installSelectors = __webpack_require__(639);
	
	Object.keys(_installSelectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _installSelectors[key];
	    }
	  });
	});
	
	var _reduxForm = __webpack_require__(44);
	
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'mp/movers/install/LOAD_CONTENT';
	var SELECT_SIK = exports.SELECT_SIK = 'mp/movers/install/SELECT_SIK';
	var SELECT_PRO = exports.SELECT_PRO = 'mp/movers/install/SELECT_PRO';
	var CONFIRM_INSTALL = exports.CONFIRM_INSTALL = 'mp/movers/install/CONFIRM_INSTALL';
	var UPDATE_OPTION = exports.UPDATE_OPTION = 'mp/movers/install/UPDATE_OPTION';
	var SET_DATA = exports.SET_DATA = 'mp/movers/install/SET_DATA';
	var SET_TIMESLOTS = exports.SET_TIMESLOTS = 'mp/movers/install/SET_TIMESLOTS';
	var SHOW_FETCHING_SPINNER = exports.SHOW_FETCHING_SPINNER = 'mp/movers/install/SHOW_FETCHING_SPINNER';
	var HIDE_FETCHING_SPINNER = exports.HIDE_FETCHING_SPINNER = 'mp/movers/install/HIDE_FETCHING_SPINNER';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'mp/movers/install/DL_PAGE_LOADED';
	
	var SIK_INSTALL_OPTION = exports.SIK_INSTALL_OPTION = 'selfInstallation';
	var PRO_INSTALL_OPTION = exports.PRO_INSTALL_OPTION = 'professionalInstallation';
	
	var initialState = {
	  content: {},
	  selectedOption: '',
	  timeSlotsFetching: false
	};
	
	var moversInstall = exports.moversInstall = function moversInstall() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case SET_DATA:
	      return _extends({}, state, action.payload);
	
	    case UPDATE_OPTION:
	      return _extends({}, state, {
	        selectedOption: action.payload
	      });
	
	    case SET_TIMESLOTS:
	      return _extends({}, state, {
	        content: _extends({}, state.content, {
	          professionalInstallation: _extends({}, state.content.professionalInstallation, action.payload)
	        })
	      });
	
	    case HIDE_FETCHING_SPINNER:
	      return _extends({}, state, {
	        timeSlotsFetching: false
	      });
	
	    case SHOW_FETCHING_SPINNER:
	      return _extends({}, state, {
	        timeSlotsFetching: true
	      });
	
	    default:
	      return state;
	  }
	};
	
	var loadContent = exports.loadContent = function loadContent() {
	  return {
	    type: LOAD_CONTENT
	  };
	};
	
	var setData = exports.setData = function setData(data) {
	  return {
	    type: SET_DATA,
	    payload: data
	  };
	};
	
	var updateInstallationOption = exports.updateInstallationOption = function updateInstallationOption(option) {
	  return {
	    type: UPDATE_OPTION,
	    payload: option
	  };
	};
	
	var setTimeslots = exports.setTimeslots = function setTimeslots(timeslots) {
	  return {
	    type: SET_TIMESLOTS,
	    payload: timeslots
	  };
	};
	
	var selectSik = exports.selectSik = function selectSik() {
	  return {
	    type: SELECT_SIK
	  };
	};
	
	var selectPro = exports.selectPro = function selectPro() {
	  return {
	    type: SELECT_PRO
	  };
	};
	
	var confirmInstall = exports.confirmInstall = function confirmInstall() {
	  return {
	    type: CONFIRM_INSTALL
	  };
	};
	
	var hideFetchingSpinner = exports.hideFetchingSpinner = function hideFetchingSpinner() {
	  return {
	    type: HIDE_FETCHING_SPINNER
	  };
	};
	
	var showFetchingSpinner = exports.showFetchingSpinner = function showFetchingSpinner() {
	  return {
	    type: SHOW_FETCHING_SPINNER
	  };
	};
	
	/* Likely belongs in helpers */
	var setSelectedTimeSlot = exports.setSelectedTimeSlot = function setSelectedTimeSlot(timeSlot) {
	  return (0, _reduxForm.change)('install', 'selectedTimeSlot', timeSlot);
	};
	
	exports.default = moversInstall;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _src = __webpack_require__(676);
	
	Object.keys(_src).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _src[key];
	    }
	  });
	});

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createValidator = exports.afterDisconnectDate = exports.validateDateRange = exports.validDate = exports.equalsFieldValue = exports.oneOf = exports.integer = exports.maxLength = exports.meetsCondition = exports.equal = exports.matchOrBlank = exports.match = exports.minLength = exports.required = exports.email = exports.validateCCExpirationDate = exports.isConditionalFieldMatching = exports.numRegex = exports.zipCodeRegex = exports.stateRegex = exports.cityRegex = exports.unitNumberRegex = exports.streetAddressRegex = exports.expirationYearRegex = exports.expirationMonthRegex = exports.creditCardRegex = exports.cvvRegex = exports.ssnRegex = exports.emailRegex = exports.phoneRegex = exports.nameRegex = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nameRegex = exports.nameRegex = /^[a-zA-Z\-\,\.\' ]{1,30}$/;
	var phoneRegex = exports.phoneRegex = /^\(?([0-9]{3})\)?[- ]?([0-9]{3})[- ]?([0-9]{4})$/;
	var emailRegex = exports.emailRegex = /^([a-zA-Z0-9_\-\.]{0,}([a-zA-Z0-9_\-]){1})@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,3}|com|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum|[0-9]{1,3})(\]?)$/;
	var ssnRegex = exports.ssnRegex = /^\(?([0-9]{3})\)?[- ]?([0-9]{2})[- ]?([0-9]{4})$/;
	var cvvRegex = exports.cvvRegex = /^[0-9]{3,4}$/;
	var creditCardRegex = exports.creditCardRegex = /^\d{4} *\d{4} *\d{4} *\d{1,4}$/;
	var expirationMonthRegex = exports.expirationMonthRegex = /^[0-9]{2}$/;
	var expirationYearRegex = exports.expirationYearRegex = /^[0-9]{4}$/;
	var streetAddressRegex = exports.streetAddressRegex = /^.{1,50}$/;
	var unitNumberRegex = exports.unitNumberRegex = /^.{0,10}$/;
	var cityRegex = exports.cityRegex = /^[a-zA-Z][a-zA-Z ]*$/;
	var stateRegex = exports.stateRegex = /[a-zA-Z]{2}$/;
	var zipCodeRegex = exports.zipCodeRegex = /^\d{5}$/;
	var numRegex = exports.numRegex = /^\d{9}$/;
	
	var isEmpty = function isEmpty(value) {
	  return value === undefined || value === null || value === '';
	};
	var join = function join(rules) {
	  return function (value, data) {
	    return rules.map(function (rule) {
	      return rule(value, data);
	    }).filter(function (error) {
	      return !!error;
	    })[0 /* first error */];
	  };
	};
	
	var isConditionalFieldMatching = exports.isConditionalFieldMatching = function isConditionalFieldMatching(data) {
	  var fieldGroups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [[]];
	
	  return fieldGroups.some(function (fieldGroup) {
	    return fieldGroup.every(function (field) {
	      if (!isEmpty(field.value) && !isEmpty(field.name) && field.value === _lodash2.default.get(data, field.name)) {
	        return true;
	      }
	    });
	  });
	};
	
	var validateCCExpirationDate = exports.validateCCExpirationDate = function validateCCExpirationDate() {
	  var errorMsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Please enter a valid value';
	  var fieldGroups = arguments[1];
	
	
	  return function (value, data) {
	    value = value || '';
	    var expirationMonth = parseInt(_lodash2.default.get(data, "creditCardDetails.expirationMonth"));
	    var currentMonth = parseInt(data["currentMonth"]);
	    var expirationYear = parseInt(_lodash2.default.get(data, "creditCardDetails.expirationYear"));
	    var currentYear = parseInt(data["currentYear"]);
	
	    if (!expirationYear || !currentMonth || !currentYear) {
	      return;
	    }
	
	    if (isConditionalFieldMatching(data, fieldGroups) && expirationMonth < currentMonth && expirationYear <= currentYear) {
	      return errorMsg;
	    }
	  };
	};
	
	var email = exports.email = function email() {
	  var errorMsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Invalid email address';
	
	  return function (value) {
	    if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
	      return errorMsg;
	    }
	  };
	};
	
	var required = exports.required = function required() {
	  var errorMsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Required';
	  var fieldGroups = arguments[1];
	
	  return function (value, data) {
	    if (isConditionalFieldMatching(data, fieldGroups) && isEmpty(value)) {
	      return errorMsg;
	    }
	  };
	};
	
	var minLength = exports.minLength = function minLength(min) {
	  return function (value) {
	    if (!isEmpty(value) && value.length < min) {
	      return 'Must be at least ' + min + ' characters';
	    }
	  };
	};
	
	// conditionalFields us used when validation
	// is conditional based on the value of other fields
	var match = exports.match = function match(regex) {
	  var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Please enter a valid value';
	  var fieldGroups = arguments[2];
	
	  return function (value, data) {
	    value = value || '';
	    if (isConditionalFieldMatching(data, fieldGroups) && !regex.test(value)) {
	      return errorMsg;
	    }
	  };
	};
	
	var matchOrBlank = exports.matchOrBlank = function matchOrBlank(regex) {
	  var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Please enter a valid value';
	  var fieldGroups = arguments[2];
	
	  return function (value, data) {
	    if (!!value && isConditionalFieldMatching(data, fieldGroups) && !regex.test(value)) {
	      return errorMsg;
	    }
	  };
	};
	
	var equal = exports.equal = function equal(valueToMatch) {
	  var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Please enter a valid value';
	  var fieldGroups = arguments[2];
	
	  return function (value, data) {
	    value = value || '';
	    if (isConditionalFieldMatching(data, fieldGroups) && valueToMatch !== value) {
	      return errorMsg;
	    }
	  };
	};
	
	var meetsCondition = exports.meetsCondition = function meetsCondition(check) {
	  var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Please enter a valid value';
	  var fieldGroups = arguments[2];
	
	  return function (value, data) {
	    if (isConditionalFieldMatching(data, fieldGroups) && check(value) !== true) {
	      return errorMsg;
	    }
	  };
	};
	
	var maxLength = exports.maxLength = function maxLength(max) {
	  return function (value) {
	    if (!isEmpty(value) && value.length > max) {
	      return 'Must be no more than ' + max + ' characters';
	    }
	  };
	};
	
	var integer = exports.integer = function integer(value) {
	  if (!Number.isInteger(Number(value))) {
	    return 'Must be an integer';
	  }
	};
	
	var oneOf = exports.oneOf = function oneOf(enumeration) {
	  return function (value) {
	    if (!~enumeration.indexOf(value)) {
	      return 'Must be one of: ' + enumeration.join(', ');
	    }
	  };
	};
	
	var equalsFieldValue = exports.equalsFieldValue = function equalsFieldValue(field) {
	  return function (value, data) {
	    if (data) {
	      if (value !== data[field]) {
	        return 'Do not match';
	      }
	    }
	  };
	};
	
	var validDate = exports.validDate = function validDate() {
	  var errorMsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Please enter a valid date';
	
	  return function (value) {
	    var compareMoment = (0, _moment2.default)(value);
	
	    if (!compareMoment.isValid()) {
	      return errorMsg;
	    }
	  };
	};
	
	var validateDateRange = exports.validateDateRange = function validateDateRange() {
	  var errorMsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'The selected time';
	
	  return function (value, data) {
	    var compareMoment = (0, _moment2.default)(value);
	    var startDate = _lodash2.default.get(data, "startDate");
	    var endDate = _lodash2.default.get(data, "endDate");
	    var startDateFormatted = (0, _moment2.default)(startDate).format('M/DD/YYYY');
	    var endDateFormatted = (0, _moment2.default)(endDate).format('M/DD/YYYY');
	
	    if (!compareMoment.isBetween(startDateFormatted, endDateFormatted, null, '[]')) {
	      return errorMsg + ' needs to be after ' + startDateFormatted + ' and before ' + endDateFormatted;
	    }
	  };
	};
	
	var afterDisconnectDate = exports.afterDisconnectDate = function afterDisconnectDate() {
	  var errorMsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Please enter a valid date';
	
	  return function (value, data) {
	    var compareMoment = (0, _moment2.default)(value);
	    var serviceStopDate = _lodash2.default.get(data, "serviceStopDate");
	    var serviceStopDateFormatted = (0, _moment2.default)(serviceStopDate).format('M/DD/YYYY');
	
	    if (compareMoment.isBefore(serviceStopDateFormatted)) {
	      return errorMsg;
	    }
	  };
	};
	
	var createValidator = exports.createValidator = function createValidator(rules) {
	  return function () {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var errors = {};
	
	    Object.keys(rules).forEach(function (key) {
	      var rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
	      var error = rule(_lodash2.default.get(data, key), data);
	
	      if (error) {
	        _lodash2.default.set(errors, key, error);
	      }
	    });
	    // USE FOR TROUBLESHOOTING
	    // EXPOSED IN PROPS.ERROR IN DECORATED CONTAINERS
	    //  _.set(errors, '_error', errors);
	    return errors;
	  };
	};

/***/ },
/* 145 */
[1286, 35, 23, 85],
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(8)
	  , $export           = __webpack_require__(1)
	  , redefine          = __webpack_require__(33)
	  , redefineAll       = __webpack_require__(83)
	  , meta              = __webpack_require__(67)
	  , forOf             = __webpack_require__(102)
	  , anInstance        = __webpack_require__(78)
	  , isObject          = __webpack_require__(14)
	  , fails             = __webpack_require__(12)
	  , $iterDetect       = __webpack_require__(151)
	  , setToStringTag    = __webpack_require__(104)
	  , inheritIfRequired = __webpack_require__(207);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(32)
	  , redefine = __webpack_require__(33)
	  , fails    = __webpack_require__(12)
	  , defined  = __webpack_require__(46)
	  , wks      = __webpack_require__(15);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(6);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ },
/* 149 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(14)
	  , cof      = __webpack_require__(45)
	  , MATCH    = __webpack_require__(15)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },
/* 151 */
[1303, 15],
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(79)|| !__webpack_require__(12)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(8)[K];
	});

/***/ },
/* 153 */
238,
/* 154 */
[1320, 8],
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8)
	  , hide   = __webpack_require__(32)
	  , uid    = __webpack_require__(86)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ },
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buffers = exports.BUFFER_OVERFLOW = undefined;
	
	var _utils = __webpack_require__(66);
	
	var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = 'Channel\'s Buffer overflow!';
	
	var ON_OVERFLOW_THROW = 1;
	var ON_OVERFLOW_DROP = 2;
	var ON_OVERFLOW_SLIDE = 3;
	var ON_OVERFLOW_EXPAND = 4;
	
	var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };
	
	function ringBuffer() {
	  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
	  var overflowAction = arguments[1];
	
	  var arr = new Array(limit);
	  var length = 0;
	  var pushIndex = 0;
	  var popIndex = 0;
	
	  var push = function push(it) {
	    arr[pushIndex] = it;
	    pushIndex = (pushIndex + 1) % limit;
	    length++;
	  };
	
	  var take = function take() {
	    if (length != 0) {
	      var it = arr[popIndex];
	      arr[popIndex] = null;
	      length--;
	      popIndex = (popIndex + 1) % limit;
	      return it;
	    }
	  };
	
	  var flush = function flush() {
	    var items = [];
	    while (length) {
	      items.push(take());
	    }
	    return items;
	  };
	
	  return {
	    isEmpty: function isEmpty() {
	      return length == 0;
	    },
	    put: function put(it) {
	      if (length < limit) {
	        push(it);
	      } else {
	        var doubledLimit = void 0;
	        switch (overflowAction) {
	          case ON_OVERFLOW_THROW:
	            throw new Error(BUFFER_OVERFLOW);
	          case ON_OVERFLOW_SLIDE:
	            arr[pushIndex] = it;
	            pushIndex = (pushIndex + 1) % limit;
	            popIndex = pushIndex;
	            break;
	          case ON_OVERFLOW_EXPAND:
	            doubledLimit = 2 * limit;
	
	            arr = flush();
	
	            length = arr.length;
	            pushIndex = arr.length;
	            popIndex = 0;
	
	            arr.length = doubledLimit;
	            limit = doubledLimit;
	
	            push(it);
	            break;
	          default:
	          // DROP
	        }
	      }
	    },
	    take: take, flush: flush
	  };
	}
	
	var buffers = exports.buffers = {
	  none: function none() {
	    return zeroBuffer;
	  },
	  fixed: function fixed(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_THROW);
	  },
	  dropping: function dropping(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_DROP);
	  },
	  sliding: function sliding(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
	  },
	  expanding: function expanding(initialSize) {
	    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
	  }
	};

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.emitter = emitter;
	exports.channel = channel;
	exports.eventChannel = eventChannel;
	exports.stdChannel = stdChannel;
	
	var _utils = __webpack_require__(66);
	
	var _buffers = __webpack_require__(184);
	
	var _scheduler = __webpack_require__(574);
	
	var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
	var END = exports.END = { type: CHANNEL_END_TYPE };
	var isEnd = exports.isEnd = function isEnd(a) {
	  return a && a.type === CHANNEL_END_TYPE;
	};
	
	function emitter() {
	  var subscribers = [];
	
	  function subscribe(sub) {
	    subscribers.push(sub);
	    return function () {
	      return (0, _utils.remove)(subscribers, sub);
	    };
	  }
	
	  function emit(item) {
	    var arr = subscribers.slice();
	    for (var i = 0, len = arr.length; i < len; i++) {
	      arr[i](item);
	    }
	  }
	
	  return {
	    subscribe: subscribe,
	    emit: emit
	  };
	}
	
	var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';
	var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';
	
	if (false) {
	  exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
	}
	
	function channel() {
	  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers.buffers.fixed();
	
	  var closed = false;
	  var takers = [];
	
	  (0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);
	
	  function checkForbiddenStates() {
	    if (closed && takers.length) {
	      throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');
	    }
	    if (takers.length && !buffer.isEmpty()) {
	      throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');
	    }
	  }
	
	  function put(input) {
	    checkForbiddenStates();
	    (0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);
	    if (closed) {
	      return;
	    }
	    if (!takers.length) {
	      return buffer.put(input);
	    }
	    for (var i = 0; i < takers.length; i++) {
	      var cb = takers[i];
	      if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {
	        takers.splice(i, 1);
	        return cb(input);
	      }
	    }
	  }
	
	  function take(cb) {
	    checkForbiddenStates();
	    (0, _utils.check)(cb, _utils.is.func, 'channel.take\'s callback must be a function');
	
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	    } else if (!buffer.isEmpty()) {
	      cb(buffer.take());
	    } else {
	      takers.push(cb);
	      cb.cancel = function () {
	        return (0, _utils.remove)(takers, cb);
	      };
	    }
	  }
	
	  function flush(cb) {
	    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
	    (0, _utils.check)(cb, _utils.is.func, 'channel.flush\' callback must be a function');
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	      return;
	    }
	    cb(buffer.flush());
	  }
	
	  function close() {
	    checkForbiddenStates();
	    if (!closed) {
	      closed = true;
	      if (takers.length) {
	        var arr = takers;
	        takers = [];
	        for (var i = 0, len = arr.length; i < len; i++) {
	          arr[i](END);
	        }
	      }
	    }
	  }
	
	  return { take: take, put: put, flush: flush, close: close,
	    get __takers__() {
	      return takers;
	    },
	    get __closed__() {
	      return closed;
	    }
	  };
	}
	
	function eventChannel(subscribe) {
	  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers.buffers.none();
	  var matcher = arguments[2];
	
	  /**
	    should be if(typeof matcher !== undefined) instead?
	    see PR #273 for a background discussion
	  **/
	  if (arguments.length > 2) {
	    (0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');
	  }
	
	  var chan = channel(buffer);
	  var unsubscribe = subscribe(function (input) {
	    if (isEnd(input)) {
	      chan.close();
	      return;
	    }
	    if (matcher && !matcher(input)) {
	      return;
	    }
	    chan.put(input);
	  });
	
	  if (!_utils.is.func(unsubscribe)) {
	    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
	  }
	
	  return {
	    take: chan.take,
	    flush: chan.flush,
	    close: function close() {
	      if (!chan.__closed__) {
	        chan.close();
	        unsubscribe();
	      }
	    }
	  };
	}
	
	function stdChannel(subscribe) {
	  var chan = eventChannel(function (cb) {
	    return subscribe(function (input) {
	      if (input[_utils.SAGA_ACTION]) {
	        cb(input);
	        return;
	      }
	      (0, _scheduler.asap)(function () {
	        return cb(input);
	      });
	    });
	  });
	
	  return _extends({}, chan, {
	    take: function take(cb, matcher) {
	      if (arguments.length > 1) {
	        (0, _utils.check)(matcher, _utils.is.func, 'channel.take\'s matcher argument must be a function');
	        cb[_utils.MATCH] = matcher;
	      }
	      chan.take(cb);
	    }
	  });
	}

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.asEffect = exports.takem = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.take = take;
	exports.put = put;
	exports.race = race;
	exports.call = call;
	exports.apply = apply;
	exports.cps = cps;
	exports.fork = fork;
	exports.spawn = spawn;
	exports.join = join;
	exports.cancel = cancel;
	exports.select = select;
	exports.actionChannel = actionChannel;
	exports.cancelled = cancelled;
	exports.flush = flush;
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	exports.throttle = throttle;
	
	var _utils = __webpack_require__(66);
	
	var _sagaHelpers = __webpack_require__(573);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var IO = (0, _utils.sym)('IO');
	var TAKE = 'TAKE';
	var PUT = 'PUT';
	var RACE = 'RACE';
	var CALL = 'CALL';
	var CPS = 'CPS';
	var FORK = 'FORK';
	var JOIN = 'JOIN';
	var CANCEL = 'CANCEL';
	var SELECT = 'SELECT';
	var ACTION_CHANNEL = 'ACTION_CHANNEL';
	var CANCELLED = 'CANCELLED';
	var FLUSH = 'FLUSH';
	
	var deprecationWarning = function deprecationWarning(deprecated, preferred) {
	  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
	};
	
	var effect = function effect(type, payload) {
	  var _ref;
	
	  return _ref = {}, _defineProperty(_ref, IO, true), _defineProperty(_ref, type, payload), _ref;
	};
	
	function take() {
	  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';
	
	  if (arguments.length) {
	    (0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
	  }
	  if (_utils.is.pattern(patternOrChannel)) {
	    return effect(TAKE, { pattern: patternOrChannel });
	  }
	  if (_utils.is.channel(patternOrChannel)) {
	    return effect(TAKE, { channel: patternOrChannel });
	  }
	  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
	}
	
	take.maybe = function () {
	  var eff = take.apply(undefined, arguments);
	  eff[TAKE].maybe = true;
	  return eff;
	};
	
	var takem = exports.takem = (0, _utils.deprecate)(take.maybe, deprecationWarning('takem', 'take.maybe'));
	
	function put(channel, action) {
	  if (arguments.length > 1) {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');
	    (0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
	    (0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');
	  } else {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');
	    action = channel;
	    channel = null;
	  }
	  return effect(PUT, { channel: channel, action: action });
	}
	
	put.resolve = function () {
	  var eff = put.apply(undefined, arguments);
	  eff[PUT].resolve = true;
	  return eff;
	};
	
	put.sync = (0, _utils.deprecate)(put.resolve, deprecationWarning('put.sync', 'put.resolve'));
	
	function race(effects) {
	  return effect(RACE, effects);
	}
	
	function getFnCallDesc(meth, fn, args) {
	  (0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');
	
	  var context = null;
	  if (_utils.is.array(fn)) {
	    var _fn = fn;
	
	    var _fn2 = _slicedToArray(_fn, 2);
	
	    context = _fn2[0];
	    fn = _fn2[1];
	  } else if (fn.fn) {
	    var _fn3 = fn;
	    context = _fn3.context;
	    fn = _fn3.fn;
	  }
	  (0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');
	
	  return { context: context, fn: fn, args: args };
	}
	
	function call(fn) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return effect(CALL, getFnCallDesc('call', fn, args));
	}
	
	function apply(context, fn) {
	  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
	}
	
	function cps(fn) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return effect(CPS, getFnCallDesc('cps', fn, args));
	}
	
	function fork(fn) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    args[_key3 - 1] = arguments[_key3];
	  }
	
	  return effect(FORK, getFnCallDesc('fork', fn, args));
	}
	
	function spawn(fn) {
	  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    args[_key4 - 1] = arguments[_key4];
	  }
	
	  var eff = fork.apply(undefined, [fn].concat(args));
	  eff[FORK].detached = true;
	  return eff;
	}
	
	var isForkedTask = function isForkedTask(task) {
	  return task[_utils.TASK];
	};
	
	function join(task) {
	  if (_utils.is.array(task)) {
	    return task.map(join);
	  }
	  (0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');
	  if (!isForkedTask(task)) {
	    throw new Error('join(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
	  }
	
	  return effect(JOIN, task);
	}
	
	function cancel(task) {
	  (0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');
	  if (!isForkedTask(task)) {
	    throw new Error('cancel(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
	  }
	
	  return effect(CANCEL, task);
	}
	
	function select(selector) {
	  for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    args[_key5 - 1] = arguments[_key5];
	  }
	
	  if (arguments.length === 0) {
	    selector = _utils.ident;
	  } else {
	    (0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');
	    (0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');
	  }
	  return effect(SELECT, { selector: selector, args: args });
	}
	
	/**
	  channel(pattern, [buffer])    => creates an event channel for store actions
	**/
	function actionChannel(pattern, buffer) {
	  (0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
	  if (arguments.length > 1) {
	    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
	    (0, _utils.check)(buffer, _utils.is.buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
	  }
	  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
	}
	
	function cancelled() {
	  return effect(CANCELLED, {});
	}
	
	function flush(channel) {
	  (0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');
	  return effect(FLUSH, channel);
	}
	
	function takeEvery(patternOrChannel, worker) {
	  for (var _len6 = arguments.length, args = Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
	    args[_key6 - 2] = arguments[_key6];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.takeEveryHelper, patternOrChannel, worker].concat(args));
	}
	
	function takeLatest(patternOrChannel, worker) {
	  for (var _len7 = arguments.length, args = Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
	    args[_key7 - 2] = arguments[_key7];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.takeLatestHelper, patternOrChannel, worker].concat(args));
	}
	
	function throttle(ms, pattern, worker) {
	  for (var _len8 = arguments.length, args = Array(_len8 > 3 ? _len8 - 3 : 0), _key8 = 3; _key8 < _len8; _key8++) {
	    args[_key8 - 3] = arguments[_key8];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.throttleHelper, ms, pattern, worker].concat(args));
	}
	
	var createAsEffectType = function createAsEffectType(type) {
	  return function (effect) {
	    return effect && effect[IO] && effect[type];
	  };
	};
	
	var asEffect = exports.asEffect = {
	  take: createAsEffectType(TAKE),
	  put: createAsEffectType(PUT),
	  race: createAsEffectType(RACE),
	  call: createAsEffectType(CALL),
	  cps: createAsEffectType(CPS),
	  fork: createAsEffectType(FORK),
	  join: createAsEffectType(JOIN),
	  cancel: createAsEffectType(CANCEL),
	  select: createAsEffectType(SELECT),
	  actionChannel: createAsEffectType(ACTION_CHANNEL),
	  cancelled: createAsEffectType(CANCELLED),
	  flush: createAsEffectType(FLUSH)
	};

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(118).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187).setImmediate, __webpack_require__(187).clearImmediate))

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _selectors = __webpack_require__(621);
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});
	var SET_DATA = exports.SET_DATA = 'mp/confirmation/SET_DATA';
	
	
	// TODO: when the endpoint is ready, replace this dummy content with an empty object
	var initialState = exports.initialState = {
	  loaded: false,
	  content: {}
	};
	
	var confirmation = exports.confirmation = function confirmation() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case SET_DATA:
	      return _extends({}, state, action.payload);
	
	    default:
	      return state;
	  }
	};
	
	exports.default = confirmation;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hideMobileFilters = exports.toggleMobileFilters = exports.updateSort = exports.updatePrice = exports.clearSubFilters = exports.updateSubFilter = exports.updateFilter = exports.addOfferToCart = exports.setOffers = exports.offers = exports.initialState = exports.HIDE_MOBILEFILTERS = exports.TOGGLE_MOBILEFILTERS = exports.ADD_OFFER = exports.UPDATE_SORT = exports.UPDATE_PRICE = exports.CLEAR_SUBFILTERS = exports.UPDATE_SUBFILTER = exports.UPDATE_FILTER = exports.SET_OFFERS = exports.SET_DATA = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _offersHelpers = __webpack_require__(190);
	
	Object.keys(_offersHelpers).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _offersHelpers[key];
	    }
	  });
	});
	
	var _filterSelectors = __webpack_require__(304);
	
	Object.keys(_filterSelectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _filterSelectors[key];
	    }
	  });
	});
	
	var _sortSelectors = __webpack_require__(627);
	
	Object.keys(_sortSelectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _sortSelectors[key];
	    }
	  });
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var SET_DATA = exports.SET_DATA = 'mp/offers/SET_DATA';
	var SET_OFFERS = exports.SET_OFFERS = 'mp/offers/SET_OFFERS';
	var UPDATE_FILTER = exports.UPDATE_FILTER = 'mp/offers/UPDATE_FILTER';
	var UPDATE_SUBFILTER = exports.UPDATE_SUBFILTER = 'mp/offers/UPDATE_SUBFILTER';
	var CLEAR_SUBFILTERS = exports.CLEAR_SUBFILTERS = 'mp/offers/CLEAR_SUBFILTERS';
	var UPDATE_PRICE = exports.UPDATE_PRICE = 'mp/offers/UPDATE_PRICE';
	var UPDATE_SORT = exports.UPDATE_SORT = 'mp/offers/UPDATE_SORT';
	var ADD_OFFER = exports.ADD_OFFER = 'mp/offers/ADD_OFFER';
	var TOGGLE_MOBILEFILTERS = exports.TOGGLE_MOBILEFILTERS = 'mp/offers/TOGGLE_MOBILEFILTERS';
	var HIDE_MOBILEFILTERS = exports.HIDE_MOBILEFILTERS = 'mp/offers/HIDE_MOBILEFILTERS';
	
	var initialState = exports.initialState = {
	  loaded: false,
	  offerData: [],
	  localized: true,
	  mobileFilters: {
	    open: false,
	    hidden: false
	  },
	  filterData: [{
	    lob: {
	      name: "LinesOfBusiness",
	      label: "TV",
	      id: "lob-tv",
	      value: "TV",
	      selected: false,
	      order: 1
	    }
	  }, {
	    lob: {
	      name: "LinesOfBusiness",
	      label: "Internet",
	      id: "lob-internet",
	      value: "Internet",
	      selected: false,
	      order: 2
	    }
	  }, {
	    lob: {
	      name: "LinesOfBusiness",
	      label: "Phone",
	      id: "lob-voice",
	      value: "Voice",
	      selected: false,
	      order: 3
	    }
	  }, {
	    lob: {
	      name: "LinesOfBusiness",
	      label: "Home Security",
	      id: "lob-home",
	      value: "Home",
	      selected: false,
	      order: 4
	    }
	  }, {
	    name: "Monthly Price Range",
	    legend: "Monthly Price Range",
	    isSlider: true,
	    options: [{
	      name: "Price",
	      min: 0,
	      max: 0,
	      step: 1,
	      value: 0,
	      lowerValue: 0,
	      message: "Pricing does not include equipment, installation, taxes and fees, and other applicable charges.",
	      id: "Price",
	      label: "Monthly Price Range"
	    }]
	  }],
	  sortItems: [{
	    id: null,
	    label: "Price",
	    options: [{
	      key: "priceValue",
	      type: "numeric",
	      dir: "asc",
	      name: "Price: Low to High"
	    }, {
	      key: "priceValue",
	      type: "numeric",
	      dir: "desc",
	      name: "Price: High to Low"
	    }],
	    LOB: null
	  }, {
	    id: "sort-tv",
	    label: "TV",
	    options: [{
	      key: "tvPackage.numberOfChannels",
	      type: "numeric",
	      dir: "desc",
	      name: "Most Channels"
	    }],
	    LOB: "lob-tv"
	  }, {
	    id: "sort-hsd",
	    label: "Internet",
	    options: [{
	      key: "internetPackage.internetDownloadSpeedMbps",
	      type: "numeric",
	      dir: "desc",
	      name: "Fastest Speeds"
	    }],
	    LOB: "lob-internet"
	  }],
	  currentSort: ['priceValue', 'asc'],
	  sortTitle: "Sort Your Options",
	  channelLineupLogos: {
	    All: ["cinemax", "hbo", "showtime", "starz"],
	    "Limited Basic": [],
	    "Digital Economy": [],
	    "Digital Preferred": ["cinemax", "starz", "hbo", "showtime"],
	    "Digital Premier": ["cinemax", "hbo", "showtime", "starz"],
	    "Digital Premium": [],
	    "Digital Starter": [],
	    "Xfinity Tv 200 Latino": [],
	    "Xfinity Tv 300 Latino": [],
	    "Xfinity Tv 450 Latino": []
	  },
	  offerCardGigabitLearnMoreUrl: '',
	  enableDefaultLobs: false,
	  showOffersForLobs: {}
	};
	
	var offers = exports.offers = function offers() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case SET_DATA:
	      {
	
	        var filterDataLobs = action.payload.enableDefaultLobs ? action.payload.filterData : [].concat(_toConsumableArray(state.filterData.slice(0, 4)), _toConsumableArray(action.payload.filterData));
	
	        return _extends({}, state, action.payload, {
	          filterData: [].concat(_toConsumableArray(filterDataLobs))
	        });
	      }
	
	    case SET_OFFERS:
	      {
	        return _extends({}, state, {
	          loaded: true,
	          offerData: action.offers.offers,
	          offerCount: action.offers.offerCount,
	          offerMinimumPrice: action.offers.offerMinimumPrice,
	          offerCardGigabitLearnMoreUrl: action.offers.offerCardGigabitLearnMoreUrl,
	          filterData: action.offers.filters,
	          enableDynamicLobSelection: action.offers.enableDynamicLobSelection
	        });
	      }
	    case UPDATE_FILTER:
	      return _extends({}, state, {
	        filterData: [].concat(_toConsumableArray(state.filterData.slice(0, action.index)), [_extends({}, state.filterData[action.index], {
	          lob: _extends({}, state.filterData[action.index].lob, {
	            selected: action.selected
	          })
	        })], _toConsumableArray(state.filterData.slice(action.index + 1)))
	      });
	    case UPDATE_SUBFILTER:
	      {
	        var filterIndex = _lodash2.default.findIndex(state.filterData, ['options[0].name', action.filterName]);
	        var optionIndex = _lodash2.default.findIndex(state.filterData[filterIndex].options[0].options, ['id', action.optionId]);
	
	        return _extends({}, state, {
	          filterData: [].concat(_toConsumableArray(state.filterData.slice(0, filterIndex)), [_extends({}, state.filterData[filterIndex], {
	            options: [_extends({}, state.filterData[filterIndex].options[0], {
	              options: [].concat(_toConsumableArray(state.filterData[filterIndex].options[0].options.slice(0, optionIndex)), [_extends({}, state.filterData[filterIndex].options[0].options[optionIndex], {
	                selected: action.selected
	              })], _toConsumableArray(state.filterData[filterIndex].options[0].options.slice(optionIndex + 1)))
	            })]
	          })], _toConsumableArray(state.filterData.slice(filterIndex + 1)))
	        });
	      }
	    case CLEAR_SUBFILTERS:
	      {
	        return _extends({}, state, {
	          filterData: state.filterData.map(function (filter) {
	            return _extends({}, filter, {
	              options: filter.options && filter.options.map(function (option) {
	                return _extends({}, option, {
	                  options: option.options && option.options.map(function (subOption) {
	                    return _extends({}, subOption, {
	                      selected: false
	                    });
	                  })
	                });
	              })
	            });
	          })
	        });
	      }
	    case UPDATE_PRICE:
	      {
	        var _filterIndex = _lodash2.default.findIndex(state.filterData, ['options[0].name', action.filterName]);
	
	        return _extends({}, state, {
	          filterData: [].concat(_toConsumableArray(state.filterData.slice(0, _filterIndex)), [_extends({}, state.filterData[_filterIndex], {
	            options: [_extends({}, state.filterData[_filterIndex].options[0], {
	              value: action.value,
	              lowerValue: action.lowerValue
	            })]
	          })], _toConsumableArray(state.filterData.slice(_filterIndex + 1)))
	        });
	      }
	    case UPDATE_SORT:
	      {
	        return _extends({}, state, {
	          currentSort: action.selected
	        });
	      }
	    case TOGGLE_MOBILEFILTERS:
	      {
	        return _extends({}, state, {
	          mobileFilters: _extends({}, state.mobileFilters, {
	            open: !state.mobileFilters.open
	          })
	        });
	      }
	    case HIDE_MOBILEFILTERS:
	      {
	        return _extends({}, state, {
	          mobileFilters: _extends({}, state.mobileFilters, {
	            hidden: !state.mobileFilters.hidden
	          })
	        });
	      }
	    default:
	      return state;
	  }
	};
	
	var setOffers = exports.setOffers = function setOffers(offers) {
	  return {
	    type: SET_OFFERS,
	    offers: offers
	  };
	};
	
	var addOfferToCart = exports.addOfferToCart = function addOfferToCart(offer, force, currentLOBs) {
	  return {
	    type: ADD_OFFER,
	    force: force,
	    overlayName: offer.overlayName,
	    currentLOBs: currentLOBs,
	    offer: {
	      offerId: offer.id || offer.offerId,
	      offerLOBs: _lodash2.default.join(offer.linesOfBusiness, '|') || offer.offerLOBs
	    }
	  };
	};
	
	var updateFilter = exports.updateFilter = function updateFilter(selected, index) {
	  return {
	    type: UPDATE_FILTER,
	    selected: selected,
	    index: index
	  };
	};
	
	var updateSubFilter = exports.updateSubFilter = function updateSubFilter(selected, filterName, optionId) {
	  return {
	    type: UPDATE_SUBFILTER,
	    selected: selected,
	    filterName: filterName,
	    optionId: optionId
	  };
	};
	
	var clearSubFilters = exports.clearSubFilters = function clearSubFilters() {
	  return {
	    type: CLEAR_SUBFILTERS
	  };
	};
	
	var updatePrice = exports.updatePrice = function updatePrice(filterName, value, lowerValue) {
	  return {
	    type: UPDATE_PRICE,
	    filterName: filterName,
	    value: value,
	    lowerValue: lowerValue
	  };
	};
	
	var updateSort = exports.updateSort = function updateSort(selected) {
	  return {
	    type: UPDATE_SORT,
	    selected: selected
	  };
	};
	
	var toggleMobileFilters = exports.toggleMobileFilters = function toggleMobileFilters() {
	  return {
	    type: TOGGLE_MOBILEFILTERS
	  };
	};
	
	var hideMobileFilters = exports.hideMobileFilters = function hideMobileFilters() {
	  return {
	    type: HIDE_MOBILEFILTERS
	  };
	};
	
	exports.default = offers;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.roundFloor = exports.roundValue = exports.lobString = exports.formatOffersForDataLayer = exports.LobValuesfromAggregate = exports.aggregateOffers = exports.extractPrice = exports.errorListDataSelector = exports.overlayDataSelector = exports.overlaySelector = exports.localizedSelector = exports.offersFlowTypeSelector = exports.offerSelector = undefined;
	
	var _reselect = __webpack_require__(38);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var offerSelector = exports.offerSelector = function offerSelector(state) {
	  return state.offers.offerData;
	};
	var offersFlowTypeSelector = exports.offersFlowTypeSelector = function offersFlowTypeSelector(state) {
	  return state.offers.flowType;
	};
	var localizedSelector = exports.localizedSelector = function localizedSelector(state) {
	  return state.offers.localized;
	};
	var overlaySelector = exports.overlaySelector = function overlaySelector(state) {
	  return state.overlay.overlays;
	};
	var overlayDataSelector = exports.overlayDataSelector = function overlayDataSelector(state) {
	  return state.overlay.overlayData;
	};
	
	var errorListDataSelector = exports.errorListDataSelector = (0, _reselect.createSelector)(overlayDataSelector, function (overlayData) {
	  return _lodash2.default.get(overlayData, 'errorOverlay.errorList', []);
	});
	
	var extractPrice = exports.extractPrice = function extractPrice(price) {
	  var amount = _lodash2.default.get(_lodash2.default.head(price.prices), 'amount');
	  var amountNumber = parseFloat(amount.dollars + '.' + amount.cents);
	
	  return amountNumber;
	};
	
	var aggregateOffers = exports.aggregateOffers = function aggregateOffers(processedOffers) {
	  // group all related offers
	  var processedIds = [];
	
	  return _lodash2.default.compact(processedOffers.map(function (offer) {
	    if (_lodash2.default.indexOf(processedIds, offer.id) !== -1) {
	      return null;
	    }
	
	    var relatedOffers = [];
	
	    relatedOffers = _lodash2.default.union([offer], _lodash2.default.filter(processedOffers, _lodash2.default.flow(_lodash2.default.property('relatedOffers'), _lodash2.default.partialRight(_lodash2.default.some, { id: offer.id }))));
	
	    _lodash2.default.forEach(relatedOffers, function (offer) {
	      return processedIds.push(offer.id);
	    }); // eslint-disable-line lodash/prefer-map
	
	    return relatedOffers;
	  }));
	};
	
	var LobValuesfromAggregate = exports.LobValuesfromAggregate = function LobValuesfromAggregate(offers) {
	  return _lodash2.default.isEmpty(offers) ? [] : _lodash2.default.head(_lodash2.default.head(offers)).linesOfBusiness;
	};
	
	var formatOffersForDataLayer = exports.formatOffersForDataLayer = function formatOffersForDataLayer(offers) {
	  return _lodash2.default.map(offers, function (offer) {
	    var tierKeys = Object.keys(offer.metadata).filter(function (key) {
	      return key.slice(-5) === "_TIER";
	    });
	    var lobSummary = function lobSummary(lobs) {
	      var uncapsLobs = _lodash2.default.map(lobs, function (lob) {
	        return lob.toLowerCase();
	      });
	
	      if (uncapsLobs.length === 4) {
	        return 'quad play|' + uncapsLobs.join('|');
	      } else if (uncapsLobs.length === 3) {
	        return 'triple play|' + uncapsLobs.join('|');
	      } else if (uncapsLobs.length === 2) {
	        return 'double play|' + uncapsLobs.join('|');
	      } else {
	        return uncapsLobs[0];
	      }
	    };
	
	    return {
	      productID: offer.id,
	      LOB: lobSummary(offer.linesOfBusiness),
	      system: "SCMS",
	      tier: tierKeys.map(function (tierKey) {
	        return offer.metadata[tierKey];
	      }).join('/') || ""
	    };
	  });
	};
	
	var lobString = exports.lobString = function lobString(lobs) {
	
	  var summaryTitle = '';
	
	  if (!_lodash2.default.isEmpty(lobs)) {
	    var initialLobs = _lodash2.default.initial(lobs).join(', ');
	
	    summaryTitle = _lodash2.default.isEmpty(initialLobs) ? summaryTitle : ' ' + initialLobs;
	    summaryTitle = _lodash2.default.size(lobs) <= 1 ? summaryTitle : summaryTitle + ' and';
	    summaryTitle = _lodash2.default.trim(summaryTitle + ' ' + _lodash2.default.last(lobs));
	  }
	
	  return summaryTitle;
	};
	
	var roundValue = exports.roundValue = function roundValue(number, nearest) {
	  return Math.round(number / nearest) * nearest;
	};
	var roundFloor = exports.roundFloor = function roundFloor(number, nearest) {
	  return Math.floor(number / nearest) * nearest;
	};

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setOverlayData = exports.setAllOverlays = exports.setOverlay = exports.overlay = exports.initialState = exports.SET_OVERLAY_DATA = exports.SET_ALL_OVERLAYS = exports.SET_OVERLAY = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _overlaySelectors = __webpack_require__(633);
	
	Object.keys(_overlaySelectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _overlaySelectors[key];
	    }
	  });
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SET_OVERLAY = exports.SET_OVERLAY = 'mp/overlay/SET_OVERLAY';
	var SET_ALL_OVERLAYS = exports.SET_ALL_OVERLAYS = 'mp/overlay/SET_ALL_OVERLAYS';
	var SET_OVERLAY_DATA = exports.SET_OVERLAY_DATA = 'mp/overlay/SET_OVERLAY_DATA';
	var initialState = exports.initialState = {
	  overlays: {},
	  overlayData: {}
	};
	
	var overlay = exports.overlay = function overlay() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	
	    case SET_OVERLAY:
	      return _extends({}, state, {
	        overlays: _extends({}, state.overlays, action.payload.overlays)
	      });
	
	    case SET_ALL_OVERLAYS:
	      return _extends({}, state, {
	        overlays: action.payload.overlays
	      });
	
	    case SET_OVERLAY_DATA:
	      return _extends({}, state, {
	        overlayData: _extends({}, state.overlayData, action.payload.overlayData)
	      });
	
	    default:
	      return state;
	  }
	};
	
	var setOverlay = exports.setOverlay = function setOverlay(key, status) {
	  return {
	    type: SET_OVERLAY,
	    payload: {
	      overlays: _defineProperty({}, key, status)
	    }
	  };
	};
	
	var setAllOverlays = exports.setAllOverlays = function setAllOverlays(overlays, value) {
	  var overlaysWithNewValues = _lodash2.default.mapValues(overlays, function () {
	    return value;
	  });
	
	  return {
	    type: SET_ALL_OVERLAYS,
	    payload: {
	      overlays: overlaysWithNewValues
	    }
	  };
	};
	
	var setOverlayData = exports.setOverlayData = function setOverlayData(key, data) {
	  var _overlayData;
	
	  return {
	    type: SET_OVERLAY_DATA,
	    payload: {
	      overlayData: (_overlayData = {}, _defineProperty(_overlayData, key, data), _defineProperty(_overlayData, 'overlayName', key), _overlayData)
	    }
	  };
	};
	
	exports.default = overlay;

/***/ },
/* 192 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'hg/accountMultipleAddress/LOAD_CONTENT';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'hg/accountMultipleAddress/DL_PAGE_LOADED';
	var SET_DATA = exports.SET_DATA = 'hg/accountMultipleAddress/SET_DATA';
	var SET_ADDRESS = exports.SET_ADDRESS = 'hg/accountMultipleAddress/SET_ADDRESS';
	
	var initialState = {
	  customerBillingAccounts: []
	};
	
	var accountMultipleAddress = exports.accountMultipleAddress = function accountMultipleAddress() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case SET_DATA:
	      return _extends({}, state, {
	        customerBillingAccounts: action.payload.customerBillingAccounts
	      });
	
	    default:
	      return state;
	  }
	};
	
	var loadContent = exports.loadContent = function loadContent() {
	  return {
	    type: LOAD_CONTENT
	  };
	};
	
	var setAddress = exports.setAddress = function setAddress(accountNumber) {
	  return {
	    type: SET_ADDRESS,
	    accountNumber: accountNumber
	  };
	};
	
	exports.default = accountMultipleAddress;

/***/ },
/* 193 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'hg/moversConfirmation/LOAD_CONTENT';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'hg/moversConfirmation/DL_PAGE_LOADED';
	var SET_DATA = exports.SET_DATA = 'hg/moversConfirmation/SET_DATA';
	
	var initialState = {
	  content: {
	    currentEquipment: {
	      equipments: []
	    }
	  }
	};
	
	var moversConfirmation = exports.moversConfirmation = function moversConfirmation() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case SET_DATA:
	      return _extends({}, state, action.payload);
	
	    default:
	      return state;
	  }
	};
	
	var loadContent = exports.loadContent = function loadContent() {
	  return {
	    type: LOAD_CONTENT
	  };
	};
	
	exports.default = moversConfirmation;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.touchFields = exports.selectSuggestion = exports.getSuggestions = exports.moveCustomer = exports.loadCustomer = exports.DL_PAGE_LOADED = exports.SELECT_SUGGESTION = exports.GET_SUGGESTIONS = exports.MOVE_CUSTOMER = exports.SET_CUSTOMER = exports.LOAD_CUSTOMER = undefined;
	
	var _localizationHelpers = __webpack_require__(640);
	
	Object.keys(_localizationHelpers).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _localizationHelpers[key];
	    }
	  });
	});
	
	var _reduxForm = __webpack_require__(44);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var LOAD_CUSTOMER = exports.LOAD_CUSTOMER = 'mp/moving/LOAD_CUSTOMER';
	var SET_CUSTOMER = exports.SET_CUSTOMER = 'mp/moving/SET_CUSTOMER';
	var MOVE_CUSTOMER = exports.MOVE_CUSTOMER = 'mp/moving/MOVE_CUSTOMER';
	var GET_SUGGESTIONS = exports.GET_SUGGESTIONS = 'mp/moving/GET_SUGGESTIONS';
	var SELECT_SUGGESTION = exports.SELECT_SUGGESTION = 'mp/moving/SELECT_SUGGESTION';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'mp/movers/localization/DL_PAGE_LOADED';
	
	var loadCustomer = exports.loadCustomer = function loadCustomer() {
	  return {
	    type: LOAD_CUSTOMER
	  };
	};
	var moveCustomer = exports.moveCustomer = function moveCustomer() {
	  return {
	    type: MOVE_CUSTOMER
	  };
	};
	var getSuggestions = exports.getSuggestions = function getSuggestions(search) {
	  return {
	    type: GET_SUGGESTIONS,
	    payload: {
	      search: search
	    }
	  };
	};
	
	var selectSuggestion = exports.selectSuggestion = function selectSuggestion(suggestion) {
	  return {
	    type: SELECT_SUGGESTION,
	    payload: {
	      suggestion: suggestion
	    }
	  };
	};
	
	var touchFields = exports.touchFields = function touchFields() {
	  return function (dispatch) {
	    dispatch(_reduxForm.untouch.apply(undefined, ['movers'].concat(_toConsumableArray(_localizationHelpers.fields))));
	    dispatch(_reduxForm.touch.apply(undefined, ['movers'].concat(_toConsumableArray(_localizationHelpers.fields))));
	  };
	};

/***/ },
/* 195 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'hg/moversReview/LOAD_CONTENT';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'hg/moversReview/DL_PAGE_LOADED';
	var SET_DATA = exports.SET_DATA = 'hg/moversReview/SET_DATA';
	var SUBMIT_ORDER = exports.SUBMIT_ORDER = 'hg/moversReview/SUBMIT_ORDER';
	
	var initialState = {
	  content: {
	    currentEquipment: {
	      equipments: []
	    }
	  }
	};
	
	var moversReview = exports.moversReview = function moversReview() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case SET_DATA:
	      return _extends({}, state, action.payload);
	
	    default:
	      return state;
	  }
	};
	
	var loadContent = exports.loadContent = function loadContent() {
	  return {
	    type: LOAD_CONTENT
	  };
	};
	
	var submitOrder = exports.submitOrder = function submitOrder() {
	  return {
	    type: SUBMIT_ORDER
	  };
	};
	
	exports.default = moversReview;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //export * from './reviewSelectors';
	
	//export * from './reviewHelpers';
	
	
	var _reviewSelectors = __webpack_require__(306);
	
	Object.keys(_reviewSelectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reviewSelectors[key];
	    }
	  });
	});
	
	var _reviewHelpers = __webpack_require__(305);
	
	Object.keys(_reviewHelpers).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reviewHelpers[key];
	    }
	  });
	});
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'mp/review/LOAD_CONTENT';
	var CONFIRM = exports.CONFIRM = 'hg/review/CONFIRM';
	var SET_CONTENT = exports.SET_CONTENT = 'hg/review/SET_CONTENT';
	var SELECT_OPTION = exports.SELECT_OPTION = 'hg/review/SELECT_OPTION';
	var SET_REF_NUM = exports.SET_REF_NUM = 'hg/review/SET_REF_NUM';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'mp/review/DL_PAGE_LOADED';
	var DL_PAGE_FAILED = exports.DL_PAGE_FAILED = 'mp/review/DL_PAGE_FAILED';
	var SET_DATA = exports.SET_DATA = 'mp/review/SET_DATA';
	var SUBMIT_ORDER = exports.SUBMIT_ORDER = 'mp/review/SUBMIT_ORDER';
	
	var CHECKOUT_TYPE_PPV = exports.CHECKOUT_TYPE_PPV = 'QuickCheckoutPPV';
	var CHECKOUT_TYPE_DEFAULT = exports.CHECKOUT_TYPE_DEFAULT = 'QuickCheckout';
	
	// TODO: when the endpoint is ready, replace this dummy content with an empty object
	var initialState = exports.initialState = {
	  loaded: false,
	  content: {
	    "review": {
	      "flowEntryLink": {
	        "entryPointUrl": "/buy/plan",
	        "entryPointName": "Back to My Plan"
	      },
	      currentMonthlyTotalCharges: {},
	      reviewChargesSection: {
	        "monthlyChargesSection": {
	          "allPrices": {},
	          "reviewItems": {},
	          "reviewSubItems": {
	            "premiumChannels": [],
	            "equipment": []
	          }
	        },
	        "oneTimeChargesSection": {
	          "allPrices": {
	            "prices": [{
	              "amount": {
	                "dollars": "25",
	                "cents": "00"
	              },
	              "isOneTime": false,
	              "isIncluded": false,
	              "priceType": "OneTime"
	            }],
	            "isIncluded": false
	          },
	          "reviewItems": {}
	        },
	        "removedChargesSection": {
	          "allPrices": null,
	          "reviewItems": {
	            "offers": []
	          },
	          "reviewSubItems": {
	            "premiumChannels": [],
	            "equipment": []
	          }
	        }
	      },
	      reviewSummary: {
	        "newMonthlyTotalCharges": {
	          "allPrices": {
	            "prices": [],
	            "isIncluded": false
	          }
	        },
	        "oneTimeTotalCharges": {}
	      },
	      "contracts": [],
	      "verifications": []
	    }
	  }
	};
	
	var review = exports.review = function review() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	
	    case SET_CONTENT:
	      return _extends({}, state, {
	        content: action.payload.content.review
	      });
	
	    case SET_REF_NUM:
	      return _extends({}, state, {
	        refNum: action.refNum
	      });
	
	    case SELECT_OPTION:
	      return _extends({}, state, {
	        selectedOption: action.option
	      });
	
	    case SET_DATA:
	      return _extends({}, state, action.payload);
	
	    default:
	      return state;
	  }
	};
	
	// Action Creators
	var setRefNum = exports.setRefNum = function setRefNum(refNum) {
	  return {
	    type: SET_REF_NUM,
	    refNum: refNum
	  };
	};
	
	var selectOption = exports.selectOption = function selectOption(paymentOption) {
	  return {
	    type: SELECT_OPTION,
	    option: paymentOption
	  };
	};
	
	var loadContent = exports.loadContent = function loadContent() {
	  return {
	    type: LOAD_CONTENT
	  };
	};
	
	var confirm = exports.confirm = function confirm() {
	  return {
	    type: CONFIRM
	  };
	};
	
	var submitOrder = exports.submitOrder = function submitOrder(salesSessionId) {
	  return {
	    type: SUBMIT_ORDER,
	    salesSessionId: salesSessionId
	  };
	};
	
	exports.default = review;

/***/ },
/* 197 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var SET_DATA = exports.SET_DATA = 'mp/omni/omnisales/SET_DATA';
	var OMNI_GET_COMMUNITY = exports.OMNI_GET_COMMUNITY = 'mp/omni/omnisales/OMNI_GET_COMMUNITY';
	var OMNI_LOCALIZE = exports.OMNI_LOCALIZE = 'mp/omni/omnisales/OMNI_LOCALIZE';
	var GET_SUGGESTIONS = exports.GET_SUGGESTIONS = 'mp/omni/omnisales/GET_SUGGESTIONS';
	var SELECT_SUGGESTION = exports.SELECT_SUGGESTION = 'mp/omni/omnisales/SELECT_SUGGESTION';
	
	var initialState = {};
	
	var omniSales = function omniSales() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case SET_DATA:
	      return _extends({}, state, action.payload);
	
	    default:
	      return state;
	  }
	};
	
	var omniGetCommunity = exports.omniGetCommunity = function omniGetCommunity() {
	  return {
	    type: OMNI_GET_COMMUNITY
	  };
	};
	
	var omniLocalizeAddress = exports.omniLocalizeAddress = function omniLocalizeAddress() {
	  return {
	    type: OMNI_LOCALIZE
	  };
	};
	
	var getSuggestions = exports.getSuggestions = function getSuggestions(search) {
	  return {
	    type: GET_SUGGESTIONS,
	    payload: {
	      search: search
	    }
	  };
	};
	
	var selectSuggestion = exports.selectSuggestion = function selectSuggestion(suggestion) {
	  return {
	    type: SELECT_SUGGESTION,
	    payload: {
	      suggestion: suggestion
	    }
	  };
	};
	
	exports.default = omniSales;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _errorHelpers = __webpack_require__(664);
	
	Object.keys(_errorHelpers).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _errorHelpers[key];
	    }
	  });
	});
	var DL_ERROR_PAGE_LOADED = exports.DL_ERROR_PAGE_LOADED = 'hg/error/DL_PAGE_LOADED';
	var HANDLE_ERROR = exports.HANDLE_ERROR = 'hg/error/HANDLE_ERROR';
	var HANDLE_INTERACTION = exports.HANDLE_INTERACTION = 'mp/error/HANDLE_INTERACTION';
	
	
	// this is just for logging errors on the server
	var errorTypes = exports.errorTypes = {
	  EXCEPTION: 'Exception',
	  REDIRECT: 'Redirect'
	};
	var loadContent = exports.loadContent = function loadContent(routePath) {
	  return {
	    type: DL_ERROR_PAGE_LOADED,
	    path: routePath
	  };
	};
	var handleInteraction = exports.handleInteraction = function handleInteraction() {
	  return {
	    type: HANDLE_INTERACTION
	  };
	};

/***/ },
/* 199 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var normalizePhone = exports.normalizePhone = function normalizePhone(value, previousValue) {
	  if (!value) {
	    return value;
	  }
	  var onlyNums = value.replace(/[^\d]/g, '');
	
	  if (!previousValue || value.length > previousValue.length) {
	    // typing forward
	    if (onlyNums.length === 3) {
	      return '(' + onlyNums + ') ';
	    }
	    if (onlyNums.length === 6) {
	      return '(' + onlyNums.slice(0, 3) + ') ' + onlyNums.slice(3) + '-';
	    }
	  }
	  if (onlyNums.length <= 3) {
	    return onlyNums;
	  }
	  if (onlyNums.length <= 6) {
	    return '(' + onlyNums.slice(0, 3) + ') ' + onlyNums.slice(3);
	  }
	  return '(' + onlyNums.slice(0, 3) + ') ' + onlyNums.slice(3, 6) + '-' + onlyNums.slice(6, 10);
	};
	
	var normalizeSSN = exports.normalizeSSN = function normalizeSSN(value, previousValue) {
	  if (!value) {
	    return value;
	  }
	  var onlyNums = value.replace(/[^\d]/g, '');
	  // const separator = '-';
	  var separator = '';
	
	  if (!previousValue || value.length > previousValue.length) {
	    // typing forward
	    if (onlyNums.length === 3) {
	      return onlyNums + separator;
	    }
	    if (onlyNums.length === 5) {
	      return onlyNums.slice(0, 3) + separator + onlyNums.slice(3) + separator;
	    }
	  }
	
	  if (onlyNums.length <= 3) {
	    return onlyNums;
	  }
	  if (onlyNums.length <= 5) {
	    return onlyNums.slice(0, 3) + separator + onlyNums.slice(3);
	  }
	  return onlyNums.slice(0, 3) + separator + onlyNums.slice(3, 5) + separator + onlyNums.slice(5, 9);
	};
	
	var normalizeCvv = exports.normalizeCvv = function normalizeCvv(value) {
	  if (!value) {
	    return value;
	  }
	  var onlyNums = value.replace(/[^\d]/g, '');
	
	  return onlyNums.slice(0, 4);
	};
	
	var normalizeCardNumber = exports.normalizeCardNumber = function normalizeCardNumber(value) {
	  if (!value) {
	    return value;
	  }
	
	  if (value.indexOf('•') > -1) {
	    return '';
	  }
	  var onlyNums = value.replace(/[^\d]/g, '').slice(0, 16);
	
	  if (!onlyNums) {
	    return onlyNums;
	  }
	
	  var parts = onlyNums.match(new RegExp('.{1,4}', 'g'));
	
	  return parts.join(' ');
	};
	
	var normalizeZipCode = exports.normalizeZipCode = function normalizeZipCode(value) {
	  if (!value) {
	    return value;
	  }
	  var onlyNums = value.replace(/[^\d]/g, '');
	
	  return onlyNums.slice(0, 5);
	};
	
	var normalizeName = exports.normalizeName = function normalizeName() {
	  var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;
	
	  return function (value) {
	    if (!value) {
	      return value;
	    }
	
	    var onlyLetters = value.replace(/[^a-zA-Z\-\,\.\' ]/g, '');
	
	    return onlyLetters.slice(0, max);
	  };
	};
	
	var normalizeTextWithMax = exports.normalizeTextWithMax = function normalizeTextWithMax() {
	  var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
	
	  return function (value) {
	    if (!value) {
	      return value;
	    }
	
	    return value.slice(0, max);
	  };
	};
	
	var normalizeCity = exports.normalizeCity = function normalizeCity() {
	  var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
	
	  return function (value) {
	    if (!value) {
	      return value;
	    }
	
	    var onlyAlpha = value.replace(/[^a-zA-Z]/g, '');
	
	    return onlyAlpha.slice(0, max);
	  };
	};
	
	var removeNonDigits = exports.removeNonDigits = function removeNonDigits(string) {
	  return string ? string.replace(/[^0-9]+/g, '') : string;
	};

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _jsonLogicJs = __webpack_require__(985);
	
	var _jsonLogicJs2 = _interopRequireDefault(_jsonLogicJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Maestro = function () {
	  function Maestro() {
	    _classCallCheck(this, Maestro);
	  }
	
	  _createClass(Maestro, [{
	    key: 'baseRoolz',
	
	    // general app-wide reusable roolz
	    value: function baseRoolz(state) {
	      var data = {
	        flow: _lodash2.default.get(state, 'common.flow'),
	        consumerType: _lodash2.default.get(state, 'common.consumerType', '')
	      };
	
	      var logic = {
	        isMoversFlow: { "==": [{ "var": "flow" }, "movers"] },
	        isOmni: {
	          "if": {
	            "or": [{ "==": [{ "var": "consumerType" }, "Einstein360"] }, { "==": [{ "var": "consumerType" }, "Etail"] }]
	          }
	        },
	        disableExternalLinks: {
	          "if": {
	            "or": [{ "==": [{ "var": "consumerType" }, "Einstein360"] }, { "==": [{ "var": "consumerType" }, "Etail"] }]
	          }
	        }
	      };
	
	      return { data: data, logic: logic };
	    }
	  }, {
	    key: 'conduct',
	    value: function conduct(state) {
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var logic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var baseRoolz = this.baseRoolz(state);
	      var mergedLogic = Object.assign({}, baseRoolz.logic, logic);
	      var mergedData = Object.assign({}, baseRoolz.data, data);
	      var keys = Object.keys(mergedLogic);
	
	      return keys.reduce(function (p, key) {
	        return Object.assign({}, p, _defineProperty({}, key, _jsonLogicJs2.default.apply(mergedLogic[key], mergedData)));
	      }, {});
	    }
	  }]);
	
	  return Maestro;
	}();
	
	//Ensure only a singleton is exported
	
	
	var instance = new Maestro();
	
	exports.default = instance;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(25)
	  , toIndex  = __webpack_require__(85)
	  , toLength = __webpack_require__(23);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 202 */
[1288, 18, 68],
/* 203 */
[1291, 14, 8],
/* 204 */
235,
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(15)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ },
/* 206 */
[1294, 8],
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(14)
	  , setPrototypeOf = __webpack_require__(215).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ },
/* 208 */
[1297, 103, 15],
/* 209 */
[1298, 45],
/* 210 */
[1301, 80, 68, 104, 32, 15],
/* 211 */
[1302, 79, 1, 33, 32, 29, 103, 210, 104, 40, 15],
/* 212 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 213 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(8)
	  , macrotask = __webpack_require__(222).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(45)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ },
/* 215 */
[1317, 14, 6, 59, 39],
/* 216 */
[1319, 154, 86],
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(6)
	  , aFunction = __webpack_require__(31)
	  , SPECIES   = __webpack_require__(15)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 218 */
[1321, 69, 46],
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(150)
	  , defined  = __webpack_require__(46);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(69)
	  , defined   = __webpack_require__(46);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },
/* 221 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(59)
	  , invoke             = __webpack_require__(149)
	  , html               = __webpack_require__(206)
	  , cel                = __webpack_require__(203)
	  , global             = __webpack_require__(8)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(45)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(8)
	  , DESCRIPTORS    = __webpack_require__(17)
	  , LIBRARY        = __webpack_require__(79)
	  , $typed         = __webpack_require__(155)
	  , hide           = __webpack_require__(32)
	  , redefineAll    = __webpack_require__(83)
	  , fails          = __webpack_require__(12)
	  , anInstance     = __webpack_require__(78)
	  , toInteger      = __webpack_require__(69)
	  , toLength       = __webpack_require__(23)
	  , gOPN           = __webpack_require__(81).f
	  , dP             = __webpack_require__(18).f
	  , arrayFill      = __webpack_require__(201)
	  , setToStringTag = __webpack_require__(104)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ },
/* 224 */
[1327, 8, 58, 79, 345, 18],
/* 225 */
[1330, 125, 15, 103, 58],
/* 226 */
[1332, 101, 333, 103, 35, 211],
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, global, process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = function (type, config) {
	  var deprecated = config && config.deprecated;
	  var storage = getStorage(type);
	  return {
	    getAllKeys: function getAllKeys(cb) {
	      // warn if deprecated
	      if (deprecated) console.warn('redux-persist: ', deprecated);
	
	      return new Promise(function (resolve, reject) {
	        try {
	          var keys = [];
	          for (var i = 0; i < storage.length; i++) {
	            keys.push(storage.key(i));
	          }
	          nextTick(function () {
	            cb && cb(null, keys);
	            resolve(keys);
	          });
	        } catch (e) {
	          cb && cb(e);
	          reject(e);
	        }
	      });
	    },
	    getItem: function getItem(key, cb) {
	      return new Promise(function (resolve, reject) {
	        try {
	          var s = storage.getItem(key);
	          nextTick(function () {
	            cb && cb(null, s);
	            resolve(s);
	          });
	        } catch (e) {
	          cb && cb(e);
	          reject(e);
	        }
	      });
	    },
	    setItem: function setItem(key, string, cb) {
	      return new Promise(function (resolve, reject) {
	        try {
	          storage.setItem(key, string);
	          nextTick(function () {
	            cb && cb(null);
	            resolve();
	          });
	        } catch (e) {
	          cb && cb(e);
	          reject(e);
	        }
	      });
	    },
	    removeItem: function removeItem(key, cb) {
	      return new Promise(function (resolve, reject) {
	        try {
	          storage.removeItem(key);
	          nextTick(function () {
	            cb && cb(null);
	            resolve();
	          });
	        } catch (e) {
	          cb && cb(e);
	          reject(e);
	        }
	      });
	    }
	  };
	};
	
	var genericSetImmediate = typeof setImmediate === 'undefined' ? global.setImmediate : setImmediate;
	var nextTick = process && process.nextTick ? process.nextTick : genericSetImmediate;
	
	var noStorage = process && process.env && ("production") === 'production' ? function () {
	  /* noop */return null;
	} : function () {
	  console.error('redux-persist asyncLocalStorage requires a global localStorage object. Either use a different storage backend or if this is a universal redux application you probably should conditionally persist like so: https://gist.github.com/rt2zz/ac9eb396793f95ff3c3b');
	  return null;
	};
	
	function hasLocalStorage() {
	  try {
	    return (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && !!window.localStorage;
	  } catch (e) {
	    return false;
	  }
	}
	
	function hasSessionStorage() {
	  try {
	    return (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && typeof window.sessionStorage !== 'undefined';
	  } catch (e) {
	    return false;
	  }
	}
	
	function getStorage(type) {
	  if (type === 'local') {
	    return hasLocalStorage() ? window.localStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
	  }
	  if (type === 'session') {
	    return hasSessionStorage() ? window.sessionStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187).setImmediate, (function() { return this; }()), __webpack_require__(118)))

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;
	exports.default = proc;
	
	var _utils = __webpack_require__(66);
	
	var _scheduler = __webpack_require__(574);
	
	var _io = __webpack_require__(186);
	
	var _channel = __webpack_require__(185);
	
	var _buffers = __webpack_require__(184);
	
	function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';
	
	var CHANNEL_END = exports.CHANNEL_END = {
	  toString: function toString() {
	    return '@@redux-saga/CHANNEL_END';
	  }
	};
	var TASK_CANCEL = exports.TASK_CANCEL = {
	  toString: function toString() {
	    return '@@redux-saga/TASK_CANCEL';
	  }
	};
	
	var matchers = {
	  wildcard: function wildcard() {
	    return _utils.kTrue;
	  },
	  default: function _default(pattern) {
	    return function (input) {
	      return input.type === String(pattern);
	    };
	  },
	  array: function array(patterns) {
	    return function (input) {
	      return patterns.some(function (p) {
	        return matcher(p)(input);
	      });
	    };
	  },
	  predicate: function predicate(_predicate) {
	    return function (input) {
	      return _predicate(input);
	    };
	  }
	};
	
	function matcher(pattern) {
	  return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.stringableFunc(pattern) ? matchers.default : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);
	}
	
	/**
	  Used to track a parent task and its forks
	  In the new fork model, forked tasks are attached by default to their parent
	  We model this using the concept of Parent task && main Task
	  main task is the main flow of the current Generator, the parent tasks is the
	  aggregation of the main tasks + all its forked tasks.
	  Thus the whole model represents an execution tree with multiple branches (vs the
	  linear execution tree in sequential (non parallel) programming)
	
	  A parent tasks has the following semantics
	  - It completes if all its forks either complete or all cancelled
	  - If it's cancelled, all forks are cancelled as well
	  - It aborts if any uncaught error bubbles up from forks
	  - If it completes, the return value is the one returned by the main task
	**/
	function forkQueue(name, mainTask, cb) {
	  var tasks = [],
	      result = void 0,
	      completed = false;
	  addTask(mainTask);
	
	  function abort(err) {
	    cancelAll();
	    cb(err, true);
	  }
	
	  function addTask(task) {
	    tasks.push(task);
	    task.cont = function (res, isErr) {
	      if (completed) {
	        return;
	      }
	
	      (0, _utils.remove)(tasks, task);
	      task.cont = _utils.noop;
	      if (isErr) {
	        abort(res);
	      } else {
	        if (task === mainTask) {
	          result = res;
	        }
	        if (!tasks.length) {
	          completed = true;
	          cb(result);
	        }
	      }
	    };
	    // task.cont.cancel = task.cancel
	  }
	
	  function cancelAll() {
	    if (completed) {
	      return;
	    }
	    completed = true;
	    tasks.forEach(function (t) {
	      t.cont = _utils.noop;
	      t.cancel();
	    });
	    tasks = [];
	  }
	
	  return {
	    addTask: addTask,
	    cancelAll: cancelAll,
	    abort: abort,
	    getTasks: function getTasks() {
	      return tasks;
	    },
	    taskNames: function taskNames() {
	      return tasks.map(function (t) {
	        return t.name;
	      });
	    }
	  };
	}
	
	function createTaskIterator(_ref) {
	  var context = _ref.context,
	      fn = _ref.fn,
	      args = _ref.args;
	
	  if (_utils.is.iterator(fn)) {
	    return fn;
	  }
	
	  // catch synchronous failures; see #152 and #441
	  var result = void 0,
	      error = void 0;
	  try {
	    result = fn.apply(context, args);
	  } catch (err) {
	    error = err;
	  }
	
	  // i.e. a generator function returns an iterator
	  if (_utils.is.iterator(result)) {
	    return result;
	  }
	
	  // do not bubble up synchronous failures for detached forks
	  // instead create a failed task. See #152 and #441
	  return error ? (0, _utils.makeIterator)(function () {
	    throw error;
	  }) : (0, _utils.makeIterator)(function () {
	    var pc = void 0;
	    var eff = { done: false, value: result };
	    var ret = function ret(value) {
	      return { done: true, value: value };
	    };
	    return function (arg) {
	      if (!pc) {
	        pc = true;
	        return eff;
	      } else {
	        return ret(arg);
	      }
	    };
	  }());
	}
	
	var wrapHelper = function wrapHelper(helper) {
	  return { fn: helper };
	};
	
	function proc(iterator) {
	  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	    return _utils.noop;
	  };
	  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _utils.noop;
	  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _utils.noop;
	  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	  var parentEffectId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	  var name = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'anonymous';
	  var cont = arguments[7];
	
	  (0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);
	
	  var sagaMonitor = options.sagaMonitor,
	      logger = options.logger,
	      onError = options.onError;
	
	  var log = logger || _utils.log;
	  var stdChannel = (0, _channel.stdChannel)(subscribe);
	  /**
	    Tracks the current effect cancellation
	    Each time the generator progresses. calling runEffect will set a new value
	    on it. It allows propagating cancellation to child effects
	  **/
	  next.cancel = _utils.noop;
	
	  /**
	    Creates a new task descriptor for this generator, We'll also create a main task
	    to track the main flow (besides other forked tasks)
	  **/
	  var task = newTask(parentEffectId, name, iterator, cont);
	  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
	  var taskQueue = forkQueue(name, mainTask, end);
	
	  /**
	    cancellation of the main task. We'll simply resume the Generator with a Cancel
	  **/
	  function cancelMain() {
	    if (mainTask.isRunning && !mainTask.isCancelled) {
	      mainTask.isCancelled = true;
	      next(TASK_CANCEL);
	    }
	  }
	
	  /**
	    This may be called by a parent generator to trigger/propagate cancellation
	    cancel all pending tasks (including the main task), then end the current task.
	     Cancellation propagates down to the whole execution tree holded by this Parent task
	    It's also propagated to all joiners of this task and their execution tree/joiners
	     Cancellation is noop for terminated/Cancelled tasks tasks
	  **/
	  function cancel() {
	    /**
	      We need to check both Running and Cancelled status
	      Tasks can be Cancelled but still Running
	    **/
	    if (iterator._isRunning && !iterator._isCancelled) {
	      iterator._isCancelled = true;
	      taskQueue.cancelAll();
	      /**
	        Ending with a Never result will propagate the Cancellation to all joiners
	      **/
	      end(TASK_CANCEL);
	    }
	  }
	  /**
	    attaches cancellation logic to this task's continuation
	    this will permit cancellation to propagate down the call chain
	  **/
	  cont && (cont.cancel = cancel);
	
	  // tracks the running status
	  iterator._isRunning = true;
	
	  // kicks up the generator
	  next();
	
	  // then return the task descriptor to the caller
	  return task;
	
	  /**
	    This is the generator driver
	    It's a recursive async/continuation function which calls itself
	    until the generator terminates or throws
	  **/
	  function next(arg, isErr) {
	    // Preventive measure. If we end up here, then there is really something wrong
	    if (!mainTask.isRunning) {
	      throw new Error('Trying to resume an already finished generator');
	    }
	
	    try {
	      var result = void 0;
	      if (isErr) {
	        result = iterator.throw(arg);
	      } else if (arg === TASK_CANCEL) {
	        /**
	          getting TASK_CANCEL automatically cancels the main task
	          We can get this value here
	           - By cancelling the parent task manually
	          - By joining a Cancelled task
	        **/
	        mainTask.isCancelled = true;
	        /**
	          Cancels the current effect; this will propagate the cancellation down to any called tasks
	        **/
	        next.cancel();
	        /**
	          If this Generator has a `return` method then invokes it
	          Thill will jump to the finally block
	        **/
	        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
	      } else if (arg === CHANNEL_END) {
	        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
	        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
	      } else {
	        result = iterator.next(arg);
	      }
	
	      if (!result.done) {
	        runEffect(result.value, parentEffectId, '', next);
	      } else {
	        /**
	          This Generator has ended, terminate the main task and notify the fork queue
	        **/
	        mainTask.isMainRunning = false;
	        mainTask.cont && mainTask.cont(result.value);
	      }
	    } catch (error) {
	      if (mainTask.isCancelled) {
	        log('error', 'uncaught at ' + name, error.message);
	      }
	      mainTask.isMainRunning = false;
	      mainTask.cont(error, true);
	    }
	  }
	
	  function end(result, isErr) {
	    iterator._isRunning = false;
	    stdChannel.close();
	    if (!isErr) {
	      if (result === TASK_CANCEL && _utils.isDev) {
	        log('info', name + ' has been cancelled', '');
	      }
	      iterator._result = result;
	      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
	    } else {
	      if (result instanceof Error) {
	        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
	      }
	      if (!task.cont) {
	        log('error', 'uncaught', result.sagaStack || result.stack);
	        if (result instanceof Error && onError) {
	          onError(result);
	        }
	      }
	      iterator._error = result;
	      iterator._isAborted = true;
	      iterator._deferredEnd && iterator._deferredEnd.reject(result);
	    }
	    task.cont && task.cont(result, isErr);
	    task.joiners.forEach(function (j) {
	      return j.cb(result, isErr);
	    });
	    task.joiners = null;
	  }
	
	  function runEffect(effect, parentEffectId) {
	    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var cb = arguments[3];
	
	    var effectId = (0, _utils.uid)();
	    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });
	
	    /**
	      completion callback and cancel callback are mutually exclusive
	      We can't cancel an already completed effect
	      And We can't complete an already cancelled effectId
	    **/
	    var effectSettled = void 0;
	
	    // Completion callback passed to the appropriate effect runner
	    function currCb(res, isErr) {
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      cb.cancel = _utils.noop; // defensive measure
	      if (sagaMonitor) {
	        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
	      }
	
	      cb(res, isErr);
	    }
	    // tracks down the current cancel
	    currCb.cancel = _utils.noop;
	
	    // setup cancellation logic on the parent cb
	    cb.cancel = function () {
	      // prevents cancelling an already completed effect
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      /**
	        propagates cancel downward
	        catch uncaught cancellations errors; since we can no longer call the completion
	        callback, log errors raised during cancellations into the console
	      **/
	      try {
	        currCb.cancel();
	      } catch (err) {
	        log('error', 'uncaught at ' + name, err.message);
	      }
	      currCb.cancel = _utils.noop; // defensive measure
	
	      sagaMonitor && sagaMonitor.effectCancelled(effectId);
	    };
	
	    /**
	      each effect runner must attach its own logic of cancellation to the provided callback
	      it allows this generator to propagate cancellation downward.
	       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
	      And the setup must occur before calling the callback
	       This is a sort of inversion of control: called async functions are responsible
	      of completing the flow by calling the provided continuation; while caller functions
	      are responsible for aborting the current flow by calling the attached cancel function
	       Library users can attach their own cancellation logic to promises by defining a
	      promise[CANCEL] method in their returned promises
	      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
	    **/
	    var data = void 0;
	    return (
	      // Non declarative effect
	      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)
	
	      // declarative effects
	      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : /* anything else returned as is        */currCb(effect)
	    );
	  }
	
	  function resolvePromise(promise, cb) {
	    var cancelPromise = promise[_utils.CANCEL];
	    if (typeof cancelPromise === 'function') {
	      cb.cancel = cancelPromise;
	    }
	    promise.then(cb, function (error) {
	      return cb(error, true);
	    });
	  }
	
	  function resolveIterator(iterator, effectId, name, cb) {
	    proc(iterator, subscribe, dispatch, getState, options, effectId, name, cb);
	  }
	
	  function runTakeEffect(_ref2, cb) {
	    var channel = _ref2.channel,
	        pattern = _ref2.pattern,
	        maybe = _ref2.maybe;
	
	    channel = channel || stdChannel;
	    var takeCb = function takeCb(inp) {
	      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
	    };
	    try {
	      channel.take(takeCb, matcher(pattern));
	    } catch (err) {
	      return cb(err, true);
	    }
	    cb.cancel = takeCb.cancel;
	  }
	
	  function runPutEffect(_ref3, cb) {
	    var channel = _ref3.channel,
	        action = _ref3.action,
	        resolve = _ref3.resolve;
	
	    /**
	      Schedule the put in case another saga is holding a lock.
	      The put will be executed atomically. ie nested puts will execute after
	      this put has terminated.
	    **/
	    (0, _scheduler.asap)(function () {
	      var result = void 0;
	      try {
	        result = (channel ? channel.put : dispatch)(action);
	      } catch (error) {
	        // If we have a channel or `put.resolve` was used then bubble up the error.
	        if (channel || resolve) return cb(error, true);
	        log('error', 'uncaught at ' + name, error.stack || error.message || error);
	      }
	
	      if (resolve && _utils.is.promise(result)) {
	        resolvePromise(result, cb);
	      } else {
	        return cb(result);
	      }
	    });
	    // Put effects are non cancellables
	  }
	
	  function runCallEffect(_ref4, effectId, cb) {
	    var context = _ref4.context,
	        fn = _ref4.fn,
	        args = _ref4.args;
	
	    var result = void 0;
	    // catch synchronous failures; see #152
	    try {
	      result = fn.apply(context, args);
	    } catch (error) {
	      return cb(error, true);
	    }
	    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
	  }
	
	  function runCPSEffect(_ref5, cb) {
	    var context = _ref5.context,
	        fn = _ref5.fn,
	        args = _ref5.args;
	
	    // CPS (ie node style functions) can define their own cancellation logic
	    // by setting cancel field on the cb
	
	    // catch synchronous failures; see #152
	    try {
	      (function () {
	        var cpsCb = function cpsCb(err, res) {
	          return _utils.is.undef(err) ? cb(res) : cb(err, true);
	        };
	        fn.apply(context, args.concat(cpsCb));
	        if (cpsCb.cancel) {
	          cb.cancel = function () {
	            return cpsCb.cancel();
	          };
	        }
	      })();
	    } catch (error) {
	      return cb(error, true);
	    }
	  }
	
	  function runForkEffect(_ref6, effectId, cb) {
	    var context = _ref6.context,
	        fn = _ref6.fn,
	        args = _ref6.args,
	        detached = _ref6.detached;
	
	    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });
	
	    try {
	      (0, _scheduler.suspend)();
	      var _task = proc(taskIterator, subscribe, dispatch, getState, options, effectId, fn.name, detached ? null : _utils.noop);
	
	      if (detached) {
	        cb(_task);
	      } else {
	        if (taskIterator._isRunning) {
	          taskQueue.addTask(_task);
	          cb(_task);
	        } else if (taskIterator._error) {
	          taskQueue.abort(taskIterator._error);
	        } else {
	          cb(_task);
	        }
	      }
	    } finally {
	      (0, _scheduler.flush)();
	    }
	    // Fork effects are non cancellables
	  }
	
	  function runJoinEffect(t, cb) {
	    if (t.isRunning()) {
	      (function () {
	        var joiner = { task: task, cb: cb };
	        cb.cancel = function () {
	          return (0, _utils.remove)(t.joiners, joiner);
	        };
	        t.joiners.push(joiner);
	      })();
	    } else {
	      t.isAborted() ? cb(t.error(), true) : cb(t.result());
	    }
	  }
	
	  function runCancelEffect(task, cb) {
	    if (task.isRunning()) {
	      task.cancel();
	    }
	    cb();
	    // cancel effects are non cancellables
	  }
	
	  function runParallelEffect(effects, effectId, cb) {
	    if (!effects.length) {
	      return cb([]);
	    }
	
	    var completedCount = 0;
	    var completed = void 0;
	    var results = Array(effects.length);
	
	    function checkEffectEnd() {
	      if (completedCount === results.length) {
	        completed = true;
	        cb(results);
	      }
	    }
	
	    var childCbs = effects.map(function (eff, idx) {
	      var chCbAtIdx = function chCbAtIdx(res, isErr) {
	        if (completed) {
	          return;
	        }
	        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
	          cb.cancel();
	          cb(res, isErr);
	        } else {
	          results[idx] = res;
	          completedCount++;
	          checkEffectEnd();
	        }
	      };
	      chCbAtIdx.cancel = _utils.noop;
	      return chCbAtIdx;
	    });
	
	    cb.cancel = function () {
	      if (!completed) {
	        completed = true;
	        childCbs.forEach(function (chCb) {
	          return chCb.cancel();
	        });
	      }
	    };
	
	    effects.forEach(function (eff, idx) {
	      return runEffect(eff, effectId, idx, childCbs[idx]);
	    });
	  }
	
	  function runRaceEffect(effects, effectId, cb) {
	    var completed = void 0;
	    var keys = Object.keys(effects);
	    var childCbs = {};
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	
	        if (isErr) {
	          // Race Auto cancellation
	          cb.cancel();
	          cb(res, true);
	        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
	          cb.cancel();
	          completed = true;
	          cb(_defineProperty({}, key, res));
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      // prevents unnecessary cancellation
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	    keys.forEach(function (key) {
	      if (completed) {
	        return;
	      }
	      runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runSelectEffect(_ref7, cb) {
	    var selector = _ref7.selector,
	        args = _ref7.args;
	
	    try {
	      var state = selector.apply(undefined, [getState()].concat(_toConsumableArray(args)));
	      cb(state);
	    } catch (error) {
	      cb(error, true);
	    }
	  }
	
	  function runChannelEffect(_ref8, cb) {
	    var pattern = _ref8.pattern,
	        buffer = _ref8.buffer;
	
	    var match = matcher(pattern);
	    match.pattern = pattern;
	    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
	  }
	
	  function runCancelledEffect(data, cb) {
	    cb(!!mainTask.isCancelled);
	  }
	
	  function runFlushEffect(channel, cb) {
	    channel.flush(cb);
	  }
	
	  function newTask(id, name, iterator, cont) {
	    var _done, _ref9, _mutatorMap;
	
	    iterator._deferredEnd = null;
	    return _ref9 = {}, _defineProperty(_ref9, _utils.TASK, true), _defineProperty(_ref9, 'id', id), _defineProperty(_ref9, 'name', name), _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
	      if (iterator._deferredEnd) {
	        return iterator._deferredEnd.promise;
	      } else {
	        var def = (0, _utils.deferred)();
	        iterator._deferredEnd = def;
	        if (!iterator._isRunning) {
	          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
	        }
	        return def.promise;
	      }
	    }, _defineProperty(_ref9, 'cont', cont), _defineProperty(_ref9, 'joiners', []), _defineProperty(_ref9, 'cancel', cancel), _defineProperty(_ref9, 'isRunning', function isRunning() {
	      return iterator._isRunning;
	    }), _defineProperty(_ref9, 'isCancelled', function isCancelled() {
	      return iterator._isCancelled;
	    }), _defineProperty(_ref9, 'isAborted', function isAborted() {
	      return iterator._isAborted;
	    }), _defineProperty(_ref9, 'result', function result() {
	      return iterator._result;
	    }), _defineProperty(_ref9, 'error', function error() {
	      return iterator._error;
	    }), _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
	  }
	}

/***/ },
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(43);
	
	var _maestro = __webpack_require__(200);
	
	var _maestro2 = _interopRequireDefault(_maestro);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExternalLink = function (_Component) {
		_inherits(ExternalLink, _Component);
	
		function ExternalLink() {
			_classCallCheck(this, ExternalLink);
	
			return _possibleConstructorReturn(this, (ExternalLink.__proto__ || Object.getPrototypeOf(ExternalLink)).apply(this, arguments));
		}
	
		_createClass(ExternalLink, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    className = _props.className,
				    disableExternalLinks = _props.disableExternalLinks,
				    href = _props.href,
				    target = _props.target;
	
	
				var dataTracking = this.props['data-tracking'];
	
				return _react2.default.createElement(
					'span',
					null,
					disableExternalLinks ? _react2.default.createElement(
						'span',
						{ className: className },
						this.props.children
					) : _react2.default.createElement(
						'a',
						{ href: href,
							'data-tracking': dataTracking,
							className: className,
							target: target
						},
						this.props.children
					)
				);
			}
		}]);
	
		return ExternalLink;
	}(_react.Component);
	
	ExternalLink.propTypes = {
		children: _react.PropTypes.element.isRequired,
		className: _react.PropTypes.string,
		'data-tracking': _react.PropTypes.string,
		disableExternalLinks: _react.PropTypes.bool.isRequired,
		href: _react.PropTypes.string.isRequired,
		target: _react.PropTypes.string
	};
	
	function mapStateToProps(state) {
		var _Maestro$conduct = _maestro2.default.conduct(state),
		    disableExternalLinks = _Maestro$conduct.disableExternalLinks;
	
		return {
			disableExternalLinks: disableExternalLinks
		};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ExternalLink);

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.closeWindow = exports.navRoolz = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _maestro = __webpack_require__(200);
	
	var _maestro2 = _interopRequireDefault(_maestro);
	
	var _helpers = __webpack_require__(77);
	
	var _contentProvider = __webpack_require__(74);
	
	var _contentProvider2 = _interopRequireDefault(_contentProvider);
	
	var _review = __webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navRoolz = exports.navRoolz = function navRoolz(state) {
		var currentPath = (0, _helpers.noEndingSlash)(_lodash2.default.get(state, 'routing.locationBeforeTransitions.pathname', ''));
		var flow = _lodash2.default.get(state, 'common.flow');
		var flowType = _lodash2.default.get(state, 'common.flowType', '');
		var consumerType = _lodash2.default.get(state, 'common.consumerType', '');
	
		var checkoutQueryType = _lodash2.default.get(state, 'checkout.queryType', '');
		var reviewItemFlowType = _lodash2.default.get(state, 'review.content.review.flowType', '');
		var isQuickCheckoutPPV = checkoutQueryType === 'ppv' || reviewItemFlowType === _review.CHECKOUT_TYPE_PPV;
	
		var quickCheckoutId = _lodash2.default.get(state, 'quickCheckout.quickCheckout.productId', '');
		var serviceLinkContentString = 'quickCheckoutProducts.' + quickCheckoutId + '.backNav';
		var serviceLink = isQuickCheckoutPPV ? '/learn/ppv' : _contentProvider2.default.getValue(serviceLinkContentString, [], 'hide');
	
		var data = {
			consumerType: consumerType,
			currentPath: currentPath,
			flow: flow,
			flowType: flowType,
			isQuickCheckoutPPV: isQuickCheckoutPPV,
			serviceLink: serviceLink
		};
	
		var logic = {
			// backNavDestination also controls whether the back button displays. no destination = no button
			backNavDestination: {
				"if": [{ "and": [{ "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.MYPLAN].path] }, { "!=": [{ "var": "consumerType" }, "Einstein360"] }] }, 'https://customer.xfinity.com/', { "or": [{ "and": [{ "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.OFFERS_FILTER].path] }, { "!=": [{ "var": "flowType" }, "MoveRepackager"] }] }, { "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.ERROR].path] }, { "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.CONTACTUS].path] }] }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.MYPLAN].path, { "and": [{ "or": [{ "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.CHECKOUT].path] }, { "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.REVIEW].path] }] }, { "or": [{ "==": [{ "var": "isQuickCheckoutPPV" }, true] }, { "!=": [{ "var": "serviceLink" }, "hide"] }] }] }, data.serviceLink, { "and": [{ "or": [{ "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.SPECIALIST].path] }, { "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.INSTALL].path] }] }, { "==": [{ "var": "flow" }, "movers"] }] }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.LOCALIZATION].path]
			},
			backNavText: {
				"if": [{ "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.MYPLAN].path] }, 'Go to My Account', { "or": [{ "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.OFFERS_FILTER].path] }, { "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.ERROR].path] }, { "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.CONTACTUS].path] }] }, 'Back to My Plan',
	
				// all others
				'Back']
			},
			backNavIsExternalDestination: {
				"if": [{ "or": [{ "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.MYPLAN].path] }, { "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.CHECKOUT].path] }, { "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.REVIEW].path] }] }]
			},
			showCancelButton: {
				"and": [{ "==": [{ "var": "consumerType" }, "Einstein360"] }, { "or": [{ "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.MYPLAN].path] }, { "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.OFFERS_FILTER].path] }, { "==": [{ "var": "currentPath" }, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.LOCALIZATION].path] }] }]
			}
		};
	
		return _maestro2.default.conduct(state, data, logic);
	};
	
	// from Mercury's E360OftAccount.jsx
	var closeWindow = exports.closeWindow = function closeWindow(data) {
		var parent = window.opener;
	
		var mapping = [
		// 'http://localhost/e360',
		// 'http://127.0.0.1/e360',
		'https://mcsweb-dt-s1d.cable.comcast.com', 'https://mcsweb-dt-s1q.cable.comcast.com', 'https://mcsweb-ch2-a1s.cable.comcast.com', 'https://einstein360-uat.cable.comcast.com', 'https://einstein360.cable.comcast.com'];
	
		if (parent) {
			var msg = Object.assign({}, { sender: 'buyflow' }, data);
	
			Object.keys(mapping).forEach(function (key) {
				var targetOrigin = mapping[key];
	
				parent.postMessage(msg, targetOrigin);
			});
			window.close();
		}
	};

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _checkoutSelectors = __webpack_require__(620);
	
	Object.keys(_checkoutSelectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _checkoutSelectors[key];
	    }
	  });
	});
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'hg/checkout/LOAD_CONTENT';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'hg/checkout/DL_PAGE_LOADED';
	var SET_DATA = exports.SET_DATA = 'hg/checkout/SET_DATA';
	var SET_PRODUCT_ID = exports.SET_PRODUCT_ID = 'hg/checkout/SET_PRODUCT_ID';
	
	var initialState = {
	  loaded: false
	};
	
	var checkout = exports.checkout = function checkout() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case SET_DATA:
	      return _extends({}, state, action.payload);
	
	    case SET_PRODUCT_ID:
	      return _extends({}, state, {
	        priceReferenceId: action.payload
	      });
	    default:
	      return state;
	  }
	};
	
	var loadContent = exports.loadContent = function loadContent(payload) {
	  var lowerCaseProductType = typeof payload.type === 'string' ? payload.type.toLowerCase() : 'qc';
	
	  return {
	    type: LOAD_CONTENT,
	    payload: {
	      uid: payload.uid, //LEGACY URL SUPPORT
	      productName: payload.sn,
	      checkoutType: lowerCaseProductType
	    }
	  };
	};
	
	var setData = exports.setData = function setData(payload) {
	  return {
	    type: SET_DATA,
	    payload: payload
	  };
	};
	
	var setProductId = exports.setProductId = function setProductId(payload) {
	  return {
	    type: SET_PRODUCT_ID,
	    payload: payload
	  };
	};
	
	exports.default = checkout;

/***/ },
/* 303 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var SET_DATA = exports.SET_DATA = 'mp/equipment/SET_DATA';
	
	var initialState = exports.initialState = {
	  loaded: false,
	  equipment: []
	};
	
	var equipment = exports.equipment = function equipment() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	
	    case SET_DATA:
	      return _extends({}, state, action.payload);
	
	    default:
	      return state;
	  }
	};
	
	exports.default = equipment;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.showInternetOffers = exports.dlFilterOptionSelected = exports.dlPriceStringSelector = exports.downgradeLobsStringSelector = exports.downgradeLobsSelector = exports.activeLobStringSelector = exports.subscribedLobStringSelector = exports.subscribedLobsSelector = exports.summaryTitleSelector = exports.dlOffersSelector = exports.offerPriceSelector = exports.priceSelector = exports.sliderSelector = exports.showOffersForSelectedLobsSelector = exports.filterWithDisabledSelector = exports.lobFilterSelector = exports.offerLOBselector = exports.offerWithPriceSelector = exports.activelobValuesSelector = exports.activeLobFilterSelector = exports.activeCheckboxFilterSelector = exports.checkboxFilterSelector = exports.enableDynamicLobSelectionSelector = exports.enableDefaultLobsSelector = exports.showOffersForLobsSelector = exports.enableShowOffersForLobsSelector = exports.mobileFiltersHiddenSelector = exports.mobileFiltersOpenSelector = exports.filterSelector = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reselect = __webpack_require__(38);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _common = __webpack_require__(7);
	
	var _offersHelpers = __webpack_require__(190);
	
	var _plan = __webpack_require__(123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filterSelector = exports.filterSelector = function filterSelector(state) {
	  return _lodash2.default.get(state, 'offers.filterData');
	};
	var mobileFiltersOpenSelector = exports.mobileFiltersOpenSelector = function mobileFiltersOpenSelector(state) {
	  return _lodash2.default.get(state, 'offers.mobileFilters.open');
	};
	var mobileFiltersHiddenSelector = exports.mobileFiltersHiddenSelector = function mobileFiltersHiddenSelector(state) {
	  return _lodash2.default.get(state, 'offers.mobileFilters.hidden');
	};
	var enableShowOffersForLobsSelector = exports.enableShowOffersForLobsSelector = function enableShowOffersForLobsSelector(state) {
	  return _lodash2.default.get(state, 'offers.showOffersForLobs.isEnabled');
	};
	var showOffersForLobsSelector = exports.showOffersForLobsSelector = function showOffersForLobsSelector(state) {
	  return _lodash2.default.get(state, 'offers.showOffersForLobs.lobs');
	};
	var enableDefaultLobsSelector = exports.enableDefaultLobsSelector = function enableDefaultLobsSelector(state) {
	  return _lodash2.default.get(state, 'offers.enableDefaultLobs');
	};
	
	// HACK: Used for below showInternetOffers hack
	var enableDynamicLobSelectionSelector = exports.enableDynamicLobSelectionSelector = function enableDynamicLobSelectionSelector(state) {
	  return _lodash2.default.get(state, 'offers.enableDynamicLobSelection');
	};
	
	// LOB and Option data for all checkboxes
	var checkboxFilterSelector = exports.checkboxFilterSelector = (0, _reselect.createSelector)(filterSelector, function (filters) {
	  return _lodash2.default.reject(filters, 'isSlider');
	});
	
	// All LOB and option data for selected checkboxes
	var activeCheckboxFilterSelector = exports.activeCheckboxFilterSelector = (0, _reselect.createSelector)(checkboxFilterSelector, function (filters) {
	  return _lodash2.default.filter(filters, 'lob.selected');
	});
	
	// Just LOB data for selected checkboxes
	var activeLobFilterSelector = exports.activeLobFilterSelector = (0, _reselect.createSelector)(activeCheckboxFilterSelector, function (filters) {
	  return _lodash2.default.map(filters, 'lob');
	});
	
	// Plain array of LOBs selected
	var activelobValuesSelector = exports.activelobValuesSelector = (0, _reselect.createSelector)(activeLobFilterSelector, function (lobs) {
	  return _lodash2.default.flatMap(lobs, 'value');
	});
	
	var offerWithPriceSelector = exports.offerWithPriceSelector = (0, _reselect.createSelector)(_offersHelpers.offerSelector, function (offers) {
	  return _lodash2.default.map(offers, function (offer) {
	    return _extends({}, offer, {
	      priceValue: (0, _offersHelpers.extractPrice)(offer.price)
	    });
	  });
	});
	
	// offers filtered by selected LOBs
	// had to change equality check to xor and isEmpty because our LOB order now differs from the LOB order in the offer
	var offerLOBselector = exports.offerLOBselector = (0, _reselect.createSelector)(offerWithPriceSelector, activelobValuesSelector, function (offers, lobs) {
	  return _lodash2.default.filter(offers, function (offer) {
	    return _lodash2.default.isEmpty(_lodash2.default.xor(lobs, offer.linesOfBusiness));
	  });
	});
	
	// The LOB data for all checkboxes
	// Also returns them ordered by the order property
	var lobFilterSelector = exports.lobFilterSelector = (0, _reselect.createSelector)(checkboxFilterSelector, function (filters) {
	  return _lodash2.default.orderBy(_lodash2.default.map(filters, 'lob'), 'order');
	});
	
	//Add disabled and subscribed properties to lob checkbox data
	var filterWithDisabledSelector = exports.filterWithDisabledSelector = (0, _reselect.createSelector)(lobFilterSelector, _plan.addableSelector, _plan.tierOfServiceSelector, _common.flowTypeSelector, enableShowOffersForLobsSelector, function (filters, addAble, tiers, flowType, enableShowOffersForLobs) {
	  return _lodash2.default.map(filters, function (lob) {
	    var subscribed = _lodash2.default.findKey(tiers, ['lineOfBusiness', lob.value]) > -1;
	    var addable = _lodash2.default.indexOf(addAble, lob.value) > -1;
	    var disabledDefault = !addable || subscribed && !enableShowOffersForLobs; //Disabled if LOB not addable
	    var disabledMoveRepackager = !addable && !subscribed; //Disabled if LOB not addable and user is not subscribed to LOB
	    var disabled = flowType === 'MoveRepackager' ? disabledMoveRepackager : disabledDefault;
	
	    return _extends({}, lob, {
	      disabled: disabled,
	      subscribed: subscribed
	    });
	  });
	});
	
	var showOffersForSelectedLobsSelector = exports.showOffersForSelectedLobsSelector = (0, _reselect.createSelector)(enableShowOffersForLobsSelector, showOffersForLobsSelector, activelobValuesSelector, function (enabled, allDisplayableLobs, activeLobs) {
	  var noSelectedLobs = activeLobs.length === 0;
	  var matchFound = enabled && _lodash2.default.some(allDisplayableLobs, function (displayableLobs) {
	    return _lodash2.default.isEmpty(_lodash2.default.xor(displayableLobs, activeLobs));
	  });
	
	  return !enabled || noSelectedLobs || matchFound;
	});
	
	var sliderSelector = exports.sliderSelector = (0, _reselect.createSelector)(filterSelector, function (filters) {
	  return _lodash2.default.flatMap(_lodash2.default.filter(filters, 'isSlider'), 'options');
	});
	
	var priceSelector = exports.priceSelector = (0, _reselect.createSelector)(offerLOBselector, sliderSelector, function (offers, slider) {
	  var minMax = _lodash2.default.reduce(offers, function (result, offer) {
	    var price = (0, _offersHelpers.extractPrice)(offer.price);
	
	    return {
	      max: price > result.max ? price : result.max,
	      min: price < result.min || result.min === 0 ? price : result.min
	    };
	  }, { max: 0, min: 0 });
	
	  var value = slider && slider[0] ? slider[0].value : 0;
	  var lowerValue = slider && slider[0] ? slider[0].lowerValue : 0;
	  var computedValue = value > minMax.max || value < minMax.min ? minMax.max : value;
	  var computedLowerValue = lowerValue > minMax.max || lowerValue < minMax.min ? minMax.min : lowerValue;
	
	  if (!slider[0]) {
	    return [{
	      value: computedValue
	    }];
	  }
	
	  //rounding so step value works properly with slider max and min
	  var nearest = slider[0].step;
	  var roundedMax = (0, _offersHelpers.roundValue)(minMax.max, nearest);
	  var roundedMin = (0, _offersHelpers.roundFloor)(minMax.min, nearest);
	  //rounding the user input because the server could return an
	  //invalid value on first load and the function wouldn't be the wiser
	  //HACK: find a better solution to this, because it shouldn't need to happen after first load
	  var roundedComputed = (0, _offersHelpers.roundValue)(computedValue, nearest);
	  var roundedComputedLower = (0, _offersHelpers.roundFloor)(computedLowerValue, nearest);
	
	  return [_extends({}, slider[0], {
	    max: roundedMax,
	    min: roundedMin,
	    value: roundedComputed,
	    lowerValue: roundedComputedLower
	  })];
	});
	
	var offerPriceSelector = exports.offerPriceSelector = (0, _reselect.createSelector)(offerLOBselector, priceSelector, function (offers, price) {
	  return _lodash2.default.filter(offers, function (offer) {
	    var offerPrice = (0, _offersHelpers.extractPrice)(offer.price);
	    var value = _lodash2.default.get(price, '[0].value');
	    var lowerValue = _lodash2.default.get(price, '[0].lowerValue');
	
	    return offerPrice <= value && offerPrice >= lowerValue;
	  });
	});
	
	// prepares offer data for the datalayer
	var dlOffersSelector = exports.dlOffersSelector = (0, _reselect.createSelector)(_offersHelpers.offerSelector, function (offers) {
	  return (0, _offersHelpers.formatOffersForDataLayer)(offers);
	});
	
	var summaryTitleSelector = exports.summaryTitleSelector = (0, _reselect.createSelector)(offerPriceSelector, activelobValuesSelector, function (offers, lobs) {
	  var offerCount = offers.length;
	  var lobStringValue = (0, _offersHelpers.lobString)(lobs);
	  var summaryTitle = offerCount + ' ' + lobStringValue + ' Offer' + (offers.length !== 1 ? 's' : '');
	
	  return summaryTitle;
	});
	
	var subscribedLobsSelector = exports.subscribedLobsSelector = (0, _reselect.createSelector)(_plan.lobSelector, function (lobs) {
	  return (0, _lodash2.default)(lobs).filter('subscribed').map('lobName').value();
	});
	
	var subscribedLobStringSelector = exports.subscribedLobStringSelector = (0, _reselect.createSelector)(subscribedLobsSelector, function (subscribedLobs) {
	  return (0, _offersHelpers.lobString)(subscribedLobs);
	});
	
	var activeLobStringSelector = exports.activeLobStringSelector = (0, _reselect.createSelector)(activelobValuesSelector, function (lobs) {
	  return (0, _offersHelpers.lobString)(lobs);
	});
	
	var downgradeLobsSelector = exports.downgradeLobsSelector = (0, _reselect.createSelector)(activelobValuesSelector, subscribedLobsSelector, function (activeLobs, subscribedLobs) {
	  return _lodash2.default.xor(activeLobs, subscribedLobs);
	});
	
	var downgradeLobsStringSelector = exports.downgradeLobsStringSelector = (0, _reselect.createSelector)(downgradeLobsSelector, function (lobs) {
	  return (0, _offersHelpers.lobString)(lobs);
	});
	
	var dlPriceStringSelector = exports.dlPriceStringSelector = (0, _reselect.createSelector)(priceSelector, function (prices) {
	  return 'price|' + _lodash2.default.get(_lodash2.default.head(prices), 'lowerValue') + '-' + _lodash2.default.get(_lodash2.default.head(prices), 'value');
	});
	
	var dlFilterOptionSelected = exports.dlFilterOptionSelected = (0, _reselect.createSelector)(dlPriceStringSelector, activelobValuesSelector, function (pricesStringRaw, lobs) {
	  var priceString = ':' + pricesStringRaw;
	  var lobString = _lodash2.default.map(lobs, function (lob) {
	    return _lodash2.default.lowerCase(lob);
	  }).join(':');
	
	  return lobString + priceString;
	});
	
	// HACK: determine whether or not to auto check the internet offers checkbox
	// This is being developed to specifically check the internet box for a "TV ONLY" customer as they currently see 0 offers
	// This should only be active when the config is turned on
	// This should only return true in regular repackager flow but not for move repackage
	var showInternetOffers = exports.showInternetOffers = (0, _reselect.createSelector)(activelobValuesSelector, _common.flowTypeSelector, enableDynamicLobSelectionSelector, function (lobs, flowType, enableDynamicLobSelection) {
	  var onlyTV = _lodash2.default.isEqual(["TV"], lobs);
	  var RepackageFlow = flowType !== 'MoveRepackager';
	
	  return onlyTV && RepackageFlow && enableDynamicLobSelection ? true : false;
	});

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validation = exports.fields = undefined;
	
	var _validation = __webpack_require__(144);
	
	var fields = exports.fields = ['acceptedVerifications', 'acceptedContracts', 'contractsAvailable', 'verificationRequired'];
	
	var validation = exports.validation = (0, _validation.createValidator)({
	  'acceptedContracts': [(0, _validation.equal)(true, 'Please accept the terms and agreements')]
	  // 'acceptedVerifications': [equal(true, 'Please verify you are 18 or older', [[{'name' : 'verificationRequired', 'value': true}]])],
	});
	
	//
	// export const normalizeCart = (state, currentPath) => {
	//   if (_.isEmpty(state.cart.cart)) {
	//     return state.cart.cart;
	//   }
	//
	//   const rawCart = state.cart.cart;
	//   const routes = getRoutes(state, currentPath);
	//
	//   // TODO: This is not the most productive way to do these ckecks with the empty array, we should probably not
	//   // try to fill these variables if detailedCart isn't here
	//
	//   const currentSections = rawCart.detailedCart ? rawCart.detailedCart.cartSections
	//     .filter(
	//       cart => apiTypeToNavigationRoute(cart.customizationType) === routes.currentRoute
	//     ) : [];
	//
	//   // This will only work if one of the installation types has a 0 amount
	//   // otherwise we will need to track the current selection and return the correct sub total
	//   const currentSubTotal = currentSections.length > 0 ? currentSections
	//     .map(section => section.sectionTotalPrice)
	//     .reduce((a, b) => {
	//       const cents = (Number(a.cents) + Number(b.cents));
	//       const rem = Math.floor(cents / 100);
	//       const dollars = Number(a.dollars) + Number(b.dollars) + rem;
	//
	//         return {
	//           dollars: (dollars).toString(),
	//           cents: formatCents((cents % 100).toString())
	//         };
	//     }) : [{dollars: "0", cents: "00"}];
	//
	//   // Currently either SIK or PRO could contain the false value we are looking for so we search for it in
	//   // both places and display accordingly
	//   const displaySelectionRequired = _(currentSections).map('displaySelectionRequired').indexOf(false) === -1;
	//
	//   const cartItems = currentSections.length > 0 ? currentSections
	//     .map(section => section.cartSectionItems)
	//     .reduce((a, b) => a.concat(b), [])
	//     .filter((a) => a.displayInCart) : [];
	//
	//   const cartSummaryItems = rawCart.summaryCart ? rawCart.summaryCart.cartItems : [];
	//   const showSummary = state.cart.showSummary && !routes.currentRoute.disableSummary;
	//
	//   const selectedPaymentOption = getPaymentOptionForState(state, paymentOptionsStates.ACTIVE);
	//   const dueToday = rawCart.hybridCart ? deriveDueToday(state, routes, selectedPaymentOption) : null;
	//
	//   return {
	//     ...rawCart,
	//     displaySelectionRequired,
	//     currentSubTotal,
	//     cartItems,
	//     cartSummaryItems,
	//     currentRoute: routes.currentRoute,
	//     nextRoute: routes.nextRoute,
	//     prevRoute: routes.prevRoute,
	//     cartTabsRoutes: routes.cartTabsRoutes,
	//     showSummary,
	//     dueToday
	//   };
	// };

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.showShippingAddressSelector = exports.allChargesSelector = exports.removedChargesSelector = exports.removedReviewSubItemsSelector = exports.removedReviewItemsSelector = exports.removedChargesSectionSelector = exports.oneTimeChargesSelector = exports.oneTimeChargesSectionSelector = exports.monthlyChargesSelector = exports.monthlyReviewSubItemsSelector = exports.monthlyReviewItemsSelector = exports.monthlyChargesSectionSelector = exports.cartSelector = exports.contractIdsSelector = exports.contractsSelector = exports.reviewSummarySelector = exports.reviewFlowTypeSelector = exports.reviewSelector = exports.currentReviewContentState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _review = __webpack_require__(141);
	
	var _reselect = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentReviewContentState = exports.currentReviewContentState = function currentReviewContentState(state) {
	  return state.review.content;
	};
	
	var reviewSelector = exports.reviewSelector = (0, _reselect.createSelector)(currentReviewContentState, function (content) {
	  return _lodash2.default.get(content, 'review', []);
	});
	
	var reviewFlowTypeSelector = exports.reviewFlowTypeSelector = (0, _reselect.createSelector)(reviewSelector, function (review) {
	  return _lodash2.default.get(review, 'flowType');
	});
	
	var reviewSummarySelector = exports.reviewSummarySelector = (0, _reselect.createSelector)(reviewSelector, reviewFlowTypeSelector, function (review, flowType) {
	  var summary = _lodash2.default.get(review, 'reviewSummary', {});
	
	  return flowType === _review.CHECKOUT_TYPE_PPV ? _extends({}, summary, { newMonthlyTotalCharges: null }) : summary;
	});
	
	var contractsSelector = exports.contractsSelector = (0, _reselect.createSelector)(reviewSelector, function (review) {
	  return _lodash2.default.get(review, 'contracts', []);
	});
	
	var contractIdsSelector = exports.contractIdsSelector = (0, _reselect.createSelector)(contractsSelector, function (contracts) {
	  return _lodash2.default.map(contracts, function (contract) {
	    return contract.contractId;
	  });
	});
	
	var cartSelector = exports.cartSelector = (0, _reselect.createSelector)(currentReviewContentState, function (content) {
	  return _lodash2.default.get(content, 'cart', {});
	});
	
	var monthlyChargesSectionSelector = exports.monthlyChargesSectionSelector = (0, _reselect.createSelector)(reviewSelector, function (review) {
	  return _lodash2.default.get(review, 'reviewChargesSection.monthlyChargesSection', []);
	});
	
	var monthlyReviewItemsSelector = exports.monthlyReviewItemsSelector = (0, _reselect.createSelector)(monthlyChargesSectionSelector, function (review) {
	  return _lodash2.default.get(review, 'reviewItems', []);
	});
	
	var monthlyReviewSubItemsSelector = exports.monthlyReviewSubItemsSelector = (0, _reselect.createSelector)(monthlyChargesSectionSelector, function (review) {
	  return _lodash2.default.get(review, 'reviewSubItems', []);
	});
	
	var monthlyChargesSelector = exports.monthlyChargesSelector = (0, _reselect.createSelector)(monthlyReviewItemsSelector, monthlyReviewSubItemsSelector, function (monthlyItems, monthlySubItems) {
	  return _lodash2.default.merge({}, monthlyItems, monthlySubItems);
	});
	
	var oneTimeChargesSectionSelector = exports.oneTimeChargesSectionSelector = (0, _reselect.createSelector)(reviewSelector, function (review) {
	  return _lodash2.default.get(review, 'reviewChargesSection.oneTimeChargesSection', []);
	});
	
	var oneTimeChargesSelector = exports.oneTimeChargesSelector = (0, _reselect.createSelector)(oneTimeChargesSectionSelector, function (review) {
	  return _lodash2.default.get(review, 'reviewItems', []);
	});
	
	var removedChargesSectionSelector = exports.removedChargesSectionSelector = (0, _reselect.createSelector)(reviewSelector, function (review) {
	  return _lodash2.default.get(review, 'reviewChargesSection.removedChargesSection', []);
	});
	
	var removedReviewItemsSelector = exports.removedReviewItemsSelector = (0, _reselect.createSelector)(removedChargesSectionSelector, function (review) {
	  return _lodash2.default.get(review, 'reviewItems', []);
	});
	
	var removedReviewSubItemsSelector = exports.removedReviewSubItemsSelector = (0, _reselect.createSelector)(removedChargesSectionSelector, function (review) {
	  return _lodash2.default.get(review, 'reviewSubItems', []);
	});
	
	var removedChargesSelector = exports.removedChargesSelector = (0, _reselect.createSelector)(removedReviewItemsSelector, removedReviewSubItemsSelector, function (monthlyItems, monthlySubItems) {
	  return _lodash2.default.merge({}, monthlyItems, monthlySubItems);
	});
	
	var allChargesSelector = exports.allChargesSelector = (0, _reselect.createSelector)(monthlyReviewItemsSelector, monthlyReviewSubItemsSelector, oneTimeChargesSelector, removedReviewItemsSelector, removedReviewSubItemsSelector, function (monthlyItems, monthlySubItems, oneTimeItems, removedItems, removedSubItems) {
	  return _lodash2.default.merge({}, monthlyItems, monthlySubItems, oneTimeItems, removedItems, removedSubItems);
	});
	
	var showShippingAddressSelector = exports.showShippingAddressSelector = (0, _reselect.createSelector)(monthlyReviewSubItemsSelector, function (subItems) {
	  return !_lodash2.default.isEmpty(subItems.equipment);
	});

/***/ },
/* 307 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'hg/account/LOAD_CONTENT';
	
	var account = exports.account = function account() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    default:
	      return state;
	  }
	};
	
	var loadContent = exports.loadContent = function loadContent() {
	  return { type: LOAD_CONTENT };
	};
	
	exports.default = account;

/***/ },
/* 308 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'hg/cancel/LOAD_CONTENT';
	var DISCONNECT_CUSTOMER = exports.DISCONNECT_CUSTOMER = 'hg/cancel/DISCONNECT_CUSTOMER';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'mp/movers/cancel/DL_PAGE_LOADED';

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.touchFields = exports.submitOrder = exports.loadContent = exports.DL_PAGE_LOADED = exports.SUBMIT_ORDER = exports.LOAD_CONTENT = undefined;
	
	var _specialistHelpers = __webpack_require__(643);
	
	Object.keys(_specialistHelpers).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _specialistHelpers[key];
	    }
	  });
	});
	
	var _reduxForm = __webpack_require__(44);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'hg/specialist/LOAD_CONTENT';
	var SUBMIT_ORDER = exports.SUBMIT_ORDER = 'hg/specialist/SUBMIT_ORDER';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'hg/specialist/DL_PAGE_LOADED';
	
	var loadContent = exports.loadContent = function loadContent() {
	  return {
	    type: LOAD_CONTENT
	  };
	};
	
	var submitOrder = exports.submitOrder = function submitOrder() {
	  return {
	    type: SUBMIT_ORDER
	  };
	};
	
	var touchFields = exports.touchFields = function touchFields() {
	  return function (dispatch) {
	    dispatch(_reduxForm.untouch.apply(undefined, ['specialist'].concat(_toConsumableArray(_specialistHelpers.fields))));
	    dispatch(_reduxForm.touch.apply(undefined, ['specialist'].concat(_toConsumableArray(_specialistHelpers.fields))));
	  };
	};

/***/ },
/* 310 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_CUSTOMER = exports.LOAD_CUSTOMER = 'mp/movers/UNSERVICEABLE_LOAD_CUSTOMER';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'mp/movers/unserviceable/DL_PAGE_LOADED';
	
	var loadCustomer = exports.loadCustomer = function loadCustomer() {
	  return {
	    type: LOAD_CUSTOMER
	  };
	};

/***/ },
/* 311 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'mp/confirmation/LOAD_CONTENT';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'mp/confirmation/DL_PAGE_LOADED';
	var SET_DATA = exports.SET_DATA = 'mp/confirmation/SET_DATA';
	
	var loadContent = exports.loadContent = function loadContent() {
	  return {
	    type: LOAD_CONTENT
	  };
	};

/***/ },
/* 312 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'hg/myplan/LOAD_CONTENT';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'hg/myplan/DL_PAGE_LOADED';
	
	var loadContent = exports.loadContent = function loadContent() {
	  return {
	    type: LOAD_CONTENT
	  };
	};

/***/ },
/* 313 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_OFFERS = exports.LOAD_OFFERS = 'mp/show-offers-filter/LOAD_OFFERS';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'hg/show-offers-filter/DL_PAGE_LOADED';
	
	var loadOffers = exports.loadOffers = function loadOffers() {
	  return {
	    type: LOAD_OFFERS
	  };
	};

/***/ },
/* 314 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'hg/confirmation/LOAD_CONTENT';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'hg/confirmation/DL_PAGE_LOADED';
	var SET_DATA_QUICKCHECKOUT = exports.SET_DATA_QUICKCHECKOUT = 'hg/confirmation/SET_DATA_QUICKCHECKOUT';
	
	var loadContent = exports.loadContent = function loadContent() {
	  return {
	    type: LOAD_CONTENT
	  };
	};

/***/ },
/* 315 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'mp/checkout/redirect/LOAD_CONTENT';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'mp/checkout/redirect/DL_PAGE_LOADED';
	
	var loadContent = exports.loadContent = function loadContent() {
	  return {
	    type: LOAD_CONTENT
	  };
	};

/***/ },
/* 316 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'hg/review/LOAD_CONTENT';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'hg/review/DL_PAGE_LOADED';
	var SUBMIT_ORDER = exports.SUBMIT_ORDER = 'hg/review/SUBMIT_ORDER';
	
	var loadContent = exports.loadContent = function loadContent() {
	  return {
	    type: LOAD_CONTENT
	  };
	};

/***/ },
/* 317 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SET_SUGGESTIONS = exports.SET_SUGGESTIONS = 'mp/suggestions/SET_SUGGESTIONS';
	var CLEAR_SUGGESTIONS = exports.CLEAR_SUGGESTIONS = 'mp/suggestions/CLEAR_SUGGESTIONS';
	
	var initialState = exports.initialState = {
	  suggestions: {}
	};
	
	var suggestions = exports.suggestions = function suggestions() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	
	    case SET_SUGGESTIONS:
	      return _extends({}, state, {
	        suggestions: _extends({}, state.suggestions, action.payload.suggestions)
	      });
	
	    case CLEAR_SUGGESTIONS:
	      return _extends({}, state, {
	        suggestions: {}
	      });
	
	    default:
	      return state;
	  }
	};
	
	var setSuggestions = exports.setSuggestions = function setSuggestions(key, suggestions) {
	  return {
	    type: SET_SUGGESTIONS,
	    payload: {
	      suggestions: _defineProperty({}, key, suggestions)
	    }
	  };
	};
	
	var clearSuggestions = exports.clearSuggestions = function clearSuggestions() {
	  return {
	    type: CLEAR_SUGGESTIONS
	  };
	};
	
	exports.default = suggestions;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = exports.ACTIONS_RECEIVED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _update = __webpack_require__(560);
	
	var _update2 = _interopRequireDefault(_update);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACTIONS_RECEIVED = exports.ACTIONS_RECEIVED = 'hg/target/ACTIONS_RECEIVED';
	var initialState = exports.initialState = {
	  actions: [],
	  actionsReceived: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case ACTIONS_RECEIVED:
	      return _extends({}, state, {
	        actions: (0, _update2.default)(state.actions, { $push: [action.payload] }),
	        actionsReceived: true
	      });
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _src = __webpack_require__(672);
	
	exports.default = _src.Badge;

/***/ },
/* 320 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var subfolder = exports.subfolder = '/buy/plan';
	var moversFolder = exports.moversFolder = 'move';
	var checkoutFolder = exports.checkoutFolder = 'checkout';
	var accountFolder = exports.accountFolder = 'account';

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(869);
	
	__webpack_require__(870);
	
	__webpack_require__(689);
	
	/* eslint max-len: 0 */
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	// Should be removed in the next major release:
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(45);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(25)
	  , toIndex  = __webpack_require__(85)
	  , toLength = __webpack_require__(23);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(102);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(31)
	  , toObject  = __webpack_require__(25)
	  , IObject   = __webpack_require__(126)
	  , toLength  = __webpack_require__(23);
	
	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(31)
	  , isObject   = __webpack_require__(14)
	  , invoke     = __webpack_require__(149)
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP          = __webpack_require__(18).f
	  , create      = __webpack_require__(80)
	  , redefineAll = __webpack_require__(83)
	  , ctx         = __webpack_require__(59)
	  , anInstance  = __webpack_require__(78)
	  , defined     = __webpack_require__(46)
	  , forOf       = __webpack_require__(102)
	  , $iterDefine = __webpack_require__(211)
	  , step        = __webpack_require__(333)
	  , setSpecies  = __webpack_require__(84)
	  , DESCRIPTORS = __webpack_require__(17)
	  , fastKey     = __webpack_require__(67).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(125)
	  , from    = __webpack_require__(324);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(83)
	  , getWeak           = __webpack_require__(67).getWeak
	  , anObject          = __webpack_require__(6)
	  , isObject          = __webpack_require__(14)
	  , anInstance        = __webpack_require__(78)
	  , forOf             = __webpack_require__(102)
	  , createArrayMethod = __webpack_require__(51)
	  , $has              = __webpack_require__(29)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ },
/* 330 */
[1295, 17, 12, 203],
/* 331 */
[1299, 14],
/* 332 */
[1300, 6],
/* 333 */
899,
/* 334 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 335 */
[1306, 82, 153, 127, 25, 126, 12],
/* 336 */
[1309, 18, 6, 82, 17],
/* 337 */
[1311, 35, 81],
/* 338 */
[1314, 29, 35, 145, 216],
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(82)
	  , toIObject = __webpack_require__(35)
	  , isEnum    = __webpack_require__(127).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(81)
	  , gOPS     = __webpack_require__(153)
	  , anObject = __webpack_require__(6)
	  , Reflect  = __webpack_require__(8).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(8).parseFloat
	  , $trim       = __webpack_require__(105).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(221) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(8).parseInt
	  , $trim     = __webpack_require__(105).trim
	  , ws        = __webpack_require__(221)
	  , hex       = /^[\-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ },
/* 343 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(23)
	  , repeat   = __webpack_require__(220)
	  , defined  = __webpack_require__(46);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 345 */
[1328, 15],
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(327);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(146)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(17) && /./g.flags != 'g')__webpack_require__(18).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(148)
	});

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(327);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(146)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(51)(0)
	  , redefine     = __webpack_require__(33)
	  , meta         = __webpack_require__(67)
	  , assign       = __webpack_require__(335)
	  , weak         = __webpack_require__(329)
	  , isObject     = __webpack_require__(14)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(146)('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 378 */,
/* 379 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(384),
	    getSymbolsIn = __webpack_require__(392),
	    keysIn = __webpack_require__(173);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(256),
	    getPrototype = __webpack_require__(261),
	    getSymbols = __webpack_require__(262),
	    stubArray = __webpack_require__(407);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(377),
	    baseEach = __webpack_require__(1003),
	    castFunction = __webpack_require__(1028),
	    isArray = __webpack_require__(37);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ },
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1123);


/***/ },
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(98),
	    _assign = __webpack_require__(139);
	
	var invariant = __webpack_require__(5);
	var hasOwnProperty = {}.hasOwnProperty;
	
	function shallowCopy(x) {
	  if (Array.isArray(x)) {
	    return x.concat();
	  } else if (x && typeof x === 'object') {
	    return _assign(new x.constructor(), x);
	  } else {
	    return x;
	  }
	}
	
	var COMMAND_PUSH = '$push';
	var COMMAND_UNSHIFT = '$unshift';
	var COMMAND_SPLICE = '$splice';
	var COMMAND_SET = '$set';
	var COMMAND_MERGE = '$merge';
	var COMMAND_APPLY = '$apply';
	
	var ALL_COMMANDS_LIST = [COMMAND_PUSH, COMMAND_UNSHIFT, COMMAND_SPLICE, COMMAND_SET, COMMAND_MERGE, COMMAND_APPLY];
	
	var ALL_COMMANDS_SET = {};
	
	ALL_COMMANDS_LIST.forEach(function (command) {
	  ALL_COMMANDS_SET[command] = true;
	});
	
	function invariantArrayCase(value, spec, command) {
	  !Array.isArray(value) ?  false ? invariant(false, 'update(): expected target of %s to be an array; got %s.', command, value) : _prodInvariant('1', command, value) : void 0;
	  var specValue = spec[command];
	  !Array.isArray(specValue) ?  false ? invariant(false, 'update(): expected spec of %s to be an array; got %s. Did you forget to wrap your parameter in an array?', command, specValue) : _prodInvariant('2', command, specValue) : void 0;
	}
	
	/**
	 * Returns a updated shallow copy of an object without mutating the original.
	 * See https://facebook.github.io/react/docs/update.html for details.
	 */
	function update(value, spec) {
	  !(typeof spec === 'object') ?  false ? invariant(false, 'update(): You provided a key path to update() that did not contain one of %s. Did you forget to include {%s: ...}?', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : _prodInvariant('3', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : void 0;
	
	  if (hasOwnProperty.call(spec, COMMAND_SET)) {
	    !(Object.keys(spec).length === 1) ?  false ? invariant(false, 'Cannot have more than one key in an object with %s', COMMAND_SET) : _prodInvariant('4', COMMAND_SET) : void 0;
	
	    return spec[COMMAND_SET];
	  }
	
	  var nextValue = shallowCopy(value);
	
	  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
	    var mergeObj = spec[COMMAND_MERGE];
	    !(mergeObj && typeof mergeObj === 'object') ?  false ? invariant(false, 'update(): %s expects a spec of type \'object\'; got %s', COMMAND_MERGE, mergeObj) : _prodInvariant('5', COMMAND_MERGE, mergeObj) : void 0;
	    !(nextValue && typeof nextValue === 'object') ?  false ? invariant(false, 'update(): %s expects a target of type \'object\'; got %s', COMMAND_MERGE, nextValue) : _prodInvariant('6', COMMAND_MERGE, nextValue) : void 0;
	    _assign(nextValue, spec[COMMAND_MERGE]);
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
	    invariantArrayCase(value, spec, COMMAND_PUSH);
	    spec[COMMAND_PUSH].forEach(function (item) {
	      nextValue.push(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
	    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
	    spec[COMMAND_UNSHIFT].forEach(function (item) {
	      nextValue.unshift(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
	    !Array.isArray(value) ?  false ? invariant(false, 'Expected %s target to be an array; got %s', COMMAND_SPLICE, value) : _prodInvariant('7', COMMAND_SPLICE, value) : void 0;
	    !Array.isArray(spec[COMMAND_SPLICE]) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : _prodInvariant('8', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : void 0;
	    spec[COMMAND_SPLICE].forEach(function (args) {
	      !Array.isArray(args) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : _prodInvariant('8', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : void 0;
	      nextValue.splice.apply(nextValue, args);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
	    !(typeof spec[COMMAND_APPLY] === 'function') ?  false ? invariant(false, 'update(): expected spec of %s to be a function; got %s.', COMMAND_APPLY, spec[COMMAND_APPLY]) : _prodInvariant('9', COMMAND_APPLY, spec[COMMAND_APPLY]) : void 0;
	    nextValue = spec[COMMAND_APPLY](nextValue);
	  }
	
	  for (var k in spec) {
	    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
	      nextValue[k] = update(value[k], spec[k]);
	    }
	  }
	
	  return nextValue;
	}
	
	module.exports = update;

/***/ },
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPersistor;
	
	var _constants = __webpack_require__(140);
	
	var _asyncLocalStorage = __webpack_require__(295);
	
	var _asyncLocalStorage2 = _interopRequireDefault(_asyncLocalStorage);
	
	var _purgeStoredState = __webpack_require__(571);
	
	var _purgeStoredState2 = _interopRequireDefault(_purgeStoredState);
	
	var _jsonStringifySafe = __webpack_require__(986);
	
	var _jsonStringifySafe2 = _interopRequireDefault(_jsonStringifySafe);
	
	var _forEach = __webpack_require__(404);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPersistor(store, config) {
	  // defaults
	  var serialize = config.serialize || defaultSerialize;
	  var deserialize = config.deserialize || defaultDeserialize;
	  var blacklist = config.blacklist || [];
	  var whitelist = config.whitelist || false;
	  var transforms = config.transforms || [];
	  var debounce = config.debounce || false;
	  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : _constants.KEY_PREFIX;
	
	  // pluggable state shape (e.g. immutablejs)
	  var stateInit = config._stateInit || {};
	  var stateIterator = config._stateIterator || defaultStateIterator;
	  var stateGetter = config._stateGetter || defaultStateGetter;
	  var stateSetter = config._stateSetter || defaultStateSetter;
	
	  // storage with keys -> getAllKeys for localForage support
	  var storage = config.storage || (0, _asyncLocalStorage2.default)('local');
	  if (storage.keys && !storage.getAllKeys) {
	    storage.getAllKeys = storage.keys;
	  }
	
	  // initialize stateful values
	  var lastState = stateInit;
	  var paused = false;
	  var storesToProcess = [];
	  var timeIterator = null;
	
	  store.subscribe(function () {
	    if (paused) return;
	
	    var state = store.getState();
	
	    stateIterator(state, function (subState, key) {
	      if (!passWhitelistBlacklist(key)) return;
	      if (stateGetter(lastState, key) === stateGetter(state, key)) return;
	      if (storesToProcess.indexOf(key) !== -1) return;
	      storesToProcess.push(key);
	    });
	
	    // time iterator (read: debounce)
	    if (timeIterator === null) {
	      timeIterator = setInterval(function () {
	        if (storesToProcess.length === 0) {
	          clearInterval(timeIterator);
	          timeIterator = null;
	          return;
	        }
	
	        var key = storesToProcess[0];
	        var storageKey = createStorageKey(key);
	        var endState = transforms.reduce(function (subState, transformer) {
	          return transformer.in(subState, key);
	        }, stateGetter(store.getState(), key));
	        if (typeof endState !== 'undefined') storage.setItem(storageKey, serialize(endState), warnIfSetError(key));
	        storesToProcess.shift();
	      }, debounce);
	    }
	
	    lastState = state;
	  });
	
	  function passWhitelistBlacklist(key) {
	    if (whitelist && whitelist.indexOf(key) === -1) return false;
	    if (blacklist.indexOf(key) !== -1) return false;
	    return true;
	  }
	
	  function adhocRehydrate(incoming) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var state = {};
	    if (options.serial) {
	      (0, _forEach2.default)(incoming, function (subState, key) {
	        try {
	          var data = deserialize(subState);
	          var value = transforms.reduceRight(function (interState, transformer) {
	            return transformer.out(interState, key);
	          }, data);
	          state = stateSetter(state, key, value);
	        } catch (err) {
	          if (false) console.warn('Error rehydrating data for key "' + key + '"', subState, err);
	        }
	      });
	    } else state = incoming;
	
	    store.dispatch(rehydrateAction(state));
	    return state;
	  }
	
	  function createStorageKey(key) {
	    return '' + keyPrefix + key;
	  }
	
	  // return `persistor`
	  return {
	    rehydrate: adhocRehydrate,
	    pause: function pause() {
	      paused = true;
	    },
	    resume: function resume() {
	      paused = false;
	    },
	    purge: function purge(keys) {
	      return (0, _purgeStoredState2.default)({ storage: storage, keyPrefix: keyPrefix }, keys);
	    }
	  };
	}
	
	function warnIfSetError(key) {
	  return function setError(err) {
	    if (err && ("production") !== 'production') {
	      console.warn('Error storing data for key:', key, err);
	    }
	  };
	}
	
	function defaultSerialize(data) {
	  return (0, _jsonStringifySafe2.default)(data, null, null, function (k, v) {
	    if (false) return null;
	    throw new Error('\n      redux-persist: cannot process cyclical state.\n      Consider changing your state structure to have no cycles.\n      Alternatively blacklist the corresponding reducer key.\n      Cycle encounted at key "' + k + '" with value "' + v + '".\n    ');
	  });
	}
	
	function defaultDeserialize(serial) {
	  return JSON.parse(serial);
	}
	
	function rehydrateAction(data) {
	  return {
	    type: _constants.REHYDRATE,
	    payload: data
	  };
	}
	
	function defaultStateIterator(collection, callback) {
	  return (0, _forEach2.default)(collection, callback);
	}
	
	function defaultStateGetter(state, key) {
	  return state[key];
	}
	
	function defaultStateSetter(state, key, value) {
	  state[key] = value;
	  return state;
	}

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = getStoredState;
	
	var _forEach = __webpack_require__(404);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _constants = __webpack_require__(140);
	
	var _asyncLocalStorage = __webpack_require__(295);
	
	var _asyncLocalStorage2 = _interopRequireDefault(_asyncLocalStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStoredState(config, onComplete) {
	  var storage = config.storage || (0, _asyncLocalStorage2.default)('local');
	  var deserialize = config.deserialize || defaultDeserialize;
	  var blacklist = config.blacklist || [];
	  var whitelist = config.whitelist || false;
	  var transforms = config.transforms || [];
	  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : _constants.KEY_PREFIX;
	
	  // fallback getAllKeys to `keys` if present (LocalForage compatability)
	  if (storage.keys && !storage.getAllKeys) storage = _extends({}, storage, { getAllKeys: storage.keys });
	
	  var restoredState = {};
	  var completionCount = 0;
	
	  storage.getAllKeys(function (err, allKeys) {
	    if (err) {
	      if (false) console.warn('redux-persist/getStoredState: Error in storage.getAllKeys');
	      complete(err);
	    }
	
	    var persistKeys = allKeys.filter(function (key) {
	      return key.indexOf(keyPrefix) === 0;
	    }).map(function (key) {
	      return key.slice(keyPrefix.length);
	    });
	    var keysToRestore = persistKeys.filter(passWhitelistBlacklist);
	
	    var restoreCount = keysToRestore.length;
	    if (restoreCount === 0) complete(null, restoredState);
	    (0, _forEach2.default)(keysToRestore, function (key) {
	      storage.getItem(createStorageKey(key), function (err, serialized) {
	        if (err && ("production") !== 'production') console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);else restoredState[key] = rehydrate(key, serialized);
	        completionCount += 1;
	        if (completionCount === restoreCount) complete(null, restoredState);
	      });
	    });
	  });
	
	  function rehydrate(key, serialized) {
	    var state = null;
	
	    try {
	      var data = deserialize(serialized);
	      state = transforms.reduceRight(function (subState, transformer) {
	        return transformer.out(subState, key);
	      }, data);
	    } catch (err) {
	      if (false) console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);
	    }
	
	    return state;
	  }
	
	  function complete(err, restoredState) {
	    onComplete(err, restoredState);
	  }
	
	  function passWhitelistBlacklist(key) {
	    if (whitelist && whitelist.indexOf(key) === -1) return false;
	    if (blacklist.indexOf(key) !== -1) return false;
	    return true;
	  }
	
	  function createStorageKey(key) {
	    return '' + keyPrefix + key;
	  }
	
	  if (typeof onComplete !== 'function' && !!Promise) {
	    return new Promise(function (resolve, reject) {
	      onComplete = function onComplete(err, restoredState) {
	        if (err) reject(err);else resolve(restoredState);
	      };
	    });
	  }
	}
	
	function defaultDeserialize(serial) {
	  return JSON.parse(serial);
	}

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = purgeStoredState;
	
	var _constants = __webpack_require__(140);
	
	function purgeStoredState(config, keys) {
	  var storage = config.storage;
	  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : _constants.KEY_PREFIX;
	
	  // basic validation
	  if (Array.isArray(config)) throw new Error('redux-persist: purgeStoredState requires config as a first argument (found array). An array of keys is the optional second argument.');
	  if (!storage) throw new Error('redux-persist: config.storage required in purgeStoredState');
	
	  if (typeof keys === 'undefined') {
	    // if keys is not defined, purge all keys
	    return new Promise(function (resolve, reject) {
	      storage.getAllKeys(function (err, allKeys) {
	        if (err && ("production") !== 'production') {
	          console.warn('redux-persist: error during purgeStoredState in storage.getAllKeys');
	          reject(err);
	        } else {
	          resolve(purgeStoredState(config, allKeys.filter(function (key) {
	            return key.indexOf(keyPrefix) === 0;
	          }).map(function (key) {
	            return key.slice(keyPrefix.length);
	          })));
	        }
	      });
	    });
	  } else {
	    // otherwise purge specified keys
	    return Promise.all(keys.map(function (key) {
	      return storage.removeItem('' + keyPrefix + key, warnIfRemoveError(key));
	    }));
	  }
	}
	
	function warnIfRemoveError(key) {
	  return function removeError(err) {
	    if (err && ("production") !== 'production') {
	      console.warn('Error storing data for key:', key, err);
	    }
	  };
	}

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _io = __webpack_require__(186);
	
	Object.defineProperty(exports, 'take', {
	  enumerable: true,
	  get: function get() {
	    return _io.take;
	  }
	});
	Object.defineProperty(exports, 'takem', {
	  enumerable: true,
	  get: function get() {
	    return _io.takem;
	  }
	});
	Object.defineProperty(exports, 'put', {
	  enumerable: true,
	  get: function get() {
	    return _io.put;
	  }
	});
	Object.defineProperty(exports, 'race', {
	  enumerable: true,
	  get: function get() {
	    return _io.race;
	  }
	});
	Object.defineProperty(exports, 'call', {
	  enumerable: true,
	  get: function get() {
	    return _io.call;
	  }
	});
	Object.defineProperty(exports, 'apply', {
	  enumerable: true,
	  get: function get() {
	    return _io.apply;
	  }
	});
	Object.defineProperty(exports, 'cps', {
	  enumerable: true,
	  get: function get() {
	    return _io.cps;
	  }
	});
	Object.defineProperty(exports, 'fork', {
	  enumerable: true,
	  get: function get() {
	    return _io.fork;
	  }
	});
	Object.defineProperty(exports, 'spawn', {
	  enumerable: true,
	  get: function get() {
	    return _io.spawn;
	  }
	});
	Object.defineProperty(exports, 'join', {
	  enumerable: true,
	  get: function get() {
	    return _io.join;
	  }
	});
	Object.defineProperty(exports, 'cancel', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancel;
	  }
	});
	Object.defineProperty(exports, 'select', {
	  enumerable: true,
	  get: function get() {
	    return _io.select;
	  }
	});
	Object.defineProperty(exports, 'actionChannel', {
	  enumerable: true,
	  get: function get() {
	    return _io.actionChannel;
	  }
	});
	Object.defineProperty(exports, 'cancelled', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancelled;
	  }
	});
	Object.defineProperty(exports, 'flush', {
	  enumerable: true,
	  get: function get() {
	    return _io.flush;
	  }
	});
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _io.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _io.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _io.throttle;
	  }
	});

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.throttle = exports.takeLatest = exports.takeEvery = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.takeEveryHelper = takeEveryHelper;
	exports.takeLatestHelper = takeLatestHelper;
	exports.throttleHelper = throttleHelper;
	
	var _channel = __webpack_require__(185);
	
	var _utils = __webpack_require__(66);
	
	var _io = __webpack_require__(186);
	
	var _buffers = __webpack_require__(184);
	
	var done = { done: true, value: undefined };
	var qEnd = {};
	
	function fsmIterator(fsm, q0) {
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';
	
	  var updateState = void 0,
	      qNext = q0;
	
	  function next(arg, error) {
	    if (qNext === qEnd) {
	      return done;
	    }
	
	    if (error) {
	      qNext = qEnd;
	      throw error;
	    } else {
	      updateState && updateState(arg);
	
	      var _fsm$qNext = fsm[qNext](),
	          _fsm$qNext2 = _slicedToArray(_fsm$qNext, 3),
	          q = _fsm$qNext2[0],
	          output = _fsm$qNext2[1],
	          _updateState = _fsm$qNext2[2];
	
	      qNext = q;
	      updateState = _updateState;
	      return qNext === qEnd ? done : output;
	    }
	  }
	
	  return (0, _utils.makeIterator)(next, function (error) {
	    return next(null, error);
	  }, name, true);
	}
	
	function safeName(patternOrChannel) {
	  if (_utils.is.channel(patternOrChannel)) {
	    return 'channel';
	  } else if (Array.isArray(patternOrChannel)) {
	    return String(patternOrChannel.map(function (entry) {
	      return String(entry);
	    }));
	  } else {
	    return String(patternOrChannel);
	  }
	}
	
	function takeEveryHelper(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	
	  var action = void 0,
	      setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [qEnd] : ['q1', yFork(action)];
	    }
	  }, 'q1', 'takeEvery(' + safeName(patternOrChannel) + ', ' + worker.name + ')');
	}
	
	function takeLatestHelper(patternOrChannel, worker) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	    args[_key2 - 2] = arguments[_key2];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yCancel = function yCancel(task) {
	    return { done: false, value: (0, _io.cancel)(task) };
	  };
	
	  var task = void 0,
	      action = void 0;
	  var setTask = function setTask(t) {
	    return task = t;
	  };
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
	    },
	    q3: function q3() {
	      return ['q1', yFork(action), setTask];
	    }
	  }, 'q1', 'takeLatest(' + safeName(patternOrChannel) + ', ' + worker.name + ')');
	}
	
	function throttleHelper(delayLength, pattern, worker) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
	    args[_key3 - 3] = arguments[_key3];
	  }
	
	  var action = void 0,
	      channel = void 0;
	
	  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
	  var yTake = function yTake() {
	    return { done: false, value: (0, _io.take)(channel, pattern) };
	  };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };
	
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	  var setChannel = function setChannel(ch) {
	    return channel = ch;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return ['q2', yActionChannel, setChannel];
	    },
	    q2: function q2() {
	      return ['q3', yTake(), setAction];
	    },
	    q3: function q3() {
	      return action === _channel.END ? [qEnd] : ['q4', yFork(action)];
	    },
	    q4: function q4() {
	      return ['q2', yDelay];
	    }
	  }, 'q1', 'throttle(' + safeName(pattern) + ', ' + worker.name + ')');
	}
	
	var deprecationWarning = function deprecationWarning(helperName) {
	  return 'import ' + helperName + ' from \'redux-saga\' has been deprecated in favor of import ' + helperName + ' from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
	};
	var takeEvery = exports.takeEvery = (0, _utils.deprecate)(takeEveryHelper, deprecationWarning('takeEvery'));
	var takeLatest = exports.takeLatest = (0, _utils.deprecate)(takeLatestHelper, deprecationWarning('takeLatest'));
	var throttle = exports.throttle = (0, _utils.deprecate)(throttleHelper, deprecationWarning('throttle'));

/***/ },
/* 574 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.asap = asap;
	exports.suspend = suspend;
	exports.flush = flush;
	
	var queue = [];
	/**
	  Variable to hold a counting semaphore
	  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
	    already suspended)
	  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
	    triggers flushing the queued tasks.
	**/
	var semaphore = 0;
	
	/**
	  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
	  and flushed after this task has finished (assuming the scheduler endup in a released
	  state).
	**/
	function exec(task) {
	  try {
	    suspend();
	    task();
	  } finally {
	    flush();
	  }
	}
	
	/**
	  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
	**/
	function asap(task) {
	  if (!semaphore) {
	    exec(task);
	  } else {
	    queue.push(task);
	  }
	}
	
	/**
	  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
	  scheduler is released.
	**/
	function suspend() {
	  semaphore++;
	}
	
	/**
	  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
	**/
	function flush() {
	  semaphore--;
	  if (!semaphore && queue.length) {
	    exec(queue.shift());
	  }
	}

/***/ },
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppContainer = __webpack_require__(610);
	
	var _AppContainer2 = _interopRequireDefault(_AppContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _AppContainer2.default,
	        null,
	        this.props.children
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	App.propTypes = {
	  children: _react.PropTypes.element,
	  route: _react.PropTypes.object
	};
	
	exports.default = App;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(28);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _IconError = __webpack_require__(597);
	
	var _IconError2 = _interopRequireDefault(_IconError);
	
	var _helpers = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ErrorPanel = function (_Component) {
	  _inherits(ErrorPanel, _Component);
	
	  function ErrorPanel() {
	    _classCallCheck(this, ErrorPanel);
	
	    return _possibleConstructorReturn(this, (ErrorPanel.__proto__ || Object.getPrototypeOf(ErrorPanel)).apply(this, arguments));
	  }
	
	  _createClass(ErrorPanel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          errors = _props.errors;
	
	
	      var flatErrors = (0, _helpers.flattenObject)(errors);
	
	      var classes = 'x-error-panel';
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(className, classes) },
	        Object.keys(flatErrors).map(function (error, index) {
	          return _react2.default.createElement(
	            'p',
	            { className: 'x-error-message x-body1', key: index },
	            _react2.default.createElement(_IconError2.default, { className: 'x-error-icon', size: '30' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'x-error-text' },
	              flatErrors[error]
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return ErrorPanel;
	}(_react.Component);
	
	ErrorPanel.propTypes = {
	  className: _react.PropTypes.string,
	  errors: _react.PropTypes.object
	};
	
	exports.default = ErrorPanel;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(28);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var iconError = function (_Component) {
	  _inherits(iconError, _Component);
	
	  function iconError() {
	    _classCallCheck(this, iconError);
	
	    return _possibleConstructorReturn(this, (iconError.__proto__ || Object.getPrototypeOf(iconError)).apply(this, arguments));
	  }
	
	  _createClass(iconError, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          _props$size = _props.size,
	          size = _props$size === undefined ? 60 : _props$size;
	
	
	      var classes = '';
	
	      return _react2.default.createElement(
	        'svg',
	        { className: (0, _classnames2.default)(className, classes), width: size, height: size, viewBox: '0 0 60 60', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement(
	          'title',
	          null,
	          'Alert'
	        ),
	        _react2.default.createElement(
	          'g',
	          { fill: 'none', fillRule: 'evenodd' },
	          _react2.default.createElement('path', { d: 'M30 0C13.43 0 0 13.43 0 30s13.43 30 30 30 30-13.43 30-30S46.57 0 30 0', fill: '#FB543F' }),
	          _react2.default.createElement('path', { d: 'M33.333 13.333v9.954l-1.266 13.38h-4.084l-1.316-13.38v-9.954h6.666zm-6.626 33.334h6.626V40.04h-6.626v6.627z', fill: '#FFF' })
	        )
	      );
	    }
	  }]);
	
	  return iconError;
	}(_react.Component);
	
	iconError.propTypes = {
	  className: _react.PropTypes.string,
	  size: _react.PropTypes.string
	};
	
	exports.default = iconError;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(143);
	
	var _contentProvider = __webpack_require__(74);
	
	var _contentProvider2 = _interopRequireDefault(_contentProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
	  }
	
	  _createClass(Footer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { 'aria-label': 'Footer', role: 'footer', className: 'mp-footer' },
	        _react2.default.createElement(
	          _Grid.Row,
	          { className: 'flex-align-center centered-column no-margin' },
	          _react2.default.createElement(
	            _Grid.Col,
	            { xs: 12 },
	            _react2.default.createElement(
	              'p',
	              { className: 'text-center x-body3' },
	              String.fromCharCode(169),
	              ' ',
	              _contentProvider2.default.getValue('myplanFooter.copyrightYear'),
	              ' Comcast'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(28);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputField = function (_Component) {
	  _inherits(InputField, _Component);
	
	  function InputField() {
	    _classCallCheck(this, InputField);
	
	    return _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).apply(this, arguments));
	  }
	
	  _createClass(InputField, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          dataTracking = _props.dataTracking,
	          input = _props.input,
	          id = _props.id,
	          labelText = _props.labelText,
	          placeholder = _props.placeholder,
	          min = _props.min,
	          max = _props.max,
	          type = _props.type,
	          beforeOnChange = _props.beforeOnChange,
	          afterOnChange = _props.afterOnChange,
	          beforeOnBlur = _props.beforeOnBlur,
	          afterOnBlur = _props.afterOnBlur,
	          onKeyDown = _props.onKeyDown,
	          _props$meta = _props.meta,
	          touched = _props$meta.touched,
	          error = _props$meta.error,
	          invalid = _props$meta.invalid;
	
	
	      var inputIsDatepicker = type === "date";
	      var inputIsCheckbox = type === "checkbox";
	
	      var containerClasses = {
	        "form-group__field": true,
	        "date-picker": inputIsDatepicker,
	        "x-field x-field--checkbox": inputIsCheckbox,
	        "form-group__msg--error": inputIsCheckbox && touched && invalid
	      };
	
	      var inputClasses = {
	        "form-control": true,
	        "x-input-checkbox x-checkbox x--vh": inputIsCheckbox
	      };
	
	      var labelClasses = {
	        "x-field__label": true,
	        "x-checkbox-label": inputIsCheckbox
	      };
	
	      var errorMessagingEnabled = error && touched;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        inputIsCheckbox && errorMessagingEnabled && _react2.default.createElement(
	          'strong',
	          { className: 'form-group__msg form-group__msg--error' },
	          error
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(containerClasses) },
	          _react2.default.createElement('input', _extends({}, input, {
	            'data-tracking': dataTracking,
	            min: min,
	            max: max,
	            placeholder: placeholder,
	            id: id,
	            type: type,
	            className: (0, _classnames2.default)(inputClasses),
	            onKeyDown: onKeyDown,
	            onBlur: function onBlur(event) {
	              beforeOnBlur(event);
	              input.onBlur(inputIsCheckbox ? input.checked : event.target.value);
	              afterOnBlur(event);
	            },
	            onChange: function onChange(event) {
	              beforeOnChange(event);
	              input.onChange(inputIsCheckbox ? !input.checked : event.target.value);
	              afterOnChange(event);
	            } })),
	          labelText && _react2.default.createElement(
	            'label',
	            { className: (0, _classnames2.default)(labelClasses), htmlFor: id },
	            _react2.default.createElement(
	              'span',
	              null,
	              labelText
	            )
	          )
	        ),
	        !inputIsCheckbox && errorMessagingEnabled && _react2.default.createElement(
	          'span',
	          { className: 'form-group__msg form-group__msg--error' },
	          error
	        )
	      );
	    }
	  }]);
	
	  return InputField;
	}(_react.Component);
	
	InputField.defaultProps = {
	  beforeOnChange: function beforeOnChange() {},
	  afterOnChange: function afterOnChange() {},
	  beforeOnBlur: function beforeOnBlur() {},
	  afterOnBlur: function afterOnBlur() {},
	  onKeyDown: function onKeyDown() {}
	};
	
	InputField.propTypes = {
	  input: _react.PropTypes.object.isRequired,
	  id: _react.PropTypes.string,
	  labelText: _react.PropTypes.string,
	  placeholder: _react.PropTypes.string,
	  min: _react.PropTypes.string,
	  max: _react.PropTypes.string,
	  type: _react.PropTypes.string,
	  meta: _react.PropTypes.object,
	  beforeOnChange: _react.PropTypes.func,
	  afterOnChange: _react.PropTypes.func,
	  beforeOnBlur: _react.PropTypes.func,
	  afterOnBlur: _react.PropTypes.func,
	  onKeyDown: _react.PropTypes.func,
	  dataTracking: _react.PropTypes.object,
	  showErrorLabel: _react.PropTypes.bool
	};
	
	exports.default = InputField;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExternalLink = __webpack_require__(300);
	
	var _ExternalLink2 = _interopRequireDefault(_ExternalLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CenterNavButton = function (_Component) {
		_inherits(CenterNavButton, _Component);
	
		function CenterNavButton() {
			_classCallCheck(this, CenterNavButton);
	
			return _possibleConstructorReturn(this, (CenterNavButton.__proto__ || Object.getPrototypeOf(CenterNavButton)).apply(this, arguments));
		}
	
		_createClass(CenterNavButton, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_ExternalLink2.default,
					{ href: '/', 'data-tracking': JSON.stringify({ eventAction: 'XFINITY' }) },
					_react2.default.createElement(
						'div',
						{ className: 'polaris-xfinity-logo text-center' },
						_react2.default.createElement(
							'span',
							{ className: 'vh' },
							'xfinity'
						)
					)
				);
			}
		}]);
	
		return CenterNavButton;
	}(_react.Component);
	
	exports.default = CenterNavButton;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _navHelpers = __webpack_require__(301);
	
	var _reactRouter = __webpack_require__(16);
	
	var _ExternalLink = __webpack_require__(300);
	
	var _ExternalLink2 = _interopRequireDefault(_ExternalLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeftNavButton = function (_Component) {
		_inherits(LeftNavButton, _Component);
	
		function LeftNavButton() {
			_classCallCheck(this, LeftNavButton);
	
			return _possibleConstructorReturn(this, (LeftNavButton.__proto__ || Object.getPrototypeOf(LeftNavButton)).apply(this, arguments));
		}
	
		_createClass(LeftNavButton, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    salesSessionId = _props.salesSessionId,
				    showCancelButton = _props.showCancelButton,
				    backNavText = _props.backNavText,
				    backNavDestination = _props.backNavDestination,
				    backNavIsExternalDestination = _props.backNavIsExternalDestination;
	
	
				var renderBackNav = function renderBackNav(isExternalDestination) {
					return isExternalDestination ? externalBackNav : internalBackNav;
				};
				var externalBackNav = _react2.default.createElement(
					_ExternalLink2.default,
					{ 'data-tracking': JSON.stringify({ backNavText: backNavText }), href: backNavDestination },
					_react2.default.createElement(
						'span',
						{ className: 'polaris-xfinity-back x-body2' },
						_react2.default.createElement(
							'span',
							{ className: 'vh-small' },
							backNavText
						)
					)
				);
				var internalBackNav = _react2.default.createElement(
					_reactRouter.Link,
					{ 'data-tracking': JSON.stringify({ backNavText: backNavText }), to: backNavDestination },
					_react2.default.createElement(
						'span',
						{ className: 'polaris-xfinity-back x-body2' },
						_react2.default.createElement(
							'span',
							{ className: 'vh-small' },
							backNavText
						)
					)
				);
	
				var renderCancelButton = function renderCancelButton() {
					return _react2.default.createElement(
						'button',
						{ className: 'x-button--text', 'data-tracking': {}, onClick: function onClick() {
								return (0, _navHelpers.closeWindow)({ salesSessionId: salesSessionId });
							} },
						_react2.default.createElement(
							'span',
							{ className: 'polaris-xfinity-back--cancel x-body2' },
							'Cancel'
						)
					);
				};
	
				return _react2.default.createElement(
					'div',
					null,
					backNavDestination && !showCancelButton && renderBackNav(backNavIsExternalDestination),
					showCancelButton && renderCancelButton()
				);
			}
		}]);
	
		return LeftNavButton;
	}(_react.Component);
	
	LeftNavButton.propTypes = {
		salesSessionId: _react.PropTypes.string,
		showCancelButton: _react.PropTypes.bool.isRequired,
		backNavText: _react.PropTypes.string,
		backNavDestination: _react.PropTypes.string,
		backNavIsExternalDestination: _react.PropTypes.bool
	};
	
	exports.default = LeftNavButton;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(43);
	
	var _Grid = __webpack_require__(143);
	
	var _navHelpers = __webpack_require__(301);
	
	var _LeftNavButton = __webpack_require__(601);
	
	var _LeftNavButton2 = _interopRequireDefault(_LeftNavButton);
	
	var _CenterNavButton = __webpack_require__(600);
	
	var _CenterNavButton2 = _interopRequireDefault(_CenterNavButton);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nav = function (_Component) {
	  _inherits(Nav, _Component);
	
	  function Nav() {
	    _classCallCheck(this, Nav);
	
	    return _possibleConstructorReturn(this, (Nav.__proto__ || Object.getPrototypeOf(Nav)).apply(this, arguments));
	  }
	
	  _createClass(Nav, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          showCancelButton = _props.showCancelButton,
	          backNavDestination = _props.backNavDestination;
	
	
	      var showLeftNavButton = backNavDestination || showCancelButton;
	
	      return _react2.default.createElement(
	        'div',
	        { role: 'banner', className: 'polaris-rwd', 'data-dtm': 'container', 'data-dtm-level1': 'header', id: 'polaris-nav-header-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { 'aria-label': 'Main Navigation', className: 'polaris-recognized', 'data-click-track-placement': 'GlobalHeader', id: 'polaris-header', role: 'navigation' },
	          _react2.default.createElement(
	            'div',
	            { className: 'polaris-nav container', 'data-track-module': 'header', 'data-track-type': 'basic' },
	            _react2.default.createElement(
	              _Grid.Row,
	              null,
	              _react2.default.createElement(
	                _Grid.Col,
	                { xs: 12 },
	                _react2.default.createElement(
	                  _Grid.Row,
	                  { className: 'flex-align-center' },
	                  showLeftNavButton && _react2.default.createElement(
	                    _Grid.Col,
	                    { xs: 4, className: 'polaris-xfinity-back-container text-left' },
	                    _react2.default.createElement(_LeftNavButton2.default, this.props)
	                  ),
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    { xs: showLeftNavButton ? 4 : 12, className: 'text-center' },
	                    _react2.default.createElement(_CenterNavButton2.default, null)
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Nav;
	}(_react.Component);
	
	Nav.propTypes = {
	  showCancelButton: _react.PropTypes.bool.isRequired,
	  backNavDestination: _react.PropTypes.string
	};
	
	function mapStateToProps(state) {
	  var _navRoolz = (0, _navHelpers.navRoolz)(state),
	      showCancelButton = _navRoolz.showCancelButton,
	      backNavText = _navRoolz.backNavText,
	      backNavDestination = _navRoolz.backNavDestination,
	      backNavIsExternalDestination = _navRoolz.backNavIsExternalDestination;
	
	  return {
	    salesSessionId: _lodash2.default.get(state, 'common.salesSessionId', ''),
	    showCancelButton: showCancelButton,
	    backNavText: backNavText,
	    backNavDestination: backNavDestination,
	    backNavIsExternalDestination: backNavIsExternalDestination
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Nav);

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaderAdvanced = __webpack_require__(539);
	
	var _reactLoaderAdvanced2 = _interopRequireDefault(_reactLoaderAdvanced);
	
	var _classnames = __webpack_require__(28);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = function (_Component) {
	  _inherits(Spinner, _Component);
	
	  function Spinner() {
	    _classCallCheck(this, Spinner);
	
	    return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
	  }
	
	  _createClass(Spinner, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          isGlobal = _props.isGlobal,
	          slim = _props.slim,
	          message = _props.message,
	          _props$backgroundStyl = _props.backgroundStyle,
	          backgroundStyle = _props$backgroundStyl === undefined ? { position: 'absolute' } : _props$backgroundStyl;
	
	
	      var Message = _react2.default.createElement(
	        'div',
	        { className: 'spinner-container' },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('spinner', { 'slim': slim }, { 'spinner-inline': !isGlobal }) },
	          _react2.default.createElement('div', { className: 'bounce1' }),
	          _react2.default.createElement('div', { className: 'bounce2' }),
	          _react2.default.createElement('div', { className: 'bounce3' })
	        ),
	        message && _react2.default.createElement(
	          'h2',
	          { className: 'spinner-message x-heading3' },
	          message
	        )
	      );
	
	      return _react2.default.createElement(
	        _reactLoaderAdvanced2.default,
	        _extends({
	          backgroundBlur: 47,
	          backgroundStyle: _extends({ backgroundColor: 'rgba(0,0,0,0.15)' }, backgroundStyle)
	        }, this.props, {
	          message: Message
	        }),
	        children
	      );
	    }
	  }]);
	
	  return Spinner;
	}(_react.Component);
	
	Spinner.propTypes = {
	  children: _react.PropTypes.node,
	  isGlobal: _react.PropTypes.bool,
	  backgroundStyle: _react.PropTypes.object,
	  slim: _react.PropTypes.bool,
	  message: _react.PropTypes.string
	};
	
	exports.default = Spinner;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(16);
	
	var _classnames = __webpack_require__(28);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MoversNav = function (_Component) {
	  _inherits(MoversNav, _Component);
	
	  function MoversNav() {
	    _classCallCheck(this, MoversNav);
	
	    return _possibleConstructorReturn(this, (MoversNav.__proto__ || Object.getPrototypeOf(MoversNav)).apply(this, arguments));
	  }
	
	  _createClass(MoversNav, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          previousLink = _props.previousLink,
	          nextLink = _props.nextLink,
	          previousText = _props.previousText,
	          nextText = _props.nextText,
	          valid = _props.valid,
	          externalLink = _props.externalLink;
	
	
	      var nextBtnClass = {
	        'x-button--solid': valid !== false,
	        'x-button--disabled': valid === false,
	        'movers-nav-button': true
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'movers-nav' },
	        nextText ? nextLink ? _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            className: 'x-button--solid movers-nav-button',
	            to: nextLink,
	            'data-tracking': '{}'
	          },
	          nextText
	        ) : _react2.default.createElement(
	          'button',
	          {
	            type: 'submit',
	            className: (0, _classnames2.default)(nextBtnClass),
	            'data-tracking': '{}'
	          },
	          nextText
	        ) : null,
	        previousLink && previousText ? externalLink ? _react2.default.createElement(
	          'a',
	          {
	            className: 'x-button--outline movers-nav-button',
	            href: previousLink,
	            'data-tracking': '{}'
	          },
	          previousText
	        ) : _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            className: 'x-button--outline movers-nav-button',
	            to: previousLink,
	            'data-tracking': '{}'
	          },
	          previousText
	        ) : null
	      );
	    }
	  }]);
	
	  return MoversNav;
	}(_react.Component);
	
	MoversNav.propTypes = {
	  previousLink: _react.PropTypes.string,
	  nextLink: _react.PropTypes.string,
	  previousText: _react.PropTypes.string,
	  nextText: _react.PropTypes.string,
	  valid: _react.PropTypes.bool,
	  externalLink: _react.PropTypes.bool
	};
	
	exports.default = MoversNav;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h4',
	      null,
	      '404 Page Not Found'
	    ),
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: '/' },
	      ' Go back to homepage '
	    )
	  );
	};
	
	exports.default = NotFoundPage;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Grid = __webpack_require__(143);
	
	var _FeedContainer = __webpack_require__(607);
	
	var _FeedContainer2 = _interopRequireDefault(_FeedContainer);
	
	var _FeedItemSingle = __webpack_require__(609);
	
	var _FeedItemSingle2 = _interopRequireDefault(_FeedItemSingle);
	
	var _FeedItem = __webpack_require__(608);
	
	var _FeedItem2 = _interopRequireDefault(_FeedItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Feed = function (_Component) {
	  _inherits(Feed, _Component);
	
	  function Feed() {
	    _classCallCheck(this, Feed);
	
	    return _possibleConstructorReturn(this, (Feed.__proto__ || Object.getPrototypeOf(Feed)).apply(this, arguments));
	  }
	
	  _createClass(Feed, [{
	    key: 'render',
	    value: function render() {
	      var feedData = this.props.feedData;
	
	
	      var releaseNotes = _lodash2.default.concat([], _lodash2.default.get(feedData, 'releaseNotes.topics[0]', []));
	      var features = _lodash2.default.get(feedData, 'features.topics');
	      var issues = _lodash2.default.get(feedData, 'issues.topics');
	
	      var communityData = _lodash2.default.concat([], releaseNotes, features, issues);
	
	      return _react2.default.createElement(
	        _Grid.Row,
	        null,
	        _react2.default.createElement(
	          _Grid.Col,
	          { xs: 12 },
	          communityData && communityData.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'community-feed' },
	            releaseNotes && releaseNotes.length > 0 && releaseNotes.map(function (item, index) {
	              return _react2.default.createElement(_FeedItemSingle2.default, {
	                key: index,
	                item: item
	              });
	            }),
	            features && features.length > 0 && _react2.default.createElement(
	              _FeedContainer2.default,
	              { items: features },
	              features.map(function (item, index) {
	                return _react2.default.createElement(_FeedItem2.default, {
	                  key: index,
	                  item: item
	                });
	              })
	            ),
	            issues && issues.length > 0 && _react2.default.createElement(
	              _FeedContainer2.default,
	              { items: issues },
	              issues.map(function (item, index) {
	                return _react2.default.createElement(_FeedItem2.default, {
	                  key: index,
	                  item: item
	                });
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Feed;
	}(_react.Component);
	
	Feed.propTypes = {
	  feedData: _react.PropTypes.object
	};
	
	exports.default = Feed;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Badge = __webpack_require__(319);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Feed = function (_Component) {
	  _inherits(Feed, _Component);
	
	  function Feed() {
	    _classCallCheck(this, Feed);
	
	    return _possibleConstructorReturn(this, (Feed.__proto__ || Object.getPrototypeOf(Feed)).apply(this, arguments));
	  }
	
	  _createClass(Feed, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          items = _props.items,
	          children = _props.children;
	
	
	      var catcid = _lodash2.default.get(items, '[0]category.cid');
	      var catName = _lodash2.default.get(items, '[0]category.name');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'community-feed__item-container community-feed__item-container--' + catcid },
	        _react2.default.createElement(
	          _Badge2.default,
	          { className: 'community-feed-badge community-feed-badge--' + catcid },
	          catName
	        ),
	        children
	      );
	    }
	  }]);
	
	  return Feed;
	}(_react.Component);
	
	Feed.propTypes = {
	  items: _react.PropTypes.array,
	  children: _react.PropTypes.node
	};
	
	exports.default = Feed;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Feed = function (_Component) {
	  _inherits(Feed, _Component);
	
	  function Feed() {
	    _classCallCheck(this, Feed);
	
	    return _possibleConstructorReturn(this, (Feed.__proto__ || Object.getPrototypeOf(Feed)).apply(this, arguments));
	  }
	
	  _createClass(Feed, [{
	    key: 'render',
	    value: function render() {
	      var item = this.props.item;
	
	
	      return _react2.default.createElement(
	        'a',
	        { href: '//omni-feedback.aws-origin.xfinity.com/topic/' + item.slug, className: 'community-feed__item' },
	        _react2.default.createElement(
	          'div',
	          { className: 'community-feed-post' },
	          _react2.default.createElement(
	            'div',
	            { className: 'community-feed-user' },
	            item.user.picture && _react2.default.createElement('img', { className: 'community-feed-user-picture', src: '//omni-feedback.aws-origin.xfinity.com' + item.user.picture }),
	            !item.user.picture && _react2.default.createElement(
	              'div',
	              { className: 'community-feed-user-icon', style: { 'backgroundColor': item.user['icon:bgColor'] } },
	              item.user['icon:text']
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'community-feed-title community-feed-post-content' },
	            _react2.default.createElement(
	              'span',
	              { className: 'x-body2' },
	              item.title
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'community-feed-date community-feed-post-content' },
	            _react2.default.createElement(
	              'span',
	              { className: 'x-body2' },
	              (0, _moment2.default)(item.timestampISO).format('YYYY[-]MM[-]DD')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Feed;
	}(_react.Component);
	
	Feed.propTypes = {
	  item: _react.PropTypes.object
	};
	
	exports.default = Feed;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Badge = __webpack_require__(319);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Feed = function (_Component) {
	  _inherits(Feed, _Component);
	
	  function Feed() {
	    _classCallCheck(this, Feed);
	
	    return _possibleConstructorReturn(this, (Feed.__proto__ || Object.getPrototypeOf(Feed)).apply(this, arguments));
	  }
	
	  _createClass(Feed, [{
	    key: 'render',
	    value: function render() {
	      var item = this.props.item;
	
	
	      var catcid = _lodash2.default.get(item, 'category.cid');
	      var catName = _lodash2.default.get(item, 'category.name');
	
	      return _react2.default.createElement(
	        'a',
	        { href: '//omni-feedback.aws-origin.xfinity.com/topic/' + item.slug, className: 'community-feed__item community-feed__item--singular community-feed__item--' + catcid },
	        _react2.default.createElement(
	          _Badge2.default,
	          { className: 'community-feed-badge community-feed-badge--' + catcid },
	          catName
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'community-feed-post' },
	          _react2.default.createElement(
	            'div',
	            { className: 'community-feed-user' },
	            item.user.picture && _react2.default.createElement('img', { className: 'community-feed-user-picture', src: '//omni-feedback.aws-origin.xfinity.com' + item.user.picture }),
	            !item.user.picture && _react2.default.createElement(
	              'div',
	              { className: 'community-feed-user-icon', style: { 'backgroundColor': item.user['icon:bgColor'] } },
	              item.user['icon:text']
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'community-feed-title community-feed-post-content' },
	            _react2.default.createElement(
	              'span',
	              { className: 'x-body2' },
	              item.title
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'community-feed-date community-feed-post-content' },
	            _react2.default.createElement(
	              'span',
	              { className: 'x-body2' },
	              (0, _moment2.default)(item.timestampISO).format('YYYY[-]MM[-]DD')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Feed;
	}(_react.Component);
	
	Feed.propTypes = {
	  item: _react.PropTypes.object
	};
	
	exports.default = Feed;

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(43);
	
	var _Spinner = __webpack_require__(603);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _Nav = __webpack_require__(602);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Footer = __webpack_require__(598);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _common = __webpack_require__(7);
	
	var _queryString = __webpack_require__(1099);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _redux = __webpack_require__(73);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ErrorPanel = __webpack_require__(596);
	
	var _ErrorPanel2 = _interopRequireDefault(_ErrorPanel);
	
	var _classnames = __webpack_require__(28);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dataLayer = __webpack_require__(75);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppContainer = function (_Component) {
	  _inherits(AppContainer, _Component);
	
	  function AppContainer() {
	    _classCallCheck(this, AppContainer);
	
	    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
	  }
	
	  _createClass(AppContainer, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        logUserClick: this.props.logUserClick
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var setDev = this.props.setDev;
	
	
	      var query = _queryString2.default.parse(window.location.search);
	
	      // enable dev mode if env is develop or if ?dev=true is provided in the url
	      // if(process.env.NODE_ENV === 'development' || query.dev === 'true'){
	      if (false) {
	        setDev(true);
	        //a11y(React, { ReactDOM: ReactDOM, includeSrcNode: true });
	      } else if (query.dev === 'false') {
	        setDev(false);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          spinner = _props.spinner,
	          children = _props.children,
	          pageErrors = _props.pageErrors,
	          dev = _props.dev;
	
	
	      var query = _queryString2.default.parse(window.location.search);
	      var showLabels = query.labels === 'true';
	      var containerClasses = (0, _classnames2.default)({
	        'mp-main': true,
	        'mp-main--omni': true,
	        'show-labels': showLabels,
	        'dev': dev
	      });
	
	      return _react2.default.createElement(
	        _Spinner2.default,
	        {
	          show: spinner.show,
	          priority: 10,
	          isGlobal: true,
	          message: spinner.message,
	          backgroundStyle: { position: 'fixed' },
	          hideContentOnLoad: spinner.hideContent },
	        _react2.default.createElement(_Nav2.default, null),
	        !_lodash2.default.isEmpty(pageErrors) && _react2.default.createElement(
	          'div',
	          { className: 'x-error-panel-container container' },
	          _react2.default.createElement(_ErrorPanel2.default, { errors: pageErrors })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: containerClasses, role: 'main' },
	          children
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return AppContainer;
	}(_react.Component);
	
	AppContainer.childContextTypes = {
	  logUserClick: _react.PropTypes.func
	};
	
	AppContainer.propTypes = {
	  children: _react.PropTypes.node,
	  spinner: _react.PropTypes.object.isRequired,
	  pageErrors: _react.PropTypes.array,
	  setDev: _react.PropTypes.func.isRequired,
	  dev: _react.PropTypes.bool.isRequired,
	  logUserClick: _react.PropTypes.func
	};
	
	function mapStateToProps(state) {
	  return {
	    spinner: state.common.spinner,
	    pageErrors: state.common.pageErrors,
	    dev: state.common.dev
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    setDev: (0, _redux.bindActionCreators)(_common.setDev, dispatch),
	    logUserClick: (0, _redux.bindActionCreators)(_dataLayer.logUserClick, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AppContainer);

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(73);
	
	var _reactRedux = __webpack_require__(43);
	
	var _reduxForm = __webpack_require__(44);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _localization = __webpack_require__(194);
	
	var _localization2 = __webpack_require__(197);
	
	var _customer = __webpack_require__(76);
	
	var _common = __webpack_require__(7);
	
	var _Grid = __webpack_require__(143);
	
	var _reactHelmet = __webpack_require__(1163);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _MoversNav = __webpack_require__(604);
	
	var _MoversNav2 = _interopRequireDefault(_MoversNav);
	
	var _InputField = __webpack_require__(599);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _Feed = __webpack_require__(606);
	
	var _Feed2 = _interopRequireDefault(_Feed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OmniSalesPage = function (_Component) {
	  _inherits(OmniSalesPage, _Component);
	
	  function OmniSalesPage() {
	    _classCallCheck(this, OmniSalesPage);
	
	    return _possibleConstructorReturn(this, (OmniSalesPage.__proto__ || Object.getPrototypeOf(OmniSalesPage)).apply(this, arguments));
	  }
	
	  _createClass(OmniSalesPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var omniGetCommunity = this.props.actions.omniGetCommunity;
	
	
	      omniGetCommunity();
	    }
	  }, {
	    key: 'handleContinue',
	    value: function handleContinue() {
	      var _props = this.props,
	          actions = _props.actions,
	          valid = _props.valid;
	
	
	      if (valid) {
	        actions.omniLocalizeAddress();
	      } else {
	        actions.touchFields();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          feedData = _props2.feedData,
	          valid = _props2.valid,
	          handleSubmit = _props2.handleSubmit;
	
	
	      var linkOutImg = ("/assets/") + 'img/common/icons/link-out.svg'; // eslint-disable-line no-undef
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'omni-localization mp-page-container' },
	        _react2.default.createElement(_reactHelmet2.default, {
	          title: 'Omni Sales'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container container--omni' },
	          _react2.default.createElement(
	            _Grid.Row,
	            null,
	            _react2.default.createElement(
	              _Grid.Col,
	              { lg: 10, lgOffset: 1, xs: 12 },
	              _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit(this.handleContinue.bind(this)) },
	                _react2.default.createElement(
	                  _Grid.Row,
	                  null,
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    { xs: 12 },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'hgroup' },
	                      _react2.default.createElement(
	                        'h1',
	                        { className: 'x-heading1' },
	                        'Welcome to Omni Sales'
	                      ),
	                      _react2.default.createElement(
	                        'h2',
	                        { className: 'x-heading2 hgroup__subheading' },
	                        'Select continue to localize'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _Grid.Row,
	                  { className: 'row--movers' },
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    { xs: 6, md: 3, lg: 2 },
	                    _react2.default.createElement(_reduxForm.Field, { component: _InputField2.default, name: 'ntId', type: 'ntId', placeholder: 'ntId' })
	                  ),
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    { xs: 6, md: 3, lg: 2 },
	                    _react2.default.createElement(_reduxForm.Field, { component: _InputField2.default, name: 'csgSalesRepId', type: 'csgSalesRepId', placeholder: 'csgSalesRepId' })
	                  ),
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    { xs: 6, md: 3, lg: 2 },
	                    _react2.default.createElement(_reduxForm.Field, { component: _InputField2.default, name: 'csgOperatorId', type: 'csgOperatorId', placeholder: 'csgOperatorId' })
	                  ),
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    { xs: 6, md: 3, lg: 2 },
	                    _react2.default.createElement(_reduxForm.Field, { component: _InputField2.default, name: 'ddpSalesRepId', type: 'ddpSalesRepId', placeholder: 'ddpSalesRepId' })
	                  ),
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    { xs: 6, md: 3, lg: 2 },
	                    _react2.default.createElement(_reduxForm.Field, { component: _InputField2.default, name: 'ddpOperatorId', type: 'ddpOperatorId', placeholder: 'ddpOperatorId' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _Grid.Row,
	                  { className: 'row--movers' },
	                  _react2.default.createElement(
	                    _Grid.Col,
	                    { xs: 12, md: 6, mdOffset: 6 },
	                    _react2.default.createElement(_MoversNav2.default, {
	                      nextText: 'Continue',
	                      valid: valid
	                    })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'community-feed-link-out', href: '//omni-feedback.aws-origin.xfinity.com', target: '_blank' },
	          _react2.default.createElement('img', { width: '40', height: '40', src: linkOutImg }),
	          _react2.default.createElement(
	            'p',
	            { className: 'x-body4 community-feed-link-out-text' },
	            'Community',
	            _react2.default.createElement('br', null),
	            'Portal'
	          )
	        ),
	        feedData && _react2.default.createElement(
	          'div',
	          { className: 'container container--omni container--omni-bottom' },
	          _react2.default.createElement(
	            _Grid.Row,
	            null,
	            _react2.default.createElement(
	              _Grid.Col,
	              { lg: 10, lgOffset: 1, xs: 12 },
	              _react2.default.createElement(_Feed2.default, { feedData: feedData })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return OmniSalesPage;
	}(_react.Component);
	
	OmniSalesPage.propTypes = {
	  customer: _react.PropTypes.object.isRequired,
	  suggestions: _react.PropTypes.array.isRequired,
	  actions: _react.PropTypes.object.isRequired,
	  valid: _react.PropTypes.bool.isRequired,
	  dateRange: _react.PropTypes.object.isRequired,
	  isMobile: _react.PropTypes.bool.isRequired,
	  handleSubmit: _react.PropTypes.func.isRequired,
	  formValues: _react.PropTypes.object,
	  feedData: _react.PropTypes.object
	};
	
	function mapStateToProps(state) {
	  var formValues = (0, _reduxForm.getFormValues)('omniLocalize')(state) || { streetAddress: '' };
	
	  return {
	    customer: state.customer.customer,
	    feedData: _lodash2.default.get(state, 'omniSales.communityData'),
	    dateRange: (0, _customer.moveDateRangeSelector)(state),
	    isMobile: (0, _common.isMobileSelector)(state),
	    suggestions: _lodash2.default.get(state, 'suggestions.suggestions.localizeSuggestions', []),
	    formValues: formValues,
	    initialValues: {
	      streetAddress: _lodash2.default.get(state, 'customer.customer.moveToAddress.streetAddress', ''),
	      unitNumber: _lodash2.default.get(state, 'customer.customer.moveToAddress.unitNumber', ''),
	      zipCode: _lodash2.default.get(state, 'customer.customer.moveToAddress.zipCode', '')
	    }
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({
	      omniGetCommunity: _localization2.omniGetCommunity,
	      omniLocalizeAddress: _localization2.omniLocalizeAddress,
	      touchFields: _localization.touchFields
	    }, dispatch)
	  };
	}
	
	var OmniSalesPageForm = (0, _reduxForm.reduxForm)({
	  form: 'omniLocalize',
	  enableReinitialize: true
	})(OmniSalesPage);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OmniSalesPageForm);

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(321);
	
	var _jquery = __webpack_require__(131);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(510);
	
	var _reactRedux = __webpack_require__(43);
	
	var _reactRouter = __webpack_require__(16);
	
	var _routes = __webpack_require__(670);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _configureStore = __webpack_require__(668);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _contentProvider = __webpack_require__(74);
	
	var _contentProvider2 = _interopRequireDefault(_contentProvider);
	
	var _contentProvider3 = __webpack_require__(684);
	
	var _content = __webpack_require__(984);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _reactRouterRedux = __webpack_require__(180);
	
	__webpack_require__(965);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _configureStore2.default)(); //HACK: to enable shared components to access a shared content provider
	//eslint-disable-line no-unused-vars
	/*eslint-disable import/default*/
	
	
	_contentProvider2.default.setStore(store);
	_contentProvider3.contentProvider.setStore(store);
	// TODO: provide content from API call
	_contentProvider2.default.setContent(_content2.default);
	_contentProvider3.contentProvider.setContent(_content2.default);
	
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	//window.trackingDebug = true;
	
	(0, _reactDom.render)(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(
	    _reactRouter.Router,
	    {
	      history: history,
	      onUpdate: function onUpdate() {
	        return document.getElementById('polaris-nav-header-wrapper').scrollIntoView();
	      }
	    },
	    (0, _routes2.default)(store.dispatch)
	  )
	), document.getElementById('app'));

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = collapse;
	exports.dispatchToggelPanel = dispatchToggelPanel;
	exports.dispatchInitializeCollapse = dispatchInitializeCollapse;
	
	var _update2 = __webpack_require__(560);
	
	var _update3 = _interopRequireDefault(_update2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var INITIALIZE_COLLAPSE = 'hg/collapse/INITIALIZE_COLLAPSE';
	var TOGGLE_PANEL = 'hg/collapse/TOGGLE_PANEL';
	
	var initialState = {
	  collapse: {}
	};
	
	function collapse() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case INITIALIZE_COLLAPSE:
	      return _extends({}, state, {
	        collapse: _extends({}, state.collapse, _defineProperty({}, action.collapseName, action.collapseChildren))
	      });
	    case TOGGLE_PANEL:
	      return _extends({}, state, {
	        collapse: (0, _update3.default)(state.collapse, _defineProperty({}, action.collapseName, _defineProperty({}, action.collapseIndex, { $set: action.collapseStatus })))
	      });
	    default:
	      return state;
	  }
	}
	
	function toggelPanel(name, index, status) {
	  return {
	    type: TOGGLE_PANEL,
	    collapseName: name,
	    collapseIndex: index,
	    collapseStatus: status
	  };
	}
	
	function dispatchToggelPanel(name, index, status) {
	  return toggelPanel(name, index, status);
	}
	
	function initializeCollapse(name, children) {
	  return {
	    type: INITIALIZE_COLLAPSE,
	    collapseName: name,
	    collapseChildren: children
	  };
	}
	
	function dispatchInitializeCollapse(name, children) {
	  return initializeCollapse(name, children);
	}

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isMobileSelector = exports.osFamilySelector = exports.errorPageByFlow = exports.commonErrorsSelector = exports.flowTypeSelector = exports.flowSelector = exports.commonSelector = exports.errorPageConfig = undefined;
	
	var _reselect = __webpack_require__(38);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _navigationHelpers = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Flow is determined by the route and returns 1 of the first 3 values
	// FlowType is coming back with either "MyPlan" or "MoveRepackage"
	var errorPageConfig = exports.errorPageConfig = {
	  'myPlan': _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.ERROR].path,
	  'movers': _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.ERROR].path,
	  'quickCheckout': _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.ERROR].path,
	  'MyPlan': _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.ERROR].path,
	  'MoveRepackager': _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.ERROR].path
	};
	
	var commonSelector = exports.commonSelector = function commonSelector(state) {
	  return state.common;
	};
	
	// get flow from state
	var flowSelector = exports.flowSelector = (0, _reselect.createSelector)(commonSelector, function (common) {
	  return _lodash2.default.get(common, 'flow', '');
	});
	
	var flowTypeSelector = exports.flowTypeSelector = (0, _reselect.createSelector)(commonSelector, function (common) {
	  return _lodash2.default.get(common, 'flowType', '');
	});
	
	var commonErrorsSelector = exports.commonErrorsSelector = (0, _reselect.createSelector)(commonSelector, function (common) {
	  return _lodash2.default.get(common, 'error.errors', []);
	});
	
	var errorPageByFlow = exports.errorPageByFlow = (0, _reselect.createSelector)(flowSelector, flowTypeSelector, function (flow, flowType) {
	  return _lodash2.default.get(errorPageConfig, flowType ? flowType : flow, _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.ERROR].path);
	});
	
	var osFamilySelector = exports.osFamilySelector = (0, _reselect.createSelector)(commonSelector, function (common) {
	  return _lodash2.default.get(common, 'platform.os.family', '');
	});
	
	var isMobileSelector = exports.isMobileSelector = (0, _reselect.createSelector)(osFamilySelector, function (os) {
	  return os == "iOS" || os == "Android";
	});

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageLoadVarsForRoute = exports.pageLoadActionsForRoute = exports.roolz = undefined;
	
	var _config;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _maestro = __webpack_require__(200);
	
	var _maestro2 = _interopRequireDefault(_maestro);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _contentProvider = __webpack_require__(74);
	
	var _contentProvider2 = _interopRequireDefault(_contentProvider);
	
	var _myplan = __webpack_require__(312);
	
	var myplanActions = _interopRequireWildcard(_myplan);
	
	var _review = __webpack_require__(196);
	
	var myplanReviewActions = _interopRequireWildcard(_review);
	
	var _confirmation = __webpack_require__(311);
	
	var myplanConfirmationActions = _interopRequireWildcard(_confirmation);
	
	var _showOffersFilter = __webpack_require__(313);
	
	var showOffersFilterActions = _interopRequireWildcard(_showOffersFilter);
	
	var _review2 = __webpack_require__(316);
	
	var quickCheckoutReviewActions = _interopRequireWildcard(_review2);
	
	var _confirmation2 = __webpack_require__(314);
	
	var quickCheckoutConfirmationActions = _interopRequireWildcard(_confirmation2);
	
	var _redirect = __webpack_require__(315);
	
	var quickCheckoutRedirectActions = _interopRequireWildcard(_redirect);
	
	var _localization = __webpack_require__(194);
	
	var moversLocalizationActions = _interopRequireWildcard(_localization);
	
	var _unserviceable = __webpack_require__(310);
	
	var moversUnserviceableActions = _interopRequireWildcard(_unserviceable);
	
	var _cancel = __webpack_require__(308);
	
	var moversCancelActions = _interopRequireWildcard(_cancel);
	
	var _specialist = __webpack_require__(309);
	
	var moversSpecialistActions = _interopRequireWildcard(_specialist);
	
	var _install = __webpack_require__(142);
	
	var moversInstallActions = _interopRequireWildcard(_install);
	
	var _review3 = __webpack_require__(195);
	
	var moversReviewActions = _interopRequireWildcard(_review3);
	
	var _confirmation3 = __webpack_require__(193);
	
	var moversConfirmationActions = _interopRequireWildcard(_confirmation3);
	
	var _multipleAddress = __webpack_require__(192);
	
	var accountMultipleAddressActions = _interopRequireWildcard(_multipleAddress);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var config = (_config = {}, _defineProperty(_config, _navigationHelpers.navigationSteps.myPlan.MYPLAN, {
	  pageLoadActions: [myplanActions.DL_PAGE_LOADED],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.myPlan.REVIEW, {
	  pageLoadActions: [myplanReviewActions.DL_PAGE_LOADED],
	  pageLoadVars: function pageLoadVars(state) {
	    var isConsent = _lodash2.default.get(state, 'review.content.review.consentReview');
	
	    return {
	      page: {
	        attributes: {
	          pageLoadEvent: 'Order review'
	        }
	      },
	      transaction: {
	        attributes: {
	          buyflowType: "CancelStreamingVideo",
	          buyflowStep: "review",
	          consentDecree: isConsent ? 'success' : 'failure'
	        }
	      }
	    };
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.myPlan.CONFIRMATION, {
	  pageLoadActions: [myplanConfirmationActions.DL_PAGE_LOADED],
	  pageLoadVars: function pageLoadVars(state) {
	    var hasWorklist = _lodash2.default.get(state, 'confirmation.content.cartInfo.hasWorklist');
	
	    return {
	      page: {
	        attributes: {
	          pageLoadEvent: 'Purchase'
	        }
	      },
	      transaction: {
	        attributes: {
	          buyflowType: "CancelStreamingVideo",
	          buyflowStep: "order",
	          installationType: "not required",
	          fulfillmentType: hasWorklist ? "shop:order flow thru:soft" : "shop:order flow thru"
	        }
	      }
	    };
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.myPlan.OFFERS_FILTER, {
	  pageLoadActions: [showOffersFilterActions.DL_PAGE_LOADED],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.myPlan.CONTACTUS, {
	  pageLoadActions: [],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.myPlan.MESSAGE, {
	  pageLoadActions: [],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.myPlan.ERROR, {
	  pageLoadActions: [],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.myPlan.OMNI_LANDING, {
	  pageLoadActions: [],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.movers.LOCALIZATION, {
	  pageLoadActions: [moversLocalizationActions.DL_PAGE_LOADED],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.movers.UNSERVICEABLE, {
	  pageLoadActions: [moversUnserviceableActions.DL_PAGE_LOADED],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.movers.CANCEL, {
	  pageLoadActions: [moversCancelActions.DL_PAGE_LOADED],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.movers.SPECIALIST, {
	  pageLoadActions: [moversSpecialistActions.DL_PAGE_LOADED],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.movers.INSTALL, {
	  pageLoadActions: [moversInstallActions.DL_PAGE_LOADED],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.movers.REVIEW, {
	  pageLoadActions: [moversReviewActions.DL_PAGE_LOADED],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.movers.CONFIRMATION, {
	  pageLoadActions: [moversConfirmationActions.DL_PAGE_LOADED],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.movers.CONTACTUS, {
	  pageLoadActions: [],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.movers.CANCELLATION_CONTACTUS, {
	  pageLoadActions: [],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.movers.ERROR, {
	  pageLoadActions: [],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.quickCheckout.REVIEW, {
	  pageLoadActions: [quickCheckoutReviewActions.DL_PAGE_LOADED],
	  pageLoadVars: function pageLoadVars(state) {
	    var isConsent = _lodash2.default.get(state, 'review.content.review.consentReview');
	
	    return {
	      page: {
	        attributes: {
	          pageLoadEvent: 'Order review'
	        }
	      },
	      transaction: {
	        attributes: {
	          buyflowType: "quick checkout",
	          buyflowStep: "review",
	          installationType: "not required",
	          consentDecree: isConsent ? 'success' : 'failure'
	        }
	      }
	    };
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.quickCheckout.CONFIRMATION, {
	  pageLoadActions: [quickCheckoutConfirmationActions.DL_PAGE_LOADED],
	  pageLoadVars: function pageLoadVars(state) {
	    var hasWorklist = _lodash2.default.get(state, 'confirmation.content.cartInfo.hasWorklist');
	
	    return {
	      page: {
	        attributes: {
	          pageLoadEvent: 'Purchase'
	        }
	      },
	      transaction: {
	        attributes: {
	          buyflowType: "quick checkout",
	          buyflowStep: "order",
	          installationType: "not required",
	          fulfillmentType: hasWorklist ? "shop:order flow thru:soft" : "shop:order flow thru"
	        }
	      }
	    };
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.quickCheckout.REDIRECT, {
	  pageLoadActions: [quickCheckoutRedirectActions.DL_PAGE_LOADED],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.quickCheckout.ERROR, {
	  pageLoadActions: [],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.quickCheckout.CONTACTUS, {
	  pageLoadActions: [],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _defineProperty(_config, _navigationHelpers.navigationSteps.account.MULTIPLE_ADDRESS, {
	  pageLoadActions: [accountMultipleAddressActions.DL_PAGE_LOADED],
	  pageLoadVars: function pageLoadVars() {
	    return {};
	  }
	}), _config);
	
	var roolz = exports.roolz = function roolz(state) {
	  var data = {};
	
	  var subCategoryLogic = {
	    subCategory1: {
	      "if": [
	      // MyPlan
	      { "==": [{ "var": "flow" }, "myPlan"] }, "my plan",
	      // Movers
	      { "==": [{ "var": "flow" }, "movers"] }, "movers",
	      // QuickCheckout
	      { "==": [{ "var": "flow" }, "quickCheckout"] }, "checkout",
	      // Account
	      { "==": [{ "var": "flow" }, "account"] }, "account"]
	    }
	  };
	
	  return _maestro2.default.conduct(state, data, subCategoryLogic);
	};
	
	var basePageLoadVars = function basePageLoadVars(state) {
	  var _roolz = roolz(state),
	      isMoversFlow = _roolz.isMoversFlow,
	      subCategory1 = _roolz.subCategory1;
	
	  var userInfoFromClient = [{
	    profile: [{
	      profileInfo: {
	        currentMRC: !isMoversFlow ? _lodash2.default.get(state, 'plan.totalAmount.prices[0].amount.dollars') + '.' + _lodash2.default.get(state, 'plan.totalAmount.prices[0].amount.cents') : undefined,
	        hasEmail: typeof _lodash2.default.get(state, 'customer.customer.emailAddress') === "string" && _lodash2.default.get(state, 'customer.customer.emailAddress') !== "",
	        recognizationType: 'cookie recognized',
	        services: !isMoversFlow ? {
	          LOB: {
	            name: _lodash2.default.flatten(_lodash2.default.map(_lodash2.default.get(state, 'plan.servicePackages.packages'), function (item) {
	              return item.lineOfBusinesses;
	            })),
	            tier: _lodash2.default.flatten(_lodash2.default.map(_lodash2.default.get(state, 'plan.servicePackages.packages'), function (item) {
	              return item.name;
	            }))
	          },
	          productType: function () {
	            var lobCount = _lodash2.default.get(state, 'plan.servicePackages.packages[0].lineOfBusinesses.length');
	
	            switch (lobCount) {
	              case 4:
	                return "quad play";
	              case 3:
	                return "triple play";
	              case 2:
	                return "double play";
	              default:
	                return _lodash2.default.get(state, 'plan.servicePackages.packages.length') > 1 ? "unbundled" : "single play";
	            }
	          }(),
	          addOns: _lodash2.default.flatten(_lodash2.default.map(_lodash2.default.get(state, 'plan.channels'), function (item) {
	            return item.name;
	          })),
	          equipments: _lodash2.default.flatten(_lodash2.default.map(_lodash2.default.get(state, 'equipment.equipment'), function (item) {
	            return item.name;
	          }))
	        } : undefined
	      }
	    }],
	    segment: {
	      isLocalized: _lodash2.default.get(state, 'customer.loaded')
	    }
	  }];
	
	  return {
	    schemaVersion: 0.1,
	    page: {
	      category: {
	        primaryCategory: 'shop',
	        subCategory1: subCategory1,
	        businessType: 'resi',
	        siteType: 'sales',
	        designType: 'responsive'
	      },
	      pageInfo: {
	        language: 'en'
	      },
	      attributes: {
	        errorMessage: _lodash2.default.get(state, 'dataLayer.analyticsData.digitalData.page.errorMessages')
	      },
	      codebase: {
	        name: 'df my plan',
	        releaseVersion: '17.06.01'
	      },
	      affiliate: {
	        name: 'comcast',
	        channel: 'web'
	      }
	    },
	    product: _lodash2.default.get(state, 'dataLayer.analyticsData.digitalData.page.product'),
	    siteInfo: {
	      sessionID: _lodash2.default.get(state, 'dataLayer.analyticsData.digitalData.page.siteInfo.sessionID'),
	      visitorID: _lodash2.default.get(state, 'dataLayer.analyticsData.digitalData.page.siteInfo.visitorID'),
	      ctpSessionID: _lodash2.default.get(state, 'dataLayer.analyticsData.digitalData.page.siteInfo.ctpSessionID')
	    },
	    transaction: _lodash2.default.get(state, 'dataLayer.analyticsData.digitalData.page.transaction'),
	    user: _lodash2.default.map(_lodash2.default.merge(_lodash2.default.get(state, 'dataLayer.analyticsData.digitalData.page.user', []), userInfoFromClient))
	  };
	};
	
	var pageLoadActionsForRoute = exports.pageLoadActionsForRoute = function pageLoadActionsForRoute(routeKey) {
	  return _lodash2.default.get(config, routeKey + '.pageLoadActions');
	};
	
	var pageLoadVarsForRoute = exports.pageLoadVarsForRoute = function pageLoadVarsForRoute(routeKey, state) {
	  var routePageLoadVarsSelector = _lodash2.default.get(config, routeKey + '.pageLoadVars');
	  var routePageLoadVars = routePageLoadVarsSelector(state);
	  var screenName = _contentProvider2.default.getValue(routeKey + '.screenName');
	
	  var pageNameAtts = {
	    page: {
	      pageInfo: {
	        screenName: screenName || ''
	      }
	    }
	  };
	  var pageLoadVars = _lodash2.default.merge({}, basePageLoadVars(state), pageNameAtts, routePageLoadVars);
	
	  return pageLoadVars;
	};

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageLoadedWatcher = pageLoadedWatcher;
	exports.errorPageLoadedWatcher = errorPageLoadedWatcher;
	exports.analyticsDataWatcher = analyticsDataWatcher;
	exports.errorsWatcher = errorsWatcher;
	exports.customEventWatcher = customEventWatcher;
	exports.dataLayerFlow = dataLayerFlow;
	exports.errorPageLoadedWorker = errorPageLoadedWorker;
	exports.pageLoadedWorker = pageLoadedWorker;
	exports.errorsWorker = errorsWorker;
	exports.customEventWorker = customEventWorker;
	exports.analyticsDataWorker = analyticsDataWorker;
	exports.default = dataLayerSagas;
	
	var _effects = __webpack_require__(10);
	
	var _reduxSaga = __webpack_require__(99);
	
	var _reactRouterRedux = __webpack_require__(180);
	
	var _jquery = __webpack_require__(131);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dataLayerHelpers = __webpack_require__(615);
	
	var _dataLayer = __webpack_require__(75);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _error = __webpack_require__(198);
	
	var _helpers = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [pageLoadedWatcher, errorPageLoadedWatcher, analyticsDataWatcher, errorsWatcher, customEventWatcher, dataLayerFlow, errorPageLoadedWorker, pageLoadedWorker, errorsWorker, customEventWorker, analyticsDataWorker, dataLayerSagas].map(regeneratorRuntime.mark); /*eslint-disable require-yield*/
	//eslint-disable-line no-unused-vars
	
	
	// WATCHERS
	function pageLoadedWatcher() {
	  return regeneratorRuntime.wrap(function pageLoadedWatcher$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_dataLayer.PAGE_LOADED, pageLoadedWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function errorPageLoadedWatcher() {
	  return regeneratorRuntime.wrap(function errorPageLoadedWatcher$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_error.DL_ERROR_PAGE_LOADED, errorPageLoadedWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function analyticsDataWatcher() {
	  return regeneratorRuntime.wrap(function analyticsDataWatcher$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_dataLayer.ANALYTICS_DATA_RECEIVED, analyticsDataWorker);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function errorsWatcher() {
	  return regeneratorRuntime.wrap(function errorsWatcher$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeLatest)(_dataLayer.ANALYTICS_ERRORS_RECEIVED, errorsWorker);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function customEventWatcher() {
	  var action;
	  return regeneratorRuntime.wrap(function customEventWatcher$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          if (false) {
	            _context5.next = 10;
	            break;
	          }
	
	          _context5.next = 3;
	          return (0, _effects.take)(_dataLayer.CUSTOM_EVENT_RECEIVED);
	
	        case 3:
	          action = _context5.sent;
	          _context5.next = 6;
	          return (0, _effects.fork)(customEventWorker, action);
	
	        case 6:
	          _context5.next = 8;
	          return (0, _effects.call)(_reduxSaga.delay, 100);
	
	        case 8:
	          _context5.next = 0;
	          break;
	
	        case 10:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}
	
	function dataLayerFlow() {
	  var _ref, pathname, currentRoute, routeKey, pageLoadActions, state, pageLoadVars, action;
	
	  return regeneratorRuntime.wrap(function dataLayerFlow$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          if (false) {
	            _context6.next = 21;
	            break;
	          }
	
	          _context6.next = 3;
	          return (0, _effects.take)(_reactRouterRedux.LOCATION_CHANGE);
	
	        case 3:
	          _ref = _context6.sent;
	          pathname = _ref.payload.pathname;
	
	          currentRoute = function currentRoute(currentPath) {
	            return _navigationHelpers.navigationRoutes[_lodash2.default.findKey(_navigationHelpers.navigationRoutes, function (route) {
	              return (0, _helpers.noEndingSlash)(_lodash2.default.toLower(currentPath)) === (0, _helpers.noEndingSlash)(route.path);
	            })];
	          };
	
	          routeKey = _lodash2.default.get(currentRoute(pathname), 'key');
	          pageLoadActions = (0, _dataLayerHelpers.pageLoadActionsForRoute)(routeKey);
	
	          if (!_lodash2.default.isEmpty(pageLoadActions)) {
	            _context6.next = 10;
	            break;
	          }
	
	          return _context6.abrupt('continue', 0);
	
	        case 10:
	          _context6.next = 12;
	          return (0, _effects.take)(pageLoadActions);
	
	        case 12:
	          _context6.next = 14;
	          return (0, _effects.select)();
	
	        case 14:
	          state = _context6.sent;
	          pageLoadVars = (0, _dataLayerHelpers.pageLoadVarsForRoute)(routeKey, state);
	          action = {
	            type: _dataLayer.PAGE_LOADED,
	            payload: {
	              pageLoadVars: pageLoadVars
	            }
	          };
	          _context6.next = 19;
	          return (0, _effects.put)(action);
	
	        case 19:
	          _context6.next = 0;
	          break;
	
	        case 21:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this);
	}
	
	function errorPageLoadedWorker(payload) {
	  var navStep, state, pageLoadVars, action;
	  return regeneratorRuntime.wrap(function errorPageLoadedWorker$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          navStep = (0, _error.getErrorContentPath)(payload.path);
	          _context7.next = 3;
	          return (0, _effects.select)();
	
	        case 3:
	          state = _context7.sent;
	          pageLoadVars = (0, _dataLayerHelpers.pageLoadVarsForRoute)(navStep, state);
	          action = {
	            type: _dataLayer.PAGE_LOADED,
	            payload: {
	              pageLoadVars: pageLoadVars
	            }
	          };
	          _context7.next = 8;
	          return (0, _effects.put)(action);
	
	        case 8:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}
	
	function pageLoadedWorker(_ref2) {
	  var pageLoadVars = _ref2.payload.pageLoadVars;
	  return regeneratorRuntime.wrap(function pageLoadedWorker$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          (0, _jquery2.default)(document).trigger('c-tracking-log-page', pageLoadVars);
	
	        case 1:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked[7], this);
	}
	
	function errorsWorker(_ref3) {
	  var errorMessages = _ref3.payload.errorMessages;
	  var errorMessage, errorMessageEvent;
	  return regeneratorRuntime.wrap(function errorsWorker$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          if (!_lodash2.default.isEmpty(errorMessages)) {
	            _context9.next = 2;
	            break;
	          }
	
	          return _context9.abrupt('return');
	
	        case 2:
	          errorMessage = errorMessages.join(' | ');
	          errorMessageEvent = {
	            eventMethod: 'send-Error',
	            errorMessage: errorMessage
	          };
	
	
	          (0, _jquery2.default)(document.body).trigger('c-tracking-log-dom', errorMessageEvent);
	
	        case 5:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked[8], this);
	}
	
	function customEventWorker(_ref4) {
	  var eventContent = _ref4.payload.eventContent;
	  return regeneratorRuntime.wrap(function customEventWorker$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          if (!_lodash2.default.isEmpty(eventContent)) {
	            _context10.next = 2;
	            break;
	          }
	
	          return _context10.abrupt('return');
	
	        case 2:
	
	          (0, _jquery2.default)(document.body).trigger('c-tracking-log-dom', eventContent);
	
	        case 3:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked[9], this);
	}
	
	function analyticsDataWorker(_ref5) {
	  var analyticsData = _ref5.payload.analyticsData;
	  var events;
	  return regeneratorRuntime.wrap(function analyticsDataWorker$(_context11) {
	    while (1) {
	      switch (_context11.prev = _context11.next) {
	        case 0:
	          events = analyticsData.digitalData.events;
	
	
	          _lodash2.default.forEach(events, function (analyticsItem) {
	            analyticsItem = _lodash2.default.omitBy(analyticsItem, _lodash2.default.isNull); // would prefer null values to not be sent by the server
	            (0, _jquery2.default)(document.body).trigger('c-tracking-log-dom', analyticsItem);
	          });
	
	        case 2:
	        case 'end':
	          return _context11.stop();
	      }
	    }
	  }, _marked[10], this);
	}
	
	function dataLayerSagas() {
	  return regeneratorRuntime.wrap(function dataLayerSagas$(_context12) {
	    while (1) {
	      switch (_context12.prev = _context12.next) {
	        case 0:
	          _context12.next = 2;
	          return [(0, _effects.fork)(dataLayerFlow), (0, _effects.fork)(errorPageLoadedWatcher), (0, _effects.fork)(pageLoadedWatcher), (0, _effects.fork)(analyticsDataWatcher), (0, _effects.fork)(errorsWatcher), (0, _effects.fork)(customEventWatcher)];
	
	        case 2:
	        case 'end':
	          return _context12.stop();
	      }
	    }
	  }, _marked[11], this);
	}

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _navigationHelpers = __webpack_require__(11);
	
	var dataConfig = {
	  auth: {
	    state: 'auth',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.MYPLAN].endpoints.validateAuth
	  },
	  context: {
	    state: 'context',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.MYPLAN].endpoints.getContext
	  },
	  customer: {
	    state: 'customer',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.MYPLAN].endpoints.loadCustomer
	  },
	  plan: {
	    state: 'plan',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.MYPLAN].endpoints.loadPlan
	  },
	  equipment: {
	    state: 'equipment',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.MYPLAN].endpoints.loadEquipment
	  },
	  offers: {
	    state: 'offers',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.OFFERS].endpoints.loadContent
	  },
	  checkEligibility: {
	    state: 'alwaysCall',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.ADDON_CHANNEL].endpoints.checkEligibility
	  },
	  addDefaultOffer: {
	    state: 'addDefaultOffer',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.CHECKOUT].endpoints.addDefaultOffer
	  },
	  productMapping: {
	    state: 'productMapping',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.CHECKOUT].endpoints.validateProductMapping
	  },
	  customerLobAndProduct: {
	    state: 'customerLobAndProduct',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.CHECKOUT].endpoints.validateCustomerLobAndProduct
	  },
	  productForQuickcheckout: {
	    state: 'productForQuickcheckout',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.CHECKOUT].endpoints.validateProductForQuickcheckout
	  },
	  configureProduct: {
	    state: 'configureProduct',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.CHECKOUT].endpoints.configureProductToCart
	  },
	  review: {
	    state: 'review',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.REVIEW].endpoints.reviewCart
	  },
	  reviewPlanCart: {
	    state: 'review',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.REVIEW].endpoints.reviewCart
	  },
	  submitOrder: {
	    state: 'submitOrder',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.REVIEW].endpoints.submitOrder
	  },
	  confirmation: {
	    state: 'confirmation',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.CONFIRMATION].endpoints.getConfirmation
	  },
	  myplanConfirmation: {
	    state: 'myplanConfirmation',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.CONFIRMATION].endpoints.getConfirmation
	  },
	  quickCheckoutAnalytics: {
	    state: 'alwaysCall',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.CHECKOUT].endpoints.analytics
	  },
	  moversInstall: {
	    state: 'alwaysCall',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.INSTALL].endpoints.loadInstall
	  },
	  moversReview: {
	    state: 'alwaysCall',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.REVIEW].endpoints.loadReview
	  },
	  moversConfirmation: {
	    state: 'alwaysCall',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.CONFIRMATION].endpoints.loadConfirmation
	  },
	  accountMultipleAddress: {
	    state: 'accountMultipleAddress',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.account.MULTIPLE_ADDRESS].endpoints.getAddresses
	  },
	  omniPrerequisites: {
	    state: 'omniPrerequisites',
	    message: '',
	    endpoint: _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.OMNI_LANDING].endpoints.getPrerequisites
	  }
	};
	
	exports.default = dataConfig;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.touchFields = exports.disconnectCustomer = exports.loadContent = exports.cancel = exports.DL_PAGE_LOADED = exports.DISCONNECT_CUSTOMER = exports.LOAD_CONTENT = undefined;
	
	var _cancelHelpers = __webpack_require__(619);
	
	Object.keys(_cancelHelpers).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _cancelHelpers[key];
	    }
	  });
	});
	
	var _reduxForm = __webpack_require__(44);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'hg/cancel/LOAD_CONTENT';
	var DISCONNECT_CUSTOMER = exports.DISCONNECT_CUSTOMER = 'hg/cancel/DISCONNECT_CUSTOMER';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'hg/cancel/DL_PAGE_LOADED';
	
	var initialState = {
	  loaded: false,
	  content: {}
	};
	
	var cancel = exports.cancel = function cancel() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    default:
	      return state;
	  }
	};
	
	var loadContent = exports.loadContent = function loadContent() {
	  return {
	    type: LOAD_CONTENT
	  };
	};
	
	var disconnectCustomer = exports.disconnectCustomer = function disconnectCustomer() {
	  return {
	    type: DISCONNECT_CUSTOMER
	  };
	};
	
	var touchFields = exports.touchFields = function touchFields() {
	  return function (dispatch) {
	    dispatch(_reduxForm.untouch.apply(undefined, ['cancel'].concat(_toConsumableArray(_cancelHelpers.fields))));
	    dispatch(_reduxForm.touch.apply(undefined, ['cancel'].concat(_toConsumableArray(_cancelHelpers.fields))));
	  };
	};
	
	exports.default = cancel;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fields = exports.validation = undefined;
	
	var _validation = __webpack_require__(144);
	
	var validation = exports.validation = (0, _validation.createValidator)({
	  'serviceStopDate': [(0, _validation.required)('Please enter a valid date'), (0, _validation.validateDateRange)('The disconnect date')]
	});
	
	var fields = exports.fields = ['serviceStopDate'];

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.priceReferenceIdSelector = exports.shoppingElementIdSelector = exports.checkoutContentSelector = exports.checkoutSelector = undefined;
	
	var _reselect = __webpack_require__(38);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkoutSelector = exports.checkoutSelector = function checkoutSelector(state) {
	  return state.checkout;
	};
	
	var checkoutContentSelector = exports.checkoutContentSelector = (0, _reselect.createSelector)(checkoutSelector, function (checkout) {
	  return _lodash2.default.get(checkout, 'content', '');
	});
	
	var shoppingElementIdSelector = exports.shoppingElementIdSelector = (0, _reselect.createSelector)(checkoutContentSelector, function (content) {
	  return _lodash2.default.get(content, 'shoppingElementId', '');
	});
	
	var priceReferenceIdSelector = exports.priceReferenceIdSelector = (0, _reselect.createSelector)(checkoutSelector, function (content) {
	  return _lodash2.default.get(content, 'priceReferenceId', '');
	});

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.showShippingInfoSelector = exports.equipmentAddedSelector = exports.showWatchNowSelector = exports.cartInfoSelector = exports.customerNameEmailSelector = exports.customerConfirmationInfoSelector = exports.confirmationContentSelector = undefined;
	
	var _reselect = __webpack_require__(38);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var confirmationContentSelector = exports.confirmationContentSelector = function confirmationContentSelector(state) {
	  return state.confirmation.content;
	};
	
	var customerConfirmationInfoSelector = exports.customerConfirmationInfoSelector = (0, _reselect.createSelector)(confirmationContentSelector, function (content) {
	  return _lodash2.default.get(content, 'customerInfo.customerInfo', []);
	});
	
	var customerNameEmailSelector = exports.customerNameEmailSelector = (0, _reselect.createSelector)(customerConfirmationInfoSelector, function (customer) {
	  return {
	    firstName: _lodash2.default.get(customer, 'firstName', ''),
	    emailAddress: _lodash2.default.get(customer, 'emailAddress', '')
	  };
	});
	
	var cartInfoSelector = exports.cartInfoSelector = (0, _reselect.createSelector)(confirmationContentSelector, function (content) {
	  return _lodash2.default.get(content, 'cartInfo', {});
	});
	
	var showWatchNowSelector = exports.showWatchNowSelector = (0, _reselect.createSelector)(confirmationContentSelector, function (content) {
	  return _lodash2.default.get(content, 'tVEGoEnableWatchNow', false);
	});
	
	var equipmentAddedSelector = exports.equipmentAddedSelector = (0, _reselect.createSelector)(cartInfoSelector, function (cart) {
	  return _lodash2.default.get(cart, 'equipmentAdded', {});
	});
	
	var showShippingInfoSelector = exports.showShippingInfoSelector = (0, _reselect.createSelector)(equipmentAddedSelector, function (equipment) {
	  return !_lodash2.default.isEmpty(equipment);
	});

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.normalizeWatch = normalizeWatch;
	exports.normalizeWorker = normalizeWorker;
	exports.default = contextSagas;
	
	var _effects = __webpack_require__(10);
	
	var _dataProvider = __webpack_require__(26);
	
	var _plan = __webpack_require__(123);
	
	var _common = __webpack_require__(7);
	
	var _marked = [normalizeWatch, normalizeWorker, contextSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function normalizeWatch() {
	  return regeneratorRuntime.wrap(function normalizeWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_dataProvider.NORMALIZE_DATA, normalizeWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	// WORKERS
	function normalizeWorker(_ref) {
	  var key = _ref.key,
	      data = _ref.data;
	  return regeneratorRuntime.wrap(function normalizeWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          if (!(key !== 'context')) {
	            _context2.next = 2;
	            break;
	          }
	
	          return _context2.abrupt('return');
	
	        case 2:
	          _context2.next = 4;
	          return (0, _effects.put)((0, _common.setConsumerType)(data.consumerType));
	
	        case 4:
	          _context2.next = 6;
	          return (0, _effects.put)({ type: _plan.SET_DATA, payload: {
	              isPlanAvailable: data.isPlanAvailable !== false
	            } });
	
	        case 6:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function contextSagas() {
	  return regeneratorRuntime.wrap(function contextSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(normalizeWatch)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.normalizeWatch = normalizeWatch;
	exports.normalizeWorker = normalizeWorker;
	exports.default = customerSagas;
	
	var _effects = __webpack_require__(10);
	
	var _dataProvider = __webpack_require__(26);
	
	var _customer = __webpack_require__(76);
	
	var _common = __webpack_require__(7);
	
	var _marked = [normalizeWatch, normalizeWorker, customerSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function normalizeWatch() {
	  return regeneratorRuntime.wrap(function normalizeWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_dataProvider.NORMALIZE_DATA, normalizeWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	// WORKERS
	function normalizeWorker(_ref) {
	  var key = _ref.key,
	      data = _ref.data,
	      meta = _ref.meta;
	  return regeneratorRuntime.wrap(function normalizeWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          if (!(key !== 'customer')) {
	            _context2.next = 2;
	            break;
	          }
	
	          return _context2.abrupt('return');
	
	        case 2:
	          _context2.next = 4;
	          return (0, _effects.put)({
	            type: _customer.SET_DATA,
	            payload: _extends({}, meta, {
	              customer: data.customerInfo
	            })
	          });
	
	        case 4:
	          _context2.next = 6;
	          return (0, _effects.put)({
	            type: _common.SET_SALES_SESSION_ID,
	            salesSessionId: data.customerInfo.salesSessionId
	          });
	
	        case 6:
	          _context2.next = 8;
	          return (0, _effects.put)((0, _common.setConsumerType)(data.consumerType));
	
	        case 8:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function customerSagas() {
	  return regeneratorRuntime.wrap(function customerSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(normalizeWatch)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preferredTelephoneSelector = exports.moveDateRangeSelector = exports.moveToAddressSelector = exports.customerInfoSelector = exports.customerSelector = undefined;
	
	var _reselect = __webpack_require__(38);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customerSelector = exports.customerSelector = function customerSelector(state) {
	  return state.customer.customer;
	};
	
	// for customer name and contact info
	var customerInfoSelector = exports.customerInfoSelector = (0, _reselect.createSelector)(customerSelector, function (customer) {
	  return {
	    streetAddress: _lodash2.default.get(customer, 'serviceAddress.streetAddress', ''),
	    unitNumber: _lodash2.default.get(customer, 'serviceAddress.unitNumber', ''),
	    city: _lodash2.default.get(customer, 'serviceAddress.city', ''),
	    state: _lodash2.default.get(customer, 'serviceAddress.state', ''),
	    zipCode: _lodash2.default.get(customer, 'serviceAddress.zipCode', ''),
	    firstName: _lodash2.default.get(customer, 'firstName', ''),
	    emailAddress: _lodash2.default.get(customer, 'emailAddress', ''),
	    salesSessionId: _lodash2.default.get(customer, 'salesSessionId', '')
	  };
	});
	
	// for user entered moveToAddress comparison
	var moveToAddressSelector = exports.moveToAddressSelector = (0, _reselect.createSelector)(customerSelector, function (customer) {
	  return {
	    streetAddress1: _lodash2.default.get(customer, 'moveToAddress.streetAddress', null),
	    unitNumber: _lodash2.default.get(customer, 'moveToAddress.unitNumber', null),
	    zipCode: _lodash2.default.get(customer, 'moveToAddress.zipCode', null)
	  };
	});
	
	// for min & max acceptable dates in move flow
	var moveDateRangeSelector = exports.moveDateRangeSelector = (0, _reselect.createSelector)(customerSelector, function (customer) {
	  return {
	    min: _lodash2.default.get(customer, 'moveStartDate', null),
	    max: _lodash2.default.get(customer, 'moveEndDate', null)
	  };
	});
	
	var preferredTelephoneSelector = exports.preferredTelephoneSelector = (0, _reselect.createSelector)(customerSelector, function (customer) {
	  var preferredTelephoneNumber = _lodash2.default.get(customer, 'preferredTelephoneNumber', '');
	  var telephoneNumber = _lodash2.default.get(customer, 'telephoneNumber', '');
	
	  return preferredTelephoneNumber || telephoneNumber;
	});

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.normalizeWatch = normalizeWatch;
	exports.normalizeWorker = normalizeWorker;
	exports.default = equipmentSagas;
	
	var _effects = __webpack_require__(10);
	
	var _dataProvider = __webpack_require__(26);
	
	var _equipment = __webpack_require__(303);
	
	var _marked = [normalizeWatch, normalizeWorker, equipmentSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function normalizeWatch() {
	  return regeneratorRuntime.wrap(function normalizeWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_dataProvider.NORMALIZE_DATA, normalizeWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	// WORKERS
	function normalizeWorker(_ref) {
	  var key = _ref.key,
	      data = _ref.data,
	      meta = _ref.meta;
	  return regeneratorRuntime.wrap(function normalizeWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          if (!(key !== 'equipment')) {
	            _context2.next = 2;
	            break;
	          }
	
	          return _context2.abrupt('return');
	
	        case 2:
	          _context2.next = 4;
	          return (0, _effects.put)({
	            type: _equipment.SET_DATA,
	            payload: _extends({}, meta, {
	              equipment: data.equipments
	            })
	          });
	
	        case 4:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function equipmentSagas() {
	  return regeneratorRuntime.wrap(function equipmentSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(normalizeWatch)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.normalizeWatch = normalizeWatch;
	exports.addOfferWatch = addOfferWatch;
	exports.filterOfferWatch = filterOfferWatch;
	exports.priceOfferWatch = priceOfferWatch;
	exports.sortOfferWatch = sortOfferWatch;
	exports.normalizeWorker = normalizeWorker;
	exports.addOfferWorker = addOfferWorker;
	exports.filterOfferWorker = filterOfferWorker;
	exports.priceOfferWorker = priceOfferWorker;
	exports.sortOfferWorker = sortOfferWorker;
	exports.default = offersSagas;
	
	var _effects = __webpack_require__(10);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _loader = __webpack_require__(27);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _dataProvider = __webpack_require__(26);
	
	var _offers = __webpack_require__(189);
	
	var _common = __webpack_require__(7);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _dataLayer = __webpack_require__(75);
	
	var _overlay = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var _marked = [normalizeWatch, addOfferWatch, filterOfferWatch, priceOfferWatch, sortOfferWatch, normalizeWorker, addOfferWorker, filterOfferWorker, priceOfferWorker, sortOfferWorker, offersSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function normalizeWatch() {
	  return regeneratorRuntime.wrap(function normalizeWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_dataProvider.NORMALIZE_DATA, normalizeWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function addOfferWatch() {
	  return regeneratorRuntime.wrap(function addOfferWatch$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_offers.ADD_OFFER, addOfferWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function filterOfferWatch() {
	  return regeneratorRuntime.wrap(function filterOfferWatch$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_offers.UPDATE_FILTER, filterOfferWorker);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function priceOfferWatch() {
	  return regeneratorRuntime.wrap(function priceOfferWatch$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeLatest)(_offers.UPDATE_PRICE, priceOfferWorker);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function sortOfferWatch() {
	  return regeneratorRuntime.wrap(function sortOfferWatch$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.takeLatest)(_offers.UPDATE_SORT, sortOfferWorker);
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}
	
	// WORKERS
	function normalizeWorker(_ref) {
	  var key = _ref.key,
	      data = _ref.data,
	      meta = _ref.meta;
	  var defaultLobs;
	  return regeneratorRuntime.wrap(function normalizeWorker$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          if (!(key !== 'offers')) {
	            _context6.next = 2;
	            break;
	          }
	
	          return _context6.abrupt('return');
	
	        case 2:
	          defaultLobs = _lodash2.default.get(data, 'defaultLobs') ? _lodash2.default.get(data, 'defaultLobs') : [];
	          _context6.next = 5;
	          return (0, _effects.put)({
	            type: _offers.SET_DATA,
	            payload: _extends({}, meta, {
	              flowType: data.flowType,
	              offerData: data.offers,
	              offerCount: data.offerCount,
	              offerMinimumPrice: data.offerMinimumPrice,
	              offerCardGigabitLearnMoreUrl: data.offerCardGigabitLearnMoreUrl,
	              enableDynamicLobSelection: data.enableDynamicLobSelection,
	              filterData: [].concat(_toConsumableArray(defaultLobs), [{
	                name: "Monthly Price Range",
	                legend: "Monthly Price Range",
	                isSlider: true,
	                options: [_extends({
	                  name: "Price",
	                  step: 1,
	                  message: "Pricing does not include equipment, installation, taxes and fees, and other applicable charges.",
	                  id: "Price",
	                  label: "Monthly Price Range"
	                }, data.offerFinderBuilder)]
	              }]),
	              showOffersForLobs: data.showOffersForLobs,
	              enableDefaultLobs: data.enableDefaultLobs
	            })
	          });
	
	        case 5:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this);
	}
	
	function addOfferWorker(action) {
	  var errorPage, authEndpoint, addOfferEndpoint, offersData, currentOverlays, data, filterOptionSelected;
	  return regeneratorRuntime.wrap(function addOfferWorker$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 2:
	          errorPage = _context7.sent;
	          authEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.MYPLAN].endpoints.validateAuth();
	          addOfferEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.OFFERS].endpoints.addOfferToCart();
	          _context7.next = 7;
	          return (0, _effects.select)(_offers.dlOffersSelector);
	
	        case 7:
	          offersData = _context7.sent;
	          _context7.next = 10;
	          return (0, _effects.select)(_overlay.currentOverlaysSelector);
	
	        case 10:
	          currentOverlays = _context7.sent;
	          data = {
	            offerId: action.offer.offerId,
	            force: action.force,
	            overlayName: action.overlayName,
	            offerLOBs: action.offer.offerLOBs,
	            currentLOBs: action.currentLOBs
	          };
	          _context7.prev = 12;
	          _context7.next = 15;
	          return (0, _effects.put)((0, _overlay.setAllOverlays)(currentOverlays, false));
	
	        case 15:
	          _context7.next = 17;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: false }));
	
	        case 17:
	          _context7.next = 19;
	          return (0, _effects.call)(_loader2.default.request, authEndpoint, { useGlobalSpinner: false });
	
	        case 19:
	          _context7.next = 21;
	          return (0, _effects.put)({
	            type: _overlay.SET_OVERLAY_DATA,
	            payload: {
	              overlayData: data
	            }
	          });
	
	        case 21:
	          _context7.next = 23;
	          return (0, _effects.call)(_loader2.default.request, addOfferEndpoint, { data: data, useGlobalSpinner: false, errorPage: errorPage });
	
	        case 23:
	          _context7.next = 25;
	          return (0, _effects.select)(_offers.dlFilterOptionSelected);
	
	        case 25:
	          filterOptionSelected = _context7.sent;
	          _context7.next = 28;
	          return (0, _effects.put)((0, _dataLayer.logCustomEvent)({
	            eventName: "Add to cart",
	            eventAction: "add to cart",
	            type: "click",
	            eventMethod: "cart-Addition",
	            product: [{
	              productInfo: offersData.filter(function (offer) {
	                return offer.productID === data.offerId;
	              })[0]
	            }],
	            page: {
	              attributes: {
	                filterOptionSelected: filterOptionSelected
	              }
	            }
	          }));
	
	        case 28:
	
	          window.location.href = _navigationHelpers.buyFlowUrls.CUSTOMIZE;
	
	          _context7.next = 35;
	          break;
	
	        case 31:
	          _context7.prev = 31;
	          _context7.t0 = _context7['catch'](12);
	          _context7.next = 35;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 35:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this, [[12, 31]]);
	}
	
	/*
	    HACK: Relying on digitalData global
	    I'm using UPDATE_FILTER action to prepopulate the user's default filters
	    in pages/showOffers/showOffersFilterSagas.
	    This would cause extra dataLayer events to be fired on page load.
	    Instead, I'm searching the digitalData for the page load event before
	    registering any filter click events.
	    The cleaner implementation would be to fire a separate action to prepopulate
	    and therefore this worker wouldn't have to diff between page load actions
	    and user click actions
	*/
	function filterOfferWorker() {
	  var offersData, offerDataPageLoaded, filterOptionSelected;
	  return regeneratorRuntime.wrap(function filterOfferWorker$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          if (!(!_lodash2.default.isEmpty(window.digitalData) && window.digitalData.event)) {
	            _context8.next = 11;
	            break;
	          }
	
	          _context8.next = 3;
	          return (0, _effects.select)(_offers.dlDisplayedOffersSelector);
	
	        case 3:
	          offersData = _context8.sent;
	          offerDataPageLoaded = _lodash2.default.findIndex(window.digitalData.event, {
	            eventInfo: {
	              eventName: "Offer Loaded",
	              eventAction: "product view",
	              type: "page load"
	            }
	          }) > -1;
	
	          if (!offerDataPageLoaded) {
	            _context8.next = 11;
	            break;
	          }
	
	          _context8.next = 8;
	          return (0, _effects.select)(_offers.dlFilterOptionSelected);
	
	        case 8:
	          filterOptionSelected = _context8.sent;
	          _context8.next = 11;
	          return (0, _effects.put)((0, _dataLayer.logCustomEvent)({
	            eventName: "Offer Loaded",
	            eventAction: "Filter changed",
	            type: "click",
	            eventMethod: "product-View",
	            product: offersData.map(function (offer) {
	              return {
	                productInfo: _extends({}, offer)
	              };
	            }),
	            page: {
	              attributes: {
	                filterOptionSelected: filterOptionSelected
	              }
	            }
	          }));
	
	        case 11:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked[7], this);
	}
	
	function priceOfferWorker() {
	  var pricesStringRaw;
	  return regeneratorRuntime.wrap(function priceOfferWorker$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          _context9.next = 2;
	          return (0, _effects.select)(_offers.dlPriceStringSelector);
	
	        case 2:
	          pricesStringRaw = _context9.sent;
	          _context9.next = 5;
	          return (0, _effects.put)((0, _dataLayer.logCustomEvent)({
	            eventName: "Button/link click",
	            eventAction: pricesStringRaw,
	            type: "click",
	            eventMethod: "send-Event"
	          }));
	
	        case 5:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked[8], this);
	}
	
	function sortOfferWorker() {
	  var offersData, filterOptionSelected;
	  return regeneratorRuntime.wrap(function sortOfferWorker$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          _context10.next = 2;
	          return (0, _effects.select)(_offers.dlDisplayedOffersSelector);
	
	        case 2:
	          offersData = _context10.sent;
	          _context10.next = 5;
	          return (0, _effects.select)(_offers.dlFilterOptionSelected);
	
	        case 5:
	          filterOptionSelected = _context10.sent;
	          _context10.next = 8;
	          return (0, _effects.put)((0, _dataLayer.logCustomEvent)({
	            eventName: "Offer Loaded",
	            eventAction: "Filter changed",
	            type: "click",
	            eventMethod: "product-View",
	            product: offersData.map(function (offer) {
	              return {
	                productInfo: _extends({}, offer)
	              };
	            }),
	            page: {
	              attributes: {
	                filterOptionSelected: filterOptionSelected
	              }
	            }
	          }));
	
	        case 8:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked[9], this);
	}
	
	function offersSagas() {
	  return regeneratorRuntime.wrap(function offersSagas$(_context11) {
	    while (1) {
	      switch (_context11.prev = _context11.next) {
	        case 0:
	          _context11.next = 2;
	          return [(0, _effects.fork)(normalizeWatch), (0, _effects.fork)(addOfferWatch), (0, _effects.fork)(filterOfferWatch), (0, _effects.fork)(priceOfferWatch), (0, _effects.fork)(sortOfferWatch)];
	
	        case 2:
	        case 'end':
	          return _context11.stop();
	      }
	    }
	  }, _marked[10], this);
	}

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dlDisplayedOffersSelector = exports.currentLobValues = exports.currentLobValuesServer = exports.offerClientUnfilteredSelector = exports.offerClientFilteredSelector = exports.offerServerFilteredSelector = exports.offerSortSelector = exports.sortSelector = exports.availableSortItemsSelector = exports.sortItemsSelector = exports.sortTitleSelector = exports.currentSortSelector = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reselect = __webpack_require__(38);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _offersHelpers = __webpack_require__(190);
	
	var _filterSelectors = __webpack_require__(304);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var currentSortSelector = exports.currentSortSelector = function currentSortSelector(state) {
	  return state.offers.currentSort;
	};
	var sortTitleSelector = exports.sortTitleSelector = function sortTitleSelector(state) {
	  return state.offers.sortTitle;
	};
	var sortItemsSelector = exports.sortItemsSelector = function sortItemsSelector(state) {
	  return state.offers.sortItems;
	};
	
	var availableSortItemsSelector = exports.availableSortItemsSelector = (0, _reselect.createSelector)(sortItemsSelector, _filterSelectors.offerLOBselector, function (sortItems, lobs) {
	  var items = _lodash2.default.map(sortItems, function (item) {
	    return _extends({}, item, {
	      options: _lodash2.default.filter(item.options, function (item) {
	        return _lodash2.default.find(lobs, item.key);
	      })
	    });
	  });
	
	  return _lodash2.default.filter(items, function (item) {
	    return item.options.length > 0;
	  });
	});
	
	var sortSelector = exports.sortSelector = (0, _reselect.createSelector)(availableSortItemsSelector, currentSortSelector, function (sortItems, currentSort) {
	  var selection = !_lodash2.default.isEmpty(sortItems) && !_lodash2.default.isEmpty(currentSort) && _lodash2.default.find(_lodash2.default.flatMap(sortItems, 'options'), { key: currentSort[0], dir: currentSort[1] });
	
	  return selection || { key: '', dir: '' };
	});
	
	//Sort offers by the current selected sort criteria
	var offerSortSelector = exports.offerSortSelector = (0, _reselect.createSelector)(_filterSelectors.offerPriceSelector, sortSelector, function (offers, sort) {
	  var sortedOffers = _lodash2.default.orderBy(offers, sort.key, sort.dir.toLowerCase()),
	      sortKey = sort.key.split('.');
	
	  // all further logic places null values last in all cases.
	  var lastNullIndex = -1;
	
	  _lodash2.default.forEach(sortedOffers, function (sortedOffer, index) {
	    var isNullVal = false,
	        tempObj = sortedOffer;
	
	    _lodash2.default.forEach(sortKey, function (key) {
	      if (tempObj.hasOwnProperty(key) && !_lodash2.default.isNull(tempObj[key])) {
	        tempObj = tempObj[key];
	      } else {
	        isNullVal = true;
	      }
	    });
	    if (isNullVal) {
	      lastNullIndex = index;
	    }
	  });
	
	  lastNullIndex = lastNullIndex + 1;
	
	  return [].concat(_toConsumableArray(sortedOffers.slice(lastNullIndex)), _toConsumableArray(sortedOffers.slice(0, lastNullIndex)));
	});
	
	var offerServerFilteredSelector = exports.offerServerFilteredSelector = (0, _reselect.createSelector)(_offersHelpers.offerSelector, function (processedOffers) {
	  return (0, _offersHelpers.aggregateOffers)(processedOffers);
	});
	
	var offerClientFilteredSelector = exports.offerClientFilteredSelector = (0, _reselect.createSelector)(offerSortSelector, function (processedOffers) {
	  return (0, _offersHelpers.aggregateOffers)(processedOffers);
	});
	
	var offerClientUnfilteredSelector = exports.offerClientUnfilteredSelector = (0, _reselect.createSelector)(offerSortSelector, function (unprocessedOffers) {
	  return unprocessedOffers;
	});
	
	var currentLobValuesServer = exports.currentLobValuesServer = (0, _reselect.createSelector)(offerServerFilteredSelector, function (offers) {
	  return (0, _offersHelpers.LobValuesfromAggregate)(offers);
	});
	
	//LOBs for the sticky header need to be calculated last,
	//because it needs to be accurate for both user selection and default offers
	var currentLobValues = exports.currentLobValues = (0, _reselect.createSelector)(offerClientFilteredSelector, function (offers) {
	  return (0, _offersHelpers.LobValuesfromAggregate)(offers);
	});
	
	var dlDisplayedOffersSelector = exports.dlDisplayedOffersSelector = (0, _reselect.createSelector)(offerSortSelector, function (offers) {
	  return (0, _offersHelpers.formatOffersForDataLayer)(offers);
	});

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleToggle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var handleToggle = exports.handleToggle = function handleToggle(stateSlice, name) {
	  var index = _lodash2.default.findIndex(stateSlice, { name: name });
	
	  return [].concat(_toConsumableArray(stateSlice.slice(0, index)), [_extends({}, stateSlice[index], {
	    showDetails: !stateSlice[index].showDetails
	  })], _toConsumableArray(stateSlice.slice(index + 1)));
	};

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.normalizeWatch = normalizeWatch;
	exports.normalizeWorker = normalizeWorker;
	exports.default = customerSagas;
	
	var _effects = __webpack_require__(10);
	
	var _dataProvider = __webpack_require__(26);
	
	var _plan = __webpack_require__(123);
	
	var _marked = [normalizeWatch, normalizeWorker, customerSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function normalizeWatch() {
	  return regeneratorRuntime.wrap(function normalizeWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_dataProvider.NORMALIZE_DATA, normalizeWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	// WORKERS
	function normalizeWorker(_ref) {
	  var key = _ref.key,
	      data = _ref.data,
	      meta = _ref.meta;
	  return regeneratorRuntime.wrap(function normalizeWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          if (!(key !== 'plan')) {
	            _context2.next = 2;
	            break;
	          }
	
	          return _context2.abrupt('return');
	
	        case 2:
	          _context2.next = 4;
	          return (0, _effects.put)({
	            type: _plan.SET_DATA,
	            payload: _extends({}, meta, {
	              servicePackages: data.servicePackages,
	              currentPlan: data.currentPlan,
	              totalAmount: data.monthlyTotalAmount,
	              charges: data.charges,
	              channels: data.channels,
	              additionalServices: data.additionalServices,
	              eligibility: {
	                managePlanUpgradeCenterUrl: data.managePlanUpgradeCenterUrl,
	                enableADManagePlanFlow: data.enableADManagePlanFlow
	              },
	              enableManageChannel: data.enableManageChannel,
	              enableManageEquipment: data.enableManageEquipment,
	              isStreamingVideoCustomer: data.isStreamingVideoCustomer,
	              addAdjustCapability: data.myPlanAddAdjustCapability
	            })
	          });
	
	        case 4:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function customerSagas() {
	  return regeneratorRuntime.wrap(function customerSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(normalizeWatch)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.manageChannelLinkSelector = exports.enableManageEquipmentSelector = exports.enableManageChannelSelector = exports.hasVideoLob = exports.lobSelector = exports.addableSelector = exports.tierOfServiceSelector = exports.packagesSelector = exports.currentPlanState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reselect = __webpack_require__(38);
	
	var _navigationHelpers = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentPlanState = exports.currentPlanState = function currentPlanState(state) {
	  return state.plan;
	};
	
	var packagesSelector = exports.packagesSelector = (0, _reselect.createSelector)(currentPlanState, function (plan) {
	  return _lodash2.default.get(plan, 'servicePackages.packages', []);
	});
	
	var tierOfServiceSelector = exports.tierOfServiceSelector = (0, _reselect.createSelector)(packagesSelector, function (packages) {
	  return _lodash2.default.flatten(_lodash2.default.map(packages, function (pack) {
	    return pack.tierOfServices;
	  }));
	});
	
	var addableSelector = exports.addableSelector = (0, _reselect.createSelector)(currentPlanState, function (plan) {
	  return _lodash2.default.get(plan, 'addAdjustCapability.add', []);
	});
	
	var lobSelector = exports.lobSelector = (0, _reselect.createSelector)(currentPlanState, tierOfServiceSelector, addableSelector, function (plan, tiers, isAddable) {
	  return _lodash2.default.map(plan.lobs, function (lob, lobName) {
	
	    var tierKey = _lodash2.default.findKey(tiers, ['lineOfBusiness', lobName]);
	    var tier = subscribed ? tiers[tierKey] : {};
	    var subscribed = tierKey > -1;
	    var addable = _lodash2.default.indexOf(isAddable, lobName) !== -1;
	
	    return _extends({
	      lobName: lobName,
	      subscribed: subscribed,
	      addable: addable
	    }, tier, lob);
	  });
	});
	
	var hasVideoLob = exports.hasVideoLob = (0, _reselect.createSelector)(lobSelector, function (lobs) {
	  return _lodash2.default.findIndex(lobs, function (lob) {
	    return lob.lobName === 'TV' && lob.subscribed;
	  }) > -1;
	});
	
	var enableManageChannelSelector = exports.enableManageChannelSelector = (0, _reselect.createSelector)(currentPlanState, function (plan) {
	  var enableManageChannel = _lodash2.default.get(plan, 'enableManageChannel');
	
	  return enableManageChannel !== false;
	});
	
	var enableManageEquipmentSelector = exports.enableManageEquipmentSelector = (0, _reselect.createSelector)(currentPlanState, function (plan) {
	  var enableManageEquipment = _lodash2.default.get(plan, 'enableManageEquipment');
	
	  return enableManageEquipment !== false;
	});
	
	var manageChannelLinkSelector = exports.manageChannelLinkSelector = (0, _reselect.createSelector)(currentPlanState, function (plan) {
	  return _lodash2.default.get(plan, 'isStreamingVideoCustomer') ? _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.ADDON_MANAGE_STREAMING_VIDEO].path : _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.ADDON_CHANNEL].path;
	});

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.backNavUrl = exports.channelRedirectUrl = exports.productNameSelector = exports.productIdSelector = exports.checkoutSelector = undefined;
	
	var _reselect = __webpack_require__(38);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkoutSelector = exports.checkoutSelector = function checkoutSelector(state) {
	  return state.quickCheckout.quickCheckout;
	};
	
	var productIdSelector = exports.productIdSelector = (0, _reselect.createSelector)(checkoutSelector, function (quickCheckout) {
	  return _lodash2.default.get(quickCheckout, 'productId', '');
	});
	
	var productNameSelector = exports.productNameSelector = (0, _reselect.createSelector)(checkoutSelector, function (quickCheckout) {
	  return _lodash2.default.get(quickCheckout, 'productName', '');
	});
	
	var channelRedirectUrl = exports.channelRedirectUrl = (0, _reselect.createSelector)(_common.osFamilySelector, productIdSelector, function (os, productId) {
	  var urlType = os === 'iOS' || os === 'Android' ? os : 'Web';
	
	  return 'quickCheckoutProducts.' + productId + '.redirectUrl.' + urlType;
	});
	
	var backNavUrl = exports.backNavUrl = (0, _reselect.createSelector)(productIdSelector, function (productId) {
	  return 'quickCheckoutProducts.' + productId + '.backNav';
	});

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(73);
	
	var _TimeSlotCalendar = __webpack_require__(677);
	
	var _common = __webpack_require__(7);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _offers = __webpack_require__(189);
	
	var _offers2 = _interopRequireDefault(_offers);
	
	var _equipment = __webpack_require__(303);
	
	var _equipment2 = _interopRequireDefault(_equipment);
	
	var _customer = __webpack_require__(76);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _checkout = __webpack_require__(302);
	
	var _checkout2 = _interopRequireDefault(_checkout);
	
	var _plan = __webpack_require__(123);
	
	var _plan2 = _interopRequireDefault(_plan);
	
	var _review = __webpack_require__(141);
	
	var _review2 = _interopRequireDefault(_review);
	
	var _confirmation = __webpack_require__(188);
	
	var _confirmation2 = _interopRequireDefault(_confirmation);
	
	var _cancel = __webpack_require__(618);
	
	var _cancel2 = _interopRequireDefault(_cancel);
	
	var _quickCheckout = __webpack_require__(124);
	
	var _quickCheckout2 = _interopRequireDefault(_quickCheckout);
	
	var _localization = __webpack_require__(197);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	var _review3 = __webpack_require__(195);
	
	var _review4 = _interopRequireDefault(_review3);
	
	var _confirmation3 = __webpack_require__(193);
	
	var _confirmation4 = _interopRequireDefault(_confirmation3);
	
	var _install = __webpack_require__(142);
	
	var _install2 = _interopRequireDefault(_install);
	
	var _account = __webpack_require__(307);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _multipleAddress = __webpack_require__(192);
	
	var _multipleAddress2 = _interopRequireDefault(_multipleAddress);
	
	var _collapse = __webpack_require__(613);
	
	var _collapse2 = _interopRequireDefault(_collapse);
	
	var _overlay = __webpack_require__(191);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _suggestions = __webpack_require__(317);
	
	var _suggestions2 = _interopRequireDefault(_suggestions);
	
	var _dataLayer = __webpack_require__(75);
	
	var _dataLayer2 = _interopRequireDefault(_dataLayer);
	
	var _target = __webpack_require__(318);
	
	var _target2 = _interopRequireDefault(_target);
	
	var _contentProvider = __webpack_require__(74);
	
	var _reactRouterRedux = __webpack_require__(180);
	
	var _reduxForm = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = (0, _redux.combineReducers)({
	  account: _account2.default,
	  accountMultipleAddress: _multipleAddress2.default,
	  calendar: _TimeSlotCalendar.calendar,
	  cancel: _cancel2.default,
	  checkout: _checkout2.default,
	  collapse: _collapse2.default,
	  common: _common2.default,
	  confirmation: _confirmation2.default,
	  contentProvider: _contentProvider.reducer,
	  customer: _customer2.default,
	  dataLayer: _dataLayer2.default,
	  target: _target2.default,
	  equipment: _equipment2.default,
	  form: _reduxForm.reducer,
	  omniSales: _localization2.default,
	  moversInstall: _install2.default,
	  moversConfirmation: _confirmation4.default,
	  moversReview: _review4.default,
	  offers: _offers2.default,
	  overlay: _overlay2.default,
	  plan: _plan2.default,
	  quickCheckout: _quickCheckout2.default,
	  review: _review2.default,
	  suggestions: _suggestions2.default,
	  routing: _reactRouterRedux.routerReducer // keep this one last, seems to cause issues with webpack error reporting otherwise
	});
	
	exports.default = rootReducer;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.currentOverlaysSelector = exports.overlaysSelector = undefined;
	
	var _reselect = __webpack_require__(38);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var overlaysSelector = exports.overlaysSelector = function overlaysSelector(state) {
	  return state.overlay;
	};
	
	var currentOverlaysSelector = exports.currentOverlaysSelector = (0, _reselect.createSelector)(overlaysSelector, function (overlays) {
	  return _lodash2.default.get(overlays, 'overlays', {});
	});

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadRedirectWatch = loadRedirectWatch;
	exports.loadRedirectWorker = loadRedirectWorker;
	exports.default = accountSagas;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _effects = __webpack_require__(10);
	
	var _account = __webpack_require__(307);
	
	var _reactRouter = __webpack_require__(16);
	
	var _dataProvider = __webpack_require__(19);
	
	var _dataProvider2 = _interopRequireDefault(_dataProvider);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadRedirectWatch, loadRedirectWorker, accountSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadRedirectWatch() {
	  return regeneratorRuntime.wrap(function loadRedirectWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_account.LOAD_CONTENT, loadRedirectWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	// WORKERS
	function loadRedirectWorker() {
	  var errorPage, success, state, queryString;
	  return regeneratorRuntime.wrap(function loadRedirectWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          _context2.next = 3;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: true }));
	
	        case 3:
	          _context2.next = 5;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 5:
	          errorPage = _context2.sent;
	          _context2.next = 8;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'accountMultipleAddress' }], { errorPage: errorPage });
	
	        case 8:
	          success = _context2.sent;
	
	          if (success) {
	            _context2.next = 11;
	            break;
	          }
	
	          return _context2.abrupt('return');
	
	        case 11:
	          _context2.next = 13;
	          return (0, _effects.select)();
	
	        case 13:
	          state = _context2.sent;
	          queryString = _lodash2.default.get(state, 'routing.locationBeforeTransitions.search');
	
	
	          _reactRouter.browserHistory.push('' + _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.account.MULTIPLE_ADDRESS].path + queryString);
	
	          _context2.next = 18;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 18:
	          _context2.next = 22;
	          break;
	
	        case 20:
	          _context2.prev = 20;
	          _context2.t0 = _context2['catch'](0);
	
	        case 22:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 20]]);
	}
	
	function accountSagas() {
	  return regeneratorRuntime.wrap(function accountSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(loadRedirectWatch)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadAddressesWatch = loadAddressesWatch;
	exports.setAddressWatch = setAddressWatch;
	exports.normalizeWatch = normalizeWatch;
	exports.loadAddressesWorker = loadAddressesWorker;
	exports.setAddressWorker = setAddressWorker;
	exports.normalizeWorker = normalizeWorker;
	exports.default = accountMultipleAddressSagas;
	
	var _effects = __webpack_require__(10);
	
	var _loader = __webpack_require__(27);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _multipleAddress = __webpack_require__(192);
	
	var _dataProvider = __webpack_require__(19);
	
	var _dataProvider2 = _interopRequireDefault(_dataProvider);
	
	var _dataProvider3 = __webpack_require__(26);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadAddressesWatch, setAddressWatch, normalizeWatch, loadAddressesWorker, setAddressWorker, normalizeWorker, accountMultipleAddressSagas].map(regeneratorRuntime.mark);
	// import { browserHistory } from 'react-router';
	
	
	// WATCHERS
	function loadAddressesWatch() {
	  return regeneratorRuntime.wrap(function loadAddressesWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_multipleAddress.LOAD_CONTENT, loadAddressesWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function setAddressWatch() {
	  return regeneratorRuntime.wrap(function setAddressWatch$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_multipleAddress.SET_ADDRESS, setAddressWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function normalizeWatch() {
	  return regeneratorRuntime.wrap(function normalizeWatch$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_dataProvider3.NORMALIZE_DATA, normalizeWorker);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	// WORKERS
	function loadAddressesWorker() {
	  var currentAddresses, errorPage, success;
	  return regeneratorRuntime.wrap(function loadAddressesWorker$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.prev = 0;
	          _context4.next = 3;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: true }));
	
	        case 3:
	          _context4.next = 5;
	          return (0, _effects.select)(function (state) {
	            return state.accountMultipleAddress.customerBillingAccounts;
	          });
	
	        case 5:
	          currentAddresses = _context4.sent;
	
	          if (!(currentAddresses.length > 1)) {
	            _context4.next = 10;
	            break;
	          }
	
	          _context4.next = 9;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 9:
	          return _context4.abrupt('return');
	
	        case 10:
	          _context4.next = 12;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 12:
	          errorPage = _context4.sent;
	          _context4.next = 15;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'accountMultipleAddress' }], { errorPage: errorPage });
	
	        case 15:
	          success = _context4.sent;
	
	          if (success) {
	            _context4.next = 18;
	            break;
	          }
	
	          return _context4.abrupt('return');
	
	        case 18:
	          _context4.next = 20;
	          return (0, _effects.put)({
	            type: _multipleAddress.DL_PAGE_LOADED
	          });
	
	        case 20:
	          _context4.next = 22;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 22:
	          _context4.next = 28;
	          break;
	
	        case 24:
	          _context4.prev = 24;
	          _context4.t0 = _context4['catch'](0);
	          _context4.next = 28;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 28:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this, [[0, 24]]);
	}
	
	function setAddressWorker(_ref) {
	  var accountNumber = _ref.accountNumber;
	  var errorPage, endpoint, success;
	  return regeneratorRuntime.wrap(function setAddressWorker$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.prev = 0;
	          _context5.next = 3;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 3:
	          errorPage = _context5.sent;
	          endpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.account.MULTIPLE_ADDRESS].endpoints.setAddress(accountNumber);
	          _context5.next = 7;
	          return (0, _effects.call)(_loader2.default.request, endpoint, { hideContentWhileLoading: false, errorPage: errorPage });
	
	        case 7:
	          success = _context5.sent;
	
	          if (success) {
	            _context5.next = 10;
	            break;
	          }
	
	          return _context5.abrupt('return');
	
	        case 10:
	          _context5.next = 14;
	          break;
	
	        case 12:
	          _context5.prev = 12;
	          _context5.t0 = _context5['catch'](0);
	
	        case 14:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this, [[0, 12]]);
	}
	
	function normalizeWorker(_ref2) {
	  var key = _ref2.key,
	      data = _ref2.data;
	  return regeneratorRuntime.wrap(function normalizeWorker$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          if (!(key !== 'accountMultipleAddress')) {
	            _context6.next = 2;
	            break;
	          }
	
	          return _context6.abrupt('return');
	
	        case 2:
	          _context6.next = 4;
	          return (0, _effects.put)({
	            type: _multipleAddress.SET_DATA,
	            payload: _extends({}, data)
	          });
	
	        case 4:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this);
	}
	
	function accountMultipleAddressSagas() {
	  return regeneratorRuntime.wrap(function accountMultipleAddressSagas$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return [(0, _effects.fork)(loadAddressesWatch), (0, _effects.fork)(setAddressWatch), (0, _effects.fork)(normalizeWatch)];
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadCustomerWatch = loadCustomerWatch;
	exports.disconnectWatch = disconnectWatch;
	exports.loadCustomerWorker = loadCustomerWorker;
	exports.disconnectWorker = disconnectWorker;
	exports.default = moversCancelSagas;
	
	var _effects = __webpack_require__(10);
	
	var _reactRouter = __webpack_require__(16);
	
	var _reduxForm = __webpack_require__(44);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cancel = __webpack_require__(308);
	
	var _customer = __webpack_require__(76);
	
	var _loader = __webpack_require__(27);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _dataProvider = __webpack_require__(19);
	
	var _dataProvider2 = _interopRequireDefault(_dataProvider);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadCustomerWatch, disconnectWatch, loadCustomerWorker, disconnectWorker, moversCancelSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadCustomerWatch() {
	  return regeneratorRuntime.wrap(function loadCustomerWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_cancel.LOAD_CONTENT, loadCustomerWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function disconnectWatch() {
	  return regeneratorRuntime.wrap(function disconnectWatch$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_cancel.DISCONNECT_CUSTOMER, disconnectWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	// WORKERS
	function loadCustomerWorker() {
	  var errorPage, success;
	  return regeneratorRuntime.wrap(function loadCustomerWorker$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.prev = 0;
	          _context3.next = 3;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: true }));
	
	        case 3:
	          _context3.next = 5;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 5:
	          errorPage = _context3.sent;
	          _context3.next = 8;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'auth' }, { state: 'customer' }, { state: 'context' }], { errorPage: errorPage });
	
	        case 8:
	          success = _context3.sent;
	
	          if (success) {
	            _context3.next = 11;
	            break;
	          }
	
	          return _context3.abrupt('return');
	
	        case 11:
	          _context3.next = 13;
	          return (0, _effects.put)({
	            type: _cancel.DL_PAGE_LOADED
	          });
	
	        case 13:
	          _context3.next = 15;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 15:
	          _context3.next = 22;
	          break;
	
	        case 17:
	          _context3.prev = 17;
	          _context3.t0 = _context3['catch'](0);
	          _context3.next = 21;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 21:
	          _reactRouter.browserHistory.push(_navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.ERROR].path);
	
	        case 22:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this, [[0, 17]]);
	}
	
	function disconnectWorker() {
	  var errorPage, values, customer, data, postLoad, endpoint, success;
	  return regeneratorRuntime.wrap(function disconnectWorker$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.prev = 0;
	          _context5.next = 3;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 3:
	          errorPage = _context5.sent;
	          _context5.next = 6;
	          return (0, _effects.select)((0, _reduxForm.getFormValues)('cancel'));
	
	        case 6:
	          values = _context5.sent;
	          _context5.next = 9;
	          return (0, _effects.select)(_customer.customerSelector);
	
	        case 9:
	          customer = _context5.sent;
	          data = {
	            disconnectDate: values.serviceStopDate
	          };
	          postLoad = regeneratorRuntime.mark(function postLoad() {
	            var customerWithUpdates;
	            return regeneratorRuntime.wrap(function postLoad$(_context4) {
	              while (1) {
	                switch (_context4.prev = _context4.next) {
	                  case 0:
	                    customerWithUpdates = {
	                      customer: _extends({}, customer, {
	                        serviceStopDate: _lodash2.default.get(data, 'disconnectDate')
	                      })
	                    };
	                    _context4.next = 3;
	                    return (0, _effects.put)({
	                      type: _customer.SET_DATA,
	                      payload: customerWithUpdates
	                    });
	
	                  case 3:
	                  case 'end':
	                    return _context4.stop();
	                }
	              }
	            }, postLoad, this);
	          });
	          endpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.CANCEL].endpoints.disconnectCustomer();
	          _context5.next = 15;
	          return (0, _effects.call)(_loader2.default.request, endpoint, { data: data, hideContentWhileLoading: false, postLoad: postLoad, postLoadOnError: false, errorPage: errorPage });
	
	        case 15:
	          success = _context5.sent;
	
	          if (success) {
	            _context5.next = 18;
	            break;
	          }
	
	          return _context5.abrupt('return');
	
	        case 18:
	          _context5.next = 22;
	          break;
	
	        case 20:
	          _context5.prev = 20;
	          _context5.t0 = _context5['catch'](0);
	
	        case 22:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[3], this, [[0, 20]]);
	}
	
	function moversCancelSagas() {
	  return regeneratorRuntime.wrap(function moversCancelSagas$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return [(0, _effects.fork)(loadCustomerWatch), (0, _effects.fork)(disconnectWatch)];
	
	        case 2:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadCustomerWatch = loadCustomerWatch;
	exports.normalizeWatch = normalizeWatch;
	exports.loadCustomerWorker = loadCustomerWorker;
	exports.normalizeWorker = normalizeWorker;
	exports.default = moversCancelSagas;
	
	var _effects = __webpack_require__(10);
	
	var _reactRouter = __webpack_require__(16);
	
	var _confirmation = __webpack_require__(193);
	
	var _dataProvider = __webpack_require__(19);
	
	var _dataProvider2 = _interopRequireDefault(_dataProvider);
	
	var _dataProvider3 = __webpack_require__(26);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadCustomerWatch, normalizeWatch, loadCustomerWorker, normalizeWorker, moversCancelSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadCustomerWatch() {
	  return regeneratorRuntime.wrap(function loadCustomerWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_confirmation.LOAD_CONTENT, loadCustomerWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function normalizeWatch() {
	  return regeneratorRuntime.wrap(function normalizeWatch$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_dataProvider3.NORMALIZE_DATA, normalizeWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	// WORKERS
	function loadCustomerWorker() {
	  var errorPage, success;
	  return regeneratorRuntime.wrap(function loadCustomerWorker$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.prev = 0;
	          _context3.next = 3;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: true }));
	
	        case 3:
	          _context3.next = 5;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 5:
	          errorPage = _context3.sent;
	          _context3.next = 8;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'auth' }, { state: 'customer' }, { state: 'context' }, { state: 'moversConfirmation' }], { errorPage: errorPage });
	
	        case 8:
	          success = _context3.sent;
	
	          if (success) {
	            _context3.next = 11;
	            break;
	          }
	
	          return _context3.abrupt('return');
	
	        case 11:
	          _context3.next = 13;
	          return (0, _effects.put)({
	            type: _confirmation.DL_PAGE_LOADED
	          });
	
	        case 13:
	          _context3.next = 15;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 15:
	          _context3.next = 22;
	          break;
	
	        case 17:
	          _context3.prev = 17;
	          _context3.t0 = _context3['catch'](0);
	          _context3.next = 21;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 21:
	          _reactRouter.browserHistory.push(_navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.ERROR].path);
	
	        case 22:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this, [[0, 17]]);
	}
	
	function normalizeWorker(_ref) {
	  var key = _ref.key,
	      data = _ref.data,
	      meta = _ref.meta;
	  return regeneratorRuntime.wrap(function normalizeWorker$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          if (!(key !== 'moversConfirmation')) {
	            _context4.next = 2;
	            break;
	          }
	
	          return _context4.abrupt('return');
	
	        case 2:
	          _context4.next = 4;
	          return (0, _effects.put)({
	            type: _confirmation.SET_DATA,
	            payload: _extends({}, meta, {
	              content: data
	            })
	          });
	
	        case 4:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function moversCancelSagas() {
	  return regeneratorRuntime.wrap(function moversCancelSagas$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return [(0, _effects.fork)(loadCustomerWatch), (0, _effects.fork)(normalizeWatch)];
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadContentWatch = loadContentWatch;
	exports.normalizeWatch = normalizeWatch;
	exports.confirmInstallWatch = confirmInstallWatch;
	exports.loadContentWorker = loadContentWorker;
	exports.selectSikWorker = selectSikWorker;
	exports.selectProWorker = selectProWorker;
	exports.normalizeWorker = normalizeWorker;
	exports.confirmInstallWorker = confirmInstallWorker;
	exports.default = moversInstallSagas;
	
	var _effects = __webpack_require__(10);
	
	var _reduxForm = __webpack_require__(44);
	
	var _reactRouter = __webpack_require__(16);
	
	var _loader = __webpack_require__(27);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _install = __webpack_require__(142);
	
	var _dataProvider = __webpack_require__(19);
	
	var _dataProvider2 = _interopRequireDefault(_dataProvider);
	
	var _dataProvider3 = __webpack_require__(26);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadContentWatch, normalizeWatch, confirmInstallWatch, loadContentWorker, selectSikWorker, selectProWorker, normalizeWorker, confirmInstallWorker, moversInstallSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadContentWatch() {
	  return regeneratorRuntime.wrap(function loadContentWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_install.LOAD_CONTENT, loadContentWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function normalizeWatch() {
	  return regeneratorRuntime.wrap(function normalizeWatch$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_dataProvider3.NORMALIZE_DATA, normalizeWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function confirmInstallWatch() {
	  return regeneratorRuntime.wrap(function confirmInstallWatch$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_install.CONFIRM_INSTALL, confirmInstallWorker);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	// WORKERS
	function loadContentWorker() {
	  var errorPage, success, sikTask, proTask, sikServerSelected, proServerSelected, sikAvailable, proAvailable, action;
	  return regeneratorRuntime.wrap(function loadContentWorker$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.prev = 0;
	          _context4.next = 3;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: true }));
	
	        case 3:
	          _context4.next = 5;
	          return (0, _effects.put)((0, _install.updateInstallationOption)(''));
	
	        case 5:
	          _context4.next = 7;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 7:
	          errorPage = _context4.sent;
	          _context4.next = 10;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'auth' }, { state: 'customer' }, { state: 'context' }, { state: 'moversInstall' }], { errorPage: errorPage });
	
	        case 10:
	          success = _context4.sent;
	
	          if (success) {
	            _context4.next = 13;
	            break;
	          }
	
	          return _context4.abrupt('return');
	
	        case 13:
	          _context4.next = 15;
	          return (0, _effects.put)({
	            type: _install.DL_PAGE_LOADED
	          });
	
	        case 15:
	          _context4.next = 17;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 17:
	          sikTask = void 0, proTask = void 0;
	          _context4.next = 20;
	          return (0, _effects.select)(_install.sikServerSelectedSelector);
	
	        case 20:
	          sikServerSelected = _context4.sent;
	          _context4.next = 23;
	          return (0, _effects.select)(_install.proServerSelectedSelector);
	
	        case 23:
	          proServerSelected = _context4.sent;
	          _context4.next = 26;
	          return (0, _effects.select)(_install.sikAvailableSelector);
	
	        case 26:
	          sikAvailable = _context4.sent;
	          _context4.next = 29;
	          return (0, _effects.select)(_install.proAvailableSelector);
	
	        case 29:
	          proAvailable = _context4.sent;
	
	          if (!(proServerSelected || proAvailable && !sikAvailable)) {
	            _context4.next = 33;
	            break;
	          }
	
	          _context4.next = 33;
	          return (0, _effects.fork)(selectProWorker);
	
	        case 33:
	          if (!(sikServerSelected || !proAvailable && sikAvailable)) {
	            _context4.next = 36;
	            break;
	          }
	
	          _context4.next = 36;
	          return (0, _effects.fork)(selectSikWorker);
	
	        case 36:
	          if (false) {
	            _context4.next = 60;
	            break;
	          }
	
	          _context4.next = 39;
	          return (0, _effects.take)([_install.SELECT_SIK, _install.SELECT_PRO]);
	
	        case 39:
	          action = _context4.sent;
	
	          if (!(action.type === _install.SELECT_SIK)) {
	            _context4.next = 51;
	            break;
	          }
	
	          if (!proTask) {
	            _context4.next = 46;
	            break;
	          }
	
	          _context4.next = 44;
	          return (0, _effects.cancel)(proTask);
	
	        case 44:
	          _context4.next = 46;
	          return (0, _effects.put)((0, _install.hideFetchingSpinner)());
	
	        case 46:
	          _context4.next = 48;
	          return (0, _effects.fork)(selectSikWorker, action);
	
	        case 48:
	          sikTask = _context4.sent;
	          _context4.next = 58;
	          break;
	
	        case 51:
	          if (!(action.type === _install.SELECT_PRO)) {
	            _context4.next = 58;
	            break;
	          }
	
	          if (!sikTask) {
	            _context4.next = 55;
	            break;
	          }
	
	          _context4.next = 55;
	          return (0, _effects.cancel)(sikTask);
	
	        case 55:
	          _context4.next = 57;
	          return (0, _effects.fork)(selectProWorker, action);
	
	        case 57:
	          proTask = _context4.sent;
	
	        case 58:
	          _context4.next = 36;
	          break;
	
	        case 60:
	          _context4.next = 67;
	          break;
	
	        case 62:
	          _context4.prev = 62;
	          _context4.t0 = _context4['catch'](0);
	          _context4.next = 66;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 66:
	          _reactRouter.browserHistory.push(_navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.ERROR].path);
	
	        case 67:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this, [[0, 62]]);
	}
	
	function selectSikWorker() {
	  return regeneratorRuntime.wrap(function selectSikWorker$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.put)((0, _install.updateInstallationOption)(_install.SIK_INSTALL_OPTION));
	
	        case 2:
	          _context5.next = 4;
	          return (0, _effects.put)((0, _reduxForm.change)('install', 'selectedOption', _install.SIK_INSTALL_OPTION));
	
	        case 4:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}
	
	function selectProWorker() {
	  var errorPage, installEndpoint, proInstall, selectedTimeSlot;
	  return regeneratorRuntime.wrap(function selectProWorker$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.prev = 0;
	          _context6.next = 3;
	          return (0, _effects.put)((0, _install.showFetchingSpinner)());
	
	        case 3:
	          _context6.next = 5;
	          return (0, _effects.put)((0, _install.updateInstallationOption)(_install.PRO_INSTALL_OPTION));
	
	        case 5:
	          _context6.next = 7;
	          return (0, _effects.put)((0, _reduxForm.change)('install', 'selectedOption', _install.PRO_INSTALL_OPTION));
	
	        case 7:
	          _context6.next = 9;
	          return (0, _effects.put)((0, _reduxForm.registerField)('install', 'selectedTimeSlot', 'Field'));
	
	        case 9:
	          _context6.next = 11;
	          return (0, _effects.put)((0, _install.setTimeslots)({
	            timeSlots: []
	          }));
	
	        case 11:
	          _context6.next = 13;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 13:
	          errorPage = _context6.sent;
	          installEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.INSTALL].endpoints.loadInstall(true);
	          _context6.next = 17;
	          return (0, _effects.call)(_loader2.default.request, installEndpoint, { useGlobalSpinner: false, errorPage: errorPage });
	
	        case 17:
	          proInstall = _context6.sent;
	          _context6.next = 20;
	          return (0, _effects.put)((0, _install.setTimeslots)({
	            timeSlots: proInstall.professionalInstallation.timeSlots
	          }));
	
	        case 20:
	          _context6.next = 22;
	          return (0, _effects.select)(_install.timeSlotSelector);
	
	        case 22:
	          selectedTimeSlot = _context6.sent;
	
	          if (selectedTimeSlot) {
	            _context6.next = 26;
	            break;
	          }
	
	          _context6.next = 26;
	          return (0, _effects.put)((0, _install.setSelectedTimeSlot)(null));
	
	        case 26:
	          _context6.next = 28;
	          return (0, _effects.put)((0, _install.hideFetchingSpinner)());
	
	        case 28:
	          _context6.next = 32;
	          break;
	
	        case 30:
	          _context6.prev = 30;
	          _context6.t0 = _context6['catch'](0);
	
	        case 32:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this, [[0, 30]]);
	}
	
	function normalizeWorker(_ref) {
	  var key = _ref.key,
	      data = _ref.data,
	      meta = _ref.meta;
	  return regeneratorRuntime.wrap(function normalizeWorker$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          if (!(key !== 'moversInstall')) {
	            _context7.next = 2;
	            break;
	          }
	
	          return _context7.abrupt('return');
	
	        case 2:
	          _context7.next = 4;
	          return (0, _effects.put)((0, _install.setData)(_extends({}, meta, {
	            content: _extends({}, data)
	          })));
	
	        case 4:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}
	
	function confirmInstallWorker() {
	  var errorPage, selectedOption, selfAnswerId, proAnswerId, serviceReconnectDate, serviceStopDate, selectedTimeSlot, sikData, proData, data, sikEndpoint, proEndpoint, endpoint, receivedErrorResponse;
	  return regeneratorRuntime.wrap(function confirmInstallWorker$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 2:
	          errorPage = _context8.sent;
	          _context8.prev = 3;
	          _context8.next = 6;
	          return (0, _effects.select)(_install.selectedOptionSelector);
	
	        case 6:
	          selectedOption = _context8.sent;
	          _context8.next = 9;
	          return (0, _effects.select)(_install.selfInstallAnswerIdSelector);
	
	        case 9:
	          selfAnswerId = _context8.sent;
	          _context8.next = 12;
	          return (0, _effects.select)(_install.proInstallAnswerIdSelector);
	
	        case 12:
	          proAnswerId = _context8.sent;
	          _context8.next = 15;
	          return (0, _effects.select)(_install.selectedServiceReconnectDateSelector);
	
	        case 15:
	          serviceReconnectDate = _context8.sent;
	          _context8.next = 18;
	          return (0, _effects.select)(_install.serviceStopDateSelector);
	
	        case 18:
	          serviceStopDate = _context8.sent;
	          _context8.next = 21;
	          return (0, _effects.select)(_install.timeSlotSelector);
	
	        case 21:
	          selectedTimeSlot = _context8.sent;
	          sikData = {
	            answerId: selfAnswerId,
	            reConnectServiceDate: serviceReconnectDate,
	            disconnectServiceDate: serviceStopDate
	          };
	          proData = {
	            answerId: proAnswerId,
	            proInstall: selectedTimeSlot ? {
	              startDateTime: selectedTimeSlot.startDateTime,
	              endDateTime: selectedTimeSlot.endDateTime,
	              id: selectedTimeSlot.id
	            } : null,
	            disconnectServiceDate: serviceStopDate
	          };
	          data = selectedOption === _install.SIK_INSTALL_OPTION ? sikData : proData;
	          sikEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.INSTALL].endpoints.confirmSik();
	          proEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.INSTALL].endpoints.confirmPro();
	          endpoint = selectedOption === _install.SIK_INSTALL_OPTION ? sikEndpoint : proEndpoint;
	          _context8.next = 30;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: false }));
	
	        case 30:
	          _context8.next = 32;
	          return (0, _effects.call)(_loader2.default.request, endpoint, { data: data, useGlobalSpinner: false, errorPage: errorPage });
	
	        case 32:
	          _context8.next = 34;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 34:
	          _context8.next = 44;
	          break;
	
	        case 36:
	          _context8.prev = 36;
	          _context8.t0 = _context8['catch'](3);
	
	          if (!(_context8.t0.message === 'cancel(task): argument task is undefined')) {
	            _context8.next = 40;
	            break;
	          }
	
	          return _context8.abrupt('return');
	
	        case 40:
	          _context8.next = 42;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 42:
	          receivedErrorResponse = _context8.t0.data && _context8.t0.data.responseStatus === "Error";
	
	
	          if (!receivedErrorResponse) {
	            _reactRouter.browserHistory.push(errorPage);
	          }
	
	        case 44:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked[7], this, [[3, 36]]);
	}
	
	function moversInstallSagas() {
	  return regeneratorRuntime.wrap(function moversInstallSagas$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          _context9.next = 2;
	          return [(0, _effects.fork)(loadContentWatch), (0, _effects.fork)(normalizeWatch), (0, _effects.fork)(confirmInstallWatch)];
	
	        case 2:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked[8], this);
	}

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.installSelectors = exports.selectedServiceReconnectDateSelector = exports.initialServiceStopDateSelector = exports.serviceStopDateSelector = exports.serviceReconnectDateSelector = exports.moveDateRangeSelector = exports.moveEndDateSelector = exports.moveStartDateSelector = exports.moveToAddressSelector = exports.customerSelector = exports.proPriceSelector = exports.sikPriceSelector = exports.proServerSelectedSelector = exports.sikServerSelectedSelector = exports.noSelectionSelector = exports.proSelectedSelector = exports.sikSelectedSelector = exports.noSelectionErrorSelector = exports.selectedOptionSelector = exports.bothOptionsAvailableSelector = exports.initialOptionSelector = exports.onlyProAvailableSelector = exports.onlySikAvailableSelector = exports.proAvailableSelector = exports.sikAvailableSelector = exports.proInstallAnswerIdSelector = exports.selfInstallAnswerIdSelector = exports.equipmentSelector = exports.timeSlotSelector = exports.timeSlotsErrorMessageSelector = exports.timeSlotsHasErrorSelector = exports.selectedTimeSlotSelector = exports.serverSelectedTimeSlotSelector = exports.timeSlotsSelector = exports.timeSlotsFetchingSelector = exports.reduxFromState = exports.installSelector = undefined;
	
	var _reselect = __webpack_require__(38);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _install = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var installSelector = exports.installSelector = function installSelector(state) {
	  return state.moversInstall;
	};
	var reduxFromState = exports.reduxFromState = function reduxFromState(state) {
	  return state.form;
	};
	
	var timeSlotsFetchingSelector = exports.timeSlotsFetchingSelector = (0, _reselect.createSelector)(installSelector, function (install) {
	  return _lodash2.default.get(install, 'timeSlotsFetching', true);
	});
	
	var timeSlotsSelector = exports.timeSlotsSelector = (0, _reselect.createSelector)(installSelector, function (install) {
	  return _lodash2.default.get(install, 'content.professionalInstallation.timeSlots', []);
	});
	
	var serverSelectedTimeSlotSelector = exports.serverSelectedTimeSlotSelector = (0, _reselect.createSelector)(installSelector, function (install) {
	  return _lodash2.default.get(install, 'content.professionalInstallation.selectedTimeSlotId', '');
	});
	
	var selectedTimeSlotSelector = exports.selectedTimeSlotSelector = (0, _reselect.createSelector)(reduxFromState, function (form) {
	  return _lodash2.default.get(form, 'install.values.selectedTimeSlot', '');
	});
	
	var timeSlotsHasErrorSelector = exports.timeSlotsHasErrorSelector = (0, _reselect.createSelector)(reduxFromState, function (form) {
	  var hasError = _lodash2.default.has(form, 'install.syncErrors.selectedTimeSlot');
	  var isTouched = _lodash2.default.get(form, 'install.fields.selectedTimeSlot.touched', false);
	
	  return hasError && isTouched;
	});
	
	var timeSlotsErrorMessageSelector = exports.timeSlotsErrorMessageSelector = (0, _reselect.createSelector)(reduxFromState, function (form) {
	  return _lodash2.default.get(form, 'install.syncErrors.selectedTimeSlot', 'fallback');
	});
	
	var timeSlotSelector = exports.timeSlotSelector = (0, _reselect.createSelector)(timeSlotsSelector, selectedTimeSlotSelector, function (timeSlots, selectedTimeSlot) {
	  return _lodash2.default.find(timeSlots, function (obj) {
	    return obj.id === selectedTimeSlot;
	  });
	});
	
	var equipmentSelector = exports.equipmentSelector = (0, _reselect.createSelector)(installSelector, function (install) {
	  return _lodash2.default.get(install, 'content.selfInstallation.equipments', []);
	});
	
	var selfInstallAnswerIdSelector = exports.selfInstallAnswerIdSelector = (0, _reselect.createSelector)(installSelector, function (install) {
	  return _lodash2.default.get(install, 'content.selfInstallation.answerId', '');
	});
	
	var proInstallAnswerIdSelector = exports.proInstallAnswerIdSelector = (0, _reselect.createSelector)(installSelector, function (install) {
	  return _lodash2.default.get(install, 'content.professionalInstallation.answerId', '');
	});
	
	var sikAvailableSelector = exports.sikAvailableSelector = (0, _reselect.createSelector)(installSelector, function (install) {
	  return !_lodash2.default.isNil(_lodash2.default.get(install, 'content.selfInstallation'));
	});
	
	var proAvailableSelector = exports.proAvailableSelector = (0, _reselect.createSelector)(installSelector, function (install) {
	  return !_lodash2.default.isNil(_lodash2.default.get(install, 'content.professionalInstallation'));
	});
	
	var onlySikAvailableSelector = exports.onlySikAvailableSelector = (0, _reselect.createSelector)(sikAvailableSelector, proAvailableSelector, function (sikAvailable, proAvailable) {
	  return sikAvailable && !proAvailable;
	});
	
	var onlyProAvailableSelector = exports.onlyProAvailableSelector = (0, _reselect.createSelector)(sikAvailableSelector, proAvailableSelector, function (sikAvailable, proAvailable) {
	  return !sikAvailable && proAvailable;
	});
	
	var initialOptionSelector = exports.initialOptionSelector = (0, _reselect.createSelector)(onlySikAvailableSelector, onlyProAvailableSelector, function (onlySikAvailable, onlyProAvailable) {
	  return onlySikAvailable ? _install.SIK_INSTALL_OPTION : onlyProAvailable ? _install.PRO_INSTALL_OPTION : null;
	});
	
	var bothOptionsAvailableSelector = exports.bothOptionsAvailableSelector = (0, _reselect.createSelector)(sikAvailableSelector, proAvailableSelector, function (sikAvailable, proAvailable) {
	  return sikAvailable && proAvailable;
	});
	
	var selectedOptionSelector = exports.selectedOptionSelector = (0, _reselect.createSelector)(installSelector, function (install) {
	  return _lodash2.default.get(install, 'selectedOption', '');
	});
	
	var noSelectionErrorSelector = exports.noSelectionErrorSelector = (0, _reselect.createSelector)(reduxFromState, function (form) {
	  var currentValue = _lodash2.default.get(form, 'install.values.selectedOption', '');
	  var hasInvalidValidValue = currentValue !== _install.SIK_INSTALL_OPTION && currentValue !== _install.PRO_INSTALL_OPTION;
	  var isTouched = _lodash2.default.get(form, 'install.fields.selectedOption.touched', false);
	
	  return hasInvalidValidValue && isTouched;
	});
	
	var sikSelectedSelector = exports.sikSelectedSelector = (0, _reselect.createSelector)(selectedOptionSelector, function (selectedOption) {
	  return selectedOption === _install.SIK_INSTALL_OPTION;
	});
	
	var proSelectedSelector = exports.proSelectedSelector = (0, _reselect.createSelector)(selectedOptionSelector, function (selectedOption) {
	  return selectedOption === _install.PRO_INSTALL_OPTION;
	});
	
	var noSelectionSelector = exports.noSelectionSelector = (0, _reselect.createSelector)(sikSelectedSelector, proSelectedSelector, function (sik, pro) {
	  return !sik && !pro;
	});
	
	var sikServerSelectedSelector = exports.sikServerSelectedSelector = (0, _reselect.createSelector)(installSelector, function (install) {
	  return _lodash2.default.get(install, 'content.selfInstallation.isSelected', false);
	});
	
	var proServerSelectedSelector = exports.proServerSelectedSelector = (0, _reselect.createSelector)(installSelector, function (install) {
	  return _lodash2.default.get(install, 'content.professionalInstallation.isSelected', false);
	});
	
	var sikPriceSelector = exports.sikPriceSelector = (0, _reselect.createSelector)(installSelector, function (install) {
	  return _lodash2.default.get(install, 'content.selfInstallation.price', 0);
	});
	
	var proPriceSelector = exports.proPriceSelector = (0, _reselect.createSelector)(installSelector, function (install) {
	  return _lodash2.default.get(install, 'content.professionalInstallation.price', 0);
	});
	
	var customerSelector = exports.customerSelector = (0, _reselect.createSelector)(installSelector, function (install) {
	  return _lodash2.default.get(install, 'content.customer', {});
	});
	
	var moveToAddressSelector = exports.moveToAddressSelector = (0, _reselect.createSelector)(customerSelector, function (customer) {
	  return _lodash2.default.get(customer, 'moveToAddress', {});
	});
	
	var moveStartDateSelector = exports.moveStartDateSelector = (0, _reselect.createSelector)(customerSelector, function (customer) {
	  return _lodash2.default.get(customer, 'moveStartDate', null);
	});
	
	var moveEndDateSelector = exports.moveEndDateSelector = (0, _reselect.createSelector)(customerSelector, function (customer) {
	  return _lodash2.default.get(customer, 'moveEndDate', null);
	});
	
	var moveDateRangeSelector = exports.moveDateRangeSelector = (0, _reselect.createSelector)(moveStartDateSelector, moveEndDateSelector, function (moveStartDate, moveEndDate) {
	  return {
	    min: moveStartDate,
	    max: moveEndDate
	  };
	});
	
	var serviceReconnectDateSelector = exports.serviceReconnectDateSelector = (0, _reselect.createSelector)(customerSelector, function (customer) {
	  return _lodash2.default.get(customer, 'serviceReconnectDate', '');
	});
	
	var serviceStopDateSelector = exports.serviceStopDateSelector = (0, _reselect.createSelector)(customerSelector, function (customer) {
	  return _lodash2.default.get(customer, 'serviceStopDate', '');
	});
	
	var initialServiceStopDateSelector = exports.initialServiceStopDateSelector = (0, _reselect.createSelector)(serviceStopDateSelector, function (serviceStopDate) {
	  var selectedDate = (0, _moment2.default)(serviceStopDate).format('YYYY-MM-DD');
	  var initialDate = selectedDate === 'Invalid date' ? '' : selectedDate;
	
	  return initialDate;
	});
	
	var selectedServiceReconnectDateSelector = exports.selectedServiceReconnectDateSelector = (0, _reselect.createSelector)(reduxFromState, function (form) {
	  return _lodash2.default.get(form, 'install.values.serviceReconnectDate', '');
	});
	
	// Index of the selectors made available to InstallPage
	// since imports and proptype checks were getting hard to manage
	var installSelectors = exports.installSelectors = {
	  bothOptionsAvailableSelector: bothOptionsAvailableSelector,
	  equipmentSelector: equipmentSelector,
	  initialOptionSelector: initialOptionSelector,
	  initialServiceStopDateSelector: initialServiceStopDateSelector,
	  moveDateRangeSelector: moveDateRangeSelector,
	  moveEndDateSelector: moveEndDateSelector,
	  moveStartDateSelector: moveStartDateSelector,
	  moveToAddressSelector: moveToAddressSelector,
	  noSelectionSelector: noSelectionSelector,
	  proAvailableSelector: proAvailableSelector,
	  onlyProAvailableSelector: onlyProAvailableSelector,
	  onlySikAvailableSelector: onlySikAvailableSelector,
	  proPriceSelector: proPriceSelector,
	  proSelectedSelector: proSelectedSelector,
	  selectedTimeSlotSelector: selectedTimeSlotSelector,
	  noSelectionErrorSelector: noSelectionErrorSelector,
	  serviceStopDateSelector: serviceStopDateSelector,
	  serviceReconnectDateSelector: serviceReconnectDateSelector,
	  sikAvailableSelector: sikAvailableSelector,
	  sikPriceSelector: sikPriceSelector,
	  sikSelectedSelector: sikSelectedSelector,
	  timeSlotsFetchingSelector: timeSlotsFetchingSelector,
	  timeSlotsHasErrorSelector: timeSlotsHasErrorSelector,
	  timeSlotsErrorMessageSelector: timeSlotsErrorMessageSelector,
	  timeSlotsSelector: timeSlotsSelector,
	  timeSlotSelector: timeSlotSelector,
	  serverSelectedTimeSlotSelector: serverSelectedTimeSlotSelector
	};

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fields = exports.validation = undefined;
	
	var _validation = __webpack_require__(144);
	
	var validation = exports.validation = (0, _validation.createValidator)({
	  'phoneNumber': (0, _validation.match)(_validation.phoneRegex, 'Please enter a valid phone number'),
	  'streetAddress': (0, _validation.match)(_validation.streetAddressRegex, 'Please enter a valid street address'),
	  'unitNumber': (0, _validation.match)(_validation.unitNumberRegex, 'Please enter a valid unit number'),
	  'zipCode': (0, _validation.match)(_validation.zipCodeRegex, 'Please enter a valid zip code'),
	  'serviceStopDate': [(0, _validation.required)('Please enter a valid date'), (0, _validation.validDate)('Please enter a valid date'), (0, _validation.validateDateRange)('The disconnect date')]
	});
	
	var fields = exports.fields = ['serviceStopDate', 'phoneNumber', 'streetAddress', 'unitNumber', 'zipCode'];

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadCustomerWatch = loadCustomerWatch;
	exports.moveCustomergWatch = moveCustomergWatch;
	exports.localizeSuggestionsWatch = localizeSuggestionsWatch;
	exports.selectSuggestionsWatch = selectSuggestionsWatch;
	exports.loadCustomerWorker = loadCustomerWorker;
	exports.moveCustomergWorker = moveCustomergWorker;
	exports.localizeSuggestionsWorker = localizeSuggestionsWorker;
	exports.selectSuggestionWorker = selectSuggestionWorker;
	exports.default = moversLocalizationSagas;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _effects = __webpack_require__(10);
	
	var _reactRouter = __webpack_require__(16);
	
	var _reduxForm = __webpack_require__(44);
	
	var _normalization = __webpack_require__(199);
	
	var _helpers = __webpack_require__(77);
	
	var _localization = __webpack_require__(194);
	
	var _customer = __webpack_require__(76);
	
	var _loader = __webpack_require__(27);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _dataProvider = __webpack_require__(19);
	
	var _dataProvider2 = _interopRequireDefault(_dataProvider);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _common = __webpack_require__(7);
	
	var _suggestions = __webpack_require__(317);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadCustomerWatch, moveCustomergWatch, localizeSuggestionsWatch, selectSuggestionsWatch, loadCustomerWorker, moveCustomergWorker, localizeSuggestionsWorker, selectSuggestionWorker, moversLocalizationSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadCustomerWatch() {
	  return regeneratorRuntime.wrap(function loadCustomerWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_localization.LOAD_CUSTOMER, loadCustomerWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	function moveCustomergWatch() {
	  return regeneratorRuntime.wrap(function moveCustomergWatch$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_localization.MOVE_CUSTOMER, moveCustomergWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	function localizeSuggestionsWatch() {
	  return regeneratorRuntime.wrap(function localizeSuggestionsWatch$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_localization.GET_SUGGESTIONS, localizeSuggestionsWorker);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	function selectSuggestionsWatch() {
	  return regeneratorRuntime.wrap(function selectSuggestionsWatch$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeLatest)(_localization.SELECT_SUGGESTION, selectSuggestionWorker);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	// WORKERS
	function loadCustomerWorker() {
	  var errorPage, success;
	  return regeneratorRuntime.wrap(function loadCustomerWorker$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.prev = 0;
	          _context5.next = 3;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: true, initiator: 'localize load' }));
	
	        case 3:
	          _context5.next = 5;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 5:
	          errorPage = _context5.sent;
	          _context5.next = 8;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'auth' }, { state: 'customer', alwaysCall: true }, { state: 'context' }], { errorPage: errorPage });
	
	        case 8:
	          success = _context5.sent;
	
	          if (success) {
	            _context5.next = 11;
	            break;
	          }
	
	          return _context5.abrupt('return');
	
	        case 11:
	          _context5.next = 13;
	          return (0, _effects.put)({
	            type: _localization.DL_PAGE_LOADED
	          });
	
	        case 13:
	          _context5.next = 15;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 15:
	          _context5.next = 22;
	          break;
	
	        case 17:
	          _context5.prev = 17;
	          _context5.t0 = _context5['catch'](0);
	          _context5.next = 21;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 21:
	          _reactRouter.browserHistory.push(_navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.ERROR].path);
	
	        case 22:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this, [[0, 17]]);
	}
	
	function moveCustomergWorker() {
	  var state, errorPage, customer, authEndpoint, moveCustomerEndpoint, values, data, currentMoveTo, postLoad;
	  return regeneratorRuntime.wrap(function moveCustomergWorker$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.select)();
	
	        case 2:
	          state = _context7.sent;
	          _context7.next = 5;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 5:
	          errorPage = _context7.sent;
	          _context7.next = 8;
	          return (0, _effects.select)(_customer.customerSelector);
	
	        case 8:
	          customer = _context7.sent;
	          authEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.MYPLAN].endpoints.validateAuth();
	          moveCustomerEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.LOCALIZATION].endpoints.moveCustomer();
	          values = (0, _reduxForm.getFormValues)('movers')(state); // state.form.movers.fields;
	
	          data = {
	            "address": {
	              "streetAddress": values.streetAddress,
	              "unitNumber": values.unitNumber,
	              "zipCode": values.zipCode
	            },
	            "serviceStopDate": values.serviceStopDate, // "2016-11-17"
	            "telephoneNumber": (0, _normalization.removeNonDigits)(values.phoneNumber)
	          };
	          _context7.next = 15;
	          return (0, _effects.select)(_customer.moveToAddressSelector);
	
	        case 15:
	          currentMoveTo = _context7.sent;
	          _context7.prev = 16;
	          postLoad = regeneratorRuntime.mark(function postLoad() {
	            var customerWithUpdates;
	            return regeneratorRuntime.wrap(function postLoad$(_context6) {
	              while (1) {
	                switch (_context6.prev = _context6.next) {
	                  case 0:
	                    customerWithUpdates = !_lodash2.default.isEqual(data.address, currentMoveTo) ? {
	                      customer: _extends({}, customer, {
	                        serviceStopDate: _lodash2.default.get(data, 'serviceStopDate'),
	                        moveToAddress: {
	                          streetAddress: _lodash2.default.get(data, 'address.streetAddress'),
	                          unitNumber: _lodash2.default.get(data, 'address.unitNumber'),
	                          zipCode: _lodash2.default.get(data, 'address.zipCode')
	                        }
	                      })
	                    } : {
	                      customer: _extends({}, customer, {
	                        serviceStopDate: _lodash2.default.get(data, 'serviceStopDate')
	                      })
	                    };
	                    _context6.next = 3;
	                    return (0, _effects.put)({
	                      type: _customer.SET_DATA,
	                      payload: customerWithUpdates
	                    });
	
	                  case 3:
	                  case 'end':
	                    return _context6.stop();
	                }
	              }
	            }, postLoad, this);
	          });
	          _context7.next = 20;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: false, initiator: 'calling moveCustomer' }));
	
	        case 20:
	          _context7.next = 22;
	          return (0, _effects.call)(_loader2.default.request, authEndpoint, { useGlobalSpinner: false, errorPage: errorPage });
	
	        case 22:
	          _context7.next = 24;
	          return (0, _effects.call)(_loader2.default.request, moveCustomerEndpoint, { data: data, useGlobalSpinner: false, postLoad: postLoad, postLoadOnError: false, errorPage: errorPage });
	
	        case 24:
	          _context7.next = 26;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 26:
	          _context7.next = 30;
	          break;
	
	        case 28:
	          _context7.prev = 28;
	          _context7.t0 = _context7['catch'](16);
	
	        case 30:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[5], this, [[16, 28]]);
	}
	
	function localizeSuggestionsWorker(action) {
	  var errorPage, localizeSuggestionsEndpoint, localizeSuggestions, cleanPropsFromResponse;
	  return regeneratorRuntime.wrap(function localizeSuggestionsWorker$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 2:
	          errorPage = _context8.sent;
	          localizeSuggestionsEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.LOCALIZATION].endpoints.getSuggestions(action.payload.search);
	          _context8.prev = 4;
	          _context8.next = 7;
	          return (0, _effects.call)(_loader2.default.request, localizeSuggestionsEndpoint, { useGlobalSpinner: false, errorPage: errorPage });
	
	        case 7:
	          localizeSuggestions = _context8.sent;
	          cleanPropsFromResponse = (0, _helpers.cleanJsonInResponse)(localizeSuggestions.data); //Learn team uses capitals in thier props
	
	          _context8.next = 11;
	          return (0, _effects.put)((0, _suggestions.setSuggestions)('localizeSuggestions', cleanPropsFromResponse));
	
	        case 11:
	          _context8.next = 15;
	          break;
	
	        case 13:
	          _context8.prev = 13;
	          _context8.t0 = _context8['catch'](4);
	
	        case 15:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked[6], this, [[4, 13]]);
	}
	
	function selectSuggestionWorker(action) {
	  var address, streetAddress, unitNumber, zipCode;
	  return regeneratorRuntime.wrap(function selectSuggestionWorker$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          address = action.payload.suggestion.address, streetAddress = address.address_StreetAddress || '', unitNumber = address.address_UnitNumber || '', zipCode = address.address_ZipCode || '';
	          _context9.next = 3;
	          return (0, _effects.put)((0, _reduxForm.change)('movers', 'streetAddress', streetAddress));
	
	        case 3:
	          _context9.next = 5;
	          return (0, _effects.put)((0, _reduxForm.change)('movers', 'unitNumber', unitNumber));
	
	        case 5:
	          _context9.next = 7;
	          return (0, _effects.put)((0, _reduxForm.change)('movers', 'zipCode', zipCode));
	
	        case 7:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked[7], this);
	}
	
	function moversLocalizationSagas() {
	  return regeneratorRuntime.wrap(function moversLocalizationSagas$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          _context10.next = 2;
	          return [(0, _effects.fork)(loadCustomerWatch), (0, _effects.fork)(moveCustomergWatch), (0, _effects.fork)(localizeSuggestionsWatch), (0, _effects.fork)(selectSuggestionsWatch)];
	
	        case 2:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked[8], this);
	}

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadCustomerWatch = loadCustomerWatch;
	exports.normalizeWatch = normalizeWatch;
	exports.submitOrderWatch = submitOrderWatch;
	exports.loadCustomerWorker = loadCustomerWorker;
	exports.normalizeWorker = normalizeWorker;
	exports.submitOrderWorker = submitOrderWorker;
	exports.default = moversCancelSagas;
	
	var _effects = __webpack_require__(10);
	
	var _reactRouter = __webpack_require__(16);
	
	var _review = __webpack_require__(195);
	
	var _loader = __webpack_require__(27);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _dataProvider = __webpack_require__(19);
	
	var _dataProvider2 = _interopRequireDefault(_dataProvider);
	
	var _dataProvider3 = __webpack_require__(26);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadCustomerWatch, normalizeWatch, submitOrderWatch, loadCustomerWorker, normalizeWorker, submitOrderWorker, moversCancelSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadCustomerWatch() {
	  return regeneratorRuntime.wrap(function loadCustomerWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_review.LOAD_CONTENT, loadCustomerWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function normalizeWatch() {
	  return regeneratorRuntime.wrap(function normalizeWatch$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_dataProvider3.NORMALIZE_DATA, normalizeWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function submitOrderWatch() {
	  return regeneratorRuntime.wrap(function submitOrderWatch$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_review.SUBMIT_ORDER, submitOrderWorker);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	// WORKERS
	function loadCustomerWorker() {
	  var errorPage, success;
	  return regeneratorRuntime.wrap(function loadCustomerWorker$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.prev = 0;
	          _context4.next = 3;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: true }));
	
	        case 3:
	          _context4.next = 5;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 5:
	          errorPage = _context4.sent;
	          _context4.next = 8;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'auth' }, { state: 'customer' }, { state: 'context' }, { state: 'moversReview' }], { errorPage: errorPage });
	
	        case 8:
	          success = _context4.sent;
	
	          if (success) {
	            _context4.next = 11;
	            break;
	          }
	
	          return _context4.abrupt('return');
	
	        case 11:
	          _context4.next = 13;
	          return (0, _effects.put)({
	            type: _review.DL_PAGE_LOADED
	          });
	
	        case 13:
	          _context4.next = 15;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 15:
	          _context4.next = 22;
	          break;
	
	        case 17:
	          _context4.prev = 17;
	          _context4.t0 = _context4['catch'](0);
	          _context4.next = 21;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 21:
	          _reactRouter.browserHistory.push(_navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.ERROR].path);
	
	        case 22:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this, [[0, 17]]);
	}
	
	function normalizeWorker(_ref) {
	  var key = _ref.key,
	      data = _ref.data,
	      meta = _ref.meta;
	  return regeneratorRuntime.wrap(function normalizeWorker$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          if (!(key !== 'moversReview')) {
	            _context5.next = 2;
	            break;
	          }
	
	          return _context5.abrupt('return');
	
	        case 2:
	          _context5.next = 4;
	          return (0, _effects.put)({
	            type: _review.SET_DATA,
	            payload: _extends({}, meta, {
	              content: data
	            })
	          });
	
	        case 4:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}
	
	function submitOrderWorker() {
	  var errorPage, data, endpoint, success;
	  return regeneratorRuntime.wrap(function submitOrderWorker$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.prev = 0;
	          _context6.next = 3;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 3:
	          errorPage = _context6.sent;
	          data = {
	            isVerified: true,
	            orderType: 'Disconnect'
	          };
	          endpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.REVIEW].endpoints.submitOrder();
	          _context6.next = 8;
	          return (0, _effects.call)(_loader2.default.request, endpoint, { data: data, hideContentWhileLoading: false, errorPage: errorPage });
	
	        case 8:
	          success = _context6.sent;
	
	          if (success) {
	            _context6.next = 11;
	            break;
	          }
	
	          return _context6.abrupt('return');
	
	        case 11:
	          _context6.next = 15;
	          break;
	
	        case 13:
	          _context6.prev = 13;
	          _context6.t0 = _context6['catch'](0);
	
	        case 15:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this, [[0, 13]]);
	}
	
	function moversCancelSagas() {
	  return regeneratorRuntime.wrap(function moversCancelSagas$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return [(0, _effects.fork)(loadCustomerWatch), (0, _effects.fork)(normalizeWatch), (0, _effects.fork)(submitOrderWatch)];
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fields = exports.validation = undefined;
	
	var _validation = __webpack_require__(144);
	
	var validation = exports.validation = (0, _validation.createValidator)({
	  'phoneNumber': (0, _validation.match)(_validation.phoneRegex, 'Please enter a valid phone number')
	});
	
	var fields = exports.fields = ['phoneNumber'];

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadCustomerWatch = loadCustomerWatch;
	exports.submitOrderWatch = submitOrderWatch;
	exports.loadCustomerWorker = loadCustomerWorker;
	exports.submitOrderWorker = submitOrderWorker;
	exports.default = moversSpecialistSagas;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _effects = __webpack_require__(10);
	
	var _reactRouter = __webpack_require__(16);
	
	var _reduxForm = __webpack_require__(44);
	
	var _loader = __webpack_require__(27);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _dataProvider = __webpack_require__(19);
	
	var _dataProvider2 = _interopRequireDefault(_dataProvider);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _normalization = __webpack_require__(199);
	
	var _customer = __webpack_require__(76);
	
	var _specialist = __webpack_require__(309);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadCustomerWatch, submitOrderWatch, loadCustomerWorker, submitOrderWorker, moversSpecialistSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadCustomerWatch() {
	  return regeneratorRuntime.wrap(function loadCustomerWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_specialist.LOAD_CONTENT, loadCustomerWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function submitOrderWatch() {
	  return regeneratorRuntime.wrap(function submitOrderWatch$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_specialist.SUBMIT_ORDER, submitOrderWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	// WORKERS
	function loadCustomerWorker() {
	  var errorPage, success;
	  return regeneratorRuntime.wrap(function loadCustomerWorker$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.prev = 0;
	          _context3.next = 3;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: true }));
	
	        case 3:
	          _context3.next = 5;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 5:
	          errorPage = _context3.sent;
	          _context3.next = 8;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'auth' }, { state: 'customer' }, { state: 'context' }], { errorPage: errorPage });
	
	        case 8:
	          success = _context3.sent;
	
	          if (success) {
	            _context3.next = 11;
	            break;
	          }
	
	          return _context3.abrupt('return');
	
	        case 11:
	          _context3.next = 13;
	          return (0, _effects.put)({
	            type: _specialist.DL_PAGE_LOADED
	          });
	
	        case 13:
	          _context3.next = 15;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 15:
	          _context3.next = 22;
	          break;
	
	        case 17:
	          _context3.prev = 17;
	          _context3.t0 = _context3['catch'](0);
	          _context3.next = 21;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 21:
	          _reactRouter.browserHistory.push(_navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.ERROR].path);
	
	        case 22:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this, [[0, 17]]);
	}
	
	function submitOrderWorker() {
	  var errorPage, values, customer, data, postLoad, endpoint, receivedErrorResponse;
	  return regeneratorRuntime.wrap(function submitOrderWorker$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 2:
	          errorPage = _context5.sent;
	          _context5.prev = 3;
	          _context5.next = 6;
	          return (0, _effects.select)((0, _reduxForm.getFormValues)('specialist'));
	
	        case 6:
	          values = _context5.sent;
	          _context5.next = 9;
	          return (0, _effects.select)(_customer.customerSelector);
	
	        case 9:
	          customer = _context5.sent;
	          data = {
	            acceptedContractIds: null,
	            isVerified: true,
	            preferredTelephoneNumber: (0, _normalization.removeNonDigits)(values.phoneNumber),
	            orderType: "MoveTransfer"
	          };
	          postLoad = regeneratorRuntime.mark(function postLoad() {
	            var customerWithUpdates;
	            return regeneratorRuntime.wrap(function postLoad$(_context4) {
	              while (1) {
	                switch (_context4.prev = _context4.next) {
	                  case 0:
	                    customerWithUpdates = {
	                      customer: _extends({}, customer, {
	                        phoneNumber: _lodash2.default.get(data, 'phoneNumber')
	                      })
	                    };
	                    _context4.next = 3;
	                    return (0, _effects.put)({
	                      type: _customer.SET_DATA,
	                      payload: customerWithUpdates
	                    });
	
	                  case 3:
	                  case 'end':
	                    return _context4.stop();
	                }
	              }
	            }, postLoad, this);
	          });
	          endpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.SPECIALIST].endpoints.submitOrder();
	          _context5.next = 15;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: false }));
	
	        case 15:
	          _context5.next = 17;
	          return (0, _effects.call)(_loader2.default.request, endpoint, { data: data, useGlobalSpinner: false, postLoad: postLoad, postLoadOnError: false, errorPage: errorPage });
	
	        case 17:
	          _context5.next = 19;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 19:
	          _context5.next = 29;
	          break;
	
	        case 21:
	          _context5.prev = 21;
	          _context5.t0 = _context5['catch'](3);
	
	          if (!(_context5.t0.message === 'cancel(task): argument task is undefined')) {
	            _context5.next = 25;
	            break;
	          }
	
	          return _context5.abrupt('return');
	
	        case 25:
	          _context5.next = 27;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 27:
	          receivedErrorResponse = _context5.t0.data && _context5.t0.data.responseStatus === "Error";
	
	
	          if (!receivedErrorResponse) {
	            _reactRouter.browserHistory.push(errorPage);
	          }
	
	        case 29:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[3], this, [[3, 21]]);
	}
	
	function moversSpecialistSagas() {
	  return regeneratorRuntime.wrap(function moversSpecialistSagas$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return [(0, _effects.fork)(loadCustomerWatch), (0, _effects.fork)(submitOrderWatch)];
	
	        case 2:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadCustomerWatch = loadCustomerWatch;
	exports.loadCustomerWorker = loadCustomerWorker;
	exports.jqueryGenerator = jqueryGenerator;
	exports.default = moversUnserviceableSagas;
	
	var _jquery = __webpack_require__(131);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxSaga = __webpack_require__(99);
	
	var _effects = __webpack_require__(10);
	
	var _reactRouter = __webpack_require__(16);
	
	var _unserviceable = __webpack_require__(310);
	
	var _dataProvider = __webpack_require__(19);
	
	var _dataProvider2 = _interopRequireDefault(_dataProvider);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _common = __webpack_require__(7);
	
	var _customer = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadCustomerWatch, loadCustomerWorker, moversUnserviceableSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadCustomerWatch() {
	  return regeneratorRuntime.wrap(function loadCustomerWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_unserviceable.LOAD_CUSTOMER, loadCustomerWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	// WORKERS
	function loadCustomerWorker() {
	  var errorPage, success, customer, encodedAddressSearch, bingAddressEndpoint, bingAddress, customerWithCompleteMoveToAddress;
	  return regeneratorRuntime.wrap(function loadCustomerWorker$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.prev = 0;
	          _context3.next = 3;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: true, initiator: 'localize load' }));
	
	        case 3:
	          _context3.next = 5;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 5:
	          errorPage = _context3.sent;
	          _context3.next = 8;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'auth' }, { state: 'customer' }, { state: 'context' }], { errorPage: errorPage });
	
	        case 8:
	          success = _context3.sent;
	
	          if (success) {
	            _context3.next = 11;
	            break;
	          }
	
	          return _context3.abrupt('return');
	
	        case 11:
	          _context3.next = 13;
	          return (0, _reduxSaga.delay)(0);
	
	        case 13:
	          _context3.next = 15;
	          return (0, _effects.select)(_customer.customerSelector);
	
	        case 15:
	          customer = _context3.sent;
	
	          if (_lodash2.default.get(customer, 'moveToAddress.city')) {
	            _context3.next = 26;
	            break;
	          }
	
	          encodedAddressSearch = encodeURI(customer.moveToAddress.streetAddress + ' ' + customer.moveToAddress.zipCode);
	          bingAddressEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.UNSERVICEABLE].endpoints.getBingData(encodedAddressSearch);
	          _context3.next = 21;
	          return jqueryGenerator(regeneratorRuntime.mark(function _callee() {
	            return regeneratorRuntime.wrap(function _callee$(_context2) {
	              while (1) {
	                switch (_context2.prev = _context2.next) {
	                  case 0:
	                    _context2.prev = 0;
	                    _context2.next = 3;
	                    return _jquery2.default.ajax({
	                      url: bingAddressEndpoint.url,
	                      dataType: "jsonp",
	                      jsonp: "jsonp"
	                    });
	
	                  case 3:
	                    return _context2.abrupt('return', _context2.sent);
	
	                  case 6:
	                    _context2.prev = 6;
	                    _context2.t0 = _context2['catch'](0);
	                    return _context2.abrupt('return');
	
	                  case 9:
	                  case 'end':
	                    return _context2.stop();
	                }
	              }
	            }, _callee, this, [[0, 6]]);
	          }));
	
	        case 21:
	          bingAddress = _context3.sent;
	
	          if (!(bingAddress && _lodash2.default.get(bingAddress, 'resourceSets[0].resources[0].address.locality'))) {
	            _context3.next = 26;
	            break;
	          }
	
	          customerWithCompleteMoveToAddress = {
	            customer: _extends({}, customer, {
	              moveToAddress: _extends({}, customer.moveToAddress, {
	                city: _lodash2.default.get(bingAddress, 'resourceSets[0].resources[0].address.locality'),
	                state: _lodash2.default.get(bingAddress, 'resourceSets[0].resources[0].address.adminDistrict')
	              })
	            })
	          };
	          _context3.next = 26;
	          return (0, _effects.put)({
	            type: _customer.SET_DATA,
	            payload: customerWithCompleteMoveToAddress
	          });
	
	        case 26:
	          _context3.next = 28;
	          return (0, _effects.put)({
	            type: _unserviceable.DL_PAGE_LOADED
	          });
	
	        case 28:
	          _context3.next = 30;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 30:
	          _context3.next = 37;
	          break;
	
	        case 32:
	          _context3.prev = 32;
	          _context3.t0 = _context3['catch'](0);
	          _context3.next = 36;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 36:
	          //console.log(e, 'error');
	          _reactRouter.browserHistory.push(_navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.movers.ERROR].path);
	
	        case 37:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 32]]);
	}
	
	function jqueryGenerator(genertorFactory) {
	  var generator = genertorFactory.apply(this, arguments);
	  var handleResult = function handleResult(result) {
	    if (result.done) return result.value;
	    return result.value.then(function (nextResult) {
	      return handleResult(generator.next(nextResult));
	    }, function (error) {
	      generator.throw(error);
	    });
	  };
	
	  return handleResult(generator.next());
	}
	
	function moversUnserviceableSagas() {
	  return regeneratorRuntime.wrap(function moversUnserviceableSagas$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return [(0, _effects.fork)(loadCustomerWatch)];
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 646 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'hg/addon/LOAD_CONTENT';
	
	var loadContent = exports.loadContent = function loadContent(addOnType) {
	  return {
	    type: LOAD_CONTENT,
	    addOnType: addOnType
	  };
	};

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadContentWatch = loadContentWatch;
	exports.loadContentWorker = loadContentWorker;
	exports.default = addOnSagas;
	
	var _effects = __webpack_require__(10);
	
	var _loader = __webpack_require__(27);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _dataProvider = __webpack_require__(19);
	
	var _dataProvider2 = _interopRequireDefault(_dataProvider);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _addOn = __webpack_require__(646);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadContentWatch, loadContentWorker, addOnSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadContentWatch() {
	  return regeneratorRuntime.wrap(function loadContentWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_addOn.LOAD_CONTENT, loadContentWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	// WORKERS
	function loadContentWorker(action) {
	  var addDefaultOfferEndpoint, errorPage, success, data;
	  return regeneratorRuntime.wrap(function loadContentWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          _context2.next = 3;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)());
	
	        case 3:
	          addDefaultOfferEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.OFFERS].endpoints.addDefaultOfferToCart();
	          _context2.next = 6;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 6:
	          errorPage = _context2.sent;
	          _context2.next = 9;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'auth' }, { state: 'customer' }, { state: 'context' }, { state: 'plan' }, { state: 'checkEligibility', param: action.addOnType }, { state: 'offers', param: '' }], { errorPage: errorPage });
	
	        case 9:
	          success = _context2.sent;
	
	          if (success) {
	            _context2.next = 12;
	            break;
	          }
	
	          return _context2.abrupt('return');
	
	        case 12:
	          data = {
	            buyflowConsumerType: action.addOnType
	          };
	          _context2.next = 15;
	          return (0, _effects.call)(_loader2.default.request, addDefaultOfferEndpoint, { data: data, useGlobalSpinner: false });
	
	        case 15:
	          window.location.replace(_navigationHelpers.buyFlowUrls.CUSTOMIZE);
	
	          _context2.next = 20;
	          break;
	
	        case 18:
	          _context2.prev = 18;
	          _context2.t0 = _context2['catch'](0);
	
	        case 20:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 18]]);
	}
	
	function addOnSagas() {
	  return regeneratorRuntime.wrap(function addOnSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(loadContentWatch)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 648 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'mp/cancel/LOAD_CONTENT';
	
	var loadContent = exports.loadContent = function loadContent() {
	  return {
	    type: LOAD_CONTENT
	  };
	};

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadContentWatch = loadContentWatch;
	exports.loadContentWorker = loadContentWorker;
	exports.default = cancelSagas;
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(16);
	
	var _effects = __webpack_require__(10);
	
	var _loader = __webpack_require__(27);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _dataProvider = __webpack_require__(19);
	
	var _dataProvider2 = _interopRequireDefault(_dataProvider);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _cancel = __webpack_require__(648);
	
	var _review = __webpack_require__(196);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadContentWatch, loadContentWorker, cancelSagas].map(regeneratorRuntime.mark);
	//import { delay } from 'redux-saga';
	
	
	/*import {
	  productNameSelector,
	  setQuickCheckoutData
	 } from '../../../data/quickCheckout/quickCheckout';*/
	//import {NORMALIZE_DATA} from '../../../dataProvider/dataProvider';
	
	
	/*import {
	  shoppingElementIdSelector,
	  priceReferenceIdSelector,
	  setData,
	  setProductId
	} from '../../../data/checkout/checkout';*/
	
	// WATCHERS
	function loadContentWatch() {
	  return regeneratorRuntime.wrap(function loadContentWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_cancel.LOAD_CONTENT, loadContentWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	/*export function* normalizeWatch() {
	  yield takeLatest(NORMALIZE_DATA, normalizeWorker);
	}*/
	
	// WORKERS
	function loadContentWorker() {
	  var buyflowConsumerType, errorPage, defaultOfferData, addDefaultOfferEndpoint, confirmCartEndPoint, myPlanReviewEndpoint, success, reviewData;
	  return regeneratorRuntime.wrap(function loadContentWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          buyflowConsumerType = 'CancelStreamingVideo';
	          _context2.next = 4;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 4:
	          errorPage = _context2.sent;
	          defaultOfferData = { buyflowConsumerType: buyflowConsumerType };
	          addDefaultOfferEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.OFFERS].endpoints.addDefaultOfferToCart();
	          confirmCartEndPoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.CANCEL].endpoints.confirmCart();
	          myPlanReviewEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.REVIEW].endpoints.reviewCart();
	          _context2.next = 11;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'auth' }, { state: 'customer' }, { state: 'checkEligibility', param: buyflowConsumerType }, { state: 'offers', param: '' }], { errorPage: errorPage });
	
	        case 11:
	          success = _context2.sent;
	
	          if (success) {
	            _context2.next = 14;
	            break;
	          }
	
	          return _context2.abrupt('return');
	
	        case 14:
	          _context2.next = 16;
	          return (0, _effects.call)(_loader2.default.request, addDefaultOfferEndpoint, { data: defaultOfferData, useGlobalSpinner: false });
	
	        case 16:
	          _context2.next = 18;
	          return (0, _effects.call)(_loader2.default.request, confirmCartEndPoint, { data: defaultOfferData, useGlobalSpinner: false });
	
	        case 18:
	          _context2.next = 20;
	          return (0, _effects.call)(_loader2.default.request, myPlanReviewEndpoint, { data: defaultOfferData, useGlobalSpinner: false });
	
	        case 20:
	          reviewData = _context2.sent;
	          _context2.next = 23;
	          return (0, _effects.put)({
	            type: _review.SET_DATA,
	            payload: {
	              loaded: true,
	              persistExpiresAt: (0, _moment2.default)().add(20, 'minute').toDate(),
	              content: {
	                review: _extends({}, reviewData.review, {
	                  flowType: reviewData.flowType
	                }),
	                consentCart: reviewData.consentCart
	              }
	            }
	          });
	
	        case 23:
	
	          _reactRouter.browserHistory.replace('' + _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.REVIEW].path);
	          _context2.next = 28;
	          break;
	
	        case 26:
	          _context2.prev = 26;
	          _context2.t0 = _context2['catch'](0);
	
	        case 28:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 26]]);
	}
	
	/*export function* normalizeWorker({key, data, meta}) {
	  if (key !== 'productMapping' && key !== 'productForQuickcheckout' && key !== 'customerLobAndProduct') {
	    return;
	  }
	
	  if (key === 'productMapping') {
	    yield put(setData({
	      ...meta,
	      content: data
	    }));
	    yield put(setQuickCheckoutData({
	      productId: data.shoppingElementId,
	      productName: data.productName
	    }));
	  } else {
	    yield put(setProductId(data.priceReferenceId));
	  }
	}*/
	
	function cancelSagas() {
	  return regeneratorRuntime.wrap(function cancelSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(loadContentWatch)
	          //fork(normalizeWatch)
	          ];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadContentWatch = loadContentWatch;
	exports.normalizeWatch = normalizeWatch;
	exports.loadContentWorker = loadContentWorker;
	exports.normalizeWorker = normalizeWorker;
	exports.default = confirmationSagas;
	
	var _effects = __webpack_require__(10);
	
	var _reactRouter = __webpack_require__(16);
	
	var _dataProvider = __webpack_require__(26);
	
	var _dataProvider2 = __webpack_require__(19);
	
	var _dataProvider3 = _interopRequireDefault(_dataProvider2);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _confirmation = __webpack_require__(311);
	
	var _confirmation2 = __webpack_require__(188);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadContentWatch, normalizeWatch, loadContentWorker, normalizeWorker, confirmationSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadContentWatch() {
	  return regeneratorRuntime.wrap(function loadContentWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_confirmation.LOAD_CONTENT, loadContentWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function normalizeWatch() {
	  return regeneratorRuntime.wrap(function normalizeWatch$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_dataProvider.NORMALIZE_DATA, normalizeWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	// WORKERS
	function loadContentWorker() {
	  var errorPage, success;
	  return regeneratorRuntime.wrap(function loadContentWorker$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.prev = 0;
	          _context3.next = 3;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: true, initiator: 'localize load' }));
	
	        case 3:
	          _context3.next = 5;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 5:
	          errorPage = _context3.sent;
	          _context3.next = 8;
	          return (0, _effects.call)(_dataProvider3.default.load, [{ state: 'auth' }, { state: 'customer' }, { state: 'context' }, { state: 'plan' }, { state: 'myplanConfirmation' }], { errorPage: errorPage });
	
	        case 8:
	          success = _context3.sent;
	
	          if (success) {
	            _context3.next = 11;
	            break;
	          }
	
	          return _context3.abrupt('return');
	
	        case 11:
	          _context3.next = 13;
	          return (0, _effects.put)({
	            type: _confirmation.DL_PAGE_LOADED
	          });
	
	        case 13:
	          _context3.next = 15;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 15:
	          _context3.next = 22;
	          break;
	
	        case 17:
	          _context3.prev = 17;
	          _context3.t0 = _context3['catch'](0);
	          _context3.next = 21;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 21:
	          _reactRouter.browserHistory.push(_navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.ERROR].path);
	
	        case 22:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this, [[0, 17]]);
	}
	
	function normalizeWorker(_ref) {
	  var key = _ref.key,
	      data = _ref.data,
	      meta = _ref.meta;
	  return regeneratorRuntime.wrap(function normalizeWorker$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          if (!(key !== 'myplanConfirmation')) {
	            _context4.next = 2;
	            break;
	          }
	
	          return _context4.abrupt('return');
	
	        case 2:
	          _context4.next = 4;
	          return (0, _effects.put)({
	            type: _confirmation2.SET_DATA,
	            payload: _extends({}, meta, {
	              content: data
	            })
	          });
	
	        case 4:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function confirmationSagas() {
	  return regeneratorRuntime.wrap(function confirmationSagas$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return [(0, _effects.fork)(loadContentWatch), (0, _effects.fork)(normalizeWatch)];
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadContentWatch = loadContentWatch;
	exports.loadContentWorker = loadContentWorker;
	exports.default = myplanSagas;
	
	var _effects = __webpack_require__(10);
	
	var _reduxSaga = __webpack_require__(99);
	
	var _reactRouter = __webpack_require__(16);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dataProvider = __webpack_require__(19);
	
	var _dataProvider2 = _interopRequireDefault(_dataProvider);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _myplan = __webpack_require__(312);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadContentWatch, loadContentWorker, myplanSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadContentWatch() {
	  return regeneratorRuntime.wrap(function loadContentWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_myplan.LOAD_CONTENT, loadContentWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	// WORKERS
	function loadContentWorker() {
	  var success1, state, consumerType, isOmniContext, isPlanAvailable, success2;
	  return regeneratorRuntime.wrap(function loadContentWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          _context2.next = 3;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: true, initiator: 'myplan load' }));
	
	        case 3:
	          _context2.next = 5;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'auth' }, { state: 'customer' }, { state: 'context', param: 'true' }]);
	
	        case 5:
	          success1 = _context2.sent;
	
	          if (success1) {
	            _context2.next = 8;
	            break;
	          }
	
	          return _context2.abrupt('return');
	
	        case 8:
	          _context2.next = 10;
	          return (0, _reduxSaga.delay)(0);
	
	        case 10:
	          _context2.next = 12;
	          return (0, _effects.select)();
	
	        case 12:
	          state = _context2.sent;
	          consumerType = _lodash2.default.get(state, 'common.consumerType', '');
	          isOmniContext = consumerType === 'Einstein360' || consumerType === 'Etail';
	          isPlanAvailable = _lodash2.default.get(state, 'plan.isPlanAvailable', true);
	
	          if (!(!isOmniContext || isPlanAvailable)) {
	            _context2.next = 22;
	            break;
	          }
	
	          _context2.next = 19;
	          return (0, _effects.call)(_dataProvider2.default.load, [[{ state: 'plan' }, { state: 'equipment' }]]);
	
	        case 19:
	          success2 = _context2.sent;
	
	          if (success2) {
	            _context2.next = 22;
	            break;
	          }
	
	          return _context2.abrupt('return');
	
	        case 22:
	          _context2.next = 24;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 24:
	          _context2.next = 26;
	          return (0, _effects.put)({
	            type: _myplan.DL_PAGE_LOADED
	          });
	
	        case 26:
	          _context2.next = 33;
	          break;
	
	        case 28:
	          _context2.prev = 28;
	          _context2.t0 = _context2['catch'](0);
	          _context2.next = 32;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 32:
	          _reactRouter.browserHistory.push(_navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.ERROR].path);
	
	        case 33:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 28]]);
	}
	
	function myplanSagas() {
	  return regeneratorRuntime.wrap(function myplanSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(loadContentWatch)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 652 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'hg/omni/LOAD_CONTENT';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'hg/omni/DL_PAGE_LOADED';
	
	var loadContent = exports.loadContent = function loadContent() {
		return {
			type: LOAD_CONTENT
		};
	};

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadContentWatch = loadContentWatch;
	exports.loadContentWorker = loadContentWorker;
	exports.default = omniLandingSagas;
	
	var _effects = __webpack_require__(10);
	
	var _dataProvider = __webpack_require__(19);
	
	var _dataProvider2 = _interopRequireDefault(_dataProvider);
	
	var _omniLanding = __webpack_require__(652);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadContentWatch, loadContentWorker, omniLandingSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadContentWatch() {
	  return regeneratorRuntime.wrap(function loadContentWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_omniLanding.LOAD_CONTENT, loadContentWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	// WORKERS
	function loadContentWorker() {
	  var success;
	  return regeneratorRuntime.wrap(function loadContentWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          _context2.next = 3;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: true }));
	
	        case 3:
	          _context2.next = 5;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'omniPrerequisites' }]);
	
	        case 5:
	          success = _context2.sent;
	
	          if (success) {
	            _context2.next = 8;
	            break;
	          }
	
	          return _context2.abrupt('return');
	
	        case 8:
	          _context2.next = 10;
	          return (0, _effects.put)({
	            type: _omniLanding.DL_PAGE_LOADED
	          });
	
	        case 10:
	          _context2.next = 14;
	          break;
	
	        case 12:
	          _context2.prev = 12;
	          _context2.t0 = _context2['catch'](0);
	
	        case 14:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 12]]);
	}
	
	function omniLandingSagas() {
	  return regeneratorRuntime.wrap(function omniLandingSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(loadContentWatch)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadContentWatch = loadContentWatch;
	exports.normalizeWatch = normalizeWatch;
	exports.submitOrderWatch = submitOrderWatch;
	exports.loadContentWorker = loadContentWorker;
	exports.normalizeWorker = normalizeWorker;
	exports.submitOrderWorker = submitOrderWorker;
	exports.default = myplanReviewSagas;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _effects = __webpack_require__(10);
	
	var _reactRouter = __webpack_require__(16);
	
	var _loader = __webpack_require__(27);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _dataProvider = __webpack_require__(26);
	
	var _review = __webpack_require__(196);
	
	var _dataProvider2 = __webpack_require__(19);
	
	var _dataProvider3 = _interopRequireDefault(_dataProvider2);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _common = __webpack_require__(7);
	
	var _quickCheckout = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadContentWatch, normalizeWatch, submitOrderWatch, loadContentWorker, normalizeWorker, submitOrderWorker, myplanReviewSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadContentWatch() {
	  return regeneratorRuntime.wrap(function loadContentWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_review.LOAD_CONTENT, loadContentWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function normalizeWatch() {
	  return regeneratorRuntime.wrap(function normalizeWatch$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_dataProvider.NORMALIZE_DATA, normalizeWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function submitOrderWatch() {
	  return regeneratorRuntime.wrap(function submitOrderWatch$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_review.SUBMIT_ORDER, submitOrderWorker);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	// WORKERS
	function loadContentWorker() {
	  var errorPage, success;
	  return regeneratorRuntime.wrap(function loadContentWorker$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.prev = 0;
	          _context4.next = 3;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: true, initiator: 'localize load' }));
	
	        case 3:
	          _context4.next = 5;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 5:
	          errorPage = _context4.sent;
	          _context4.next = 8;
	          return (0, _effects.call)(_dataProvider3.default.load, [{ state: 'auth' }, { state: 'customer' }, { state: 'context' }, { state: 'plan' }, { state: 'reviewPlanCart' }, { state: 'quickCheckoutAnalytics' }], { errorPage: errorPage });
	
	        case 8:
	          success = _context4.sent;
	
	          if (success) {
	            _context4.next = 11;
	            break;
	          }
	
	          return _context4.abrupt('return');
	
	        case 11:
	          _context4.next = 13;
	          return (0, _effects.put)({
	            type: _review.DL_PAGE_LOADED
	          });
	
	        case 13:
	          _context4.next = 15;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 15:
	          _context4.next = 22;
	          break;
	
	        case 17:
	          _context4.prev = 17;
	          _context4.t0 = _context4['catch'](0);
	          _context4.next = 21;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 21:
	          _reactRouter.browserHistory.push(_navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.ERROR].path);
	
	        case 22:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this, [[0, 17]]);
	}
	
	function normalizeWorker(_ref) {
	  var key = _ref.key,
	      data = _ref.data,
	      meta = _ref.meta;
	  var allCharges, filteredCharges, productData;
	  return regeneratorRuntime.wrap(function normalizeWorker$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          if (!(key !== 'reviewPlanCart' && key !== 'submitOrder')) {
	            _context5.next = 2;
	            break;
	          }
	
	          return _context5.abrupt('return');
	
	        case 2:
	          _context5.next = 4;
	          return (0, _effects.put)({
	            type: _review.SET_DATA,
	            payload: _extends({}, meta, {
	              content: {
	                review: _extends({}, data.review, {
	                  flowType: data.flowType
	                }),
	                consentCart: data.consentCart
	              }
	            })
	          });
	
	        case 4:
	          _context5.next = 6;
	          return (0, _effects.select)(_review.allChargesSelector);
	
	        case 6:
	          allCharges = _context5.sent;
	          filteredCharges = _lodash2.default.filter(allCharges, function (item) {
	            return !_lodash2.default.isEmpty(item);
	          });
	          productData = !_lodash2.default.isEmpty(filteredCharges) ? _lodash2.default.head(filteredCharges)[0] : false;
	
	          if (!productData) {
	            _context5.next = 12;
	            break;
	          }
	
	          _context5.next = 12;
	          return (0, _effects.put)((0, _quickCheckout.setQuickCheckoutData)({
	            productId: productData.id,
	            productName: productData.name
	          }));
	
	        case 12:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}
	
	function submitOrderWorker() {
	  var errorPage, contractIds, data, endpoint, success;
	  return regeneratorRuntime.wrap(function submitOrderWorker$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.prev = 0;
	          _context6.next = 3;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 3:
	          errorPage = _context6.sent;
	          _context6.next = 6;
	          return (0, _effects.select)(_review.contractIdsSelector);
	
	        case 6:
	          contractIds = _context6.sent;
	          data = {
	            acceptedContractIds: contractIds,
	            isVerified: true
	          };
	          endpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.REVIEW].endpoints.submitOrder();
	          _context6.next = 11;
	          return (0, _effects.call)(_loader2.default.request, endpoint, { data: data, hideContentWhileLoading: false, errorPage: errorPage });
	
	        case 11:
	          success = _context6.sent;
	
	          if (success) {
	            _context6.next = 14;
	            break;
	          }
	
	          return _context6.abrupt('return');
	
	        case 14:
	          _context6.next = 18;
	          break;
	
	        case 16:
	          _context6.prev = 16;
	          _context6.t0 = _context6['catch'](0);
	
	        case 18:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this, [[0, 16]]);
	}
	
	function myplanReviewSagas() {
	  return regeneratorRuntime.wrap(function myplanReviewSagas$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return [(0, _effects.fork)(loadContentWatch), (0, _effects.fork)(normalizeWatch), (0, _effects.fork)(submitOrderWatch)];
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadContentWatch = loadContentWatch;
	exports.loadContentWorker = loadContentWorker;
	exports.default = offersSagas;
	
	var _effects = __webpack_require__(10);
	
	var _reduxSaga = __webpack_require__(99);
	
	var _reactRouter = __webpack_require__(16);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _showOffersFilter = __webpack_require__(313);
	
	var _offers = __webpack_require__(189);
	
	var _plan = __webpack_require__(123);
	
	var _dataLayer = __webpack_require__(75);
	
	var _dataProvider = __webpack_require__(19);
	
	var _dataProvider2 = _interopRequireDefault(_dataProvider);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadContentWatch, loadContentWorker, offersSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadContentWatch() {
	  return regeneratorRuntime.wrap(function loadContentWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_showOffersFilter.LOAD_OFFERS, loadContentWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	// WORKERS
	function loadContentWorker() {
	  var state, _state, rawQueryString, queryString, success, lobData, enableDefaultLobs, i, flowType, selectInternetOffers, internetIndex, offersData, filterOptionSelected;
	
	  return regeneratorRuntime.wrap(function loadContentWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)();
	
	        case 2:
	          state = _context2.sent;
	
	          if (_lodash2.default.isEmpty(state.offers.offerData)) {
	            _context2.next = 9;
	            break;
	          }
	
	          _context2.next = 6;
	          return (0, _effects.put)({
	            type: _showOffersFilter.DL_PAGE_LOADED
	          });
	
	        case 6:
	          _context2.next = 8;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 8:
	          return _context2.abrupt('return');
	
	        case 9:
	          _context2.prev = 9;
	          _context2.next = 12;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: true, initiator: 'myplan load' }));
	
	        case 12:
	          _context2.next = 14;
	          return (0, _effects.select)();
	
	        case 14:
	          _state = _context2.sent;
	          rawQueryString = _lodash2.default.get(_state, 'routing.locationBeforeTransitions.search');
	          queryString = _lodash2.default.trimStart(rawQueryString, '?'); //current implementation assumes ? character so removing from the start of the query string
	
	          _context2.next = 19;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'auth' }, { state: 'customer' }, { state: 'context' }, [{ state: 'plan' }, { state: 'equipment' }], { state: 'offers', param: queryString }]);
	
	        case 19:
	          success = _context2.sent;
	
	          if (success) {
	            _context2.next = 22;
	            break;
	          }
	
	          return _context2.abrupt('return');
	
	        case 22:
	          _context2.next = 24;
	          return (0, _effects.select)(_plan.lobSelector);
	
	        case 24:
	          lobData = _context2.sent;
	          _context2.next = 27;
	          return (0, _reduxSaga.delay)(0);
	
	        case 27:
	          _context2.next = 29;
	          return (0, _effects.select)(_offers.enableDefaultLobsSelector);
	
	        case 29:
	          enableDefaultLobs = _context2.sent;
	
	          if (enableDefaultLobs) {
	            _context2.next = 42;
	            break;
	          }
	
	          i = 0;
	
	        case 32:
	          if (!(i < lobData.length)) {
	            _context2.next = 42;
	            break;
	          }
	
	          if (!lobData[i].subscribed) {
	            _context2.next = 38;
	            break;
	          }
	
	          _context2.next = 36;
	          return (0, _effects.put)((0, _offers.updateFilter)(true, i));
	
	        case 36:
	          _context2.next = 39;
	          break;
	
	        case 38:
	          null;
	
	        case 39:
	          i++;
	          _context2.next = 32;
	          break;
	
	        case 42:
	          _context2.next = 44;
	          return (0, _effects.select)(_offers.offersFlowTypeSelector);
	
	        case 44:
	          flowType = _context2.sent;
	          _context2.next = 47;
	          return (0, _effects.put)((0, _common.setFlowType)(flowType));
	
	        case 47:
	          _context2.next = 49;
	          return (0, _effects.select)(_offers.showInternetOffers);
	
	        case 49:
	          selectInternetOffers = _context2.sent;
	
	          if (!selectInternetOffers) {
	            _context2.next = 54;
	            break;
	          }
	
	          internetIndex = _lodash2.default.findIndex(lobData, { lobName: 'Internet' });
	          _context2.next = 54;
	          return (0, _effects.put)((0, _offers.updateFilter)(true, internetIndex));
	
	        case 54:
	          _context2.next = 56;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 56:
	          _context2.next = 58;
	          return (0, _effects.put)({
	            type: _showOffersFilter.DL_PAGE_LOADED
	          });
	
	        case 58:
	          _context2.next = 60;
	          return (0, _effects.select)(_offers.dlDisplayedOffersSelector);
	
	        case 60:
	          offersData = _context2.sent;
	          _context2.next = 63;
	          return (0, _effects.select)(_offers.dlFilterOptionSelected);
	
	        case 63:
	          filterOptionSelected = _context2.sent;
	          _context2.next = 66;
	          return (0, _effects.put)((0, _dataLayer.logCustomEvent)({
	            eventName: "Offer Loaded",
	            eventAction: "product view",
	            type: "page load",
	            eventMethod: "product-View",
	            product: offersData.map(function (offer) {
	              return {
	                productInfo: _extends({}, offer)
	              };
	            }),
	            page: {
	              attributes: {
	                filterOptionSelected: filterOptionSelected
	              }
	            }
	          }));
	
	        case 66:
	          _context2.next = 73;
	          break;
	
	        case 68:
	          _context2.prev = 68;
	          _context2.t0 = _context2['catch'](9);
	          _context2.next = 72;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 72:
	          _reactRouter.browserHistory.push(_navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.ERROR].path);
	
	        case 73:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[9, 68]]);
	}
	
	function offersSagas() {
	  return regeneratorRuntime.wrap(function offersSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(loadContentWatch)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 656 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'mp/upsell/LOAD_CONTENT';
	
	var loadContent = exports.loadContent = function loadContent() {
	  return {
	    type: LOAD_CONTENT
	  };
	};

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadContentWatch = loadContentWatch;
	exports.loadContentWorker = loadContentWorker;
	exports.default = upsellSagas;
	
	var _effects = __webpack_require__(10);
	
	var _loader = __webpack_require__(27);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _dataProvider = __webpack_require__(19);
	
	var _dataProvider2 = _interopRequireDefault(_dataProvider);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _upsell = __webpack_require__(656);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadContentWatch, loadContentWorker, upsellSagas].map(regeneratorRuntime.mark);
	//import { delay } from 'redux-saga';
	
	
	/*import {
	  productNameSelector,
	  setQuickCheckoutData
	 } from '../../../data/quickCheckout/quickCheckout';*/
	//import {NORMALIZE_DATA} from '../../../dataProvider/dataProvider';
	
	
	/*import {
	  shoppingElementIdSelector,
	  priceReferenceIdSelector,
	  setData,
	  setProductId
	} from '../../../data/checkout/checkout';*/
	
	// WATCHERS
	function loadContentWatch() {
	  return regeneratorRuntime.wrap(function loadContentWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_upsell.LOAD_CONTENT, loadContentWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	/*export function* normalizeWatch() {
	  yield takeLatest(NORMALIZE_DATA, normalizeWorker);
	}*/
	
	// WORKERS
	function loadContentWorker() {
	  var buyflowConsumerType, errorPage, addDefaultOfferEndpoint, defaultOfferData, checkEligibilityEndpoint, AddProductToCartEndpoint, success, eligibility, addProductToCartData;
	  return regeneratorRuntime.wrap(function loadContentWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          buyflowConsumerType = 'StreamingVideo';
	          _context2.next = 4;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 4:
	          errorPage = _context2.sent;
	          addDefaultOfferEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.OFFERS].endpoints.addDefaultOfferToCart();
	          defaultOfferData = { buyflowConsumerType: buyflowConsumerType };
	          checkEligibilityEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.ADDON_CHANNEL].endpoints.checkEligibility(buyflowConsumerType);
	          AddProductToCartEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.UPSELL_STREAMING_VIDEO].endpoints.addToCart();
	          _context2.next = 11;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'auth' }, { state: 'customer' }, { state: 'offers', param: '' }], { errorPage: errorPage });
	
	        case 11:
	          success = _context2.sent;
	
	          if (success) {
	            _context2.next = 14;
	            break;
	          }
	
	          return _context2.abrupt('return');
	
	        case 14:
	          _context2.next = 16;
	          return (0, _effects.call)(_loader2.default.request, addDefaultOfferEndpoint, { data: defaultOfferData, useGlobalSpinner: false });
	
	        case 16:
	          _context2.next = 18;
	          return (0, _effects.call)(_loader2.default.request, checkEligibilityEndpoint, { useGlobalSpinner: false });
	
	        case 18:
	          eligibility = _context2.sent;
	          addProductToCartData = _extends({}, defaultOfferData, {
	            offerId: eligibility.priceReferenceId
	          });
	          _context2.next = 22;
	          return (0, _effects.call)(_loader2.default.request, AddProductToCartEndpoint, { data: addProductToCartData, useGlobalSpinner: false });
	
	        case 22:
	
	          window.location.replace(_navigationHelpers.buyFlowUrls.CUSTOMIZE);
	          _context2.next = 27;
	          break;
	
	        case 25:
	          _context2.prev = 25;
	          _context2.t0 = _context2['catch'](0);
	
	        case 27:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 25]]);
	}
	
	/*export function* normalizeWorker({key, data, meta}) {
	  if (key !== 'productMapping' && key !== 'productForQuickcheckout' && key !== 'customerLobAndProduct') {
	    return;
	  }
	
	  if (key === 'productMapping') {
	    yield put(setData({
	      ...meta,
	      content: data
	    }));
	    yield put(setQuickCheckoutData({
	      productId: data.shoppingElementId,
	      productName: data.productName
	    }));
	  } else {
	    yield put(setProductId(data.priceReferenceId));
	  }
	}*/
	
	function upsellSagas() {
	  return regeneratorRuntime.wrap(function upsellSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(loadContentWatch)
	          //fork(normalizeWatch)
	          ];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.omniGetCommunityWatch = omniGetCommunityWatch;
	exports.omniLocalizeAddressWatch = omniLocalizeAddressWatch;
	exports.localizeSuggestionsWatch = localizeSuggestionsWatch;
	exports.selectSuggestionsWatch = selectSuggestionsWatch;
	exports.omniGetCommunityWorker = omniGetCommunityWorker;
	exports.omniLocalizeAddressWorker = omniLocalizeAddressWorker;
	exports.localizeSuggestionsWorker = localizeSuggestionsWorker;
	exports.selectSuggestionWorker = selectSuggestionWorker;
	exports.default = omniLocalizationSagas;
	
	var _effects = __webpack_require__(10);
	
	var _reduxForm = __webpack_require__(44);
	
	__webpack_require__(77);
	
	var _localization = __webpack_require__(197);
	
	var _loader = __webpack_require__(27);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [omniGetCommunityWatch, omniLocalizeAddressWatch, localizeSuggestionsWatch, selectSuggestionsWatch, omniGetCommunityWorker, omniLocalizeAddressWorker, localizeSuggestionsWorker, selectSuggestionWorker, omniLocalizationSagas].map(regeneratorRuntime.mark); //import _ from 'lodash';
	
	
	//import {setSuggestions} from '../../../suggestions/suggestions';
	
	// WATCHERS
	function omniGetCommunityWatch() {
	  return regeneratorRuntime.wrap(function omniGetCommunityWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_localization.OMNI_GET_COMMUNITY, omniGetCommunityWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	function omniLocalizeAddressWatch() {
	  return regeneratorRuntime.wrap(function omniLocalizeAddressWatch$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_localization.OMNI_LOCALIZE, omniLocalizeAddressWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	function localizeSuggestionsWatch() {
	  return regeneratorRuntime.wrap(function localizeSuggestionsWatch$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_localization.GET_SUGGESTIONS, localizeSuggestionsWorker);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	function selectSuggestionsWatch() {
	  return regeneratorRuntime.wrap(function selectSuggestionsWatch$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeLatest)(_localization.SELECT_SUGGESTION, selectSuggestionWorker);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	// WORKERS
	function omniGetCommunityWorker() {
	  var releaseNotesEndpoint, featuresEndpoint, issuesEndpoint, communityCalls, communityData;
	  return regeneratorRuntime.wrap(function omniGetCommunityWorker$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.prev = 0;
	          releaseNotesEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.omni.OMNI_SALES].endpoints.getReleaseNotes();
	          featuresEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.omni.OMNI_SALES].endpoints.getFeatures();
	          issuesEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.omni.OMNI_SALES].endpoints.getIssues();
	          communityCalls = [(0, _effects.call)(_loader2.default.request, releaseNotesEndpoint, { useGlobalSpinner: false, redirectOnError: false }), (0, _effects.call)(_loader2.default.request, featuresEndpoint, { useGlobalSpinner: false, redirectOnError: false }), (0, _effects.call)(_loader2.default.request, issuesEndpoint, { useGlobalSpinner: false, redirectOnError: false })];
	          _context5.next = 7;
	          return communityCalls;
	
	        case 7:
	          communityData = _context5.sent;
	
	          if (!(communityData && communityData.length > 0)) {
	            _context5.next = 11;
	            break;
	          }
	
	          _context5.next = 11;
	          return (0, _effects.put)({ type: _localization.SET_DATA, payload: {
	              communityData: {
	                releaseNotes: communityData[0],
	                features: communityData[1],
	                issues: communityData[2]
	              }
	            } });
	
	        case 11:
	          _context5.next = 15;
	          break;
	
	        case 13:
	          _context5.prev = 13;
	          _context5.t0 = _context5['catch'](0);
	
	        case 15:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this, [[0, 13]]);
	}
	
	function omniLocalizeAddressWorker() {
	  var errorPage, tenantEncodeEndpoint, data, tenantToken;
	  return regeneratorRuntime.wrap(function omniLocalizeAddressWorker$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 2:
	          errorPage = _context6.sent;
	
	          //const omniLocalizeEndpoint = navigationRoutes[navigationSteps.omni.OMNI_SALES].endpoints.omniLocalize();
	
	          tenantEncodeEndpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.omni.OMNI_SALES].endpoints.tentantEncodeToken();
	
	          //const values = getFormValues('omniLocalize')(state); // state.form.movers.fields;
	          /*const data = {
	            "address": {
	              "streetAddress": values.streetAddress,
	              "unitNumber": values.unitNumber,
	              "zipCode": values.zipCode
	            },
	          };*/
	
	          data = {
	            "nbf": 1507663696,
	            "exp": 2587667296,
	            "iat": 1507667296,
	            "iss": "Einstein360",
	            "ntId": "JPadge001", //need
	            "affiliate": "OMNI-TEST",
	            "channel": "TELESALES",
	            "salesSessionId": "",
	            "source": "Einstein360",
	            "accountNumber": "",
	            "ucid": "",
	            "uid": "",
	            "avayaAgentId": "",
	            "streetAddress1": "",
	            "streetAddress2": "",
	            "unit": "",
	            "unitType": "",
	            "city": "",
	            "state": "",
	            "zip": "",
	            "csgSalesRepId": "22185", //need
	            "csgOperatorId": "d<{", //need
	            "ddpSalesRepId": "", //need
	            "ddpOperatorId": "", //need
	            "ml0": "",
	            "ml1": "",
	            "ml2": "",
	            "ml3": "",
	            "ml4": "",
	            "ml5": ""
	          };
	          _context6.prev = 5;
	          _context6.next = 8;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: false, initiator: 'calling moveCustomer' }));
	
	        case 8:
	          _context6.next = 10;
	          return (0, _effects.call)(_loader2.default.request, tenantEncodeEndpoint, { data: data, useGlobalSpinner: false, redirectOnError: false, errorPage: errorPage });
	
	        case 10:
	          tenantToken = _context6.sent;
	
	
	          window.location.href = 'https://www.stg.xfinity.com/learn/tenant/onboarding?token=' + tenantToken;
	          _context6.next = 18;
	          break;
	
	        case 14:
	          _context6.prev = 14;
	          _context6.t0 = _context6['catch'](5);
	          _context6.next = 18;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 18:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this, [[5, 14]]);
	}
	
	function localizeSuggestionsWorker() {
	  return regeneratorRuntime.wrap(function localizeSuggestionsWorker$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}
	
	function selectSuggestionWorker(action) {
	  var address, streetAddress, unitNumber, zipCode;
	  return regeneratorRuntime.wrap(function selectSuggestionWorker$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          address = action.payload.suggestion.address, streetAddress = address.address_StreetAddress || '', unitNumber = address.address_UnitNumber || '', zipCode = address.address_ZipCode || '';
	          _context8.next = 3;
	          return (0, _effects.put)((0, _reduxForm.change)('movers', 'streetAddress', streetAddress));
	
	        case 3:
	          _context8.next = 5;
	          return (0, _effects.put)((0, _reduxForm.change)('movers', 'unitNumber', unitNumber));
	
	        case 5:
	          _context8.next = 7;
	          return (0, _effects.put)((0, _reduxForm.change)('movers', 'zipCode', zipCode));
	
	        case 7:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked[7], this);
	}
	
	function omniLocalizationSagas() {
	  return regeneratorRuntime.wrap(function omniLocalizationSagas$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          _context9.next = 2;
	          return [(0, _effects.fork)(omniGetCommunityWatch), (0, _effects.fork)(omniLocalizeAddressWatch), (0, _effects.fork)(localizeSuggestionsWatch), (0, _effects.fork)(selectSuggestionsWatch)];
	
	        case 2:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked[8], this);
	}

/***/ },
/* 659 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_CONTENT = exports.LOAD_CONTENT = 'hg/checkout/LOAD_CONTENT';
	var DL_PAGE_LOADED = exports.DL_PAGE_LOADED = 'hg/checkout/DL_PAGE_LOADED';
	var SET_DATA = exports.SET_DATA = 'hg/checkout/SET_DATA';
	var SET_PRODUCT_ID = exports.SET_PRODUCT_ID = 'hg/checkout/SET_PRODUCT_ID';

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadContentWatch = loadContentWatch;
	exports.normalizeWatch = normalizeWatch;
	exports.loadContentWorker = loadContentWorker;
	exports.normalizeWorker = normalizeWorker;
	exports.default = checkoutSagas;
	
	var _effects = __webpack_require__(10);
	
	var _reactRouter = __webpack_require__(16);
	
	var _reduxSaga = __webpack_require__(99);
	
	var _dataProvider = __webpack_require__(19);
	
	var _dataProvider2 = _interopRequireDefault(_dataProvider);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _checkout = __webpack_require__(659);
	
	var _quickCheckout = __webpack_require__(124);
	
	var _dataProvider3 = __webpack_require__(26);
	
	var _common = __webpack_require__(7);
	
	var _checkout2 = __webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadContentWatch, normalizeWatch, loadContentWorker, normalizeWorker, checkoutSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadContentWatch() {
	  return regeneratorRuntime.wrap(function loadContentWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_checkout.LOAD_CONTENT, loadContentWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function normalizeWatch() {
	  return regeneratorRuntime.wrap(function normalizeWatch$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_dataProvider3.NORMALIZE_DATA, normalizeWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	// WORKERS
	function loadContentWorker(action) {
	  var errorPage, checkPricingMessage, checkAvailabilityMessage, addingProductMessage, success, isPPV, productDisplayName, planMessage, _checkPricingMessage, _checkAvailabilityMessage, _addingProductMessage, _success;
	
	  return regeneratorRuntime.wrap(function loadContentWorker$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          _context9.prev = 0;
	          _context9.next = 3;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 3:
	          errorPage = _context9.sent;
	
	          if (!action.payload.uid) {
	            _context9.next = 15;
	            break;
	          }
	
	          checkPricingMessage = regeneratorRuntime.mark(function checkPricingMessage() {
	            var productName;
	            return regeneratorRuntime.wrap(function checkPricingMessage$(_context3) {
	              while (1) {
	                switch (_context3.prev = _context3.next) {
	                  case 0:
	                    _context3.next = 2;
	                    return (0, _effects.select)(_quickCheckout.productNameSelector);
	
	                  case 2:
	                    productName = _context3.sent;
	                    return _context3.abrupt('return', 'Checking pricing for ' + productName + '...');
	
	                  case 4:
	                  case 'end':
	                    return _context3.stop();
	                }
	              }
	            }, checkPricingMessage, this);
	          });
	          checkAvailabilityMessage = regeneratorRuntime.mark(function checkAvailabilityMessage() {
	            var productName;
	            return regeneratorRuntime.wrap(function checkAvailabilityMessage$(_context4) {
	              while (1) {
	                switch (_context4.prev = _context4.next) {
	                  case 0:
	                    _context4.next = 2;
	                    return (0, _effects.select)(_quickCheckout.productNameSelector);
	
	                  case 2:
	                    productName = _context4.sent;
	                    return _context4.abrupt('return', 'Checking the availability of ' + productName + '...');
	
	                  case 4:
	                  case 'end':
	                    return _context4.stop();
	                }
	              }
	            }, checkAvailabilityMessage, this);
	          });
	          addingProductMessage = regeneratorRuntime.mark(function addingProductMessage() {
	            var productName;
	            return regeneratorRuntime.wrap(function addingProductMessage$(_context5) {
	              while (1) {
	                switch (_context5.prev = _context5.next) {
	                  case 0:
	                    _context5.next = 2;
	                    return (0, _effects.select)(_quickCheckout.productNameSelector);
	
	                  case 2:
	                    productName = _context5.sent;
	                    return _context5.abrupt('return', 'Adding ' + productName + ' to your XFINITY plan...');
	
	                  case 4:
	                  case 'end':
	                    return _context5.stop();
	                }
	              }
	            }, addingProductMessage, this);
	          });
	
	          // ADDED PLAN AND EQUIPMENT FOR DATA LAYER
	
	          _context9.next = 10;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'productMapping', spinnerMessage: 'Looking up your XFINITY Plan...', param: action.payload.uid }, { state: 'auth', spinnerMessage: 'Looking up your XFINITY Plan...' }, { state: 'customer', spinnerMessage: 'Looking up your XFINITY Plan...' }, { state: 'context', spinnerMessage: 'Looking up your XFINITY Plan...' }, { state: 'plan', spinnerMessage: 'Looking up your XFINITY Plan...' }, { state: 'offers', spinnerMessage: checkPricingMessage, param: '' }, { state: 'addDefaultOffer', spinnerMessage: checkPricingMessage }, { state: 'customerLobAndProduct', spinnerMessage: checkAvailabilityMessage, param: regeneratorRuntime.mark(function param() {
	              return regeneratorRuntime.wrap(function param$(_context6) {
	                while (1) {
	                  switch (_context6.prev = _context6.next) {
	                    case 0:
	                      _context6.next = 2;
	                      return (0, _effects.select)(_checkout2.shoppingElementIdSelector);
	
	                    case 2:
	                      return _context6.abrupt('return', _context6.sent);
	
	                    case 3:
	                    case 'end':
	                      return _context6.stop();
	                  }
	                }
	              }, param, this);
	            }) }, { state: 'configureProduct', spinnerMessage: checkAvailabilityMessage, param: regeneratorRuntime.mark(function param() {
	              return regeneratorRuntime.wrap(function param$(_context7) {
	                while (1) {
	                  switch (_context7.prev = _context7.next) {
	                    case 0:
	                      _context7.next = 2;
	                      return (0, _reduxSaga.delay)(0);
	
	                    case 2:
	                      _context7.next = 4;
	                      return (0, _effects.select)(_checkout2.priceReferenceIdSelector);
	
	                    case 4:
	                      return _context7.abrupt('return', _context7.sent);
	
	                    case 5:
	                    case 'end':
	                      return _context7.stop();
	                  }
	                }
	              }, param, this);
	            }) }, { state: 'review', spinnerMessage: addingProductMessage }, { state: 'quickCheckoutAnalytics', spinnerMessage: addingProductMessage }], { errorPage: errorPage });
	
	        case 10:
	          success = _context9.sent;
	
	          if (success) {
	            _context9.next = 13;
	            break;
	          }
	
	          return _context9.abrupt('return');
	
	        case 13:
	          _context9.next = 29;
	          break;
	
	        case 15:
	          // NEW URL PARAM productName and type
	          isPPV = action.payload.checkoutType === 'ppv';
	
	          if (!isPPV) {
	            _context9.next = 19;
	            break;
	          }
	
	          _context9.next = 19;
	          return (0, _effects.put)((0, _checkout2.setData)({ queryType: 'ppv' }));
	
	        case 19:
	          productDisplayName = isPPV ? 'selected event' : action.payload.productName;
	          planMessage = 'Looking up your XFINITY Plan...';
	          _checkPricingMessage = 'Checking pricing for ' + productDisplayName + '...';
	          _checkAvailabilityMessage = 'Checking the availability of ' + productDisplayName + '...';
	          _addingProductMessage = 'Adding ' + productDisplayName + ' to your XFINITY plan...';
	
	          // ADDED PLAN AND EQUIPMENT FOR DATA LAYER
	
	          _context9.next = 26;
	          return (0, _effects.call)(_dataProvider2.default.load, [{ state: 'auth', spinnerMessage: planMessage }, { state: 'customer', spinnerMessage: planMessage }, { state: 'context', spinnerMessage: planMessage }, { state: 'plan', spinnerMessage: planMessage }, { state: 'offers', spinnerMessage: _checkPricingMessage, param: '' }, { state: 'addDefaultOffer', spinnerMessage: _checkPricingMessage }, { state: 'productForQuickcheckout', spinnerMessage: _checkAvailabilityMessage, param: action.payload }, { state: 'configureProduct', spinnerMessage: _checkAvailabilityMessage, param: regeneratorRuntime.mark(function param() {
	              return regeneratorRuntime.wrap(function param$(_context8) {
	                while (1) {
	                  switch (_context8.prev = _context8.next) {
	                    case 0:
	                      _context8.next = 2;
	                      return (0, _reduxSaga.delay)(0);
	
	                    case 2:
	                      _context8.next = 4;
	                      return (0, _effects.select)(_checkout2.priceReferenceIdSelector);
	
	                    case 4:
	                      return _context8.abrupt('return', _context8.sent);
	
	                    case 5:
	                    case 'end':
	                      return _context8.stop();
	                  }
	                }
	              }, param, this);
	            }) }, { state: 'review', spinnerMessage: _addingProductMessage }, { state: 'quickCheckoutAnalytics', spinnerMessage: _addingProductMessage }], { errorPage: errorPage });
	
	        case 26:
	          _success = _context9.sent;
	
	          if (_success) {
	            _context9.next = 29;
	            break;
	          }
	
	          return _context9.abrupt('return');
	
	        case 29:
	          _context9.next = 31;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 31:
	          _reactRouter.browserHistory.replace(_navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.REVIEW].path);
	          _context9.next = 36;
	          break;
	
	        case 34:
	          _context9.prev = 34;
	          _context9.t0 = _context9['catch'](0);
	
	        case 36:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked[2], this, [[0, 34]]);
	}
	
	function normalizeWorker(_ref) {
	  var key = _ref.key,
	      data = _ref.data,
	      meta = _ref.meta;
	  return regeneratorRuntime.wrap(function normalizeWorker$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          if (!(key !== 'productMapping' && key !== 'productForQuickcheckout' && key !== 'customerLobAndProduct')) {
	            _context10.next = 2;
	            break;
	          }
	
	          return _context10.abrupt('return');
	
	        case 2:
	          if (!(key === 'productMapping')) {
	            _context10.next = 9;
	            break;
	          }
	
	          _context10.next = 5;
	          return (0, _effects.put)((0, _checkout2.setData)(_extends({}, meta, {
	            content: data
	          })));
	
	        case 5:
	          _context10.next = 7;
	          return (0, _effects.put)((0, _quickCheckout.setQuickCheckoutData)({
	            productId: data.shoppingElementId,
	            productName: data.productName
	          }));
	
	        case 7:
	          _context10.next = 11;
	          break;
	
	        case 9:
	          _context10.next = 11;
	          return (0, _effects.put)((0, _checkout2.setProductId)(data.priceReferenceId));
	
	        case 11:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function checkoutSagas() {
	  return regeneratorRuntime.wrap(function checkoutSagas$(_context11) {
	    while (1) {
	      switch (_context11.prev = _context11.next) {
	        case 0:
	          _context11.next = 2;
	          return [(0, _effects.fork)(loadContentWatch), (0, _effects.fork)(normalizeWatch)];
	
	        case 2:
	        case 'end':
	          return _context11.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadContentWatch = loadContentWatch;
	exports.normalizeWatch = normalizeWatch;
	exports.loadContentWorker = loadContentWorker;
	exports.normalizeWorker = normalizeWorker;
	exports.default = confirmationSagas;
	
	var _effects = __webpack_require__(10);
	
	var _reactRouter = __webpack_require__(16);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dataProvider = __webpack_require__(26);
	
	var _dataProvider2 = __webpack_require__(19);
	
	var _dataProvider3 = _interopRequireDefault(_dataProvider2);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _confirmation = __webpack_require__(314);
	
	var _confirmation2 = __webpack_require__(188);
	
	var _quickCheckout = __webpack_require__(124);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadContentWatch, normalizeWatch, loadContentWorker, normalizeWorker, confirmationSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadContentWatch() {
	  return regeneratorRuntime.wrap(function loadContentWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_confirmation.LOAD_CONTENT, loadContentWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function normalizeWatch() {
	  return regeneratorRuntime.wrap(function normalizeWatch$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_dataProvider.NORMALIZE_DATA, normalizeWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	// WORKERS
	function loadContentWorker() {
	  var errorPage, success;
	  return regeneratorRuntime.wrap(function loadContentWorker$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.prev = 0;
	          _context3.next = 3;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: true, initiator: 'localize load' }));
	
	        case 3:
	          _context3.next = 5;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 5:
	          errorPage = _context3.sent;
	          _context3.next = 8;
	          return (0, _effects.call)(_dataProvider3.default.load, [{ state: 'customer' }, { state: 'context' }, { state: 'plan' }, { state: 'confirmation' }], { errorPage: errorPage });
	
	        case 8:
	          success = _context3.sent;
	
	          if (success) {
	            _context3.next = 11;
	            break;
	          }
	
	          return _context3.abrupt('return');
	
	        case 11:
	          _context3.next = 13;
	          return (0, _effects.put)({
	            type: _confirmation.DL_PAGE_LOADED
	          });
	
	        case 13:
	          _context3.next = 15;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 15:
	          _context3.next = 22;
	          break;
	
	        case 17:
	          _context3.prev = 17;
	          _context3.t0 = _context3['catch'](0);
	          _context3.next = 21;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 21:
	          _reactRouter.browserHistory.push(_navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.ERROR].path);
	
	        case 22:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this, [[0, 17]]);
	}
	
	function normalizeWorker(_ref) {
	  var key = _ref.key,
	      data = _ref.data,
	      meta = _ref.meta;
	  var premiumChannelData, equipmentData, productData;
	  return regeneratorRuntime.wrap(function normalizeWorker$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          if (!(key !== 'confirmation')) {
	            _context4.next = 2;
	            break;
	          }
	
	          return _context4.abrupt('return');
	
	        case 2:
	          _context4.next = 4;
	          return (0, _effects.put)({
	            type: _confirmation2.SET_DATA,
	            payload: _extends({}, meta, {
	              content: data
	            })
	          });
	
	        case 4:
	          premiumChannelData = _lodash2.default.get(data, 'cartInfo.channelAdded', '');
	          equipmentData = _lodash2.default.get(data, 'cartInfo.equipmentAdded', '');
	          productData = _lodash2.default.head(_lodash2.default.filter([premiumChannelData, equipmentData], function (product) {
	            return !_lodash2.default.isEmpty(product);
	          }));
	          _context4.next = 9;
	          return (0, _effects.put)((0, _quickCheckout.setQuickCheckoutData)({
	            productId: productData.id,
	            productName: productData.name
	          }));
	
	        case 9:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function confirmationSagas() {
	  return regeneratorRuntime.wrap(function confirmationSagas$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return [(0, _effects.fork)(loadContentWatch), (0, _effects.fork)(normalizeWatch)];
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadContentWatch = loadContentWatch;
	exports.loadContentWorker = loadContentWorker;
	exports.default = redirectSagas;
	
	var _effects = __webpack_require__(10);
	
	var _reactRouter = __webpack_require__(16);
	
	var _redirect = __webpack_require__(315);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _marked = [loadContentWatch, loadContentWorker, redirectSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadContentWatch() {
	  return regeneratorRuntime.wrap(function loadContentWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_redirect.LOAD_CONTENT, loadContentWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	// WORKERS
	function loadContentWorker() {
	  return regeneratorRuntime.wrap(function loadContentWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          _context2.next = 3;
	          return (0, _effects.put)({
	            type: _redirect.DL_PAGE_LOADED
	          });
	
	        case 3:
	          _context2.next = 8;
	          break;
	
	        case 5:
	          _context2.prev = 5;
	          _context2.t0 = _context2['catch'](0);
	
	          _reactRouter.browserHistory.push(_navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.ERROR].path);
	
	        case 8:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 5]]);
	}
	
	function redirectSagas() {
	  return regeneratorRuntime.wrap(function redirectSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(loadContentWatch)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadContentWatch = loadContentWatch;
	exports.normalizeWatch = normalizeWatch;
	exports.submitOrderWatch = submitOrderWatch;
	exports.loadContentWorker = loadContentWorker;
	exports.normalizeWorker = normalizeWorker;
	exports.submitOrderWorker = submitOrderWorker;
	exports.default = reviewSagas;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _effects = __webpack_require__(10);
	
	var _reactRouter = __webpack_require__(16);
	
	var _loader = __webpack_require__(27);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _dataProvider = __webpack_require__(26);
	
	var _review = __webpack_require__(316);
	
	var _review2 = __webpack_require__(141);
	
	var _dataProvider2 = __webpack_require__(19);
	
	var _dataProvider3 = _interopRequireDefault(_dataProvider2);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _common = __webpack_require__(7);
	
	var _quickCheckout = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadContentWatch, normalizeWatch, submitOrderWatch, loadContentWorker, normalizeWorker, submitOrderWorker, reviewSagas].map(regeneratorRuntime.mark);
	
	// WATCHERS
	function loadContentWatch() {
	  return regeneratorRuntime.wrap(function loadContentWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_review.LOAD_CONTENT, loadContentWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function normalizeWatch() {
	  return regeneratorRuntime.wrap(function normalizeWatch$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_dataProvider.NORMALIZE_DATA, normalizeWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function submitOrderWatch() {
	  return regeneratorRuntime.wrap(function submitOrderWatch$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_review.SUBMIT_ORDER, submitOrderWorker);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	// WORKERS
	function loadContentWorker() {
	  var errorPage, success;
	  return regeneratorRuntime.wrap(function loadContentWorker$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.prev = 0;
	          _context4.next = 3;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)({ hideContent: true, initiator: 'localize load' }));
	
	        case 3:
	          _context4.next = 5;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 5:
	          errorPage = _context4.sent;
	          _context4.next = 8;
	          return (0, _effects.call)(_dataProvider3.default.load, [{ state: 'customer' }, { state: 'context' }, { state: 'plan' }, { state: 'review' }, {
	            state: 'quickCheckoutAnalytics',
	            stateCheck: 'dataLayer.analyticsData.digitalData.page',
	            loadCheck: 'product'
	          }], { errorPage: errorPage });
	
	        case 8:
	          success = _context4.sent;
	
	          if (success) {
	            _context4.next = 11;
	            break;
	          }
	
	          return _context4.abrupt('return');
	
	        case 11:
	          _context4.next = 13;
	          return (0, _effects.put)({
	            type: _review.DL_PAGE_LOADED
	          });
	
	        case 13:
	          _context4.next = 15;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 15:
	          _context4.next = 22;
	          break;
	
	        case 17:
	          _context4.prev = 17;
	          _context4.t0 = _context4['catch'](0);
	          _context4.next = 21;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 21:
	          _reactRouter.browserHistory.push(_navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.ERROR].path);
	
	        case 22:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this, [[0, 17]]);
	}
	
	function normalizeWorker(_ref) {
	  var key = _ref.key,
	      data = _ref.data,
	      meta = _ref.meta;
	  var allCharges, productData;
	  return regeneratorRuntime.wrap(function normalizeWorker$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          if (!(key !== 'review' && key !== 'submitOrder')) {
	            _context5.next = 2;
	            break;
	          }
	
	          return _context5.abrupt('return');
	
	        case 2:
	          _context5.next = 4;
	          return (0, _effects.put)({
	            type: _review2.SET_DATA,
	            payload: _extends({}, meta, {
	              content: {
	                review: _extends({}, data.review, {
	                  flowType: data.flowType
	                }),
	                consentCart: data.consentCart
	              }
	            })
	          });
	
	        case 4:
	          _context5.next = 6;
	          return (0, _effects.select)(_review2.allChargesSelector);
	
	        case 6:
	          allCharges = _context5.sent;
	          productData = _lodash2.default.head(_lodash2.default.filter(allCharges, function (item) {
	            return !_lodash2.default.isEmpty(item);
	          }))[0];
	          _context5.next = 10;
	          return (0, _effects.put)((0, _quickCheckout.setQuickCheckoutData)({
	            productId: productData.id,
	            productName: productData.name
	          }));
	
	        case 10:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}
	
	function submitOrderWorker() {
	  var errorPage, contractIds, flowType, data, endpoint, success;
	  return regeneratorRuntime.wrap(function submitOrderWorker$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.prev = 0;
	          _context6.next = 3;
	          return (0, _effects.select)(_common.errorPageByFlow);
	
	        case 3:
	          errorPage = _context6.sent;
	          _context6.next = 6;
	          return (0, _effects.select)(_review2.contractIdsSelector);
	
	        case 6:
	          contractIds = _context6.sent;
	          _context6.next = 9;
	          return (0, _effects.select)(_review2.reviewFlowTypeSelector);
	
	        case 9:
	          flowType = _context6.sent;
	          data = {
	            acceptedContractIds: contractIds,
	            isVerified: true,
	            orderType: flowType === _review2.CHECKOUT_TYPE_PPV ? 'PPV' : 'QC'
	          };
	          endpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.REVIEW].endpoints.submitOrder();
	          _context6.next = 14;
	          return (0, _effects.call)(_loader2.default.request, endpoint, { data: data, hideContentWhileLoading: false, errorPage: errorPage });
	
	        case 14:
	          success = _context6.sent;
	
	          if (success) {
	            _context6.next = 17;
	            break;
	          }
	
	          return _context6.abrupt('return');
	
	        case 17:
	          _context6.next = 21;
	          break;
	
	        case 19:
	          _context6.prev = 19;
	          _context6.t0 = _context6['catch'](0);
	
	        case 21:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this, [[0, 19]]);
	}
	
	function reviewSagas() {
	  return regeneratorRuntime.wrap(function reviewSagas$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return [(0, _effects.fork)(loadContentWatch), (0, _effects.fork)(normalizeWatch), (0, _effects.fork)(submitOrderWatch)];
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getErrorContentPath = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _navigationHelpers = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getErrorContentPath = exports.getErrorContentPath = function getErrorContentPath(path) {
	  var errorPages = [_navigationHelpers.navigationSteps.myPlan.ERROR, _navigationHelpers.navigationSteps.myPlan.CONTACTUS, _navigationHelpers.navigationSteps.quickCheckout.ERROR, _navigationHelpers.navigationSteps.quickCheckout.CONTACTUS, _navigationHelpers.navigationSteps.movers.CONTACTUS, _navigationHelpers.navigationSteps.movers.CANCELLATION_CONTACTUS, _navigationHelpers.navigationSteps.movers.ERROR, _navigationHelpers.navigationSteps.movers.CANCELLATION_ERROR, _navigationHelpers.navigationSteps.myPlan.MESSAGE];
	
	  var errorContentPath = _lodash2.default.get(errorPages.filter(function (errorPage) {
	    return _lodash2.default.startsWith(path, _navigationHelpers.navigationRoutes[errorPage].path);
	  }), '[0]');
	
	  return errorContentPath;
	};

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleErrorWatch = handleErrorWatch;
	exports.handleContactUsWatch = handleContactUsWatch;
	exports.setErrorWatch = setErrorWatch;
	exports.handleErrorWorker = handleErrorWorker;
	exports.handleContactUsWorker = handleContactUsWorker;
	exports.setErrorWorker = setErrorWorker;
	exports.default = errorSagas;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _effects = __webpack_require__(10);
	
	var _navigationHelpers = __webpack_require__(11);
	
	var _loader = __webpack_require__(27);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _error = __webpack_require__(198);
	
	var _common = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [handleErrorWatch, handleContactUsWatch, setErrorWatch, handleErrorWorker, handleContactUsWorker, setErrorWorker, errorSagas].map(regeneratorRuntime.mark);
	
	function handleErrorWatch() {
	  return regeneratorRuntime.wrap(function handleErrorWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_error.HANDLE_ERROR, handleErrorWorker);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function handleContactUsWatch() {
	  return regeneratorRuntime.wrap(function handleContactUsWatch$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_error.HANDLE_INTERACTION, handleContactUsWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function setErrorWatch() {
	  return regeneratorRuntime.wrap(function setErrorWatch$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_common.SET_ERROR, setErrorWorker);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function handleErrorWorker() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      content = _ref.content,
	      errorType = _ref.errorType,
	      endpointUrl = _ref.endpointUrl;
	
	  var error, pageUrl, data, endpoint;
	  return regeneratorRuntime.wrap(function handleErrorWorker$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	
	          // log exception on the server
	          error = JSON.parse(JSON.stringify(content, ["message", "arguments", "type", "name", "stack", "error", "status", "data", "statusText"]));
	          pageUrl = _lodash2.default.get(window, 'location.href');
	          data = { error: error, errorType: errorType, endpointUrl: endpointUrl, pageUrl: pageUrl };
	          endpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.myPlan.ERROR].endpoints.logErrors();
	          _context4.prev = 4;
	          _context4.next = 7;
	          return (0, _effects.fork)(_loader2.default.request, endpoint, {
	            data: data,
	            redirectOnError: false,
	            fetchContextIfNotFetched: false,
	            useGlobalSpinner: false,
	            showPageLevelError: false
	          });
	
	        case 7:
	          _context4.next = 11;
	          break;
	
	        case 9:
	          _context4.prev = 9;
	          _context4.t0 = _context4['catch'](4);
	
	        case 11:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this, [[4, 9]]);
	}
	
	function handleContactUsWorker() {
	  var endpoint, toUrl, data;
	  return regeneratorRuntime.wrap(function handleContactUsWorker$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          endpoint = _navigationHelpers.navigationRoutes[_navigationHelpers.navigationSteps.quickCheckout.CONTACTUS].endpoints.userInteraction();
	          toUrl = _lodash2.default.get(window, 'location.href');
	          data = { toUrl: toUrl };
	          _context5.next = 5;
	          return (0, _effects.call)(_loader2.default.request, endpoint, {
	            data: data,
	            redirectOnError: false,
	            useGlobalSpinner: false
	          });
	
	        case 5:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}
	
	function setErrorWorker() {
	  var errors, contactUsErrorCode;
	  return regeneratorRuntime.wrap(function setErrorWorker$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.prev = 0;
	          _context6.next = 3;
	          return (0, _effects.select)(_common.commonErrorsSelector);
	
	        case 3:
	          errors = _context6.sent;
	          contactUsErrorCode = errors ? errors.filter(function (error) {
	            return error.errorCode.indexOf('DFPLN') > -1;
	          }) : [];
	
	          if (!contactUsErrorCode) {
	            _context6.next = 8;
	            break;
	          }
	
	          _context6.next = 8;
	          return (0, _effects.put)((0, _common.setContactUsError)(contactUsErrorCode[0].errorCode));
	
	        case 8:
	          _context6.next = 12;
	          break;
	
	        case 10:
	          _context6.prev = 10;
	          _context6.t0 = _context6['catch'](0);
	
	        case 12:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this, [[0, 10]]);
	}
	
	function errorSagas() {
	  return regeneratorRuntime.wrap(function errorSagas$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return [(0, _effects.fork)(handleErrorWatch), (0, _effects.fork)(handleContactUsWatch), (0, _effects.fork)(setErrorWatch)];
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.targetSagas = exports.dataLayerSagas = exports.omniLandingSagas = exports.accountMultipleAddressSagas = exports.accountSagas = exports.redirectSagas = exports.confirmationSagas = exports.reviewSagas = exports.checkoutSagas = exports.moversConfirmationSagas = exports.moversReviewSagas = exports.moversInstallSagas = exports.moversSpecialistSagas = exports.moversCancelSagas = exports.moversUnserviceableSagas = exports.moversLocalizationSagas = exports.planSagas = exports.contextSagas = exports.customerSagas = exports.equipmentSagas = exports.offersSagas = exports.errorSagas = exports.myplanConfirmationSagas = exports.myplanReviewSagas = exports.cancelSagas = exports.upsellSagas = exports.addOnSagas = exports.showOffersFilter = exports.myplanSagas = exports.omniLocalizationSagas = undefined;
	
	var _localizationSagas = __webpack_require__(658);
	
	var _localizationSagas2 = _interopRequireDefault(_localizationSagas);
	
	var _myplanSagas2 = __webpack_require__(651);
	
	var _myplanSagas3 = _interopRequireDefault(_myplanSagas2);
	
	var _showOffersFilterSagas = __webpack_require__(655);
	
	var _showOffersFilterSagas2 = _interopRequireDefault(_showOffersFilterSagas);
	
	var _addOnSagas2 = __webpack_require__(647);
	
	var _addOnSagas3 = _interopRequireDefault(_addOnSagas2);
	
	var _upsellSagas2 = __webpack_require__(657);
	
	var _upsellSagas3 = _interopRequireDefault(_upsellSagas2);
	
	var _cancelSagas2 = __webpack_require__(649);
	
	var _cancelSagas3 = _interopRequireDefault(_cancelSagas2);
	
	var _reviewSagas2 = __webpack_require__(654);
	
	var _reviewSagas3 = _interopRequireDefault(_reviewSagas2);
	
	var _confirmationSagas2 = __webpack_require__(650);
	
	var _confirmationSagas3 = _interopRequireDefault(_confirmationSagas2);
	
	var _errorSagas2 = __webpack_require__(665);
	
	var _errorSagas3 = _interopRequireDefault(_errorSagas2);
	
	var _offersSagas2 = __webpack_require__(626);
	
	var _offersSagas3 = _interopRequireDefault(_offersSagas2);
	
	var _equipmentSagas2 = __webpack_require__(625);
	
	var _equipmentSagas3 = _interopRequireDefault(_equipmentSagas2);
	
	var _customerSagas2 = __webpack_require__(623);
	
	var _customerSagas3 = _interopRequireDefault(_customerSagas2);
	
	var _contextSagas2 = __webpack_require__(622);
	
	var _contextSagas3 = _interopRequireDefault(_contextSagas2);
	
	var _planSagas2 = __webpack_require__(629);
	
	var _planSagas3 = _interopRequireDefault(_planSagas2);
	
	var _localizationSagas3 = __webpack_require__(641);
	
	var _localizationSagas4 = _interopRequireDefault(_localizationSagas3);
	
	var _unserviceableSagas = __webpack_require__(645);
	
	var _unserviceableSagas2 = _interopRequireDefault(_unserviceableSagas);
	
	var _cancelSagas4 = __webpack_require__(636);
	
	var _cancelSagas5 = _interopRequireDefault(_cancelSagas4);
	
	var _specialistSagas = __webpack_require__(644);
	
	var _specialistSagas2 = _interopRequireDefault(_specialistSagas);
	
	var _installSagas = __webpack_require__(638);
	
	var _installSagas2 = _interopRequireDefault(_installSagas);
	
	var _reviewSagas4 = __webpack_require__(642);
	
	var _reviewSagas5 = _interopRequireDefault(_reviewSagas4);
	
	var _confirmationSagas4 = __webpack_require__(637);
	
	var _confirmationSagas5 = _interopRequireDefault(_confirmationSagas4);
	
	var _checkoutSagas2 = __webpack_require__(660);
	
	var _checkoutSagas3 = _interopRequireDefault(_checkoutSagas2);
	
	var _reviewSagas6 = __webpack_require__(663);
	
	var _reviewSagas7 = _interopRequireDefault(_reviewSagas6);
	
	var _confirmationSagas6 = __webpack_require__(661);
	
	var _confirmationSagas7 = _interopRequireDefault(_confirmationSagas6);
	
	var _redirectSagas2 = __webpack_require__(662);
	
	var _redirectSagas3 = _interopRequireDefault(_redirectSagas2);
	
	var _accountSagas2 = __webpack_require__(634);
	
	var _accountSagas3 = _interopRequireDefault(_accountSagas2);
	
	var _multipleAddressSagas = __webpack_require__(635);
	
	var _multipleAddressSagas2 = _interopRequireDefault(_multipleAddressSagas);
	
	var _omniLandingSagas2 = __webpack_require__(653);
	
	var _omniLandingSagas3 = _interopRequireDefault(_omniLandingSagas2);
	
	var _dataLayerSagas2 = __webpack_require__(616);
	
	var _dataLayerSagas3 = _interopRequireDefault(_dataLayerSagas2);
	
	var _targetSagas2 = __webpack_require__(667);
	
	var _targetSagas3 = _interopRequireDefault(_targetSagas2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.omniLocalizationSagas = _localizationSagas2.default;
	exports.myplanSagas = _myplanSagas3.default;
	exports.showOffersFilter = _showOffersFilterSagas2.default;
	exports.addOnSagas = _addOnSagas3.default;
	exports.upsellSagas = _upsellSagas3.default;
	exports.cancelSagas = _cancelSagas3.default;
	exports.myplanReviewSagas = _reviewSagas3.default;
	exports.myplanConfirmationSagas = _confirmationSagas3.default;
	exports.errorSagas = _errorSagas3.default;
	exports.offersSagas = _offersSagas3.default;
	exports.equipmentSagas = _equipmentSagas3.default;
	exports.customerSagas = _customerSagas3.default;
	exports.contextSagas = _contextSagas3.default;
	exports.planSagas = _planSagas3.default;
	exports.moversLocalizationSagas = _localizationSagas4.default;
	exports.moversUnserviceableSagas = _unserviceableSagas2.default;
	exports.moversCancelSagas = _cancelSagas5.default;
	exports.moversSpecialistSagas = _specialistSagas2.default;
	exports.moversInstallSagas = _installSagas2.default;
	exports.moversReviewSagas = _reviewSagas5.default;
	exports.moversConfirmationSagas = _confirmationSagas5.default;
	exports.checkoutSagas = _checkoutSagas3.default;
	exports.reviewSagas = _reviewSagas7.default;
	exports.confirmationSagas = _confirmationSagas7.default;
	exports.redirectSagas = _redirectSagas3.default;
	exports.accountSagas = _accountSagas3.default;
	exports.accountMultipleAddressSagas = _multipleAddressSagas2.default;
	exports.omniLandingSagas = _omniLandingSagas3.default;
	exports.dataLayerSagas = _dataLayerSagas3.default;
	exports.targetSagas = _targetSagas3.default;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actionsReceivedWatch = actionsReceivedWatch;
	exports.targetFlow = targetFlow;
	exports.actionsReceivedWorker = actionsReceivedWorker;
	exports.default = interactionSagas;
	
	var _jquery = __webpack_require__(131);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _effects = __webpack_require__(10);
	
	var _reduxSaga = __webpack_require__(99);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _target = __webpack_require__(318);
	
	var _common = __webpack_require__(7);
	
	var _dataLayer = __webpack_require__(75);
	
	var _contentProvider = __webpack_require__(74);
	
	var _contentProvider2 = _interopRequireDefault(_contentProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [actionsReceivedWatch, targetFlow, actionsReceivedWorker, interactionSagas].map(regeneratorRuntime.mark); /*eslint-disable require-yield*/
	//eslint-disable-line no-unused-vars
	
	// import queryString from 'query-string';
	
	
	// WATCHERS
	function actionsReceivedWatch() {
	  return regeneratorRuntime.wrap(function actionsReceivedWatch$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          return _context.delegateYield((0, _reduxSaga.takeLatest)(_target.ACTIONS_RECEIVED, actionsReceivedWorker), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	// WORKERS
	function targetFlow() {
	  var _marked2, simulateTargetCall, doneEventHandler, successEventHandler, failEventHandler, timeoutDelay, actionsList, successSaga, successTask, _ref, done;
	
	  return regeneratorRuntime.wrap(function targetFlow$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          successSaga = function successSaga() {
	            var success;
	            return regeneratorRuntime.wrap(function successSaga$(_context2) {
	              while (1) {
	                switch (_context2.prev = _context2.next) {
	                  case 0:
	                    if (false) {
	                      _context2.next = 7;
	                      break;
	                    }
	
	                    _context2.next = 3;
	                    return (0, _effects.call)(successEventHandler);
	
	                  case 3:
	                    success = _context2.sent;
	
	
	                    _lodash2.default.get(success, 'detail.ReactJSActions') && actionsList.push(success.detail.ReactJSActions);
	                    _context2.next = 0;
	                    break;
	
	                  case 7:
	                  case 'end':
	                    return _context2.stop();
	                }
	              }
	            }, _marked2[0], this);
	          };
	
	          _marked2 = [successSaga].map(regeneratorRuntime.mark);
	
	          // TODO:Remove. for testing/debugging only
	          simulateTargetCall = function simulateTargetCall(success, delay, instructions) {
	            var defaultnstructions = {
	              "ReactJSActions": {
	                "config": {
	                  "showPageTopMessage": true
	                },
	                "content": {
	                  "offersFilter.offerCardBannerGreeting": "new T&T greeting",
	                  "review.pageHeader": "new T&T pageHeader"
	                }
	              }
	            };
	            var successEvent = new CustomEvent('target-data-success', { detail: instructions || defaultnstructions });
	            var doneEvent = new Event('target-data-done');
	            var failEvent = new Event('target-data-fail');
	
	            $(document).on('c-tracking-log-page', function () {
	              setTimeout(function () {
	                return document.dispatchEvent(successEvent);
	              }, 100);
	              setTimeout(function () {
	                return document.dispatchEvent(success ? doneEvent : failEvent);
	              }, delay);
	            });
	          };
	
	          // to allow tests from console
	
	
	          window.simulateTargetCall = simulateTargetCall;
	
	          // Simulate successful call
	          // simulateTargetCall(true, 500);
	          // Simulate failed call
	          // simulateTargetCall(false, 500);
	          // // Simulate timeout
	          // simulateTargetCall(true, 5000);
	
	          // switch to enable/disable T&T
	          // const query = queryString.parse(window.location.search);
	          //
	          // if (query.target !== 'true') {
	          //   return;
	          // }
	
	          doneEventHandler = function doneEventHandler() {
	            return new Promise(function (resolve) {
	              return document.addEventListener('target-data-done', resolve);
	            });
	          };
	
	          successEventHandler = function successEventHandler() {
	            return new Promise(function (resolve) {
	              return document.addEventListener('target-data-success', resolve);
	            });
	          };
	
	          failEventHandler = function failEventHandler() {
	            return new Promise(function (resolve) {
	              return document.addEventListener('target-data-fail', resolve);
	            });
	          };
	
	          timeoutDelay = 500;
	          actionsList = [];
	          _context3.prev = 9;
	
	        case 10:
	          if (false) {
	            _context3.next = 31;
	            break;
	          }
	
	          _context3.next = 13;
	          return (0, _effects.take)(_dataLayer.PAGE_LOADED);
	
	        case 13:
	          _context3.next = 15;
	          return (0, _effects.put)((0, _common.showGlobalSpinner)());
	
	        case 15:
	          _context3.next = 17;
	          return (0, _effects.fork)(successSaga);
	
	        case 17:
	          successTask = _context3.sent;
	          _context3.next = 20;
	          return (0, _effects.race)({
	            done: (0, _effects.call)(doneEventHandler),
	            fail: (0, _effects.call)(failEventHandler),
	            timeout: (0, _effects.call)(_reduxSaga.delay, timeoutDelay)
	          });
	
	        case 20:
	          _ref = _context3.sent;
	          done = _ref.done;
	          _context3.next = 24;
	          return (0, _effects.cancel)(successTask);
	
	        case 24:
	          if (!done) {
	            _context3.next = 27;
	            break;
	          }
	
	          _context3.next = 27;
	          return actionsList.map(function (actions) {
	            return (0, _effects.put)({
	              type: _target.ACTIONS_RECEIVED,
	              payload: actions
	            });
	          });
	
	        case 27:
	          _context3.next = 29;
	          return (0, _effects.put)((0, _common.hideGlobalSpinner)());
	
	        case 29:
	          _context3.next = 10;
	          break;
	
	        case 31:
	          _context3.next = 35;
	          break;
	
	        case 33:
	          _context3.prev = 33;
	          _context3.t0 = _context3['catch'](9);
	
	        case 35:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[1], this, [[9, 33]]);
	}
	
	function actionsReceivedWorker(_ref2) {
	  var actions = _ref2.payload;
	  return regeneratorRuntime.wrap(function actionsReceivedWorker$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          actions.content && _contentProvider2.default.updateContent(actions.content);
	
	        case 1:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function interactionSagas() {
	  return regeneratorRuntime.wrap(function interactionSagas$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return [(0, _effects.fork)(targetFlow), (0, _effects.fork)(actionsReceivedWatch)];
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[3], this);
	}

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(669);
	} else {
	  module.exports = require('./configureStore.dev');
	}

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(73);
	
	var _modules = __webpack_require__(632);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _reduxThunk = __webpack_require__(575);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _sagas = __webpack_require__(666);
	
	var sagas = _interopRequireWildcard(_sagas);
	
	var _reduxSaga = __webpack_require__(99);
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _reduxActionBuffer = __webpack_require__(1283);
	
	var _reduxActionBuffer2 = _interopRequireDefault(_reduxActionBuffer);
	
	var _reduxPersistTransformExpire = __webpack_require__(1284);
	
	var _reduxPersistTransformExpire2 = _interopRequireDefault(_reduxPersistTransformExpire);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//eslint-disable-line
	var sagaMiddleware = (0, _reduxSaga2.default)();
	//const expireTransform = createExpirationTransform();
	
	//eslint-disable-line
	//import expireCookie from '../../util/persist/persistCookieTransform';
	
	//import {persistStore, autoRehydrate} from 'redux-persist';
	//import {REHYDRATE} from 'redux-persist/constants';
	function configureStore(initialState) {
	  // return createStore(rootReducer, initialState);
	  var store = (0, _redux.createStore)(_modules2.default, initialState, (0, _redux.compose)(
	  //autoRehydrate(),
	  //applyMiddleware(createActionBuffer(REHYDRATE, ['hg/common/TOGGLE_SPINNER', 'hg/content/SET_CONTENT']), thunk, sagaMiddleware),
	  (0, _redux.applyMiddleware)(_reduxThunk2.default, sagaMiddleware)));
	
	  //persistStore(store, {transforms: [expireTransform, expireCookie]});
	
	  // run saga watchers
	  _lodash2.default.values(sagas).forEach(sagaMiddleware.run);
	  return store;
	}

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFlow = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(16);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _directory = __webpack_require__(320);
	
	var _common = __webpack_require__(7);
	
	var _App = __webpack_require__(595);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _NotFoundPage = __webpack_require__(605);
	
	var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);
	
	var _OmniSalesPage = __webpack_require__(611);
	
	var _OmniSalesPage2 = _interopRequireDefault(_OmniSalesPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getFlow = exports.getFlow = function getFlow(dispatch) {
	  var flows = [{ "movers": _directory.moversFolder }, { "quickCheckout": _directory.checkoutFolder }, { "account": _directory.accountFolder }, { "myPlan": '' }];
	
	  var subRouteContainsFolder = function subRouteContainsFolder() {
	    var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	    var folder = arguments[1];
	    return route.indexOf(folder) > -1;
	  };
	
	  return function (nextState) {
	    var subRoute = _lodash2.default.get(nextState, 'routes[1].path');
	
	    flows.some(function (flow) {
	      var flowName = _lodash2.default.head(Object.keys(flow)),
	          flowFolder = flow[flowName];
	
	      return subRouteContainsFolder(subRoute, flowFolder) ? dispatch((0, _common.setFlow)(flowName)) : false;
	    });
	  };
	};
	
	// Omni flow pages
	
	
	var routes = function routes(store) {
	  return _react2.default.createElement(
	    _reactRouter.Route,
	    { path: '/', component: _App2.default, onEnter: getFlow(store) },
	    _react2.default.createElement(_reactRouter.IndexRoute, { component: _OmniSalesPage2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/omnisales', component: _OmniSalesPage2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _NotFoundPage2.default })
	  );
	};
	
	exports.default = routes;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(28);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import './badge.scss';
	
	var Badge = function (_Component) {
	  _inherits(Badge, _Component);
	
	  function Badge() {
	    _classCallCheck(this, Badge);
	
	    return _possibleConstructorReturn(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).apply(this, arguments));
	  }
	
	  _createClass(Badge, [{
	    key: 'render',
	    value: function render() {
	      var classes = 'hg-badge';
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(className, classes) },
	        children
	      );
	    }
	  }]);
	
	  return Badge;
	}(_react.Component);
	
	Badge.propTypes = {
	  children: _react.PropTypes.node.isRequired,
	  className: _react.PropTypes.string.isRequired
	};
	
	exports.default = Badge;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Badge = undefined;
	
	var _Badge = __webpack_require__(671);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Badge = _Badge2.default;

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(28);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styleMaps = {
	
	  SIZES: {
	    'large': 'lg',
	    'medium': 'md',
	    'small': 'sm',
	    'xsmall': 'xs',
	    'lg': 'lg',
	    'md': 'md',
	    'sm': 'sm',
	    'xs': 'xs'
	  },
	  GRID_COLUMNS: 12
	};
	
	// const Col = React.createClass({
	
	var Col = function (_Component) {
	  _inherits(Col, _Component);
	
	  function Col() {
	    _classCallCheck(this, Col);
	
	    return _possibleConstructorReturn(this, (Col.__proto__ || Object.getPrototypeOf(Col)).apply(this, arguments));
	  }
	
	  _createClass(Col, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var classes = {};
	
	      Object.keys(styleMaps.SIZES).forEach(function (key) {
	        var size = styleMaps.SIZES[key];
	        var prop = size;
	        var classPart = size + '-';
	
	        if (_this2.props[prop]) {
	          classes['col-' + classPart + _this2.props[prop]] = true;
	        }
	
	        classes['hidden-' + size] = _this2.props[size + 'Hidden'];
	
	        prop = size + 'Offset';
	        classPart = size + '-offset-';
	        if (_this2.props[prop] >= 0) {
	          classes['col-' + classPart + _this2.props[prop]] = true;
	        }
	
	        prop = size + 'Push';
	        classPart = size + '-push-';
	        if (_this2.props[prop] >= 0) {
	          classes['col-' + classPart + _this2.props[prop]] = true;
	        }
	
	        prop = size + 'Pull';
	        classPart = size + '-pull-';
	        if (_this2.props[prop] >= 0) {
	          classes['col-' + classPart + _this2.props[prop]] = true;
	        }
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(this.props.className, classes) },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Col;
	}(_react.Component);
	
	Col.propTypes = {
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _react.PropTypes.number,
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _react.PropTypes.number,
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _react.PropTypes.number,
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _react.PropTypes.number,
	
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _react.PropTypes.bool,
	
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _react.PropTypes.bool,
	
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _react.PropTypes.bool,
	
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _react.PropTypes.bool,
	
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _react.PropTypes.number,
	
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _react.PropTypes.number,
	
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _react.PropTypes.number,
	
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _react.PropTypes.number,
	
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _react.PropTypes.number,
	
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _react.PropTypes.number,
	
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _react.PropTypes.number,
	
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _react.PropTypes.number,
	
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _react.PropTypes.number,
	
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _react.PropTypes.number,
	
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _react.PropTypes.number,
	
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _react.PropTypes.number,
	
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _react.PropTypes.string,
	  children: _react.PropTypes.node.isRequired,
	  className: _react.PropTypes.string
	};
	
	exports.default = Col;

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(28);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_Component) {
	  _inherits(Container, _Component);
	
	  function Container() {
	    _classCallCheck(this, Container);
	
	    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
	  }
	
	  _createClass(Container, [{
	    key: 'render',
	    value: function render() {
	      var classes = 'container';
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(className, classes) },
	        children
	      );
	    }
	  }]);
	
	  return Container;
	}(_react.Component);
	
	Container.propTypes = {
	  children: _react.PropTypes.node.isRequired,
	  className: _react.PropTypes.string
	};
	
	exports.default = Container;

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(28);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Row = function (_Component) {
	  _inherits(Row, _Component);
	
	  function Row() {
	    _classCallCheck(this, Row);
	
	    return _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
	  }
	
	  _createClass(Row, [{
	    key: 'render',
	    value: function render() {
	      var classes = 'row';
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(className, classes) },
	        children
	      );
	    }
	  }]);
	
	  return Row;
	}(_react.Component);
	
	Row.propTypes = {
	  children: _react.PropTypes.node.isRequired,
	  className: _react.PropTypes.string
	};
	
	exports.default = Row;

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Container = exports.Col = exports.Row = undefined;
	
	var _Row = __webpack_require__(675);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Col = __webpack_require__(673);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _Container = __webpack_require__(674);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Row = _Row2.default;
	exports.Col = _Col2.default;
	exports.Container = _Container2.default;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _src = __webpack_require__(682);
	
	Object.keys(_src).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _src[key];
	    }
	  });
	});
	exports.default = _src.TimeSlotCalendar;

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(28);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeSlotRow = __webpack_require__(681);
	
	var _TimeSlotRow2 = _interopRequireDefault(_TimeSlotRow);
	
	var _TimeSlotRowHeader = __webpack_require__(680);
	
	var _TimeSlotRowHeader2 = _interopRequireDefault(_TimeSlotRowHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import './timeslotcalendar.scss';
	
	
	var TimeSlotCalendar = function (_Component) {
	  _inherits(TimeSlotCalendar, _Component);
	
	  function TimeSlotCalendar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TimeSlotCalendar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimeSlotCalendar.__proto__ || Object.getPrototypeOf(TimeSlotCalendar)).call.apply(_ref, [this].concat(args))), _this), _this.startDate = '', _this.startDay = '', _this.endDay = '', _this.page = -1, _this.step = 5, _this.numDays = 0, _this.sortTimeSlotsByDate = _lodash2.default.memoize(function (timeSlots) {
	      var sorted = [].concat(_toConsumableArray(timeSlots)).sort(function (a, b) {
	        // check if start time is the same, if so sort by endTime
	        if (a.startDateTime !== b.startDateTime) {
	          return (a.startDateTime || "").toLocaleLowerCase().localeCompare((b.startDateTime || "").toLocaleLowerCase());
	        } else {
	          return (a.endDateTime || "").toLocaleLowerCase().localeCompare((b.endDateTime || "").toLocaleLowerCase());
	        }
	      });
	
	      return sorted;
	    }), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TimeSlotCalendar, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !_lodash2.default.isEqual(this.props, nextProps) || this.startDate === '' || this.startDay === '' || this.endDay === '';
	    }
	  }, {
	    key: 'buildBetterTimeSlots',
	    // max number of days to show
	
	    // 1. gets an array of unique timeslots (time only)
	    // 2. adds utility properties to all time slots
	    // 3. groups all time slots by time slot
	    // 4. iterates over 28 days from the first timeSlot adding a day for each time slot
	    //    and appends this array of days to the unique time slots
	    // 5. ends up with an array of objects. one for unique timestamp which is a row in the cal
	    // 6. inside these time objects is an array of 28 days which contain the time slot for that day
	    // 7. the time slot for each day is all calculated relatively by the server response, no local dates are done
	    //    all time and date compuation are done based on server response but not relative to now (client)
	    // 8. a time slot has a boolean 'available' field designating availability. if no time slot is found in response
	    //    there will still be a slot but it wont have "availability"
	    // THIS SHOULD BE MODERATELY BULLETPROOF
	    // NOTE: time stamps are sorted by startTime first, then if startTime matches it will sort by endTime
	
	    value: function buildBetterTimeSlots(timeSlots) {
	      var _this2 = this;
	
	      var betterTimeSlots = timeSlots.map(function (timeSlot) {
	        var time = _this2.formatTimeSlot(timeSlot);
	
	        return _extends({}, timeSlot, time);
	      });
	
	      return betterTimeSlots;
	    }
	  }, {
	    key: 'buildTimeSlotsUnique',
	    value: function buildTimeSlotsUnique(timeSlotsOnly) {
	      var timeSlotsUnique = timeSlotsOnly.map(function (timeSlot) {
	        return _extends({}, timeSlot, {
	          days: []
	        });
	      });
	
	      return timeSlotsUnique;
	    }
	  }, {
	    key: 'getSelectedPage',
	    value: function getSelectedPage(timeSlots, selectedTimeSlotObj) {
	      if (!timeSlots || !selectedTimeSlotObj) {
	        return 0;
	      }
	
	      var sorted = this.sortTimeSlotsByDate(timeSlots);
	
	      if (!sorted.length) {
	        return 0;
	      }
	      var momentStartDay = (0, _moment2.default)(sorted[0].days[0].startDateTime);
	      var momentSelectedDay = (0, _moment2.default)(selectedTimeSlotObj.startDateTime);
	      var numDays = Math.abs(momentStartDay.diff(momentSelectedDay, 'days')) + 1;
	      var selectedPage = Math.ceil(numDays / 5) - 1;
	
	      return selectedPage;
	    }
	  }, {
	    key: 'getNumDays',
	    value: function getNumDays(timeSlots) {
	      if (!timeSlots) {
	        return;
	      }
	      var sorted = this.sortTimeSlotsByDate(timeSlots);
	
	      if (!sorted.length) {
	        return;
	      }
	      var startDay = _lodash2.default.head(sorted);
	      var endDay = _lodash2.default.last(sorted);
	
	      var momentStartDay = (0, _moment2.default)(startDay.startDateTime);
	      var momentEndDay = (0, _moment2.default)(endDay.endDateTime);
	
	      // gets absolute value of difference in days
	      var numDays = Math.abs(momentStartDay.diff(momentEndDay, 'days')) + 1;
	
	      this.numDays = numDays;
	
	      return numDays;
	    }
	  }, {
	    key: 'formatTimeSlot',
	    value: function formatTimeSlot(timeSlot) {
	      var momentStart = (0, _moment2.default)(timeSlot.startDateTime);
	      var momentEnd = (0, _moment2.default)(timeSlot.endDateTime);
	
	      // TODO FORMAT TIME AS TO UX STANDARDS
	      // Z times are 24 hour HHmm for sorting
	      var startTimeZ = momentStart.format('HHmm');
	      var endTimeZ = momentEnd.format('HHmm');
	
	      var dateString = momentEnd.format('YYYYMMDD');
	
	      // UX startTime and endTime
	      var startTime = momentStart.format('h:mmA');
	      var endTime = momentEnd.format('h:mmA');
	
	      // string of formatted time
	      var time = startTime + ' - ' + endTime;
	
	      return { startTime: startTime, endTime: endTime, startTimeZ: startTimeZ, endTimeZ: endTimeZ, formatted: time, dateString: dateString };
	    }
	
	    // used to get unique time slots, returns true if same time range
	
	  }, {
	    key: 'testTime',
	    value: function testTime(timeSlotA, timeSlotB) {
	      return timeSlotA.formatted === timeSlotB.formatted;
	    }
	
	    // build an array of unique timeslots formatted accordingly
	
	  }, {
	    key: 'getTimeSlotsOnly',
	    value: function getTimeSlotsOnly(timeSlots) {
	      var _this3 = this;
	
	      if (!timeSlots || !timeSlots.length) {
	        return;
	      }
	      // build time slots without dates (however it has a date string)
	      var justTimeSlots = timeSlots.map(function (timeSlot) {
	        return _this3.formatTimeSlot(timeSlot);
	      });
	
	      // get unique timeslots
	      var unique = _lodash2.default.uniqWith(justTimeSlots, this.testTime); // we need a custom compare method now because of dateString
	      //const unique = _.uniqWith(justTimeSlots, _.isEqual); // not used because datestring is unique
	
	      var sorted = unique.sort(function (a, b) {
	        // check if startTime is the same, if so sort by endTime
	        if (a.startTimeZ === b.startTimeZ) {
	          return a.endTimeZ - b.endTimeZ;
	        } else {
	          return a.startTimeZ - b.startTimeZ;
	        }
	      });
	
	      return sorted;
	    }
	
	    // finds the time slot in a list of timeSlots
	
	  }, {
	    key: 'findTimeSlot',
	    value: function findTimeSlot(timeSlots, timeRange, dateString) {
	      var ts = _lodash2.default.find(timeSlots, { 'formatted': timeRange, 'dateString': dateString });
	
	      return ts;
	    }
	  }, {
	    key: 'fillDays',
	    value: function fillDays(timeSlots, timeSlotsUnique, numDays) {
	      var _this4 = this;
	
	      if (!timeSlots || !timeSlotsUnique) {
	        return;
	      }
	
	      // sort time sortTimeStamps so we know which day to start on
	      var sorted = this.sortTimeSlotsByDate(timeSlots);
	
	      if (!sorted.length) {
	        return;
	      }
	      var startDay = (0, _moment2.default)(sorted[0].startDateTime); // this can only fail if there are no dates
	
	      this.startDate = (0, _moment2.default)(sorted[0].startDateTime).format('YYYYMMDD');
	
	      var timeSlotsFilled = timeSlotsUnique.map(function (timeSlot) {
	
	        // TODO: GET MAX DAYS FROM BACKEND (configurable)
	        for (var i = 0; i <= numDays; i++) {
	          var newDate = (0, _moment2.default)(startDay, "YYYYMMDD").add(i, 'days'); // add up to 28 days to first day
	          var newDateString = newDate.format('YYYYMMDD'); // format to match our date string
	          // this will find a time slot with a time range and a dateString
	          // if we dont find one we add an empty time range with available = false
	          var ts = _this4.findTimeSlot(timeSlots, timeSlot.formatted, newDateString);
	
	          if (ts) {
	            timeSlot.days.push(_extends({}, ts, {
	              available: true
	            }));
	          } else {
	            timeSlot.days.push({
	              formatted: timeSlot.formatted,
	              dateString: newDateString,
	              available: false
	            });
	          }
	        }
	        return timeSlot;
	      });
	
	      return timeSlotsFilled;
	    }
	
	    // TODO: this will need optimization not to duplicate all data calc
	    // this has a problem with days out of range
	
	  }, {
	    key: 'updateDays',
	    value: function updateDays(fillDays) {
	      if (!fillDays) {
	        return;
	      }
	
	      // TODO: this logic should be done at the global level and then passed down
	      // this is required for the row and header (startDay & endDay)
	      var start = 0 + this.step * this.page;
	      var end = 0 + this.step * (this.page + 1) - 1;
	
	      while (end >= this.numDays) {
	        end--;
	        start--;
	      }
	      var startDay = fillDays[0].days[start];
	      var endDay = fillDays[0].days[end];
	
	      // it should not reach here but just in case lets not render a day out of bounds
	      if (!startDay || !endDay) {
	        return;
	      }
	
	      this.startDay = (0, _moment2.default)(startDay.dateString).format('MMM DD, YYYY');
	      this.endDay = (0, _moment2.default)(endDay.dateString).format('MMM DD, YYYY');
	
	      return this.startDay + ' - ' + this.endDay;
	    }
	  }, {
	    key: 'timeSlotFunc',
	    value: function timeSlotFunc(timeSlots) {
	
	      if (!timeSlots || !timeSlots.length) {
	        return;
	      }
	      // get unique time slot
	
	      var numDays = this.getNumDays(timeSlots);
	
	      if (numDays < 5) {
	        numDays = 5;
	        this.numDays = numDays;
	      }
	
	      var timeSlotsOnly = this.getTimeSlotsOnly(timeSlots);
	
	      // get unique time slots with empty day array
	      var timeSlotsUnique = this.buildTimeSlotsUnique(timeSlotsOnly);
	
	      // time slots with startTime, endTime, startTimeZ, endTimeZ, formatted, day
	      var betterTimeSlots = this.buildBetterTimeSlots(timeSlots);
	
	      // time slots with 28 days full
	      var fillDays = this.fillDays(betterTimeSlots, timeSlotsUnique, numDays);
	
	      return fillDays;
	    }
	
	    // TODO: forceUpdate is not deal. Find a better way to do this
	
	  }, {
	    key: 'handleBack',
	    value: function handleBack() {
	      if (this.page > 0) {
	        this.page--;
	      }
	      this.forceUpdate();
	    }
	
	    // TODO: forceUpdate is not deal. Find a better way to do this
	
	  }, {
	    key: 'handleForward',
	    value: function handleForward() {
	      if (this.page <= 5) {
	        this.page++;
	      }
	      this.forceUpdate();
	    }
	  }, {
	    key: 'backDisabled',
	    value: function backDisabled() {
	      if (this.page <= 0) return true;
	    }
	  }, {
	    key: 'forwardDisabled',
	    value: function forwardDisabled() {
	      var numPages = Math.ceil(this.numDays / 5);
	
	      if (this.page >= numPages - 1) return true;
	    }
	
	    // renders time slots unique array
	
	  }, {
	    key: 'renderTimeSlots',
	    value: function renderTimeSlots(timeSlots) {
	      var _this5 = this;
	
	      if (!timeSlots) return;
	      if (this.page < 0) {
	        this.page = this.getSelectedPage(timeSlots, this.props.selectedTimeSlotObj);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: '' },
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(_TimeSlotRowHeader2.default, { days: timeSlots[0].days, startDate: this.startDate, page: this.page, numDaysShow: this.step, numDays: this.numDays }),
	            timeSlots.map(function (timeSlot, i) {
	              return _react2.default.createElement(_TimeSlotRow2.default, {
	                days: timeSlot.days,
	                startDate: _this5.startDate,
	                page: _this5.page,
	                numDaysShow: _this5.step,
	                numDays: _this5.numDays,
	                key: i,
	                setSelectedTimeSlot: _this5.props.setSelectedTimeSlot,
	                selectedTimeSlot: _this5.props.selectedTimeSlot
	              });
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classes = 'hg-timeSlotCalendar hidden-sm-down';
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          timeSlots = _props.timeSlots;
	
	      // conditionally enable or disable back and forward on the cal
	
	      var backClickable = !this.backDisabled() ? this.handleBack.bind(this) : null;
	      var forwardClickable = !this.forwardDisabled() ? this.handleForward.bind(this) : null;
	
	      return (
	        // TODO: fix update days not to use timeSlotFunc because it's expensive
	        _react2.default.createElement(
	          'div',
	          _extends({}, this.props, { className: (0, _classnames2.default)(className, classes) }),
	          _react2.default.createElement(
	            'div',
	            { className: 's-install--head' },
	            _react2.default.createElement(
	              'button',
	              { 'data-tracking': {}, type: 'button', className: (0, _classnames2.default)('s-install--arrow', 's-install--arrow-left', { disabled: this.backDisabled() }), disabled: this.backDisabled(), onClick: backClickable },
	              _react2.default.createElement(
	                'span',
	                { className: 'vh' },
	                'Previous'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 's-install--date-range x-heading3' },
	              this.updateDays(this.timeSlotFunc(timeSlots))
	            ),
	            _react2.default.createElement(
	              'button',
	              { 'data-tracking': {}, type: 'button', className: (0, _classnames2.default)('s-install--arrow', 's-install--arrow-right', { disabled: this.forwardDisabled() }), disabled: this.forwardDisabled(), onClick: forwardClickable },
	              _react2.default.createElement(
	                'span',
	                { className: 'vh' },
	                'Next'
	              )
	            )
	          ),
	          this.renderTimeSlots(this.timeSlotFunc(timeSlots)),
	          children
	        )
	      );
	    }
	  }]);
	
	  return TimeSlotCalendar;
	}(_react.Component);
	
	TimeSlotCalendar.propTypes = {
	  children: _react.PropTypes.node,
	  timeSlots: _react.PropTypes.array,
	  selectedTimeSlotObj: _react.PropTypes.object,
	  setSelectedTimeSlot: _react.PropTypes.func,
	  selectedTimeSlot: _react.PropTypes.string,
	  className: _react.PropTypes.string
	};
	
	exports.default = TimeSlotCalendar;

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(28);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimeSlotDay = function (_Component) {
	  _inherits(TimeSlotDay, _Component);
	
	  function TimeSlotDay() {
	    _classCallCheck(this, TimeSlotDay);
	
	    return _possibleConstructorReturn(this, (TimeSlotDay.__proto__ || Object.getPrototypeOf(TimeSlotDay)).apply(this, arguments));
	  }
	
	  _createClass(TimeSlotDay, [{
	    key: 'handleTimeSlotsSelect',
	    value: function handleTimeSlotsSelect() {
	      this.props.dispatchSelectTimeSlot(this.props.day.id);
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected() {
	      return this.props.selectedTimeSlot === this.props.day.id;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          day = _props.day;
	
	
	      if (!day) return;
	
	      var classes = 'hg-timeSlotDay';
	      var clickable = day.available ? this.handleTimeSlotsSelect.bind(this, day.id) : null;
	
	      return _react2.default.createElement(
	        'td',
	        { className: (0, _classnames2.default)(className, classes, { selected: this.getSelected() }) },
	        _react2.default.createElement(
	          'button',
	          { type: 'button', className: (0, _classnames2.default)('s-install--content', 'x-body1', { disabled: !day.available }), onClick: clickable, disabled: !day.available },
	          day.formatted
	        ),
	        children
	      );
	    }
	  }]);
	
	  return TimeSlotDay;
	}(_react.Component);
	
	TimeSlotDay.propTypes = {
	  children: _react.PropTypes.node,
	  dispatchSelectTimeSlot: _react.PropTypes.func.isRequired,
	  className: _react.PropTypes.object,
	  selectedTimeSlot: _react.PropTypes.string,
	  day: _react.PropTypes.object.isRequired,
	  setSelectedTimeSlot: _react.PropTypes.func
	};
	
	exports.default = TimeSlotDay;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(28);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimeSlotRowHeader = function (_Component) {
	  _inherits(TimeSlotRowHeader, _Component);
	
	  function TimeSlotRowHeader() {
	    _classCallCheck(this, TimeSlotRowHeader);
	
	    return _possibleConstructorReturn(this, (TimeSlotRowHeader.__proto__ || Object.getPrototypeOf(TimeSlotRowHeader)).apply(this, arguments));
	  }
	
	  _createClass(TimeSlotRowHeader, [{
	    key: 'renderTds',
	    value: function renderTds(days, numDaysShow, page, numDays) {
	      // TODO: this needs to be passed in because this logic should be handled by
	      // the cal and passed to this component
	      var temp = [];
	      var start = 0 + page * numDaysShow;
	      var end = start + numDaysShow;
	
	      while (end > numDays) {
	        end--;
	        start--;
	      }
	
	      for (var i = start; i < end; i++) {
	        temp.push(days[i]);
	      }
	
	      return temp;
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(day) {
	      var momentStart = (0, _moment2.default)(day.dateString);
	      var date = momentStart.format('ddd DD');
	
	      return date;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var classes = 'hg-TimeSlotRowHeader';
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          days = _props.days,
	          numDaysShow = _props.numDaysShow,
	          numDays = _props.numDays,
	          page = _props.page;
	
	
	      if (!days || !days.length) return null;
	
	      return _react2.default.createElement(
	        'tr',
	        _extends({}, this.props, { className: (0, _classnames2.default)(className, classes) }),
	        this.renderTds(days, numDaysShow, page, numDays).map(function (day, i) {
	          return _react2.default.createElement(
	            'th',
	            { key: i, day: day },
	            _react2.default.createElement(
	              'div',
	              { className: 's-install--content x-body2' },
	              _this2.formatDate(day)
	            )
	          );
	        }),
	        children
	      );
	    }
	  }]);
	
	  return TimeSlotRowHeader;
	}(_react.Component);
	
	TimeSlotRowHeader.propTypes = {
	  children: _react.PropTypes.node,
	  days: _react.PropTypes.array.isRequired,
	  className: _react.PropTypes.string,
	  startDate: _react.PropTypes.string.isRequired,
	  numDaysShow: _react.PropTypes.number.isRequired,
	  numDays: _react.PropTypes.number.isRequired,
	  page: _react.PropTypes.number.isRequired
	};
	
	exports.default = TimeSlotRowHeader;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(28);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TimeSlotDay = __webpack_require__(679);
	
	var _TimeSlotDay2 = _interopRequireDefault(_TimeSlotDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import './TimeSlotRow.scss';
	
	
	var TimeSlotRow = function (_Component) {
	  _inherits(TimeSlotRow, _Component);
	
	  function TimeSlotRow() {
	    _classCallCheck(this, TimeSlotRow);
	
	    return _possibleConstructorReturn(this, (TimeSlotRow.__proto__ || Object.getPrototypeOf(TimeSlotRow)).apply(this, arguments));
	  }
	
	  _createClass(TimeSlotRow, [{
	    key: 'renderTds',
	    value: function renderTds(days, numDaysShow, page, numDays) {
	      // TODO: this needs to be passed in because this logic should be handled by
	      // the cal and passed to this component
	      var temp = [];
	      var start = 0 + page * numDaysShow;
	      var end = start + numDaysShow;
	
	      while (end > numDays) {
	        end--;
	        start--;
	      }
	
	      for (var i = start; i < end; i++) {
	        temp.push(days[i]);
	      }
	
	      return temp;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classes = 'hg-timeSlotRow';
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          days = _props.days,
	          numDaysShow = _props.numDaysShow,
	          numDays = _props.numDays,
	          page = _props.page,
	          setSelectedTimeSlot = _props.setSelectedTimeSlot,
	          selectedTimeSlot = _props.selectedTimeSlot;
	
	
	      if (!days) return;
	
	      return _react2.default.createElement(
	        'tr',
	        _extends({}, this.props, { className: (0, _classnames2.default)(className, classes) }),
	        this.renderTds(days, numDaysShow, page, numDays).map(function (day, i) {
	          return _react2.default.createElement(_TimeSlotDay2.default, {
	            key: i,
	            day: day,
	            dispatchSelectTimeSlot: setSelectedTimeSlot,
	            selectedTimeSlot: selectedTimeSlot
	          });
	        }),
	        children
	      );
	    }
	  }]);
	
	  return TimeSlotRow;
	}(_react.Component);
	
	TimeSlotRow.propTypes = {
	  children: _react.PropTypes.node,
	  days: _react.PropTypes.array.isRequired,
	  className: _react.PropTypes.string,
	  startDate: _react.PropTypes.string.isRequired,
	  numDaysShow: _react.PropTypes.number.isRequired,
	  numDays: _react.PropTypes.number.isRequired,
	  page: _react.PropTypes.number.isRequired,
	  setSelectedTimeSlot: _react.PropTypes.func,
	  selectedTimeSlot: _react.PropTypes.string
	};
	
	exports.default = TimeSlotRow;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimeSlotCalendar = undefined;
	
	var _calendar = __webpack_require__(683);
	
	Object.keys(_calendar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _calendar[key];
	    }
	  });
	});
	
	var _TimeSlotCalendar2 = __webpack_require__(678);
	
	var _TimeSlotCalendar3 = _interopRequireDefault(_TimeSlotCalendar2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.TimeSlotCalendar = _TimeSlotCalendar3.default;

/***/ },
/* 683 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var UPDATE_CALENDAR_CONTROLS = exports.UPDATE_CALENDAR_CONTROLS = 'hg/calendar/UPDATE_CALENDAR_CONTROLS';
	
	var initialState = exports.initialState = {
	  calendarControls: {
	    timeSlots: [],
	    page: 0,
	    step: 5
	  }
	};
	
	var calendar = exports.calendar = function calendar() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	
	    case UPDATE_CALENDAR_CONTROLS:
	      return _extends({}, state, {
	        calendarControls: _extends({}, state.calendarControls, action.calendarControls)
	      });
	
	    default:
	      return state;
	  }
	};
	
	// Action Creators
	var updateCalendarControls = exports.updateCalendarControls = function updateCalendarControls(calendarControls) {
	  return {
	    type: UPDATE_CALENDAR_CONTROLS,
	    calendarControls: calendarControls
	  };
	};
	
	exports.default = calendar;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _src = __webpack_require__(686);
	
	Object.keys(_src).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _src[key];
	    }
	  });
	});
	exports.default = _src.contentProvider;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.inject = exports.Content = exports.DEFAULT_VAL = exports.reducer = exports.initialState = exports.UPDATE_CONTENT = exports.SET_CONTENT = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _server = __webpack_require__(536);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SET_CONTENT = exports.SET_CONTENT = 'hg/content/SET_CONTENT';
	var UPDATE_CONTENT = exports.UPDATE_CONTENT = 'hg/content/UPDATE_CONTENT';
	
	var initialState = exports.initialState = {
	  content: {},
	  isDefaultContent: false,
	  initialized: false,
	  rawContent: {},
	  newContent: {}
	};
	
	var reducer = exports.reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	
	    case SET_CONTENT:
	      return _extends({}, state, {
	        content: action.content,
	        rawContent: action.rawContent,
	        isDefaultContent: action.isDefaultContent,
	        initialized: true
	      });
	    case UPDATE_CONTENT:
	      return _extends({}, state, {
	        content: action.content,
	        newContent: action.newContent
	      });
	
	    default:
	      return state;
	  }
	};
	
	// default to empty string in prod
	var DEFAULT_VAL = exports.DEFAULT_VAL =  true ? '' : 'DEFAULT_VAL';
	
	var normalizeContent = function normalizeContent(rawContent) {
	  return rawContent;
	};
	
	var ContentProvider = function () {
	  function ContentProvider() {
	    _classCallCheck(this, ContentProvider);
	  }
	
	  _createClass(ContentProvider, [{
	    key: 'setStore',
	    value: function setStore(store) {
	      // allow passing a custome store for testing with a mocked store
	      this.store = store;
	    }
	  }, {
	    key: 'getStore',
	    value: function getStore() {
	      return this.store;
	    }
	  }, {
	    key: 'setContent',
	    value: function setContent(rawContent) {
	      var isDefaultContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var state = this.getStore().getState();
	      var content = normalizeContent(rawContent, state);
	
	      this.getStore().dispatch({
	        type: SET_CONTENT,
	        content: content,
	        rawContent: rawContent,
	        isDefaultContent: isDefaultContent
	      });
	    }
	  }, {
	    key: 'updateContent',
	    value: function updateContent(contentToInject) {
	      var state = this.getStore().getState();
	
	      // prevent content update before content is initialized
	      if (!state.contentProvider.initialized) {
	        return;
	      }
	      var existingNewContent = state.contentProvider.newContent;
	      var newContent = Object.assign({}, existingNewContent, contentToInject);
	      var content = Object.assign({}, this.getContent(), contentToInject);
	
	      this.getStore().dispatch({
	        type: UPDATE_CONTENT,
	        content: content,
	        newContent: newContent
	      });
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      var state = this.getStore().getState();
	
	      if (!state.contentProvider.initialized) {
	        return {};
	      }
	
	      return state.contentProvider.content;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue(key) {
	      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_VAL;
	
	      var content = _lodash2.default.get(this.getContent(), key, defaultValue);
	
	      return inject(content, params);
	    }
	  }, {
	    key: 'contentExists',
	    value: function contentExists(key) {
	      return !!_lodash2.default.get(this.getContent(), key);
	    }
	  }]);
	
	  return ContentProvider;
	}();
	
	//IMORTANT: 'key' and 'for' are reserved prop names. Using 'contentKey' instead
	
	
	var Content = exports.Content = function Content(_ref) {
	  var contentKey = _ref.contentKey,
	      params = _ref.params,
	      defaultValue = _ref.defaultValue;
	
	
	  return (/*eslint-disable react/no-danger*/ //disable dangerouslySetInnerHTML warning
	    _react2.default.createElement(
	      'span',
	      { className: 'content', 'data-content-key': contentKey },
	      _react2.default.createElement('span', { className: 'content-value', dangerouslySetInnerHTML: { __html: contentInstance.getValue(contentKey, params, defaultValue) } }),
	      _react2.default.createElement(
	        'span',
	        { className: 'content-key' },
	        contentKey
	      )
	    )
	  );
	};
	
	Content.propTypes = {
	  contentKey: _react.PropTypes.string.isRequired,
	  params: _react.PropTypes.array,
	  defaultValue: _react.PropTypes.string
	};
	
	var inject = exports.inject = function inject(string) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var result = string.replace(/\$\{p(\d)\}/g, function (match, id) {
	    var paramsVal = params[id - 1];
	
	    return _react2.default.isValidElement(paramsVal) ? (0, _server.renderToString)(paramsVal) : paramsVal;
	  });
	
	  return result;
	};
	
	//Ensure only a singleton is exported
	var contentInstance = new ContentProvider();
	
	exports.default = contentInstance;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.inject = exports.reducer = exports.Content = exports.DEFAULT_VAL = exports.SET_CONTENT = exports.contentProvider = undefined;
	
	var _contentProvider = __webpack_require__(685);
	
	var _contentProvider2 = _interopRequireDefault(_contentProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.contentProvider = _contentProvider2.default;
	exports.SET_CONTENT = _contentProvider.SET_CONTENT;
	exports.DEFAULT_VAL = _contentProvider.DEFAULT_VAL;
	exports.Content = _contentProvider.Content;
	exports.reducer = _contentProvider.reducer;
	exports.inject = _contentProvider.inject;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PROXY_PREFIX = exports.PROXY_PREFIX = 'http://local.omni.cws.xfinity.com:3003/';
	
	// export const BASE_URL = `${PROXY_PREFIX}http://ebzweb-dt-1d12:85`;
	//export const BASE_URL = '';
	
	var BASE_URL = exports.BASE_URL =  true ? '' : process.env.MOCK ? PROXY_PREFIX + 'http://localhost:3005' : PROXY_PREFIX + 'http://www.dev12.xfinity.com';
	
	//  : (process.env.MOCK)? `${PROXY_PREFIX}http://localhost:3005` : `${PROXY_PREFIX}http://myplan.xfinity.com:8080`;
	//export const BASE_URL = process.env.NODE_ENV === 'production' ? `` : `${PROXY_PREFIX}http://localhost:3005`;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactCookie = __webpack_require__(509);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getUserId: function getUserId() {
	    var content = _reactCookie2.default.load('SC') || '';
	
	    var accountIdKV = content.split('&').filter(function (params) {
	      return params.match(/RC\.ACCT=/);
	    }).map(function (params) {
	      return params.split('=');
	    }).map(function (params) {
	      return params[1];
	    });
	
	    var accountId = accountIdKV.length ? accountIdKV[0] : null;
	
	    return accountId;
	  },
	  getADB: function getADB() {
	    var content = _reactCookie2.default.load('ADB') || '';
	
	    return content;
	  },
	  isAuth: function isAuth() {
	    var content = _reactCookie2.default.load('isAuth') || '';
	
	    return content;
	  }
	};

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(698);
	module.exports = __webpack_require__(58).RegExp.escape;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(14)
	  , isArray  = __webpack_require__(209)
	  , SPECIES  = __webpack_require__(15)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(690);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(6)
	  , toPrimitive = __webpack_require__(53)
	  , NUMBER      = 'number';
	
	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ },
/* 693 */
[1292, 82, 153, 127],
/* 694 */
[1304, 82, 35],
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(696)
	  , invoke    = __webpack_require__(149)
	  , aFunction = __webpack_require__(31);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(8);

/***/ },
/* 697 */
/***/ function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(1)
	  , $re     = __webpack_require__(697)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(323)});
	
	__webpack_require__(101)('copyWithin');

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $every  = __webpack_require__(51)(4);
	
	$export($export.P + $export.F * !__webpack_require__(47)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', {fill: __webpack_require__(201)});
	
	__webpack_require__(101)('fill');

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $filter = __webpack_require__(51)(2);
	
	$export($export.P + $export.F * !__webpack_require__(47)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(1)
	  , $find   = __webpack_require__(51)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(101)(KEY);

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(1)
	  , $find   = __webpack_require__(51)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(101)(KEY);

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(1)
	  , $forEach = __webpack_require__(51)(0)
	  , STRICT   = __webpack_require__(47)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 706 */
[1331, 59, 1, 25, 332, 208, 23, 202, 225, 151],
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(1)
	  , $indexOf      = __webpack_require__(145)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(47)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Array', {isArray: __webpack_require__(209)});

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(1)
	  , toIObject = __webpack_require__(35)
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(126) != Object || !__webpack_require__(47)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(1)
	  , toIObject     = __webpack_require__(35)
	  , toInteger     = __webpack_require__(69)
	  , toLength      = __webpack_require__(23)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(47)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $map    = __webpack_require__(51)(1);
	
	$export($export.P + $export.F * !__webpack_require__(47)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(1)
	  , createProperty = __webpack_require__(202);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(12)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $reduce = __webpack_require__(325);
	
	$export($export.P + $export.F * !__webpack_require__(47)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $reduce = __webpack_require__(325);
	
	$export($export.P + $export.F * !__webpack_require__(47)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(1)
	  , html       = __webpack_require__(206)
	  , cof        = __webpack_require__(45)
	  , toIndex    = __webpack_require__(85)
	  , toLength   = __webpack_require__(23)
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(12)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $some   = __webpack_require__(51)(3);
	
	$export($export.P + $export.F * !__webpack_require__(47)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(1)
	  , aFunction = __webpack_require__(31)
	  , toObject  = __webpack_require__(25)
	  , fails     = __webpack_require__(12)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(47)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(84)('Array');

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(1)
	  , fails   = __webpack_require__(12)
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(1)
	  , toObject    = __webpack_require__(25)
	  , toPrimitive = __webpack_require__(53);
	
	$export($export.P + $export.F * __webpack_require__(12)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(15)('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__(32)(proto, TO_PRIMITIVE, __webpack_require__(692));

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(33)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Function', {bind: __webpack_require__(326)});

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(14)
	  , getPrototypeOf = __webpack_require__(40)
	  , HAS_INSTANCE   = __webpack_require__(15)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(18).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(18).f
	  , createDesc = __webpack_require__(68)
	  , has        = __webpack_require__(29)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(17) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(1)
	  , log1p   = __webpack_require__(334)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(1)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(1)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(1)
	  , sign    = __webpack_require__(213);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(1)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(1)
	  , $expm1  = __webpack_require__(212);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(1)
	  , sign      = __webpack_require__(213)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(1)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(1)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(12)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(334)});

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {sign: __webpack_require__(213)});

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(1)
	  , expm1   = __webpack_require__(212)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(12)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(1)
	  , expm1   = __webpack_require__(212)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(8)
	  , has               = __webpack_require__(29)
	  , cof               = __webpack_require__(45)
	  , inheritIfRequired = __webpack_require__(207)
	  , toPrimitive       = __webpack_require__(53)
	  , fails             = __webpack_require__(12)
	  , gOPN              = __webpack_require__(81).f
	  , gOPD              = __webpack_require__(39).f
	  , dP                = __webpack_require__(18).f
	  , $trim             = __webpack_require__(105).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(80)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(17) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(33)(global, NUMBER, $Number);
	}

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(1)
	  , _isFinite = __webpack_require__(8).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(331)});

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },
/* 749 */
[1333, 1, 331],
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(1)
	  , $parseFloat = __webpack_require__(341);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(1)
	  , $parseInt = __webpack_require__(342);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(1)
	  , toInteger    = __webpack_require__(69)
	  , aNumberValue = __webpack_require__(322)
	  , repeat       = __webpack_require__(220)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(12)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(1)
	  , $fails       = __webpack_require__(12)
	  , aNumberValue = __webpack_require__(322)
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ },
/* 756 */
[1334, 1, 335],
/* 757 */
[1335, 1, 80],
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(17), 'Object', {defineProperties: __webpack_require__(336)});

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(17), 'Object', {defineProperty: __webpack_require__(18).f});

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(14)
	  , meta     = __webpack_require__(67).onFreeze;
	
	__webpack_require__(52)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(35)
	  , $getOwnPropertyDescriptor = __webpack_require__(39).f;
	
	__webpack_require__(52)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 762 */
[1336, 52, 337],
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(25)
	  , $getPrototypeOf = __webpack_require__(40);
	
	__webpack_require__(52)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(52)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(52)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(52)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', {is: __webpack_require__(343)});

/***/ },
/* 768 */
[1337, 25, 82, 52],
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(14)
	  , meta     = __webpack_require__(67).onFreeze;
	
	__webpack_require__(52)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(14)
	  , meta     = __webpack_require__(67).onFreeze;
	
	__webpack_require__(52)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ },
/* 771 */
[1338, 1, 215],
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(125)
	  , test    = {};
	test[__webpack_require__(15)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(33)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(1)
	  , $parseFloat = __webpack_require__(341);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(1)
	  , $parseInt = __webpack_require__(342);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(79)
	  , global             = __webpack_require__(8)
	  , ctx                = __webpack_require__(59)
	  , classof            = __webpack_require__(125)
	  , $export            = __webpack_require__(1)
	  , isObject           = __webpack_require__(14)
	  , aFunction          = __webpack_require__(31)
	  , anInstance         = __webpack_require__(78)
	  , forOf              = __webpack_require__(102)
	  , speciesConstructor = __webpack_require__(217)
	  , task               = __webpack_require__(222).set
	  , microtask          = __webpack_require__(214)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(15)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(83)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(104)($Promise, PROMISE);
	__webpack_require__(84)(PROMISE);
	Wrapper = __webpack_require__(58)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(151)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(1)
	  , aFunction = __webpack_require__(31)
	  , anObject  = __webpack_require__(6)
	  , rApply    = (__webpack_require__(8).Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(12)(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__(1)
	  , create     = __webpack_require__(80)
	  , aFunction  = __webpack_require__(31)
	  , anObject   = __webpack_require__(6)
	  , isObject   = __webpack_require__(14)
	  , fails      = __webpack_require__(12)
	  , bind       = __webpack_require__(326)
	  , rConstruct = (__webpack_require__(8).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(18)
	  , $export     = __webpack_require__(1)
	  , anObject    = __webpack_require__(6)
	  , toPrimitive = __webpack_require__(53);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(12)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(1)
	  , gOPD     = __webpack_require__(39).f
	  , anObject = __webpack_require__(6);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(1)
	  , anObject = __webpack_require__(6);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(210)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(39)
	  , $export  = __webpack_require__(1)
	  , anObject = __webpack_require__(6);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(1)
	  , getProto = __webpack_require__(40)
	  , anObject = __webpack_require__(6);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(39)
	  , getPrototypeOf = __webpack_require__(40)
	  , has            = __webpack_require__(29)
	  , $export        = __webpack_require__(1)
	  , isObject       = __webpack_require__(14)
	  , anObject       = __webpack_require__(6);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(1)
	  , anObject      = __webpack_require__(6)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(340)});

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(1)
	  , anObject           = __webpack_require__(6)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(1)
	  , setProto = __webpack_require__(215);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(18)
	  , gOPD           = __webpack_require__(39)
	  , getPrototypeOf = __webpack_require__(40)
	  , has            = __webpack_require__(29)
	  , $export        = __webpack_require__(1)
	  , createDesc     = __webpack_require__(68)
	  , anObject       = __webpack_require__(6)
	  , isObject       = __webpack_require__(14);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(8)
	  , inheritIfRequired = __webpack_require__(207)
	  , dP                = __webpack_require__(18).f
	  , gOPN              = __webpack_require__(81).f
	  , isRegExp          = __webpack_require__(150)
	  , $flags            = __webpack_require__(148)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(17) && (!CORRECT_NEW || __webpack_require__(12)(function(){
	  re2[__webpack_require__(15)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(33)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(84)('RegExp');

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(147)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(147)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(147)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(147)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(150)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(347);
	var anObject    = __webpack_require__(6)
	  , $flags      = __webpack_require__(148)
	  , DESCRIPTORS = __webpack_require__(17)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__(33)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(12)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(34)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(34)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(34)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(34)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $at     = __webpack_require__(218)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(1)
	  , toLength  = __webpack_require__(23)
	  , context   = __webpack_require__(219)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(205)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(34)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(34)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(34)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(1)
	  , toIndex        = __webpack_require__(85)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(1)
	  , context  = __webpack_require__(219)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(205)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(34)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ },
/* 808 */
[1339, 218, 211],
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(34)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(1)
	  , toIObject = __webpack_require__(35)
	  , toLength  = __webpack_require__(23);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(220)
	});

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(34)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(1)
	  , toLength    = __webpack_require__(23)
	  , context     = __webpack_require__(219)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(205)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(34)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(34)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(34)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(105)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ },
/* 818 */
[1340, 8, 29, 17, 1, 33, 67, 12, 154, 104, 86, 15, 345, 224, 694, 693, 209, 6, 35, 53, 68, 80, 337, 39, 18, 82, 81, 127, 153, 79, 32],
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(1)
	  , $typed       = __webpack_require__(155)
	  , buffer       = __webpack_require__(223)
	  , anObject     = __webpack_require__(6)
	  , toIndex      = __webpack_require__(85)
	  , toLength     = __webpack_require__(23)
	  , isObject     = __webpack_require__(14)
	  , ArrayBuffer  = __webpack_require__(8).ArrayBuffer
	  , speciesConstructor = __webpack_require__(217)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(12)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(84)(ARRAY_BUFFER);

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	$export($export.G + $export.W + $export.F * !__webpack_require__(155).ABV, {
	  DataView: __webpack_require__(223).DataView
	});

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(61)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(329);
	
	// 23.4 WeakSet Objects
	__webpack_require__(146)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(1)
	  , $includes = __webpack_require__(145)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(101)('includes');

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(1)
	  , microtask = __webpack_require__(214)()
	  , process   = __webpack_require__(8).process
	  , isNode    = __webpack_require__(45)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(1)
	  , cof     = __webpack_require__(45);
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(328)('Map')});

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(1)
	  , toObject        = __webpack_require__(25)
	  , aFunction       = __webpack_require__(31)
	  , $defineProperty = __webpack_require__(18);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(17) && $export($export.P + __webpack_require__(152), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(1)
	  , toObject        = __webpack_require__(25)
	  , aFunction       = __webpack_require__(31)
	  , $defineProperty = __webpack_require__(18);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(17) && $export($export.P + __webpack_require__(152), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(1)
	  , $entries = __webpack_require__(339)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(1)
	  , ownKeys        = __webpack_require__(340)
	  , toIObject      = __webpack_require__(35)
	  , gOPD           = __webpack_require__(39)
	  , createProperty = __webpack_require__(202);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(1)
	  , toObject                 = __webpack_require__(25)
	  , toPrimitive              = __webpack_require__(53)
	  , getPrototypeOf           = __webpack_require__(40)
	  , getOwnPropertyDescriptor = __webpack_require__(39).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(17) && $export($export.P + __webpack_require__(152), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(1)
	  , toObject                 = __webpack_require__(25)
	  , toPrimitive              = __webpack_require__(53)
	  , getPrototypeOf           = __webpack_require__(40)
	  , getOwnPropertyDescriptor = __webpack_require__(39).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(17) && $export($export.P + __webpack_require__(152), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1)
	  , $values = __webpack_require__(339)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(1)
	  , global      = __webpack_require__(8)
	  , core        = __webpack_require__(58)
	  , microtask   = __webpack_require__(214)()
	  , OBSERVABLE  = __webpack_require__(15)('observable')
	  , aFunction   = __webpack_require__(31)
	  , anObject    = __webpack_require__(6)
	  , anInstance  = __webpack_require__(78)
	  , redefineAll = __webpack_require__(83)
	  , hide        = __webpack_require__(32)
	  , forOf       = __webpack_require__(102)
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__(84)('Observable');

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(60)
	  , anObject                  = __webpack_require__(6)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(60)
	  , anObject               = __webpack_require__(6)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(348)
	  , from                    = __webpack_require__(324)
	  , metadata                = __webpack_require__(60)
	  , anObject                = __webpack_require__(6)
	  , getPrototypeOf          = __webpack_require__(40)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(60)
	  , anObject               = __webpack_require__(6)
	  , getPrototypeOf         = __webpack_require__(40)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(60)
	  , anObject                = __webpack_require__(6)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(60)
	  , anObject               = __webpack_require__(6)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(60)
	  , anObject               = __webpack_require__(6)
	  , getPrototypeOf         = __webpack_require__(40)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(60)
	  , anObject               = __webpack_require__(6)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(60)
	  , anObject                  = __webpack_require__(6)
	  , aFunction                 = __webpack_require__(31)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(328)('Set')});

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(1)
	  , $at     = __webpack_require__(218)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(1)
	  , defined     = __webpack_require__(46)
	  , toLength    = __webpack_require__(23)
	  , isRegExp    = __webpack_require__(150)
	  , getFlags    = __webpack_require__(148)
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(210)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1)
	  , $pad    = __webpack_require__(344);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1)
	  , $pad    = __webpack_require__(344);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(105)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(105)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ },
/* 863 */
[1341, 224],
/* 864 */
[1342, 224],
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.S, 'System', {global: __webpack_require__(8)});

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(226)
	  , redefine      = __webpack_require__(33)
	  , global        = __webpack_require__(8)
	  , hide          = __webpack_require__(32)
	  , Iterators     = __webpack_require__(103)
	  , wks           = __webpack_require__(15)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	  , $task   = __webpack_require__(222);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(8)
	  , $export    = __webpack_require__(1)
	  , invoke     = __webpack_require__(149)
	  , partial    = __webpack_require__(695)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(818);
	__webpack_require__(757);
	__webpack_require__(759);
	__webpack_require__(758);
	__webpack_require__(761);
	__webpack_require__(763);
	__webpack_require__(768);
	__webpack_require__(762);
	__webpack_require__(760);
	__webpack_require__(770);
	__webpack_require__(769);
	__webpack_require__(765);
	__webpack_require__(766);
	__webpack_require__(764);
	__webpack_require__(756);
	__webpack_require__(767);
	__webpack_require__(771);
	__webpack_require__(772);
	__webpack_require__(724);
	__webpack_require__(726);
	__webpack_require__(725);
	__webpack_require__(774);
	__webpack_require__(773);
	__webpack_require__(744);
	__webpack_require__(754);
	__webpack_require__(755);
	__webpack_require__(745);
	__webpack_require__(746);
	__webpack_require__(747);
	__webpack_require__(748);
	__webpack_require__(749);
	__webpack_require__(750);
	__webpack_require__(751);
	__webpack_require__(752);
	__webpack_require__(753);
	__webpack_require__(727);
	__webpack_require__(728);
	__webpack_require__(729);
	__webpack_require__(730);
	__webpack_require__(731);
	__webpack_require__(732);
	__webpack_require__(733);
	__webpack_require__(734);
	__webpack_require__(735);
	__webpack_require__(736);
	__webpack_require__(737);
	__webpack_require__(738);
	__webpack_require__(739);
	__webpack_require__(740);
	__webpack_require__(741);
	__webpack_require__(742);
	__webpack_require__(743);
	__webpack_require__(805);
	__webpack_require__(810);
	__webpack_require__(817);
	__webpack_require__(808);
	__webpack_require__(800);
	__webpack_require__(801);
	__webpack_require__(806);
	__webpack_require__(811);
	__webpack_require__(813);
	__webpack_require__(796);
	__webpack_require__(797);
	__webpack_require__(798);
	__webpack_require__(799);
	__webpack_require__(802);
	__webpack_require__(803);
	__webpack_require__(804);
	__webpack_require__(807);
	__webpack_require__(809);
	__webpack_require__(812);
	__webpack_require__(814);
	__webpack_require__(815);
	__webpack_require__(816);
	__webpack_require__(719);
	__webpack_require__(721);
	__webpack_require__(720);
	__webpack_require__(723);
	__webpack_require__(722);
	__webpack_require__(708);
	__webpack_require__(706);
	__webpack_require__(712);
	__webpack_require__(709);
	__webpack_require__(715);
	__webpack_require__(717);
	__webpack_require__(705);
	__webpack_require__(711);
	__webpack_require__(702);
	__webpack_require__(716);
	__webpack_require__(700);
	__webpack_require__(714);
	__webpack_require__(713);
	__webpack_require__(707);
	__webpack_require__(710);
	__webpack_require__(699);
	__webpack_require__(701);
	__webpack_require__(704);
	__webpack_require__(703);
	__webpack_require__(718);
	__webpack_require__(226);
	__webpack_require__(790);
	__webpack_require__(795);
	__webpack_require__(347);
	__webpack_require__(791);
	__webpack_require__(792);
	__webpack_require__(793);
	__webpack_require__(794);
	__webpack_require__(775);
	__webpack_require__(346);
	__webpack_require__(348);
	__webpack_require__(349);
	__webpack_require__(830);
	__webpack_require__(819);
	__webpack_require__(820);
	__webpack_require__(825);
	__webpack_require__(828);
	__webpack_require__(829);
	__webpack_require__(823);
	__webpack_require__(826);
	__webpack_require__(824);
	__webpack_require__(827);
	__webpack_require__(821);
	__webpack_require__(822);
	__webpack_require__(776);
	__webpack_require__(777);
	__webpack_require__(778);
	__webpack_require__(779);
	__webpack_require__(780);
	__webpack_require__(783);
	__webpack_require__(781);
	__webpack_require__(782);
	__webpack_require__(784);
	__webpack_require__(785);
	__webpack_require__(786);
	__webpack_require__(787);
	__webpack_require__(789);
	__webpack_require__(788);
	__webpack_require__(831);
	__webpack_require__(857);
	__webpack_require__(860);
	__webpack_require__(859);
	__webpack_require__(861);
	__webpack_require__(862);
	__webpack_require__(858);
	__webpack_require__(863);
	__webpack_require__(864);
	__webpack_require__(842);
	__webpack_require__(845);
	__webpack_require__(841);
	__webpack_require__(839);
	__webpack_require__(840);
	__webpack_require__(843);
	__webpack_require__(844);
	__webpack_require__(834);
	__webpack_require__(856);
	__webpack_require__(865);
	__webpack_require__(833);
	__webpack_require__(835);
	__webpack_require__(837);
	__webpack_require__(836);
	__webpack_require__(838);
	__webpack_require__(847);
	__webpack_require__(848);
	__webpack_require__(850);
	__webpack_require__(849);
	__webpack_require__(852);
	__webpack_require__(851);
	__webpack_require__(853);
	__webpack_require__(854);
	__webpack_require__(855);
	__webpack_require__(832);
	__webpack_require__(846);
	__webpack_require__(868);
	__webpack_require__(867);
	__webpack_require__(866);
	module.exports = __webpack_require__(58);

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(118)))

/***/ },
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */
/***/ function(module, exports) {

	module.exports = {
		"myplan.pageTitle": "My Plan",
		"myplan.screenName": "my plan",
		"myplan.isOmniFlow.text": "Review details for your current plan below. To make changes to your plan, click the Manage Plan button. To move your plan to a new address, ",
		"myplan.isOmniFlow.link": "click here",
		"myplanFooter.copyrightYear": "2017",
		"myPlanOffers.pageTitle": "Offers",
		"myPlanOffers.screenName": "offers",
		"myPlanOffersFilter.pageTitle": "Offers",
		"myPlanOffersFilter.screenName": "offers filter",
		"myPlanReview.screenName": "review",
		"myPlanReview.pageHeader": "Please review your new monthly charges.",
		"myPlanReview.pageSubHeader": "These will take effect immediately when you cancel XFINITY Instant TV. You will also lose any<br/>additional channels you may have added to your plan.",
		"myPlanConfirmation.screenName": "confirmation",
		"myPlanContactUs.pageTitle": "Contact Us",
		"myPlanContactUs.screenName": "contact us",
		"myPlanContactUs.phoneNumber": "1-877-680-7173",
		"isOmniError.mainText": "We're very sorry.<span class='next-line'> An error has occurred, preventing the order from being processed.</span>",
		"myPlanError.pageTitle": "Sorry",
		"myPlanError.screenName": "sorry",
		"myPlanError.phoneNumber": "1-877-680-7173",
		"myPlanError.mainText": "We’re sorry,<span class='next-line'> it looks like you'll need some help completing your order.</span>",
		"myPlanMessage.pageTitle": "Message",
		"myPlanMessage.screenName": "message",
		"myPlanMessage.DFPLN5001.icon": "success",
		"myPlanMessage.DFPLN5001.button.destination": "external",
		"myPlanMessage.DFPLN5001.button.url": "//tv.xfinity.com/",
		"myPlanMessage.DFPLN5001.button.text": "Watch Now",
		"myPlanMessage.DFPLN5002.icon": "lobwarning",
		"myPlanMessage.DFPLN5002.button.destination": "internal",
		"myPlanMessage.DFPLN5002.button.url": "/buy/plan/offersfilter",
		"myPlanMessage.DFPLN5002.button.text": "Shop TV Deals",
		"myPlanMessage.DFPLN5003.icon": "lobwarning",
		"myPlanMessage.DFPLN5003.button.destination": "internal",
		"myPlanMessage.DFPLN5003.button.url": "/buy/plan/offersfilter",
		"myPlanMessage.DFPLN5003.button.text": "Shop TV Deals",
		"myPlanMessage.DFPLN5004.icon": "warning",
		"myPlanMessage.DFPLN5004.button.destination": "internal",
		"myPlanMessage.DFPLN5004.button.url": "/buy/plan/myplan",
		"myPlanMessage.DFPLN5004.button.text": "View My Account",
		"myPlanMessage.DFPLN5005.icon": "warning",
		"myPlanMessage.DFPLN5005.button.destination": "internal",
		"myPlanMessage.DFPLN5005.button.url": "/buy/plan/myplan",
		"myPlanMessage.DFPLN5005.button.text": "View My Account",
		"myPlanMessage.DFPLN5006.icon": "lobwarning",
		"myPlanMessage.DFPLN5006.button.destination": "internal",
		"myPlanMessage.DFPLN5006.button.url": "/buy/plan/myplan",
		"myPlanMessage.DFPLN5006.button.text": "View My Account",
		"myPlanOmniLanding.pageTitle": "Omni Landing Page",
		"myPlanOmniLanding.screenName": "omni landing page",
		"addon.pageTitle": "Addon",
		"moversLocalization.pageTitle": "Localization",
		"moversLocalization.screenName": "localization",
		"moversLocalization.headerText": "XFINITY is here to support your move experience.",
		"moversLocalization.subHeaderText": "Just tell us a little more about your upcoming move.",
		"moversLocalization.movingFromText": "Moving from",
		"moversLocalization.stopServiceDateText": "When will you need to stop service at your current address?",
		"moversLocalization.contactPhoneNumberText": "What's the best number to call you if we have questions about your move?",
		"moversLocalization.contactPhoneNumberLabel": "Contact Phone Number",
		"moversLocalization.movingToText": "Where are you moving?",
		"moversUnserviceable.pageTitle": "Unserviceable",
		"moversUnserviceable.screenName": "unserviceable",
		"moversUnserviceable.headerText": "Unfortunately, XFINITY service is not available at your new home.",
		"moversUnserviceable.subHeaderText": "Don’t worry, we can still help! Get started below to learn more about canceling your XFINITY service and returning your equipment.",
		"moversUnserviceable.moveLabel": "Moving to",
		"moversCancel.pageTitle": "Cancel",
		"moversCancel.screenName": "cancel",
		"moversCancel.headerText": "Tell us when you'd like to stop your XFINITY service.",
		"moversCancel.subHeaderText": "Your service will end on this date and your final bill will be pro-rated for any service paid in advance.",
		"moversCancel.cancelDateText": "Set cancellation date",
		"moversInstall.pageTitle": "Install",
		"moversInstall.screenName": "install",
		"moversInstall.headerText": "Good news! You can keep your same great XFINITY service.",
		"moversInstall.movingToText": "Moving to",
		"moversInstall.dwkHeaderText": "Do you consent to receive your Welcome Guide online?",
		"moversInstall.dwkOnlineOption": "I'd like to receive my Welcome Guide online *",
		"moversInstall.dwkPaperOption": "I'd like to receive a paper copy in the mail",
		"moversInstall.dwkSubHeaderText": "For easy reference and to save paper, our Welcome Guide is now available online. This guide includes tips and tricks to enjoying your XFINITY service.",
		"moversInstall.dwkFootnote": "*If you ever need a paper copy of any of our material, we'll gladly mail it to you at no cost. Just call us at 1-800-XFINITY and we'll take care of the rest.",
		"moversInstall.installationMethodHeader": "Please select your preferred installation method",
		"moversInstall.installationProHeader": "Schedule a professional installation",
		"moversInstall.installationProDescription": "Bring your devices to your new home for a technician to install.",
		"moversInstall.installationSikHeader": "Use your existing devices.",
		"moversInstall.installationSikDescription": "Bring your devices to your new home to install on your own.",
		"moversInstall.sikImageAlt": "Self Installation Kit",
		"moversInstall.sikTabHeader": "I will bring my devices to my new home to install on my own.",
		"moversInstall.sikAvailToDeliverText": "Available to deliver as soon as [02/07/16]",
		"moversInstall.sikSaveMoneyText": "Save time, money and install when it's convenient.",
		"moversInstall.sikSikTimeText": "Self-installation takes up to two hours. ",
		"moversInstall.sikStepByStepText": "See step-by-step instructions ",
		"moversInstall.sikNervousAboutSikText": "Nervous about self-installation? ",
		"moversInstall.sikWhatItTakesText": "See what it takes.",
		"moversInstall.sikSelectionHeaderText": "Please select your preferred shipping method.",
		"moversInstall.sikSelectionDescriptionText": "Please confirm your shipping address and select a shipping method.",
		"moversInstall.sikOverlayHeader": "Is self-installation the right choice?",
		"moversInstall.sikOverlayText": "With self-installation, you will connect your cable boxes and modem directly to existing coaxial outlets in your new home. If you don't have outlets in all the rooms that you want service, you might want to consider installation by a professional.",
		"moversInstall.equipmentListHeader": "Your Equipment",
		"moversInstall.installGuideLink": "View install guide",
		"moversInstall.installGuideUrl": "https://www.xfinity.com/support/phone/how-to-install-your-self-install-kit-devices/",
		"moversInstall.stopServiceHeader": "When will you need service at your new address?",
		"moversInstall.stopServiceInstructions": "Choose ${p1} or later to start service for a continuous XFINITY experience during your move. If you choose two different dates, your bill will be pro-rated for your time without service.",
		"moversInstall.proImageAlt": "Professional Installation",
		"moversInstall.proTabHeader": "I will bring my devices to my new home for a technician to install.",
		"moversInstall.proDescLine1": "Two-hour window guaranteed.",
		"moversInstall.proTwoHourWindowText": "Our technicians are even available nights and weekends.",
		"moversInstall.proTimeSlotsFetching": "Please wait while loading available time slots",
		"moversInstall.proTimeWorksForYouText": "Please select an installation time and date:",
		"moversInstall.proTechnicianArriveText": "A technician will arrive on the date you choose within a 2-hour window.",
		"moversInstall.proScheduledForText": "Selected appointment:",
		"moversInstall.proContactInfoText": "Contact Information",
		"moversInstall.proWeMayContactText": "We may need to contact you with important information regarding your installation.",
		"moversInstall.proContactNumberTypeLabel": "Contact Phone Number Type",
		"moversInstall.proContactPhoneNumberLabel": "Contact Phone Number",
		"moversInstall.proSpecialInstructionsText": "Special Instructions",
		"moversInstall.proLeaveSpecialInstructionsText": "Feel free to leave instructions or notes for your technician.",
		"moversInstall.proPosId": "Someone over the age of 18 with a valid ID will be home during installation",
		"moversInstall.proCustGuaranteeText": "XFINITY Customer Commitment",
		"moversInstall.proCustGuaranteeSubText1": "We’re committed to delivering the best experience possible. We take pride in our products which is why we offer a 30-day money-back guarantee. And, we deliver service on your terms, including 24/7 support and two-hour appointment windows with a guaranteed, automatic $20 credit if we’re late.",
		"moversInstall.proCustGuaranteeSubText2": "As a courtesy, we will call you before we arrive at your home. Please be sure an adult 18 years or older is present when your technician arrives.",
		"moversInstall.proSelectTimeSlot": "Please select a time slot.",
		"moversInstall.proDayText": "Day",
		"moversInstall.proSelectADaytext": "Select a day",
		"moversInstall.proTimeText": "Time",
		"moversInstall.proShippingAddressText": "Shipping Address",
		"moversInstall.proChangeText": "Change",
		"moversInstall.sikSelectDescription": "Connect, activate and enjoy!",
		"moversInstall.sikSelectDescriptionLinkText": "What is self installation?",
		"moversInstall.proSelectDescription": "Take your devices with you and a technician will install it for you.",
		"moversInstall.proSelectDescriptionLinkText": "Learn more about a technician install",
		"moversInstall.proOverlayHeader": "Technician install",
		"moversInstall.proOverlayText": "This option is right for you if:",
		"moversInstall.proOverlayListItem1": "You're not comfortable installing audio/video technology.",
		"moversInstall.proOverlayListItem2": "You're not sure if the cable outlets are active in your new home.",
		"moversInstall.proOverlayListItem3": "You'll be too busy to do it yourself.",
		"moversInstall.proOverlayListItem4": "You have a 2-3 hour window available where you can be home to wait for a technician.",
		"moversReview.pageTitle": "Review",
		"moversReview.screenName": "review",
		"moversReview.headerText": "Review and confirm your XFINITY service cancellation.",
		"moversReview.movingFromText": "Service will end at the following address:",
		"moversReview.stopServiceDateText": "Service will end ${p1}.",
		"moversReview.finalBillHeader": "Final Bill",
		"moversReview.finalBillText1": "Your final bill amount will be your account balance on the date of service cancellation. You may be eligible for a refund depending on your balance and usage prior to cancellation.",
		"moversReview.finalBillText2": "If you are subscribed to XFINITY service as part of a promotional contract agreement, an early termination fee may apply and this pro-rated amount would then appear on your final bill.",
		"moversReview.finalBillPositiveBalance": "Your final bill amount.",
		"moversReview.finalBillNegativeBalance": "A credit will be added to your final bill.",
		"moversReview.finalBillContactUsMessage": "If you'd like to have your bill sent to your new address, please",
		"moversReview.finalBillContactUsLink": "contact us",
		"moversReview.finalBillOverlay.linkText": "Learn more about your final bill",
		"moversReview.finalBillOverlay.header": "About your final bill",
		"moversReview.finalBillOverlay.paragraph1": "We bill 30 days in advance, so we may have already processed next month's bill and you will still receive it.",
		"moversReview.finalBillOverlay.paragraph2": "Your final bill will be generated after your account has been disconnected. The final bill may result in a credit after all equipment has been returned and deposits are taken into account.",
		"moversReview.finalBillOverlay.paragraph3": "If you're enrolled in auto pay, keep in mind that you'll need to pay your final bill manually.",
		"moversReview.EarlyTerminationFeeHeader": "Early Termination Fee",
		"moversReview.EarlyTerminationFeeText": "You'll be charged a fee for breaking your contract.",
		"moversReview.equipmentHeader": "Equipment Return",
		"moversReview.returnDateText": "You'll need to return your equipment by",
		"moversReview.equipmentText": "Return the following equipment by the specified date to avoid being charged.",
		"moversReview.dropoffLocationText": "You have the following options to return equipment:",
		"moversReview.dropOffLocationLink": "Find more nearby locations",
		"moversReview.upsDropOffText": "UPS Store Drop Off",
		"moversReview.xfinityDropOffText": "XFINITY Store Drop Off",
		"moversConfirmation.pageTitle": "Confirmation",
		"moversConfirmation.screenName": "confirmation",
		"moversConfirmation.headerText": "Your cancellation has been processed.",
		"moversConfirmation.stopServiceDateText": "Your XFINITY service will stop on",
		"moversConfirmation.movingFromText": "Cancelling Service at this address:",
		"moversConfirmation.viewServiceProvidersText": "Explore TV, Internet, and Phone options at your new address.",
		"moversConfirmation.viewServiceProvidersLink": "View Service Providers",
		"moversSpecialist.pageTitle": "Specialist",
		"moversSpecialist.screenName": "specialist",
		"moversSpecialist.headerText": "We'll need to connect you with a dedicated Move Specialist who can help with your move.",
		"moversSpecialist.contactPhoneNumberLabel": "Is this the best number to reach you?",
		"moversSpecialist.contactPhoneNumberFootnote": "You can expect a call from us within the next two hours when submitting this order between 8AM and 7PM local time. Orders submitted after 7PM may result in a callback the following day.",
		"moversContactUs.pageTitle": "Contact Us",
		"moversContactUs.screenName": "contact us",
		"moversContactUs.phoneNumber": "1-877-338-5965",
		"moversCancellationContactUs.pageTitle": "Contact Us",
		"moversCancellationContactUs.screenName": "contact us",
		"moversCancellationContactUs.phoneNumber": "1-877-431-4823",
		"moversError.pageTitle": "Sorry",
		"moversError.screenName": "sorry",
		"moversError.phoneNumber": "1-877-338-5965",
		"moversError.mainText": "We’re sorry,<span class='next-line'> it looks like you'll need some help completing your order.</span>",
		"moversCancellationError.pageTitle": "Sorry",
		"moversCancellationError.screenName": "sorry cancel",
		"moversCancellationError.phoneNumber": "1-877-431-4823",
		"moversCancellationError.mainText": "We’re sorry,<span class='next-line'> it looks like you'll need some help completing your order.</span>",
		"quickCheckoutProducts.2018.displayName": "Digital Preferred TV",
		"quickCheckoutProducts.2018.backNav": "/preferredtv",
		"quickCheckoutProducts.2143.displayName": "Playboy",
		"quickCheckoutProducts.2143.backNav": "/playboy",
		"quickCheckoutProducts.8000062.displayName": "Showtime®",
		"quickCheckoutProducts.8000062.backNav": "/showtime",
		"quickCheckoutProducts.8000062.redirectUrl.Web": "http://www.showtimeanytime.com/",
		"quickCheckoutProducts.8000062.redirectUrl.iOS": "https://itunes.apple.com/us/app/showtime-anytime/id484232467?mt=8",
		"quickCheckoutProducts.8000062.redirectUrl.Android": "https://play.google.com/store/apps/details?id=com.showtime.showtimeanytime&hl=en",
		"quickCheckoutProducts.8000066.displayName": "Starz®",
		"quickCheckoutProducts.8000066.backNav": "/starz",
		"quickCheckoutProducts.8000066.redirectUrl.Web": "https://tv.xfinity.com/browse/node/9101407710301832170",
		"quickCheckoutProducts.8000066.redirectUrl.iOS": "https://itunes.apple.com/us/app/xfinity-tv/id731629156?ls=1&mt=8",
		"quickCheckoutProducts.8000066.redirectUrl.Android": "https://play.google.com/store/apps/details?id=com.xfinity.cloudtvr",
		"quickCheckoutProducts.8000068.displayName": "Cinemax®",
		"quickCheckoutProducts.8000068.backNav": "/cinemax",
		"quickCheckoutProducts.8000068.redirectUrl.Web": "http://www.maxgo.com",
		"quickCheckoutProducts.8000068.redirectUrl.iOS": "https://itunes.apple.com/us/app/max-go/id453560335?mt=8",
		"quickCheckoutProducts.8000068.redirectUrl.Android": "https://play.google.com/store/apps/details?id=com.MAXGo&hl=en",
		"quickCheckoutProducts.8000080.displayName": "HBO®",
		"quickCheckoutProducts.8000080.backNav": "/hbo",
		"quickCheckoutProducts.8000080.redirectUrl.Web": "http://play.hbogo.com/",
		"quickCheckoutProducts.8000080.redirectUrl.iOS": "https://itunes.apple.com/us/app/hbo-go/id429775439?mt=8",
		"quickCheckoutProducts.8000080.redirectUrl.Android": "https://play.google.com/store/apps/details?id=com.HBO",
		"quickCheckoutProducts.20400124.displayName": "AMC Premiere",
		"quickCheckoutProducts.20400124.backNav": "/amcpremiere",
		"quickCheckoutProducts.20400124.redirectUrl.Web": "http://www.amcpremiere.com/members/",
		"quickCheckoutProducts.20400124.redirectUrl.iOS": "https://itunes.apple.com/us/app/amc/id1025120568?mt=8",
		"quickCheckoutProducts.20400124.redirectUrl.Android": "https://play.google.com/store/apps/details?id=com.amctve.amcfullepisodes",
		"quickCheckoutProducts.10400246.displayName": "MLB Extra Innings",
		"quickCheckoutProducts.10400246.backNav": "/sports/mlb/extra-innings.html",
		"quickCheckoutProducts.2120.displayName": "MLB Extra Innings",
		"quickCheckoutProducts.2120.backNav": "/sports/mlb/extra-innings.html",
		"quickCheckoutProducts.10400537.displayName": "iPad®",
		"quickCheckoutProducts.10400537.backNav": "/IPAD",
		"quickCheckoutProducts.200000039.displayName": "Disney Family Movies",
		"quickCheckoutProducts.200000039.backNav": "/disney",
		"quickCheckoutRedirect.pageTitle": "Redirect",
		"quickCheckoutRedirect.screenName": "redirect",
		"manageplan.defaultHeading1": "Would you like to make changes to your base plan?",
		"manageplan.defaultHeading2": "",
		"manageplan.defaultDescription": "We'll try and find you the best offer to match the adjustments you make to your services",
		"manageplan.modifiedHeading1": "We found ",
		"manageplan.modifiedHeading2": ". Do you want to make any additional changes?",
		"manageplan.modifiedDescription": "Adjust another tier below or review all the matching offers",
		"offers.title": "Select a new plan",
		"offers.heading": "We found ${p1} ${p2} that ${p3} best with what you’re looking for. Choose one from the following.",
		"offers.filterLabel.TV": "TV",
		"offers.filterLabel.Internet": "Internet",
		"offers.filterLabel.Voice": "Phone",
		"offers.filterLabel.Home": "Home Security",
		"offers.offerCardDownloadSpeedsLabel": "Download Speeds",
		"offers.offerCardChannelsLabel": "Channels",
		"offers.offerCardOfferIncludesLabel": "includes:",
		"offers.offerCardOfferPriceFrequencyAccessible": "per month",
		"offers.offerCardOfferPriceFrequency": "/mo",
		"offers.offerCardPromotionLabel": "for the first {{PromotionDurationMonths}} months",
		"offers.offerCardAddOfferToCartUrl": "",
		"offers.offerCardPageName": "shop|my plan|offers filter",
		"offers.offerCardAddToCart": "Add to Cart",
		"offers.offerCardCheckAvailabilityUrl": "#checkavailability",
		"offers.localizeOverlayUrl": "",
		"offers.offerCardCheckAvailability": "Check Availability",
		"offers.offerCardPricingAndOtherInfo": "Pricing and Other Info",
		"offers.offerCardAddToCartLoadingMessage": "Getting your offer ready...",
		"offers.offerCardChannelLineupTitle": "View Channels",
		"offers.offerCardChannelLineupLink": "//www.xfinity.com/learn/channel-lineup/",
		"offers.errorOverlayHeader": "Loss of Inclusions",
		"offers.errorOverlaySubheader": "The plan you selected has different inclusions than your current base plan",
		"offers.errorOverlayPremiumChannelsHead": "Premium Channels",
		"offers.errorOverlayPremiumChannelsBody": "The plan does not include your current plan's premium channels.",
		"offers.errorOverlayNewEquipmentHead": "New Equipment",
		"offers.errorOverlayNewEquipmentBody": "Some of your equipment is not compatible with this plan. We wil send you new equipment and provide instructions on how to return your existing equipment.",
		"offers.errorOverlayCurrentEquipmentHead": "Current Equipment",
		"offers.errorOverlayCurrentEquipmentBody": "You will need to pay additional equipment rental fees or service fees if you want to keep all your current equipment.",
		"offers.errorOverlayServiceFeesHead": "Equipment & Service Fees",
		"offers.errorOverlayServiceFeesBody": "You will need to pay additional equipment rental fees or service fees if you want to keep all your current equipment.",
		"offers.equipmentNoticeHeader": "You'll be receiving new XFINITY equipment as part of your move.",
		"offers.equipmentNoticeSubheader": "You'll need to return all of your current equipment and update to our latest devices for use in your new home. Select 'Continue' below and we'll guide you through choosing new devices and installation options for your new service.",
		"offers.equipmentNoticeCta": "Continue",
		"offers.downgradeNoticeHeader": "You are removing ${p1} service from your plan.",
		"offers.downgradeNoticeSubheader": "The new offer you selected is for ${p1} service only. You will no longer have XFINITY ${p2} service. If you are ok making this change select 'continue' below.",
		"offers.downgradeNoticeCta": "Continue",
		"offers.offerComparisonOverlayHeader": "Changes to your current plan",
		"offers.offerComparisonOverlaySubheader": "The offer you selected has some changes compared to your current plan.<br/>You can review these changes in detail as you check out.",
		"offers.offerComparisonOverlayChannelsHeader": "Premium Channels",
		"offers.offerComparisonOverlayChannelsText": "You will have the opportunity to add or remove additional channels on the following screen.",
		"offers.offerComparisonOverlayEquipmentHeader": "Equipment",
		"offers.offerComparisonOverlayEquipmentText": "You can keep all of your current equipment, but you may have to pay additional fees. Click <a href=\"https://www.xfinity.com/support/cable-tv/returning-your-equipment\" target=\"_blank\">here</a> to learn about returning equipment.",
		"offers.offerComparisonNoThanksText": "No thanks, I'll select a different offer.",
		"offers.offerCardGigabitLearnMoreAction": "Learn More",
		"offers.offerCardGigabitLearnMoreUrl": "//www.xfinity.com/xfinity-one-gig-signup",
		"offers.offerCardGigabitProMessage": "Call [1-800-934-6489] to order",
		"offersFilter.pageTitle": "Offers",
		"offersFilter.screenName": "offers filter",
		"offersFilter.offerCardBannerGreeting": "${p1}, we can help you find a new plan",
		"offersFilter.offerCardBannerGreetingNoFirst": "We can help you find a new plan",
		"offersFilter.noresults": "Sorry no offers match your criteria",
		"offersFilter.servicePackageInfo": "Your current base plan includes ${p1} service for <strong>${p2}/mo</strong>",
		"offersFilter.MoveRepackager.offerCardBannerGreeting": "We offer services at your new address, but you'll need to choose a new plan.",
		"offersFilter.MoveRepackager.servicePackageInfo": "Your current base plan includes ${p1} for <strong>${p2}/mo</strong> (not including extras, taxes & fees)",
		"offersFilter.contactUs.message": "Looking for a plan with ${p1} service? Currently these orders are only being handled by our phone agents.",
		"offersFilter.contactUs.phoneNumber": "1-877-680-7173",
		"customization.speed.title": "Customize your internet options",
		"customization.speed.description": "Select a new speed and we'll find you the best offer to match the adjustments you make",
		"customization.speed.mbps": "MBPS",
		"customization.speed.speedHeading": "UP TO",
		"customization.speed.speedSubHeading": "DOWNLOAD SPEEDS",
		"customization.speed.idealFor": "Ideal for ${p1} devices",
		"customization.channels.title": "Customize your television options.",
		"customization.channels.description": "Pick the number of channels you want and we'll find you the best offer to match the adjustment you make.",
		"customization.channels.subheading": "Channels",
		"customization.channels.linkText": "View Channel Lineup",
		"errors.ADBF30001": "AGENT_INTERVENTION_REQUIRED",
		"errors.ADBF22001": "CREDIT_CHECK_DEPOSIT_AMOUNT_GREATER_THAN_ZERO",
		"errors.ADBF22002": "CUSTOMER_DEBT_EXISTS_REQUIRES_PAYMENT",
		"errors.ADBF22003": "Billing infomation is invalid",
		"errors.ADBF22004": "Credit Card infomation is invalid",
		"errors.ADBF22005": "Credit Card infomation is invalid",
		"errors.ADBF22006": "A valid expiration date is required",
		"errors.ADBF22007": "A valid Social Security number is required",
		"errors.ADBF22008": "There is Insufficient balance on this credit card, Please try a different credit card",
		"errors.ADBF12117": "A valid expiration date is required",
		"errors.DFPLN1001": "We're sorry, it looks like you'll need some help completing your order.",
		"errors.DFPLN1002": "We're sorry, it looks like you'll need some help completing your order.",
		"errors.DFPLN1003": "We're sorry, it looks like you'll need some help completing your order.",
		"errors.DFPLN4001": "We're sorry, it looks like you'll need some help completing your order.",
		"errors.DFPLN4002": "We're sorry, it looks like you'll need some help completing your order.",
		"errors.DFPLN4003": "We're sorry, it looks like you'll need some help completing your order.",
		"errors.DFPLN4004": "This channel is not available with your XFINITY plan. Have additional questions?",
		"errors.DFPLN4005": "We're sorry, it looks like you'll need some help completing your order.",
		"errors.DFPLN4006": "You must have TV service on your XFINITY plan to add this channel. Would you like to add TV service?",
		"errors.DFPLN4007": "This channel is already added to your XFINITY plan. Need help finding this channel?",
		"errors.DFPLN4008": "You are already leasing an iPad through this offer. Feel you have reached this page in error?",
		"errors.DFPLN4009": "This offer is not available with your XFINITY plan. Have additional questions?",
		"errors.DFPLN4010": "We're sorry, it looks like you'll need some help managing your channels.",
		"errors.DFPLN4011": "We're sorry, it looks like you'll need some help managing your equipment.",
		"errors.DFPLN5001": "You can already get the entertainment you love anywhere, on any device with the XFINITY Stream App. Everything is included at no addtional cost, only for XFINITY TV customers.",
		"errors.DFPLN5002": "XFINITY Instant TV isn't available to you right now, but you can still enjoy the latest movies and hottest shows.",
		"errors.DFPLN5003": "XFINITY Instant TV isn't available to you right now, but you can still enjoy the latest movies and hottest shows.",
		"errors.DFPLN5004": "You are not an XFINITY Instant TV Customer",
		"errors.DFPLN5005": "You are not an XFINITY Instant TV Customer",
		"errors.DFPLN5006": "To update or cancel your subscription, please contact us at 1-800-XFINITY.",
		"errors.default": "We're sorry, it looks like you'll need some help completing your order.",
		"checkout.pageTitle": "Checkout",
		"checkout.screenName": "checkout",
		"quickCheckoutContactUs.pageTitle": "Contact Us",
		"quickCheckoutContactUs.screenName": "contact us",
		"quickCheckoutContactUs.phoneNumber": "1-877-680-7173",
		"quickCheckoutContactUs.channelLineupButtonText": "View Channel Lineup",
		"quickCheckoutContactUs.channelLineupUrl": "https://www.xfinity.com/support/local-channel-lineup/",
		"checkoutError.pageTitle": "Sorry",
		"checkoutError.screenName": "sorry",
		"checkoutError.phoneNumber": "1-877-680-7173",
		"checkoutError.mainText": "We’re sorry,<span class='next-line'> it looks like you'll need some help completing your order.</span>",
		"review.pageTitle": "Review",
		"review.screenName": "review",
		"review.defaultHeading": "Review and confirm changes to your plan",
		"review.reviewSummary": "Please confirm your changes and new monthly payments.",
		"review.ctaLabel": "Confirm Changes",
		"review.pageHeader": "Hi ${p1}, let's review your changes.",
		"review.ppvHeader": "The following charges will appear on your bill in the next 1-2 billing cycles.",
		"review.currentMonthlyChargesHeader": "Your XFINITY Plan",
		"review.currentMonthlyChargesItemCategory": "Your previous monthly charges",
		"review.newMonthlyChargesHeader": "Your new monthly charges",
		"review.newOneTimeChargesHeader": "One-time charges*",
		"review.additionalChargesHeader": "Your additional monthly charges*",
		"review.removedChargesHeader": "Removed from Your Plan",
		"review.shippingAddressHeader": "Shipping Address",
		"review.iPadShippingMessage": "Your iPad can only be shipped to the service address for this account.",
		"review.iPadContractTitle": "iPad Terms & Conditions",
		"review.consentContractsHeader": "<div>By checking this box and clicking Submit Payment, I am representing:<ul>${p1}</ul></div>",
		"review.agreementHeader": "I agree to the ",
		"review.consentContractsCheckboxHeader": "By checking this box and clicking Submit Payment, I am representing:",
		"review.pageSubHeader.yourPreviousPlan": "Your previous plan was ___. We've summarized your new plan below. As soon as you are ready, submit your order and we'll get right on it.",
		"review.reviewHeaders.currentMonthlyTotalCharges.header": "Your XFINITY Plan",
		"review.reviewHeaders.reviewSummary.header": "Order Summary",
		"review.reviewHeaders.reviewSummary.subHeaders.Monthly": "New Monthly Plan*",
		"review.reviewHeaders.reviewSummary.subHeaders.consentMonthly": "New Monthly Charges*",
		"review.reviewHeaders.reviewSummary.subHeaders.OneTime": "One-Time Charges*",
		"review.reviewHeaders.reviewSummary.subHeaders.consentOneTime": "One-Time Charges*",
		"review.reviewHeaders.monthlyCharges.header": "Monthly Charges",
		"review.reviewHeaders.monthlyCharges.subHeaders.premiumChannels.discountInfo": "$${p1} for ${p2} months, then regular rates apply (currently $${p3}/mo)",
		"review.reviewHeaders.monthlyCharges.subHeaders.premiumChannels.discountInfoConsent": "$${p1} for ${p2} months, then regular rates apply",
		"review.reviewHeaders.monthlyCharges.subHeaders.premiumChannels.installmentInfo": "${p1} monthly payments of ${p2}. Subscription automatically renews next season at the Early Bird rate if Comcast still carries the service, unless you cancel within 30 days of being charged.",
		"review.reviewHeaders.monthlyCharges.subHeaders.premiumChannels.installmentInfoConsent": "${p1} monthly payments of ${p2}",
		"review.reviewHeaders.monthlyCharges.subHeaders.premiumChannels.installmentInfoConsentSport": ". Subscription automatically renews next season at the Early Bird rate if Comcast still carries the service, unless you cancel within 30 days of being charged.",
		"review.taxExclusion": "*Estimated taxes & government fees are included. Taxes & government fees are estimated and may include one time sales taxes. Final taxes & fees will be calculated once your order is placed and your account is set up. Your next bill will reflect the final total tax, which includes state taxes, local taxes, and any applicable fees.",
		"review.consentHeaders.consentMonthlyCharges": "Monthly Charges*",
		"review.consentHeaders.offers": "Your XFINITY Plan*",
		"review.consentHeaders.equipment": "New Equipment",
		"review.consentHeaders.fees": "Additional XFINITY Monthly Charges",
		"review.consentHeaders.feesLinkText": "why am I being charged?",
		"review.consentOverlay.additionalCharges.title": "Additional XFINITY Monthly Charges",
		"review.consentHeaders.taxesSurchargesFees": "Taxes, Surcharges, & Fees",
		"review.consentHeaders.oneTimeCharges": "One-Time Charges*",
		"review.consentHeaders.installation": "Installation Fees",
		"review.consentHeaders.otherCharges": "Other Charges",
		"review.consentHeaders.reviewSummary": "Order Summary",
		"review.consentHeaders.totalDueToday": "Total Due",
		"review.consentItem.totalMonthly": "Estimated Monthly Bill*",
		"review.consentItem.totalOneTime": "One-Time Charges",
		"review.consentItem.dueToday.creditcheck": "No payment necessary today",
		"review.consentItem.dueToday.oneTime": "One Time Payment",
		"review.consentContracts.groupHeader": "By checking this box and clicking Submit Order, I am representing that:",
		"review.consentContracts.agreementHeader": "I agree to the following terms and conditions:",
		"review.consentContracts.agreementHeaderMTA": "I agree to the",
		"review.consentContracts.errorText": "Please accept the terms and agreements",
		"review.consentDisclaimer": "*Estimated taxes & government fees are included. Taxes & government fees are estimated and may include one time sales taxes. Final taxes and fees will be calculated once your order is placed and your account is set up. Your next bill will reflect the final total tax, which includes state taxes, local taxes, and any applicable fees.",
		"labels.price.stepPricing": "${p1} for ${p2} months, then regular rates apply",
		"labels.price.stepPricing2": "${p1} for ${p2} months, then ${p3} for months ${p4}-${p5}, then regular rates apply",
		"labels.price.installment": "${p1} for ${p2} months",
		"labels.price.installmentSport": "${p1} for ${p2} months (will automatically renew annually at the current rate). This subscription automatically renews at Early Bird rate if Comcast still carries the service, unless you cancel up to 30 days into the season.",
		"confirmation.pageTitle": "Confirmation",
		"confirmation.screenName": "confirmation",
		"confirmation.defaultHeading": "Order Confirmation",
		"confirmation.reviewSummary": "Your charges for added channels from today until your next monthly bill cycle will be reflected on your next monthly bill as pro-rated charges.",
		"confirmation.headerText": "Thanks for your purchase, ${p1}.",
		"confirmation.headerText.myplan": "Your XFINITY Instant TV subscription has been cancelled.",
		"confirmation.disclaimer.header": "To ensure that changes are properly applied to your account, we’ll<br/>need to automatically reboot your cable modem now. This may take up<br/>to 15 minutes and you will not be able to access the Internet through<br/>your modem during this time.",
		"confirmation.itemOne": "Access to thousands of hit TV shows and connect to XFINITY WiFi hotspots.",
		"confirmation.itemTwo": "Manage your install appointment or track your Self-install Kit.",
		"confirmation.itemThree": "Manage your account, pay your bill, and set preferences.",
		"confirmation.ctaPrompt": "Don't wait, start watching ${p1}!",
		"confirmation.ctaLabel": "Watch Now",
		"confirmation.myplanLabel": "View My Account",
		"confirmation.myplan.button.url": "/buy/plan/myplan",
		"account.pageTitle": "Account",
		"accountMultipleAddress.pageTitle": "Multiple Addresses",
		"accountMultipleAddress.screenName": "multiple addresses",
		"accountMultipleAddress.defaultHeading": "You have more than one address on your account",
		"accountMultipleAddress.chooseAddress": "Which address would you like to shop for services?"
	};

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	Using a Universal Module Loader that should be browser, require, and AMD friendly
	http://ricostacruz.com/cheatsheets/umdjs.html
	*/
	;(function (root, factory) {
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.jsonLogic = factory();
	  }
	
	}(this, function () {
	'use strict';
	/*globals console:false */
	
	if ( ! Array.isArray) {
		Array.isArray = function(arg) {
			return Object.prototype.toString.call(arg) === '[object Array]';
		};
	}
	
	if( ! Array.unique){
		Array.prototype.unique = function() {
			var a = [];
			for (var i=0, l=this.length; i<l; i++){
				if (a.indexOf(this[i]) === -1){
					a.push(this[i]);
				}
			}
			return a;
		};
	}
	
	var jsonLogic = {},
		operations = {
			"=="  : function(a,b){ return a == b; },
			"===" : function(a,b){ return a === b; },
			"!="  : function(a,b){ return a != b; },
			"!==" : function(a,b){ return a !== b; },
			">"   : function(a,b){ return a > b; },
			">="  : function(a,b){ return a >= b; },
			"<"   : function(a,b,c){
				return (c === undefined) ?  a < b : (a < b) && (b < c);
			},
			"<="  : function(a,b,c){
				return (c === undefined) ?  a <= b : (a <= b) && (b <= c);
			},
			"!!"   : function(a){ return jsonLogic.truthy(a); },
			"!"   : function(a){ return !jsonLogic.truthy(a); },
			"%"  : function(a,b){ return a % b; },
			"log" : function(a){ console.log(a); return a; },
			"in"  : function(a, b){
				if(typeof b.indexOf === 'undefined') return false;
				return (b.indexOf(a) !== -1);
			},
			"cat" : function(){
				return Array.prototype.join.call(arguments, "");
			},
			"+" : function(){
				return Array.prototype.reduce.call(arguments, function(a,b){
					return parseFloat(a,10) + parseFloat(b, 10);
				}, 0);
			},
			"*" : function(){
				return Array.prototype.reduce.call(arguments, function(a,b){
					return parseFloat(a,10) * parseFloat(b, 10);
				});
			},
			"-" : function(a,b){ if(b === undefined){return -a;}else{return a - b;} },
			"/" : function(a,b){ if(b === undefined){return a;}else{return a / b;} },
			"min" : function(){ return Math.min.apply(this,arguments); },
			"max" : function(){ return Math.max.apply(this,arguments); },
			"merge" : function(){
				return Array.prototype.reduce.call(arguments, function(a,b){
					return a.concat(b);
				}, []);
			},
	    "var" : function(a,b){
	  		var not_found = (b === undefined) ? null : b,
	  			sub_props = String(a).split("."),
	        data = this;
	  		for(var i = 0 ; i < sub_props.length ; i++){
	  			//Descending into data
	  			data = data[ sub_props[i] ];
	  			if(data === undefined){ return not_found; }
	  		}
	  		return data;
	  	},
	    "missing" : function(){
			/*
				Missing can receive many keys as many arguments, like {"missing:[1,2]}
				Missing can also receive *one* argument that is an array of keys,
				which typically happens if it's actually acting on the output of another command
				(like 'if' or 'merge')
			*/
	
			var missing = [],
	      keys = Array.isArray(arguments[0]) ? arguments[0] : arguments ;
	
			for(var i = 0 ; i < keys.length ; i++){
	      var key = keys[i],
	        value = jsonLogic.apply({'var':key}, this);
				if(value === null || value === ""){
					missing.push(key);
				}
			}
	
			return missing;
		},
	  "missing_some" : function(need_count, options){
	      //missing_some takes two arguments, how many (minimum) items must be present, and an array of keys (just like 'missing') to check for presence.
	    var are_missing = jsonLogic.apply({'missing':options}, this);
	
	    if(options.length - are_missing.length >= need_count){
	      return [];
	    }else{
	      return are_missing;
	    }
	  },
	  "method" : function(obj, method, args){
	    return obj[method].apply(obj, args);
	  }
	
	};
	
	jsonLogic.is_logic = function(logic){
		return (logic !== null && typeof logic === "object" && ! Array.isArray(logic) );
	};
	
	/*
	This helper will defer to the JsonLogic spec as a tie-breaker when different language interpreters define different behavior for the truthiness of primitives.  E.g., PHP considers empty arrays to be falsy, but Javascript considers them to be truthy. JsonLogic, as an ecosystem, needs one consistent answer.
	
	Literal | JS    |  PHP  |  JsonLogic
	--------+-------+-------+---------------
	[]      | true  | false | false
	"0"     | true  | false | true
	*/
	jsonLogic.truthy = function(value){
		if(Array.isArray(value) && value.length === 0){ return false; }
		return !! value;
	};
	
	jsonLogic.apply = function(logic, data){
	  //Does this array contain logic? Only one way to find out.
	  if(Array.isArray(logic)){
	    return logic.map(function(l){ return jsonLogic.apply(l,data); });
	  }
		//You've recursed to a primitive, stop!
		if( ! jsonLogic.is_logic(logic) ){
			return logic;
		}
	
		data = data || {};
	
		var op = Object.keys(logic)[0],
			values = logic[op],
			i, current;
	
		//easy syntax for unary operators, like {"var" : "x"} instead of strict {"var" : ["x"]}
		if( ! Array.isArray(values)){ values = [values]; }
	
		// 'if', 'and', and 'or' violate the normal rule of depth-first calculating consequents, let each manage recursion as needed.
		if(op === 'if' || op == '?:'){
			/* 'if' should be called with a odd number of parameters, 3 or greater
				This works on the pattern:
				if( 0 ){ 1 }else{ 2 };
				if( 0 ){ 1 }else if( 2 ){ 3 }else{ 4 };
				if( 0 ){ 1 }else if( 2 ){ 3 }else if( 4 ){ 5 }else{ 6 };
	
				The implementation is:
				For pairs of values (0,1 then 2,3 then 4,5 etc)
					If the first evaluates truthy, evaluate and return the second
					If the first evaluates falsy, jump to the next pair (e.g, 0,1 to 2,3)
				given one parameter, evaluate and return it. (it's an Else and all the If/ElseIf were false)
				given 0 parameters, return NULL (not great practice, but there was no Else)
			*/
			for(i = 0 ; i < values.length - 1 ; i += 2){
				if( jsonLogic.truthy( jsonLogic.apply(values[i], data) ) ){
					return jsonLogic.apply(values[i+1], data);
				}
			}
			if(values.length === i+1) return jsonLogic.apply(values[i], data);
			return null;
		}else if(op === "and"){ //Return first falsy, or last
				for(i=0 ; i < values.length ; i+=1){
	        current = jsonLogic.apply(values[i], data);
	        if( ! jsonLogic.truthy(current)){
	          return current;
	        }
	      }
				return current; //Last
			}else if(op === "or"){//Return first truthy, or last
				for(i=0 ; i < values.length ; i+=1){
	        current = jsonLogic.apply(values[i], data);
	        if( jsonLogic.truthy(current) ){
	          return current;
	        }
	      }
				return current; //Last
			}
	
	
	
		// Everyone else gets immediate depth-first recursion
		values = values.map(function(val){ return jsonLogic.apply(val, data); });
	
	
	  if(typeof operations[op] === 'function'){
	  	return operations[op].apply(data, values);
	  }else if(op.indexOf('.') > 0){ //Contains a dot, and not in the 0th position
	    var sub_ops = String(op).split('.'),
	    operation = operations;
	    for(i = 0 ; i < sub_ops.length ; i++){
	      //Descending into operations
	      operation = operation[ sub_ops[i] ];
	      if(operation === undefined){
	        throw new Error("Unrecognized operation " + op +
	          " (failed at " + sub_ops.slice(0,i+1).join('.') + ")");
	      }
	    }
	
	    return operation.apply(data, values);
	
	  }else{
			throw new Error("Unrecognized operation " + op );
		}
	
	  //The operation is called with "data" bound to its "this" and "values" passed as arguments.
	  //Structured commands like % or > can name formal arguments while flexible commands (like missing or merge) can operate on the pseudo-array arguments
	  //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/arguments
		return operations[op].apply(data, values);
	
	};
	
	jsonLogic.uses_data = function(logic){
		var collection = [];
	
		if( jsonLogic.is_logic(logic) ){
			var op = Object.keys(logic)[0],
				values = logic[op];
	
			if( ! Array.isArray(values)){ values = [values]; }
	
			if(op === "var"){
				//This doesn't cover the case where the arg to var is itself a rule.
				collection.push(values[0]);
			}else{
				//Recursion!
				values.map(function(val){
					collection.push.apply(collection, jsonLogic.uses_data(val) );
				});
			}
		}
	
		return collection.unique();
	};
	
	jsonLogic.add_operation = function (name, code){
	  operations[name] = code;
	};
	
	return jsonLogic;
	
	}));


/***/ },
/* 986 */
/***/ function(module, exports) {

	exports = module.exports = stringify
	exports.getSerialize = serializer
	
	function stringify(obj, replacer, spaces, cycleReplacer) {
	  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
	}
	
	function serializer(replacer, cycleReplacer) {
	  var stack = [], keys = []
	
	  if (cycleReplacer == null) cycleReplacer = function(key, value) {
	    if (stack[0] === value) return "[Circular ~]"
	    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
	  }
	
	  return function(key, value) {
	    if (stack.length > 0) {
	      var thisPos = stack.indexOf(this)
	      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
	      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
	      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
	    }
	    else stack.push(value)
	
	    return replacer == null ? value : replacer.call(this, key, value)
	  }
	}


/***/ },
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 995 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(115),
	    keys = __webpack_require__(134);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(115),
	    keysIn = __webpack_require__(173);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(163),
	    arrayEach = __webpack_require__(377),
	    assignValue = __webpack_require__(381),
	    baseAssign = __webpack_require__(999),
	    baseAssignIn = __webpack_require__(1000),
	    cloneBuffer = __webpack_require__(385),
	    copyArray = __webpack_require__(260),
	    copySymbols = __webpack_require__(1034),
	    copySymbolsIn = __webpack_require__(1035),
	    getAllKeys = __webpack_require__(390),
	    getAllKeysIn = __webpack_require__(391),
	    getTag = __webpack_require__(393),
	    initCloneArray = __webpack_require__(1053),
	    initCloneByTag = __webpack_require__(1054),
	    initCloneObject = __webpack_require__(394),
	    isArray = __webpack_require__(37),
	    isBuffer = __webpack_require__(171),
	    isObject = __webpack_require__(62),
	    keys = __webpack_require__(134);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 1002 */,
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(383),
	    createBaseEach = __webpack_require__(1038);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(256),
	    isFlattenable = __webpack_require__(1055);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(166),
	    last = __webpack_require__(1088),
	    parent = __webpack_require__(1074),
	    toKey = __webpack_require__(116);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ },
/* 1027 */,
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(169);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(259);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(994),
	    arrayReduce = __webpack_require__(379),
	    mapToArray = __webpack_require__(396);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 1031 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(995),
	    arrayReduce = __webpack_require__(379),
	    setToArray = __webpack_require__(400);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(113);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(115),
	    getSymbols = __webpack_require__(262);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(115),
	    getSymbolsIn = __webpack_require__(392);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 1036 */,
/* 1037 */,
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(133);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 1039 */,
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(117);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ },
/* 1041 */,
/* 1042 */,
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(1084),
	    overRest = __webpack_require__(399),
	    setToString = __webpack_require__(401);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(259),
	    cloneDataView = __webpack_require__(1029),
	    cloneMap = __webpack_require__(1030),
	    cloneRegExp = __webpack_require__(1031),
	    cloneSet = __webpack_require__(1032),
	    cloneSymbol = __webpack_require__(1033),
	    cloneTypedArray = __webpack_require__(386);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(113),
	    isArguments = __webpack_require__(170),
	    isArray = __webpack_require__(37);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(257),
	    baseSlice = __webpack_require__(1022);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(1004);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 1089 */,
/* 1090 */,
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(255),
	    baseClone = __webpack_require__(1001),
	    baseUnset = __webpack_require__(1026),
	    castPath = __webpack_require__(166),
	    copyObject = __webpack_require__(115),
	    customOmitClone = __webpack_require__(1040),
	    flatRest = __webpack_require__(1043),
	    getAllKeysIn = __webpack_require__(391);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ },
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */
/***/ function(module, exports) {

	/* eslint-disable no-unused-vars */
	'use strict';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*!
	 * Platform.js <https://mths.be/platform>
	 * Copyright 2014-2016 Benjamin Tan <https://demoneaux.github.io/>
	 * Copyright 2011-2013 John-David Dalton <http://allyoucanleet.com/>
	 * Available under MIT license <https://mths.be/mit>
	 */
	;(function() {
	  'use strict';
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used as a reference to the global object. */
	  var root = (objectTypes[typeof window] && window) || this;
	
	  /** Backup possible global object. */
	  var oldRoot = root;
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;
	  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  /**
	   * Used as the maximum length of an array-like object.
	   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
	   * for more details.
	   */
	  var maxSafeInteger = Math.pow(2, 53) - 1;
	
	  /** Regular expression to detect Opera. */
	  var reOpera = /\bOpera/;
	
	  /** Possible global object. */
	  var thisBinding = this;
	
	  /** Used for native method references. */
	  var objectProto = Object.prototype;
	
	  /** Used to check for own properties of an object. */
	  var hasOwnProperty = objectProto.hasOwnProperty;
	
	  /** Used to resolve the internal `[[Class]]` of values. */
	  var toString = objectProto.toString;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Capitalizes a string value.
	   *
	   * @private
	   * @param {string} string The string to capitalize.
	   * @returns {string} The capitalized string.
	   */
	  function capitalize(string) {
	    string = String(string);
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  }
	
	  /**
	   * A utility function to clean up the OS name.
	   *
	   * @private
	   * @param {string} os The OS name to clean up.
	   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
	   * @param {string} [label] A label for the OS.
	   */
	  function cleanupOS(os, pattern, label) {
	    // Platform tokens are defined at:
	    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
	    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
	    var data = {
	      '10.0': '10',
	      '6.4':  '10 Technical Preview',
	      '6.3':  '8.1',
	      '6.2':  '8',
	      '6.1':  'Server 2008 R2 / 7',
	      '6.0':  'Server 2008 / Vista',
	      '5.2':  'Server 2003 / XP 64-bit',
	      '5.1':  'XP',
	      '5.01': '2000 SP1',
	      '5.0':  '2000',
	      '4.0':  'NT',
	      '4.90': 'ME'
	    };
	    // Detect Windows version from platform tokens.
	    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) &&
	        (data = data[/[\d.]+$/.exec(os)])) {
	      os = 'Windows ' + data;
	    }
	    // Correct character case and cleanup string.
	    os = String(os);
	
	    if (pattern && label) {
	      os = os.replace(RegExp(pattern, 'i'), label);
	    }
	
	    os = format(
	      os.replace(/ ce$/i, ' CE')
	        .replace(/\bhpw/i, 'web')
	        .replace(/\bMacintosh\b/, 'Mac OS')
	        .replace(/_PowerPC\b/i, ' OS')
	        .replace(/\b(OS X) [^ \d]+/i, '$1')
	        .replace(/\bMac (OS X)\b/, '$1')
	        .replace(/\/(\d)/, ' $1')
	        .replace(/_/g, '.')
	        .replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '')
	        .replace(/\bx86\.64\b/gi, 'x86_64')
	        .replace(/\b(Windows Phone) OS\b/, '$1')
	        .replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1')
	        .split(' on ')[0]
	    );
	
	    return os;
	  }
	
	  /**
	   * An iteration utility for arrays and objects.
	   *
	   * @private
	   * @param {Array|Object} object The object to iterate over.
	   * @param {Function} callback The function called per iteration.
	   */
	  function each(object, callback) {
	    var index = -1,
	        length = object ? object.length : 0;
	
	    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
	      while (++index < length) {
	        callback(object[index], index, object);
	      }
	    } else {
	      forOwn(object, callback);
	    }
	  }
	
	  /**
	   * Trim and conditionally capitalize string values.
	   *
	   * @private
	   * @param {string} string The string to format.
	   * @returns {string} The formatted string.
	   */
	  function format(string) {
	    string = trim(string);
	    return /^(?:webOS|i(?:OS|P))/.test(string)
	      ? string
	      : capitalize(string);
	  }
	
	  /**
	   * Iterates over an object's own properties, executing the `callback` for each.
	   *
	   * @private
	   * @param {Object} object The object to iterate over.
	   * @param {Function} callback The function executed per own property.
	   */
	  function forOwn(object, callback) {
	    for (var key in object) {
	      if (hasOwnProperty.call(object, key)) {
	        callback(object[key], key, object);
	      }
	    }
	  }
	
	  /**
	   * Gets the internal `[[Class]]` of a value.
	   *
	   * @private
	   * @param {*} value The value.
	   * @returns {string} The `[[Class]]`.
	   */
	  function getClassOf(value) {
	    return value == null
	      ? capitalize(value)
	      : toString.call(value).slice(8, -1);
	  }
	
	  /**
	   * Host objects can return type values that are different from their actual
	   * data type. The objects we are concerned with usually return non-primitive
	   * types of "object", "function", or "unknown".
	   *
	   * @private
	   * @param {*} object The owner of the property.
	   * @param {string} property The property to check.
	   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
	   */
	  function isHostType(object, property) {
	    var type = object != null ? typeof object[property] : 'number';
	    return !/^(?:boolean|number|string|undefined)$/.test(type) &&
	      (type == 'object' ? !!object[property] : true);
	  }
	
	  /**
	   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
	   *
	   * @private
	   * @param {string} string The string to qualify.
	   * @returns {string} The qualified string.
	   */
	  function qualify(string) {
	    return String(string).replace(/([ -])(?!$)/g, '$1?');
	  }
	
	  /**
	   * A bare-bones `Array#reduce` like utility function.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} callback The function called per iteration.
	   * @returns {*} The accumulated result.
	   */
	  function reduce(array, callback) {
	    var accumulator = null;
	    each(array, function(value, index) {
	      accumulator = callback(accumulator, value, index, array);
	    });
	    return accumulator;
	  }
	
	  /**
	   * Removes leading and trailing whitespace from a string.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} The trimmed string.
	   */
	  function trim(string) {
	    return String(string).replace(/^ +| +$/g, '');
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Creates a new platform object.
	   *
	   * @memberOf platform
	   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
	   *  context object.
	   * @returns {Object} A platform object.
	   */
	  function parse(ua) {
	
	    /** The environment context object. */
	    var context = root;
	
	    /** Used to flag when a custom context is provided. */
	    var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';
	
	    // Juggle arguments.
	    if (isCustomContext) {
	      context = ua;
	      ua = null;
	    }
	
	    /** Browser navigator object. */
	    var nav = context.navigator || {};
	
	    /** Browser user agent string. */
	    var userAgent = nav.userAgent || '';
	
	    ua || (ua = userAgent);
	
	    /** Used to flag when `thisBinding` is the [ModuleScope]. */
	    var isModuleScope = isCustomContext || thisBinding == oldRoot;
	
	    /** Used to detect if browser is like Chrome. */
	    var likeChrome = isCustomContext
	      ? !!nav.likeChrome
	      : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());
	
	    /** Internal `[[Class]]` value shortcuts. */
	    var objectClass = 'Object',
	        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
	        enviroClass = isCustomContext ? objectClass : 'Environment',
	        javaClass = (isCustomContext && context.java) ? 'JavaPackage' : getClassOf(context.java),
	        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';
	
	    /** Detect Java environments. */
	    var java = /\bJava/.test(javaClass) && context.java;
	
	    /** Detect Rhino. */
	    var rhino = java && getClassOf(context.environment) == enviroClass;
	
	    /** A character to represent alpha. */
	    var alpha = java ? 'a' : '\u03b1';
	
	    /** A character to represent beta. */
	    var beta = java ? 'b' : '\u03b2';
	
	    /** Browser document object. */
	    var doc = context.document || {};
	
	    /**
	     * Detect Opera browser (Presto-based).
	     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
	     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
	     */
	    var opera = context.operamini || context.opera;
	
	    /** Opera `[[Class]]`. */
	    var operaClass = reOpera.test(operaClass = (isCustomContext && opera) ? opera['[[Class]]'] : getClassOf(opera))
	      ? operaClass
	      : (opera = null);
	
	    /*------------------------------------------------------------------------*/
	
	    /** Temporary variable used over the script's lifetime. */
	    var data;
	
	    /** The CPU architecture. */
	    var arch = ua;
	
	    /** Platform description array. */
	    var description = [];
	
	    /** Platform alpha/beta indicator. */
	    var prerelease = null;
	
	    /** A flag to indicate that environment features should be used to resolve the platform. */
	    var useFeatures = ua == userAgent;
	
	    /** The browser/environment version. */
	    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();
	
	    /** A flag to indicate if the OS ends with "/ Version" */
	    var isSpecialCasedOS;
	
	    /* Detectable layout engines (order is important). */
	    var layout = getLayout([
	      { 'label': 'EdgeHTML', 'pattern': 'Edge' },
	      'Trident',
	      { 'label': 'WebKit', 'pattern': 'AppleWebKit' },
	      'iCab',
	      'Presto',
	      'NetFront',
	      'Tasman',
	      'KHTML',
	      'Gecko'
	    ]);
	
	    /* Detectable browser names (order is important). */
	    var name = getName([
	      'Adobe AIR',
	      'Arora',
	      'Avant Browser',
	      'Breach',
	      'Camino',
	      'Epiphany',
	      'Fennec',
	      'Flock',
	      'Galeon',
	      'GreenBrowser',
	      'iCab',
	      'Iceweasel',
	      'K-Meleon',
	      'Konqueror',
	      'Lunascape',
	      'Maxthon',
	      { 'label': 'Microsoft Edge', 'pattern': 'Edge' },
	      'Midori',
	      'Nook Browser',
	      'PaleMoon',
	      'PhantomJS',
	      'Raven',
	      'Rekonq',
	      'RockMelt',
	      'SeaMonkey',
	      { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
	      'Sleipnir',
	      'SlimBrowser',
	      { 'label': 'SRWare Iron', 'pattern': 'Iron' },
	      'Sunrise',
	      'Swiftfox',
	      'WebPositive',
	      'Opera Mini',
	      { 'label': 'Opera Mini', 'pattern': 'OPiOS' },
	      'Opera',
	      { 'label': 'Opera', 'pattern': 'OPR' },
	      'Chrome',
	      { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' },
	      { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' },
	      { 'label': 'Firefox for iOS', 'pattern': 'FxiOS' },
	      { 'label': 'IE', 'pattern': 'IEMobile' },
	      { 'label': 'IE', 'pattern': 'MSIE' },
	      'Safari'
	    ]);
	
	    /* Detectable products (order is important). */
	    var product = getProduct([
	      { 'label': 'BlackBerry', 'pattern': 'BB10' },
	      'BlackBerry',
	      { 'label': 'Galaxy S', 'pattern': 'GT-I9000' },
	      { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' },
	      { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' },
	      { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' },
	      'Google TV',
	      'Lumia',
	      'iPad',
	      'iPod',
	      'iPhone',
	      'Kindle',
	      { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
	      'Nexus',
	      'Nook',
	      'PlayBook',
	      'PlayStation 3',
	      'PlayStation 4',
	      'PlayStation Vita',
	      'TouchPad',
	      'Transformer',
	      { 'label': 'Wii U', 'pattern': 'WiiU' },
	      'Wii',
	      'Xbox One',
	      { 'label': 'Xbox 360', 'pattern': 'Xbox' },
	      'Xoom'
	    ]);
	
	    /* Detectable manufacturers. */
	    var manufacturer = getManufacturer({
	      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
	      'Archos': {},
	      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
	      'Asus': { 'Transformer': 1 },
	      'Barnes & Noble': { 'Nook': 1 },
	      'BlackBerry': { 'PlayBook': 1 },
	      'Google': { 'Google TV': 1, 'Nexus': 1 },
	      'HP': { 'TouchPad': 1 },
	      'HTC': {},
	      'LG': {},
	      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
	      'Motorola': { 'Xoom': 1 },
	      'Nintendo': { 'Wii U': 1,  'Wii': 1 },
	      'Nokia': { 'Lumia': 1 },
	      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
	      'Sony': { 'PlayStation 4': 1, 'PlayStation 3': 1, 'PlayStation Vita': 1 }
	    });
	
	    /* Detectable operating systems (order is important). */
	    var os = getOS([
	      'Windows Phone',
	      'Android',
	      'CentOS',
	      { 'label': 'Chrome OS', 'pattern': 'CrOS' },
	      'Debian',
	      'Fedora',
	      'FreeBSD',
	      'Gentoo',
	      'Haiku',
	      'Kubuntu',
	      'Linux Mint',
	      'OpenBSD',
	      'Red Hat',
	      'SuSE',
	      'Ubuntu',
	      'Xubuntu',
	      'Cygwin',
	      'Symbian OS',
	      'hpwOS',
	      'webOS ',
	      'webOS',
	      'Tablet OS',
	      'Linux',
	      'Mac OS X',
	      'Macintosh',
	      'Mac',
	      'Windows 98;',
	      'Windows '
	    ]);
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Picks the layout engine from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected layout engine.
	     */
	    function getLayout(guesses) {
	      return reduce(guesses, function(result, guess) {
	        return result || RegExp('\\b' + (
	          guess.pattern || qualify(guess)
	        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
	      });
	    }
	
	    /**
	     * Picks the manufacturer from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An object of guesses.
	     * @returns {null|string} The detected manufacturer.
	     */
	    function getManufacturer(guesses) {
	      return reduce(guesses, function(result, value, key) {
	        // Lookup the manufacturer by product or scan the UA for the manufacturer.
	        return result || (
	          value[product] ||
	          value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] ||
	          RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)
	        ) && key;
	      });
	    }
	
	    /**
	     * Picks the browser name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected browser name.
	     */
	    function getName(guesses) {
	      return reduce(guesses, function(result, guess) {
	        return result || RegExp('\\b' + (
	          guess.pattern || qualify(guess)
	        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
	      });
	    }
	
	    /**
	     * Picks the OS name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected OS name.
	     */
	    function getOS(guesses) {
	      return reduce(guesses, function(result, guess) {
	        var pattern = guess.pattern || qualify(guess);
	        if (!result && (result =
	              RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua)
	            )) {
	          result = cleanupOS(result, pattern, guess.label || guess);
	        }
	        return result;
	      });
	    }
	
	    /**
	     * Picks the product name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected product name.
	     */
	    function getProduct(guesses) {
	      return reduce(guesses, function(result, guess) {
	        var pattern = guess.pattern || qualify(guess);
	        if (!result && (result =
	              RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) ||
	              RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua)
	            )) {
	          // Split by forward slash and append product version if needed.
	          if ((result = String((guess.label && !RegExp(pattern, 'i').test(guess.label)) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
	            result[0] += ' ' + result[1];
	          }
	          // Correct character case and cleanup string.
	          guess = guess.label || guess;
	          result = format(result[0]
	            .replace(RegExp(pattern, 'i'), guess)
	            .replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ')
	            .replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
	        }
	        return result;
	      });
	    }
	
	    /**
	     * Resolves the version using an array of UA patterns.
	     *
	     * @private
	     * @param {Array} patterns An array of UA patterns.
	     * @returns {null|string} The detected version.
	     */
	    function getVersion(patterns) {
	      return reduce(patterns, function(result, pattern) {
	        return result || (RegExp(pattern +
	          '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
	      });
	    }
	
	    /**
	     * Returns `platform.description` when the platform object is coerced to a string.
	     *
	     * @name toString
	     * @memberOf platform
	     * @returns {string} Returns `platform.description` if available, else an empty string.
	     */
	    function toStringPlatform() {
	      return this.description || '';
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Convert layout to an array so we can add extra details.
	    layout && (layout = [layout]);
	
	    // Detect product names that contain their manufacturer's name.
	    if (manufacturer && !product) {
	      product = getProduct([manufacturer]);
	    }
	    // Clean up Google TV.
	    if ((data = /\bGoogle TV\b/.exec(product))) {
	      product = data[0];
	    }
	    // Detect simulators.
	    if (/\bSimulator\b/i.test(ua)) {
	      product = (product ? product + ' ' : '') + 'Simulator';
	    }
	    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
	    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
	      description.push('running in Turbo/Uncompressed mode');
	    }
	    // Detect IE Mobile 11.
	    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
	      data = parse(ua.replace(/like iPhone OS/, ''));
	      manufacturer = data.manufacturer;
	      product = data.product;
	    }
	    // Detect iOS.
	    else if (/^iP/.test(product)) {
	      name || (name = 'Safari');
	      os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua))
	        ? ' ' + data[1].replace(/_/g, '.')
	        : '');
	    }
	    // Detect Kubuntu.
	    else if (name == 'Konqueror' && !/buntu/i.test(os)) {
	      os = 'Kubuntu';
	    }
	    // Detect Android browsers.
	    else if ((manufacturer && manufacturer != 'Google' &&
	        ((/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua)) || /\bVita\b/.test(product))) ||
	        (/\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua))) {
	      name = 'Android Browser';
	      os = /\bAndroid\b/.test(os) ? os : 'Android';
	    }
	    // Detect Silk desktop/accelerated modes.
	    else if (name == 'Silk') {
	      if (!/\bMobi/i.test(ua)) {
	        os = 'Android';
	        description.unshift('desktop mode');
	      }
	      if (/Accelerated *= *true/i.test(ua)) {
	        description.unshift('accelerated');
	      }
	    }
	    // Detect PaleMoon identifying as Firefox.
	    else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
	      description.push('identifying as Firefox ' + data[1]);
	    }
	    // Detect Firefox OS and products running Firefox.
	    else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
	      os || (os = 'Firefox OS');
	      product || (product = data[1]);
	    }
	    // Detect false positives for Firefox/Safari.
	    else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
	      // Escape the `/` for Firefox 1.
	      if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
	        // Clear name of false positives.
	        name = null;
	      }
	      // Reassign a generic name.
	      if ((data = product || manufacturer || os) &&
	          (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
	        name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
	      }
	    }
	    // Detect non-Opera (Presto-based) versions (order is important).
	    if (!version) {
	      version = getVersion([
	        '(?:Cloud9|CriOS|CrMo|Edge|FxiOS|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|Silk(?!/[\\d.]+$))',
	        'Version',
	        qualify(name),
	        '(?:Firefox|Minefield|NetFront)'
	      ]);
	    }
	    // Detect stubborn layout engines.
	    if ((data =
	          layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' ||
	          /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') ||
	          /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' ||
	          !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') ||
	          layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront'
	        )) {
	      layout = [data];
	    }
	    // Detect Windows Phone 7 desktop mode.
	    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
	      name += ' Mobile';
	      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
	      description.unshift('desktop mode');
	    }
	    // Detect Windows Phone 8.x desktop mode.
	    else if (/\bWPDesktop\b/i.test(ua)) {
	      name = 'IE Mobile';
	      os = 'Windows Phone 8.x';
	      description.unshift('desktop mode');
	      version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
	    }
	    // Detect IE 11.
	    else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
	      if (name) {
	        description.push('identifying as ' + name + (version ? ' ' + version : ''));
	      }
	      name = 'IE';
	      version = data[1];
	    }
	    // Leverage environment features.
	    if (useFeatures) {
	      // Detect server-side environments.
	      // Rhino has a global function while others have a global object.
	      if (isHostType(context, 'global')) {
	        if (java) {
	          data = java.lang.System;
	          arch = data.getProperty('os.arch');
	          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
	        }
	        if (isModuleScope && isHostType(context, 'system') && (data = [context.system])[0]) {
	          os || (os = data[0].os || null);
	          try {
	            data[1] = context.require('ringo/engine').version;
	            version = data[1].join('.');
	            name = 'RingoJS';
	          } catch(e) {
	            if (data[0].global.system == context.system) {
	              name = 'Narwhal';
	            }
	          }
	        }
	        else if (
	          typeof context.process == 'object' && !context.process.browser &&
	          (data = context.process)
	        ) {
	          name = 'Node.js';
	          arch = data.arch;
	          os = data.platform;
	          version = /[\d.]+/.exec(data.version)[0];
	        }
	        else if (rhino) {
	          name = 'Rhino';
	        }
	      }
	      // Detect Adobe AIR.
	      else if (getClassOf((data = context.runtime)) == airRuntimeClass) {
	        name = 'Adobe AIR';
	        os = data.flash.system.Capabilities.os;
	      }
	      // Detect PhantomJS.
	      else if (getClassOf((data = context.phantom)) == phantomClass) {
	        name = 'PhantomJS';
	        version = (data = data.version || null) && (data.major + '.' + data.minor + '.' + data.patch);
	      }
	      // Detect IE compatibility modes.
	      else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
	        // We're in compatibility mode when the Trident version + 4 doesn't
	        // equal the document mode.
	        version = [version, doc.documentMode];
	        if ((data = +data[1] + 4) != version[1]) {
	          description.push('IE ' + version[1] + ' mode');
	          layout && (layout[1] = '');
	          version[1] = data;
	        }
	        version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
	      }
	      os = os && format(os);
	    }
	    // Detect prerelease phases.
	    if (version && (data =
	          /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) ||
	          /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) ||
	          /\bMinefield\b/i.test(ua) && 'a'
	        )) {
	      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
	      version = version.replace(RegExp(data + '\\+?$'), '') +
	        (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
	    }
	    // Detect Firefox Mobile.
	    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS)\b/.test(os)) {
	      name = 'Firefox Mobile';
	    }
	    // Obscure Maxthon's unreliable version.
	    else if (name == 'Maxthon' && version) {
	      version = version.replace(/\.[\d.]+/, '.x');
	    }
	    // Detect Xbox 360 and Xbox One.
	    else if (/\bXbox\b/i.test(product)) {
	      os = null;
	      if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
	        description.unshift('mobile mode');
	      }
	    }
	    // Add mobile postfix.
	    else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) &&
	        (os == 'Windows CE' || /Mobi/i.test(ua))) {
	      name += ' Mobile';
	    }
	    // Detect IE platform preview.
	    else if (name == 'IE' && useFeatures && context.external === null) {
	      description.unshift('platform preview');
	    }
	    // Detect BlackBerry OS version.
	    // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
	    else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data =
	          (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] ||
	          version
	        )) {
	      data = [data, /BB10/.test(ua)];
	      os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
	      version = null;
	    }
	    // Detect Opera identifying/masking itself as another browser.
	    // http://www.opera.com/support/kb/view/843/
	    else if (this != forOwn && product != 'Wii' && (
	          (useFeatures && opera) ||
	          (/Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua)) ||
	          (name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os)) ||
	          (name == 'IE' && (
	            (os && !/^Win/.test(os) && version > 5.5) ||
	            /\bWindows XP\b/.test(os) && version > 8 ||
	            version == 8 && !/\bTrident\b/.test(ua)
	          ))
	        ) && !reOpera.test((data = parse.call(forOwn, ua.replace(reOpera, '') + ';'))) && data.name) {
	      // When "identifying", the UA contains both Opera and the other browser's name.
	      data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
	      if (reOpera.test(name)) {
	        if (/\bIE\b/.test(data) && os == 'Mac OS') {
	          os = null;
	        }
	        data = 'identify' + data;
	      }
	      // When "masking", the UA contains only the other browser's name.
	      else {
	        data = 'mask' + data;
	        if (operaClass) {
	          name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
	        } else {
	          name = 'Opera';
	        }
	        if (/\bIE\b/.test(data)) {
	          os = null;
	        }
	        if (!useFeatures) {
	          version = null;
	        }
	      }
	      layout = ['Presto'];
	      description.push(data);
	    }
	    // Detect WebKit Nightly and approximate Chrome/Safari versions.
	    if ((data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
	      // Correct build number for numeric comparison.
	      // (e.g. "532.5" becomes "532.05")
	      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
	      // Nightly builds are postfixed with a "+".
	      if (name == 'Safari' && data[1].slice(-1) == '+') {
	        name = 'WebKit Nightly';
	        prerelease = 'alpha';
	        version = data[1].slice(0, -1);
	      }
	      // Clear incorrect browser versions.
	      else if (version == data[1] ||
	          version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
	        version = null;
	      }
	      // Use the full Chrome version when available.
	      data[1] = (/\bChrome\/([\d.]+)/i.exec(ua) || 0)[1];
	      // Detect Blink layout engine.
	      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
	        layout = ['Blink'];
	      }
	      // Detect JavaScriptCore.
	      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
	      if (!useFeatures || (!likeChrome && !data[1])) {
	        layout && (layout[1] = 'like Safari');
	        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : '8');
	      } else {
	        layout && (layout[1] = 'like Chrome');
	        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
	      }
	      // Add the postfix of ".x" or "+" for approximate versions.
	      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
	      // Obscure version for some Safari 1-2 releases.
	      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
	        version = data;
	      }
	    }
	    // Detect Opera desktop modes.
	    if (name == 'Opera' &&  (data = /\bzbov|zvav$/.exec(os))) {
	      name += ' ';
	      description.unshift('desktop mode');
	      if (data == 'zvav') {
	        name += 'Mini';
	        version = null;
	      } else {
	        name += 'Mobile';
	      }
	      os = os.replace(RegExp(' *' + data + '$'), '');
	    }
	    // Detect Chrome desktop mode.
	    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
	      description.unshift('desktop mode');
	      name = 'Chrome Mobile';
	      version = null;
	
	      if (/\bOS X\b/.test(os)) {
	        manufacturer = 'Apple';
	        os = 'iOS 4.3+';
	      } else {
	        os = null;
	      }
	    }
	    // Strip incorrect OS versions.
	    if (version && version.indexOf((data = /[\d.]+$/.exec(os))) == 0 &&
	        ua.indexOf('/' + data + '-') > -1) {
	      os = trim(os.replace(data, ''));
	    }
	    // Add layout engine.
	    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (
	        /Browser|Lunascape|Maxthon/.test(name) ||
	        name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) ||
	        /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Sleipnir|Web)/.test(name) && layout[1])) {
	      // Don't add layout details to description if they are falsey.
	      (data = layout[layout.length - 1]) && description.push(data);
	    }
	    // Combine contextual information.
	    if (description.length) {
	      description = ['(' + description.join('; ') + ')'];
	    }
	    // Append manufacturer to description.
	    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
	      description.push('on ' + manufacturer);
	    }
	    // Append product to description.
	    if (product) {
	      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
	    }
	    // Parse the OS into an object.
	    if (os) {
	      data = / ([\d.+]+)$/.exec(os);
	      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
	      os = {
	        'architecture': 32,
	        'family': (data && !isSpecialCasedOS) ? os.replace(data[0], '') : os,
	        'version': data ? data[1] : null,
	        'toString': function() {
	          var version = this.version;
	          return this.family + ((version && !isSpecialCasedOS) ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
	        }
	      };
	    }
	    // Add browser/OS architecture.
	    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
	      if (os) {
	        os.architecture = 64;
	        os.family = os.family.replace(RegExp(' *' + data), '');
	      }
	      if (
	          name && (/\bWOW64\b/i.test(ua) ||
	          (useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua)))
	      ) {
	        description.unshift('32-bit');
	      }
	    }
	    // Chrome 39 and above on OS X is always 64-bit.
	    else if (
	        os && /^OS X/.test(os.family) &&
	        name == 'Chrome' && parseFloat(version) >= 39
	    ) {
	      os.architecture = 64;
	    }
	
	    ua || (ua = null);
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The platform object.
	     *
	     * @name platform
	     * @type Object
	     */
	    var platform = {};
	
	    /**
	     * The platform description.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.description = ua;
	
	    /**
	     * The name of the browser's layout engine.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.layout = layout && layout[0];
	
	    /**
	     * The name of the product's manufacturer.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.manufacturer = manufacturer;
	
	    /**
	     * The name of the browser/environment.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.name = name;
	
	    /**
	     * The alpha/beta release indicator.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.prerelease = prerelease;
	
	    /**
	     * The name of the product hosting the browser.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.product = product;
	
	    /**
	     * The browser's user agent string.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.ua = ua;
	
	    /**
	     * The browser/environment version.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.version = name && version;
	
	    /**
	     * The name of the operating system.
	     *
	     * @memberOf platform
	     * @type Object
	     */
	    platform.os = os || {
	
	      /**
	       * The CPU architecture the OS is built for.
	       *
	       * @memberOf platform.os
	       * @type number|null
	       */
	      'architecture': null,
	
	      /**
	       * The family of the OS.
	       *
	       * Common values include:
	       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
	       * "Windows XP", "OS X", "Ubuntu", "Debian", "Fedora", "Red Hat", "SuSE",
	       * "Android", "iOS" and "Windows Phone"
	       *
	       * @memberOf platform.os
	       * @type string|null
	       */
	      'family': null,
	
	      /**
	       * The version of the OS.
	       *
	       * @memberOf platform.os
	       * @type string|null
	       */
	      'version': null,
	
	      /**
	       * Returns the OS string.
	       *
	       * @memberOf platform.os
	       * @returns {string} The OS string.
	       */
	      'toString': function() { return 'null'; }
	    };
	
	    platform.parse = parse;
	    platform.toString = toStringPlatform;
	
	    if (platform.version) {
	      description.unshift(version);
	    }
	    if (platform.name) {
	      description.unshift(name);
	    }
	    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
	      description.push(product ? '(' + os + ')' : 'on ' + os);
	    }
	    if (description.length) {
	      platform.description = description.join(' ');
	    }
	    return platform;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export platform.
	  var platform = parse();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
	  if (true) {
	    // Expose platform on the global object to prevent errors when platform is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    root.platform = platform;
	
	    // Define as an anonymous module so platform can be aliased through path mapping.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return platform;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for CommonJS support.
	    forOwn(platform, function(value, key) {
	      freeExports[key] = value;
	    });
	  }
	  else {
	    // Export to the global object.
	    root.platform = platform;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(100)(module), (function() { return this; }())))

/***/ },
/* 1098 */,
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(579);
	var objectAssign = __webpack_require__(1100);
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (ret[key] === undefined) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
		});
	
		return ret;
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true
		};
	
		opts = objectAssign(defaults, opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					if (val2 === null) {
						result.push(encode(key, opts));
					} else {
						result.push(encode(key, opts) + '=' + encode(val2, opts));
					}
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 1100 */
22,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(518);
	var ReactServerRendering = __webpack_require__(1137);
	var ReactVersion = __webpack_require__(527);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var React = __webpack_require__(97);
	var ReactDOMContainerInfo = __webpack_require__(515);
	var ReactDefaultBatchingStrategy = __webpack_require__(517);
	var ReactInstrumentation = __webpack_require__(42);
	var ReactMarkupChecksum = __webpack_require__(523);
	var ReactReconciler = __webpack_require__(95);
	var ReactServerBatchingStrategy = __webpack_require__(1136);
	var ReactServerRenderingTransaction = __webpack_require__(526);
	var ReactUpdates = __webpack_require__(49);
	
	var emptyObject = __webpack_require__(111);
	var instantiateReactComponent = __webpack_require__(282);
	var invariant = __webpack_require__(5);
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
	      );
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSideEffect = __webpack_require__(1209);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(367);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _objectAssign = __webpack_require__(1096);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstantsJs = __webpack_require__(1164);
	
	var _PlainComponent = __webpack_require__(1165);
	
	var _PlainComponent2 = _interopRequireDefault(_PlainComponent);
	
	var HELMET_ATTRIBUTE = "data-react-helmet";
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    var reversedPropsList = [].concat(propsList).reverse();
	
	    for (var i = 0; i < reversedPropsList.length; i++) {
	        var props = reversedPropsList[i];
	
	        if (props[property]) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, "title");
	    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");
	
	    if (innermostTemplate && innermostTitle) {
	        return innermostTemplate.replace(/\%s/g, innermostTitle);
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, "defaultTitle");
	
	    return innermostTitle || innermostDefaultTitle || "";
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
	};
	
	var getHtmlAttributesFromPropsList = function getHtmlAttributesFromPropsList(propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstantsJs.TAG_NAMES.HTML] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstantsJs.TAG_NAMES.HTML];
	    }).reduce(function (html, current) {
	        return _extends({}, html, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstantsJs.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstantsJs.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    var tagList = propsList.filter(function (props) {
	        return typeof props[tagName] !== "undefined";
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = undefined;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstantsJs.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstantsJs.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstantsJs.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstantsJs.TAG_PROPERTIES.CSS_TEXT)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2["default"])({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	
	    return tagList;
	};
	
	var updateTitle = function updateTitle(title) {
	    document.title = title || document.title;
	};
	
	var updateHtmlAttributes = function updateHtmlAttributes(attributes) {
	    var htmlTag = document.getElementsByTagName("html")[0];
	    var helmetAttributeString = htmlTag.getAttribute(HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	        htmlTag.setAttribute(attribute, value);
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var i = attributesToRemove.length - 1; i >= 0; i--) {
	        htmlTag.removeAttribute(attributesToRemove[i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        htmlTag.removeAttribute(HELMET_ATTRIBUTE);
	    } else {
	        htmlTag.setAttribute(HELMET_ATTRIBUTE, helmetAttributes.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector("head");
	    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = undefined;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === "innerHTML") {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === "cssText") {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateHtmlAttributesAsString = function generateHtmlAttributesAsString(attributes) {
	    var keys = Object.keys(attributes);
	    var attributeString = "";
	
	    for (var i = 0; i < keys.length; i++) {
	        var attribute = keys[i];
	        var attr = typeof attributes[attribute] !== "undefined" ? attribute + "=\"" + attributes[attribute] + "\"" : "" + attribute;
	        attributeString += attr + " ";
	    }
	
	    return attributeString.trim();
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title) {
	    var stringifiedMarkup = "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title) + "</" + type + ">";
	
	    return stringifiedMarkup;
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags) {
	    var stringifiedMarkup = tags.map(function (tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === "innerHTML" || attribute === "cssText");
	        }).map(function (attribute) {
	            if (typeof tag[attribute] === "undefined") {
	                return attribute;
	            }
	
	            var encodedValue = encodeSpecialCharacters(tag[attribute]);
	            return attribute + "=\"" + encodedValue + "\"";
	        }).join(" ").trim();
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        return "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (type === _HelmetConstantsJs.TAG_NAMES.SCRIPT || type === _HelmetConstantsJs.TAG_NAMES.STYLE ? ">" + tagContent + "</" + type + ">" : "/>");
	    }).join("");
	
	    return stringifiedMarkup;
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title) {
	    // assigning into an array to define toString function on it
	    var component = [_react2["default"].createElement(_HelmetConstantsJs.TAG_NAMES.TITLE, _defineProperty({
	        key: title
	    }, HELMET_ATTRIBUTE, true), title)];
	
	    return component;
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    /* eslint-disable react/display-name */
	    var component = tags.map(function (tag, i) {
	        var mappedTag = _defineProperty({
	            key: i
	        }, HELMET_ATTRIBUTE, true);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstantsJs.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2["default"].createElement(type, mappedTag);
	    });
	
	    return component;
	    /* eslint-enable react/display-name */
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags) {
	    switch (type) {
	        case _HelmetConstantsJs.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags);
	                }
	            };
	        case _HelmetConstantsJs.TAG_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return tags;
	                },
	                toString: function toString() {
	                    return generateHtmlAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var htmlAttributes = _ref.htmlAttributes;
	    var title = _ref.title;
	    var baseTag = _ref.baseTag;
	    var metaTags = _ref.metaTags;
	    var linkTags = _ref.linkTags;
	    var scriptTags = _ref.scriptTags;
	    var styleTags = _ref.styleTags;
	    return {
	        htmlAttributes: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.HTML, htmlAttributes),
	        title: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.TITLE, title),
	        base: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.BASE, baseTag),
	        meta: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.META, metaTags),
	        link: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.LINK, linkTags),
	        script: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.SCRIPT, scriptTags),
	        style: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.STYLE, styleTags)
	    };
	};
	
	var Helmet = function Helmet(Component) {
	    /* eslint-disable react/no-multi-comp */
	
	    var HelmetWrapper = (function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            _get(Object.getPrototypeOf(HelmetWrapper.prototype), "constructor", this).apply(this, arguments);
	        }
	
	        /* eslint-enable react/no-multi-comp */
	
	        _createClass(HelmetWrapper, [{
	            key: "shouldComponentUpdate",
	            value: function shouldComponentUpdate(nextProps) {
	                return !(0, _deepEqual2["default"])(this.props, nextProps);
	            }
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	        }, {
	            key: "render",
	            value: function render() {
	                return _react2["default"].createElement(Component, this.props);
	            }
	        }], [{
	            key: "propTypes",
	
	            /**
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {String} title: "Title"
	             * @param {String} defaultTitle: "Default Title"
	             * @param {String} titleTemplate: "MySite.com - %s"
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div{ display: block; color: blue; }"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             */
	            value: {
	                htmlAttributes: _react2["default"].PropTypes.object,
	                title: _react2["default"].PropTypes.string,
	                defaultTitle: _react2["default"].PropTypes.string,
	                titleTemplate: _react2["default"].PropTypes.string,
	                base: _react2["default"].PropTypes.object,
	                meta: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object),
	                link: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object),
	                script: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object),
	                style: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object),
	                onChangeClientState: _react2["default"].PropTypes.func
	            },
	            enumerable: true
	        }, {
	            key: "peek",
	            value: Component.peek,
	            enumerable: true
	        }, {
	            key: "rewind",
	            value: function value() {
	                var mappedState = Component.rewind();
	                if (!mappedState) {
	                    // provide fallback if mappedState is undefined
	                    mappedState = mapStateOnServer({
	                        htmlAttributes: [],
	                        title: "",
	                        baseTag: [],
	                        metaTags: [],
	                        linkTags: [],
	                        scriptTags: [],
	                        styleTags: []
	                    });
	                }
	
	                return mappedState;
	            },
	            enumerable: true
	        }, {
	            key: "canUseDOM",
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    })(_react2["default"].Component);
	
	    return HelmetWrapper;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        htmlAttributes: getHtmlAttributesFromPropsList(propsList),
	        title: getTitleFromPropsList(propsList),
	        baseTag: getBaseTagFromPropsList([_HelmetConstantsJs.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.META, [_HelmetConstantsJs.TAG_PROPERTIES.NAME, _HelmetConstantsJs.TAG_PROPERTIES.CHARSET, _HelmetConstantsJs.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstantsJs.TAG_PROPERTIES.PROPERTY], propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.LINK, [_HelmetConstantsJs.TAG_PROPERTIES.REL, _HelmetConstantsJs.TAG_PROPERTIES.HREF], propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.SCRIPT, [_HelmetConstantsJs.TAG_PROPERTIES.SRC, _HelmetConstantsJs.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.STYLE, [_HelmetConstantsJs.TAG_PROPERTIES.CSS_TEXT], propsList),
	        onChangeClientState: getOnChangeClientState(propsList)
	    };
	};
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    var htmlAttributes = newState.htmlAttributes;
	    var title = newState.title;
	    var baseTag = newState.baseTag;
	    var metaTags = newState.metaTags;
	    var linkTags = newState.linkTags;
	    var scriptTags = newState.scriptTags;
	    var styleTags = newState.styleTags;
	    var onChangeClientState = newState.onChangeClientState;
	
	    updateHtmlAttributes(htmlAttributes);
	
	    updateTitle(title);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstantsJs.TAG_NAMES.BASE, baseTag),
	        metaTags: updateTags(_HelmetConstantsJs.TAG_NAMES.META, metaTags),
	        linkTags: updateTags(_HelmetConstantsJs.TAG_NAMES.LINK, linkTags),
	        scriptTags: updateTags(_HelmetConstantsJs.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstantsJs.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType];
	        var newTags = _tagUpdates$tagType.newTags;
	        var oldTags = _tagUpdates$tagType.oldTags;
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var SideEffect = (0, _reactSideEffect2["default"])(reducePropsToState, handleClientStateChange, mapStateOnServer);
	
	// PlainComponent is used to be a blank component decorated by react-side-effect
	exports["default"] = Helmet(SideEffect(_PlainComponent2["default"]));
	module.exports = exports["default"];

/***/ },
/* 1164 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TAG_NAMES = {
	    HTML: "htmlAttributes",
	    TITLE: "title",
	    BASE: "base",
	    META: "meta",
	    LINK: "link",
	    SCRIPT: "script",
	    STYLE: "style"
	};
	
	exports.TAG_NAMES = TAG_NAMES;
	var TAG_PROPERTIES = {
	    NAME: "name",
	    CHARSET: "charset",
	    HTTPEQUIV: "http-equiv",
	    REL: "rel",
	    HREF: "href",
	    PROPERTY: "property",
	    SRC: "src",
	    INNER_HTML: "innerHTML",
	    CSS_TEXT: "cssText"
	};
	
	exports.TAG_PROPERTIES = TAG_PROPERTIES;
	var REACT_TAG_MAP = {
	    "charset": "charSet",
	    "http-equiv": "httpEquiv"
	};
	exports.REACT_TAG_MAP = REACT_TAG_MAP;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var PlainComponent = (function (_React$Component) {
	    _inherits(PlainComponent, _React$Component);
	
	    function PlainComponent() {
	        _classCallCheck(this, PlainComponent);
	
	        _get(Object.getPrototypeOf(PlainComponent.prototype), "constructor", this).apply(this, arguments);
	    }
	
	    _createClass(PlainComponent, [{
	        key: "render",
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return PlainComponent;
	})(_react2["default"].Component);
	
	exports["default"] = PlainComponent;
	module.exports = exports["default"];

/***/ },
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fbjsLibExecutionEnvironment = __webpack_require__(1210);
	
	var _fbjsLibExecutionEnvironment2 = _interopRequireDefault(_fbjsLibExecutionEnvironment);
	
	var _fbjsLibShallowEqual = __webpack_require__(1211);
	
	var _fbjsLibShallowEqual2 = _interopRequireDefault(_fbjsLibShallowEqual);
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = undefined;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = (function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        _Component.apply(this, arguments);
	      }
	
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may ony call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !_fbjsLibShallowEqual2['default'](nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2['default'].createElement(WrappedComponent, this.props);
	      };
	
	      _createClass(SideEffect, null, [{
	        key: 'displayName',
	
	        // Try to use displayName of wrapped component
	        value: 'SideEffect(' + getDisplayName(WrappedComponent) + ')',
	
	        // Expose canUseDOM so tests can monkeypatch it
	        enumerable: true
	      }, {
	        key: 'canUseDOM',
	        value: _fbjsLibExecutionEnvironment2['default'].canUseDOM,
	        enumerable: true
	      }]);
	
	      return SideEffect;
	    })(_react.Component);
	
	    return SideEffect;
	  };
	};

/***/ },
/* 1210 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 1211 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = autoRehydrate;
	
	var _constants = __webpack_require__(140);
	
	var _isStatePlainEnough = __webpack_require__(1272);
	
	var _isStatePlainEnough2 = _interopRequireDefault(_isStatePlainEnough);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function autoRehydrate() {
	  var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var stateReconciler = config.stateReconciler || defaultStateReconciler;
	
	  return function (next) {
	    return function (reducer, initialState, enhancer) {
	      var store = next(liftReducer(reducer), initialState, enhancer);
	      return _extends({}, store, {
	        replaceReducer: function replaceReducer(reducer) {
	          return store.replaceReducer(liftReducer(reducer));
	        }
	      });
	    };
	  };
	
	  function liftReducer(reducer) {
	    var rehydrated = false;
	    var preRehydrateActions = [];
	    return function (state, action) {
	      if (action.type !== _constants.REHYDRATE) {
	        if (config.log && !rehydrated) preRehydrateActions.push(action); // store pre-rehydrate actions for debugging
	        return reducer(state, action);
	      } else {
	        if (config.log && !rehydrated) logPreRehydrate(preRehydrateActions);
	        rehydrated = true;
	
	        var inboundState = action.payload;
	        var reducedState = reducer(state, action);
	
	        return stateReconciler(state, inboundState, reducedState, config.log);
	      }
	    };
	  }
	}
	
	function logPreRehydrate(preRehydrateActions) {
	  if (preRehydrateActions.length > 0) {
	    console.log('\n      redux-persist/autoRehydrate: %d actions were fired before rehydration completed. This can be a symptom of a race\n      condition where the rehydrate action may overwrite the previously affected state. Consider running these actions\n      after rehydration:\n    ', preRehydrateActions.length);
	  }
	}
	
	function defaultStateReconciler(state, inboundState, reducedState, log) {
	  var newState = _extends({}, reducedState);
	
	  Object.keys(inboundState).forEach(function (key) {
	    // if initialState does not have key, skip auto rehydration
	    if (!state.hasOwnProperty(key)) return;
	
	    // if initial state is an object but inbound state is null/undefined, skip
	    if (_typeof(state[key]) === 'object' && !inboundState[key]) {
	      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` is falsy but initial state is an object, skipping autoRehydrate.', key);
	      return;
	    }
	
	    // if reducer modifies substate, skip auto rehydration
	    if (state[key] !== reducedState[key]) {
	      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` modified, skipping autoRehydrate.', key);
	      newState[key] = reducedState[key];
	      return;
	    }
	
	    // otherwise take the inboundState
	    if ((0, _isStatePlainEnough2.default)(inboundState[key]) && (0, _isStatePlainEnough2.default)(state[key])) newState[key] = _extends({}, state[key], inboundState[key]); // shallow merge
	    else newState[key] = inboundState[key]; // hard set
	
	    if (log) console.log('redux-persist/autoRehydrate: key `%s`, rehydrated to ', key, newState[key]);
	  });
	  return newState;
	}

/***/ },
/* 1269 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function createTransform(inbound, outbound) {
	  var config = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  var whitelist = config.whitelist || null;
	  var blacklist = config.blacklist || null;
	
	  function whitelistBlacklistCheck(key) {
	    if (whitelist && whitelist.indexOf(key) === -1) return true;
	    if (blacklist && blacklist.indexOf(key) !== -1) return true;
	    return false;
	  }
	
	  return {
	    in: function _in(state, key) {
	      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key) : state;
	    },
	    out: function out(state, key) {
	      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key) : state;
	    }
	  };
	}
	
	exports.default = createTransform;

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.storages = exports.purgeStoredState = exports.persistStore = exports.getStoredState = exports.createTransform = exports.createPersistor = exports.autoRehydrate = undefined;
	
	var _asyncLocalStorage = __webpack_require__(295);
	
	var _asyncLocalStorage2 = _interopRequireDefault(_asyncLocalStorage);
	
	var _autoRehydrate = __webpack_require__(1268);
	
	var _autoRehydrate2 = _interopRequireDefault(_autoRehydrate);
	
	var _createPersistor = __webpack_require__(569);
	
	var _createPersistor2 = _interopRequireDefault(_createPersistor);
	
	var _createTransform = __webpack_require__(1269);
	
	var _createTransform2 = _interopRequireDefault(_createTransform);
	
	var _getStoredState = __webpack_require__(570);
	
	var _getStoredState2 = _interopRequireDefault(_getStoredState);
	
	var _persistStore = __webpack_require__(1271);
	
	var _persistStore2 = _interopRequireDefault(_persistStore);
	
	var _purgeStoredState = __webpack_require__(571);
	
	var _purgeStoredState2 = _interopRequireDefault(_purgeStoredState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storageDeprecatedMessage = function storageDeprecatedMessage(type) {
	  return '\n  To import async' + type + 'Storage please import from \'redux-persist/storages\'. For Example:\n  `import { async' + type + 'Storage } from \'redux-persist/storages\'`\n  or `var async' + type + 'Storage = require(\'redux-persist/storages\').async' + type + 'Storage`\n';
	};
	
	var storages = {
	  asyncLocalStorage: (0, _asyncLocalStorage2.default)('local', { deprecated: storageDeprecatedMessage('Local') }),
	  asyncSessionStorage: (0, _asyncLocalStorage2.default)('session', { deprecated: storageDeprecatedMessage('Session') })
	};
	
	exports.autoRehydrate = _autoRehydrate2.default;
	exports.createPersistor = _createPersistor2.default;
	exports.createTransform = _createTransform2.default;
	exports.getStoredState = _getStoredState2.default;
	exports.persistStore = _persistStore2.default;
	exports.purgeStoredState = _purgeStoredState2.default;
	exports.storages = storages;

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = persistStore;
	
	var _constants = __webpack_require__(140);
	
	var _getStoredState = __webpack_require__(570);
	
	var _getStoredState2 = _interopRequireDefault(_getStoredState);
	
	var _createPersistor = __webpack_require__(569);
	
	var _createPersistor2 = _interopRequireDefault(_createPersistor);
	
	var _omit = __webpack_require__(1091);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// try to source setImmediate as follows: setImmediate (global) -> global.setImmediate -> setTimeout(fn, 0)
	var genericSetImmediate = typeof setImmediate === 'undefined' ? global.setImmediate || function (fn) {
	  return setTimeout(fn, 0);
	} : setImmediate;
	
	function persistStore(store) {
	  var config = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var onComplete = arguments[2];
	
	  // defaults
	  // @TODO remove shouldRestore
	  var shouldRestore = !config.skipRestore;
	  if (false) console.warn('redux-persist: config.skipRestore has been deprecated. If you want to skip restoration use `createPersistor` instead');
	
	  var purgeKeys = null;
	
	  // create and pause persistor
	  var persistor = (0, _createPersistor2.default)(store, config);
	  persistor.pause();
	
	  // restore
	  if (shouldRestore) {
	    genericSetImmediate(function () {
	      (0, _getStoredState2.default)(config, function (err, restoredState) {
	        // do not persist state for purgeKeys
	        restoredState = purgeKeys ? purgeKeys === '*' ? {} : (0, _omit2.default)(restoredState, purgeKeys) : restoredState;
	
	        store.dispatch(rehydrateAction(restoredState, err));
	        complete(err, restoredState);
	      });
	    });
	  } else genericSetImmediate(complete);
	
	  function complete(err, restoredState) {
	    persistor.resume();
	    onComplete && onComplete(err, restoredState);
	  }
	
	  return _extends({}, persistor, {
	    purge: function purge(keys) {
	      purgeKeys = keys || '*';
	      persistor.purge(keys);
	    }
	  });
	}
	
	function rehydrateAction(payload) {
	  var error = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	  return {
	    type: _constants.REHYDRATE,
	    payload: payload,
	    error: error
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187).setImmediate, (function() { return this; }())))

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isStatePlainEnough;
	
	var _isPlainObject = __webpack_require__(117);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isStatePlainEnough(a) {
	  // isPlainObject + duck type not immutable
	  if (!a) return false;
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object') return false;
	  if (typeof a.mergeDeep === 'function') return false;
	  if (!(0, _isPlainObject2.default)(a)) return false;
	  return true;
	}

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sagaMiddlewareFactory;
	
	var _utils = __webpack_require__(66);
	
	var _proc = __webpack_require__(296);
	
	var _proc2 = _interopRequireDefault(_proc);
	
	var _channel = __webpack_require__(185);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function sagaMiddlewareFactory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var runSagaDynamically = void 0;
	  var sagaMonitor = options.sagaMonitor;
	
	  // monitors are expected to have a certain interface, let's fill-in any missing ones
	
	  if (sagaMonitor) {
	    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || _utils.noop;
	    sagaMonitor.effectResolved = sagaMonitor.effectResolved || _utils.noop;
	    sagaMonitor.effectRejected = sagaMonitor.effectRejected || _utils.noop;
	    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || _utils.noop;
	    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || _utils.noop;
	  }
	
	  if (_utils.is.func(options)) {
	    if (true) {
	      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
	    } else {
	      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
	    }
	  }
	
	  if (options.logger && !_utils.is.func(options.logger)) {
	    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
	  }
	
	  if (options.onerror) {
	    if (_utils.isDev) (0, _utils.log)('warn', '`options.onerror` is deprecated. Use `options.onError` instead.');
	    options.onError = options.onerror;
	    delete options.onerror;
	  }
	
	  if (options.onError && !_utils.is.func(options.onError)) {
	    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
	  }
	
	  if (options.emitter && !_utils.is.func(options.emitter)) {
	    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
	  }
	
	  function sagaMiddleware(_ref) {
	    var getState = _ref.getState,
	        dispatch = _ref.dispatch;
	
	    runSagaDynamically = runSaga;
	    var sagaEmitter = (0, _channel.emitter)();
	    sagaEmitter.emit = (options.emitter || _utils.ident)(sagaEmitter.emit);
	    var sagaDispatch = (0, _utils.wrapSagaDispatch)(dispatch);
	
	    function runSaga(saga, args, sagaId) {
	      return (0, _proc2.default)(saga.apply(undefined, _toConsumableArray(args)), sagaEmitter.subscribe, sagaDispatch, getState, options, sagaId, saga.name);
	    }
	
	    return function (next) {
	      return function (action) {
	        if (sagaMonitor) {
	          sagaMonitor.actionDispatched(action);
	        }
	        var result = next(action); // hit reducers
	        sagaEmitter.emit(action);
	        return result;
	      };
	    };
	  }
	
	  sagaMiddleware.run = function (saga) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    (0, _utils.check)(runSagaDynamically, _utils.is.notUndef, 'Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
	    (0, _utils.check)(saga, _utils.is.func, 'sagaMiddleware.run(saga, ...args): saga argument must be a Generator function!');
	
	    var effectId = (0, _utils.uid)();
	    if (sagaMonitor) {
	      sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
	    }
	    var task = runSagaDynamically(saga, args, effectId);
	    if (sagaMonitor) {
	      sagaMonitor.effectResolved(effectId, task);
	    }
	    return task;
	  };
	
	  return sagaMiddleware;
	}

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.runSaga = runSaga;
	
	var _utils = __webpack_require__(66);
	
	var _proc = __webpack_require__(296);
	
	var _proc2 = _interopRequireDefault(_proc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function runSaga(iterator, _ref) {
	  var subscribe = _ref.subscribe,
	      dispatch = _ref.dispatch,
	      getState = _ref.getState,
	      sagaMonitor = _ref.sagaMonitor,
	      logger = _ref.logger,
	      onError = _ref.onError;
	
	
	  (0, _utils.check)(iterator, _utils.is.iterator, "runSaga must be called on an iterator");
	
	  var effectId = (0, _utils.uid)();
	  if (sagaMonitor) {
	    dispatch = (0, _utils.wrapSagaDispatch)(dispatch);
	    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: iterator, args: [] } });
	  }
	  var task = (0, _proc2.default)(iterator, subscribe, dispatch, getState, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, iterator.name);
	
	  if (sagaMonitor) {
	    sagaMonitor.effectResolved(effectId, task);
	  }
	
	  return task;
	}

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(66);
	
	Object.defineProperty(exports, 'TASK', {
	  enumerable: true,
	  get: function get() {
	    return _utils.TASK;
	  }
	});
	Object.defineProperty(exports, 'SAGA_ACTION', {
	  enumerable: true,
	  get: function get() {
	    return _utils.SAGA_ACTION;
	  }
	});
	Object.defineProperty(exports, 'noop', {
	  enumerable: true,
	  get: function get() {
	    return _utils.noop;
	  }
	});
	Object.defineProperty(exports, 'is', {
	  enumerable: true,
	  get: function get() {
	    return _utils.is;
	  }
	});
	Object.defineProperty(exports, 'deferred', {
	  enumerable: true,
	  get: function get() {
	    return _utils.deferred;
	  }
	});
	Object.defineProperty(exports, 'arrayOfDeffered', {
	  enumerable: true,
	  get: function get() {
	    return _utils.arrayOfDeffered;
	  }
	});
	Object.defineProperty(exports, 'createMockTask', {
	  enumerable: true,
	  get: function get() {
	    return _utils.createMockTask;
	  }
	});
	
	var _io = __webpack_require__(186);
	
	Object.defineProperty(exports, 'asEffect', {
	  enumerable: true,
	  get: function get() {
	    return _io.asEffect;
	  }
	});
	
	var _proc = __webpack_require__(296);
	
	Object.defineProperty(exports, 'CHANNEL_END', {
	  enumerable: true,
	  get: function get() {
	    return _proc.CHANNEL_END;
	  }
	});

/***/ },
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */
/***/ function(module, exports) {

	var traverse = module.exports = function (obj) {
	    return new Traverse(obj);
	};
	
	function Traverse (obj) {
	    this.value = obj;
	}
	
	Traverse.prototype.get = function (ps) {
	    var node = this.value;
	    for (var i = 0; i < ps.length; i ++) {
	        var key = ps[i];
	        if (!node || !hasOwnProperty.call(node, key)) {
	            node = undefined;
	            break;
	        }
	        node = node[key];
	    }
	    return node;
	};
	
	Traverse.prototype.has = function (ps) {
	    var node = this.value;
	    for (var i = 0; i < ps.length; i ++) {
	        var key = ps[i];
	        if (!node || !hasOwnProperty.call(node, key)) {
	            return false;
	        }
	        node = node[key];
	    }
	    return true;
	};
	
	Traverse.prototype.set = function (ps, value) {
	    var node = this.value;
	    for (var i = 0; i < ps.length - 1; i ++) {
	        var key = ps[i];
	        if (!hasOwnProperty.call(node, key)) node[key] = {};
	        node = node[key];
	    }
	    node[ps[i]] = value;
	    return value;
	};
	
	Traverse.prototype.map = function (cb) {
	    return walk(this.value, cb, true);
	};
	
	Traverse.prototype.forEach = function (cb) {
	    this.value = walk(this.value, cb, false);
	    return this.value;
	};
	
	Traverse.prototype.reduce = function (cb, init) {
	    var skip = arguments.length === 1;
	    var acc = skip ? this.value : init;
	    this.forEach(function (x) {
	        if (!this.isRoot || !skip) {
	            acc = cb.call(this, acc, x);
	        }
	    });
	    return acc;
	};
	
	Traverse.prototype.paths = function () {
	    var acc = [];
	    this.forEach(function (x) {
	        acc.push(this.path); 
	    });
	    return acc;
	};
	
	Traverse.prototype.nodes = function () {
	    var acc = [];
	    this.forEach(function (x) {
	        acc.push(this.node);
	    });
	    return acc;
	};
	
	Traverse.prototype.clone = function () {
	    var parents = [], nodes = [];
	    
	    return (function clone (src) {
	        for (var i = 0; i < parents.length; i++) {
	            if (parents[i] === src) {
	                return nodes[i];
	            }
	        }
	        
	        if (typeof src === 'object' && src !== null) {
	            var dst = copy(src);
	            
	            parents.push(src);
	            nodes.push(dst);
	            
	            forEach(objectKeys(src), function (key) {
	                dst[key] = clone(src[key]);
	            });
	            
	            parents.pop();
	            nodes.pop();
	            return dst;
	        }
	        else {
	            return src;
	        }
	    })(this.value);
	};
	
	function walk (root, cb, immutable) {
	    var path = [];
	    var parents = [];
	    var alive = true;
	    
	    return (function walker (node_) {
	        var node = immutable ? copy(node_) : node_;
	        var modifiers = {};
	        
	        var keepGoing = true;
	        
	        var state = {
	            node : node,
	            node_ : node_,
	            path : [].concat(path),
	            parent : parents[parents.length - 1],
	            parents : parents,
	            key : path.slice(-1)[0],
	            isRoot : path.length === 0,
	            level : path.length,
	            circular : null,
	            update : function (x, stopHere) {
	                if (!state.isRoot) {
	                    state.parent.node[state.key] = x;
	                }
	                state.node = x;
	                if (stopHere) keepGoing = false;
	            },
	            'delete' : function (stopHere) {
	                delete state.parent.node[state.key];
	                if (stopHere) keepGoing = false;
	            },
	            remove : function (stopHere) {
	                if (isArray(state.parent.node)) {
	                    state.parent.node.splice(state.key, 1);
	                }
	                else {
	                    delete state.parent.node[state.key];
	                }
	                if (stopHere) keepGoing = false;
	            },
	            keys : null,
	            before : function (f) { modifiers.before = f },
	            after : function (f) { modifiers.after = f },
	            pre : function (f) { modifiers.pre = f },
	            post : function (f) { modifiers.post = f },
	            stop : function () { alive = false },
	            block : function () { keepGoing = false }
	        };
	        
	        if (!alive) return state;
	        
	        function updateState() {
	            if (typeof state.node === 'object' && state.node !== null) {
	                if (!state.keys || state.node_ !== state.node) {
	                    state.keys = objectKeys(state.node)
	                }
	                
	                state.isLeaf = state.keys.length == 0;
	                
	                for (var i = 0; i < parents.length; i++) {
	                    if (parents[i].node_ === node_) {
	                        state.circular = parents[i];
	                        break;
	                    }
	                }
	            }
	            else {
	                state.isLeaf = true;
	                state.keys = null;
	            }
	            
	            state.notLeaf = !state.isLeaf;
	            state.notRoot = !state.isRoot;
	        }
	        
	        updateState();
	        
	        // use return values to update if defined
	        var ret = cb.call(state, state.node);
	        if (ret !== undefined && state.update) state.update(ret);
	        
	        if (modifiers.before) modifiers.before.call(state, state.node);
	        
	        if (!keepGoing) return state;
	        
	        if (typeof state.node == 'object'
	        && state.node !== null && !state.circular) {
	            parents.push(state);
	            
	            updateState();
	            
	            forEach(state.keys, function (key, i) {
	                path.push(key);
	                
	                if (modifiers.pre) modifiers.pre.call(state, state.node[key], key);
	                
	                var child = walker(state.node[key]);
	                if (immutable && hasOwnProperty.call(state.node, key)) {
	                    state.node[key] = child.node;
	                }
	                
	                child.isLast = i == state.keys.length - 1;
	                child.isFirst = i == 0;
	                
	                if (modifiers.post) modifiers.post.call(state, child);
	                
	                path.pop();
	            });
	            parents.pop();
	        }
	        
	        if (modifiers.after) modifiers.after.call(state, state.node);
	        
	        return state;
	    })(root).node;
	}
	
	function copy (src) {
	    if (typeof src === 'object' && src !== null) {
	        var dst;
	        
	        if (isArray(src)) {
	            dst = [];
	        }
	        else if (isDate(src)) {
	            dst = new Date(src.getTime ? src.getTime() : src);
	        }
	        else if (isRegExp(src)) {
	            dst = new RegExp(src);
	        }
	        else if (isError(src)) {
	            dst = { message: src.message };
	        }
	        else if (isBoolean(src)) {
	            dst = new Boolean(src);
	        }
	        else if (isNumber(src)) {
	            dst = new Number(src);
	        }
	        else if (isString(src)) {
	            dst = new String(src);
	        }
	        else if (Object.create && Object.getPrototypeOf) {
	            dst = Object.create(Object.getPrototypeOf(src));
	        }
	        else if (src.constructor === Object) {
	            dst = {};
	        }
	        else {
	            var proto =
	                (src.constructor && src.constructor.prototype)
	                || src.__proto__
	                || {}
	            ;
	            var T = function () {};
	            T.prototype = proto;
	            dst = new T;
	        }
	        
	        forEach(objectKeys(src), function (key) {
	            dst[key] = src[key];
	        });
	        return dst;
	    }
	    else return src;
	}
	
	var objectKeys = Object.keys || function keys (obj) {
	    var res = [];
	    for (var key in obj) res.push(key)
	    return res;
	};
	
	function toS (obj) { return Object.prototype.toString.call(obj) }
	function isDate (obj) { return toS(obj) === '[object Date]' }
	function isRegExp (obj) { return toS(obj) === '[object RegExp]' }
	function isError (obj) { return toS(obj) === '[object Error]' }
	function isBoolean (obj) { return toS(obj) === '[object Boolean]' }
	function isNumber (obj) { return toS(obj) === '[object Number]' }
	function isString (obj) { return toS(obj) === '[object String]' }
	
	var isArray = Array.isArray || function isArray (xs) {
	    return Object.prototype.toString.call(xs) === '[object Array]';
	};
	
	var forEach = function (xs, fn) {
	    if (xs.forEach) return xs.forEach(fn)
	    else for (var i = 0; i < xs.length; i++) {
	        fn(xs[i], i, xs);
	    }
	};
	
	forEach(objectKeys(Traverse.prototype), function (key) {
	    traverse[key] = function (obj) {
	        var args = [].slice.call(arguments, 1);
	        var t = new Traverse(obj);
	        return t[key].apply(t, args);
	    };
	});
	
	var hasOwnProperty = Object.hasOwnProperty || function (obj, key) {
	    return key in obj;
	};


/***/ },
/* 1283 */
/***/ function(module, exports) {

	/*
	  HACK: This package doesn't allow us skip the buffering of some actions.
	  This results in the loading screen not appearing properly on first app load
	*/
	/* eslint-disable */
	var BUFFERED_ACTION_RETURN = 'redux-action-buffer: buffered action'
	
	module.exports = function bufferActions (breaker, ignore, cb) {
	  var active = true
	  var queue = []
	  if (typeof breaker === 'string') {
	    var actionType = breaker
	    breaker = function (action) {
	      if (action.type === actionType) return true
	      else return false
	    }
	  }
	  if (Array.isArray(ignore)) {
	    skip = function (action) {
	      return ignore.indexOf(action.type) > -1
	    }
	  }
	
	  return function (store) {
	    return function (next) {
	      return function (action) {
	        if (!active) return next(action)
	        if (skip(action)) return next(action)
	        if (breaker(action)) {
	          active = false
	          var result = next(action)
	          var queueResults = []
	          queue.forEach(function (queuedAction) {
	            var queuedActionResult = next(queuedAction)
	            queueResults.push(queuedActionResult)
	          })
	          cb && cb(null, {
	            results: queueResults,
	            queue: queue
	          })
	          return result
	        } else {
	          queue.push(action)
	          // @TODO consider returning a dummy action, or maybe null for cleanliness
	          return BUFFERED_ACTION_RETURN
	        }
	      }
	    }
	  }
	}


/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	/* HACK: This package throws errors in NPM 2 - Servers need NPM 3 for this to be pulled into package.json */
	/* eslint-disable */
	
	var reduxPersist = __webpack_require__(1270);
	var traverse = __webpack_require__(1282);
	
	var PERSIST_EXPIRE_DEFAULT_KEY = 'persistExpiresAt';
	
	module.exports = function (config) {
	  config = config || {};
	  config.expireKey = config.expireKey || PERSIST_EXPIRE_DEFAULT_KEY;
	
	  function dateToUnix (date) {
	    return +(date.getTime() / 1000).toFixed(0);
	  }
	
	  function inbound (state) {
	    if (!state) return state;
	
	    return state;
	  }
	
	  function outbound (state) {
	    if (!state) return state;
	
	    var validState = traverse(state).forEach(function (value) {
	      if (!value || typeof value !== 'object') {
	        return;
	      }
	
	      if (!value.hasOwnProperty(config.expireKey)) {
	        return;
	      }
	
	      var expireDate = value[config.expireKey];
	
	      if (!expireDate) {
	        return;
	      }
	
	      if (dateToUnix(new Date(expireDate)) < dateToUnix(new Date())) {
	        this.update({});
	      }
	    });
	
	    return validState;
	  }
	
	  return reduxPersist.createTransform(inbound, outbound);
	};


/***/ }
]);


/** WEBPACK FOOTER **
 ** bundle.js
 **/